(function () {
  'use strict';

  const PLACEHOLDER_IMAGE =
    'data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 300 300%22%3E%3Crect width%3D%22100%25%22 height%3D%22100%25%22 fill%3D%22%23f2f5f7%22%2F%3E%3Cpath d%3D%22M150 135c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20zm50 45H100c-8.284 0-15 6.716-15 15v10h130v-10c0-8.284-6.716-15-15-15z%22 fill%3D%22%23bcc7cf%22%2F%3E%3C%2Fsvg%3E';

  const ROUTE_PREFIX = '#harvest';
  const SCHEDULE_DELIVERY_COUNT = 12;
  const HISTORY_PAGE_SIZE = 3;

  const SYSTEM_PRODUCTS = [];

  function getShopDomain() {
    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const shopParam = urlParams.get('shop');
    if (shopParam) return shopParam;

    const script = document.querySelector('script[src*="shop="]');
    if (script) {
      const srcUrl = new URL(script.src, window.location.origin);
      const srcShop = srcUrl.searchParams.get('shop');
      if (srcShop) return srcShop;
    }

    const host = window.location.hostname;
    if (host && host !== 'localhost' && !host.includes('127.0.0.1') && !host.includes('gitpod') && !host.includes('webcontainer') && !host.includes('aistudio')) {
      return host;
    }

    return 'sm1s08-03.myshopify.com';
  }

  function findCatalogOrContractProduct(variantId) {
    if (!variantId) return null;
    const vId = rawId(variantId);
    
    if (typeof SYSTEM_PRODUCTS !== 'undefined' && SYSTEM_PRODUCTS.length > 0) {
      const found = SYSTEM_PRODUCTS.find(p => 
        rawId(getAddableVariantId(p) || getVariantId(p)) === vId ||
        rawId(getCatalogProductId(p)) === vId
      );
      if (found) return found;
    }
    
    const portal = window.harvestPortal || window.portal;
    if (portal && portal.contracts) {
      for (const contract of portal.contracts) {
        const lines = [
          ...getContractLines(contract),
          ...(contract.oneTimeProducts || [])
        ];
        const found = lines.find(p => 
          rawId(getAddableVariantId(p) || getVariantId(p)) === vId ||
          rawId(getCatalogProductId(p)) === vId
        );
        if (found) return found;
      }
    }
    return null;
  }

  function isHtmlPayload(payload) {
    if (typeof payload === 'string') {
      const trimmed = payload.trim().toLowerCase();
      return (
        trimmed.startsWith('<!doctype') ||
        trimmed.startsWith('<html') ||
        trimmed.includes('<body') ||
        trimmed.includes('class="no-js"')
      );
    }
    return false;
  }

  function enrichCandidatesWithExternal(candidates) {
    return candidates.map(candidate => {
      if (candidate.params) {
        candidate.params = Object.assign({ isExternal: true }, candidate.params);
      } else if (candidate.body) {
        if (Array.isArray(candidate.body)) {
          candidate.body = candidate.body.map(item => Object.assign({ isExternal: true }, item));
        } else {
          candidate.body = Object.assign({ isExternal: true }, candidate.body);
        }
      } else {
        candidate.params = { isExternal: true };
      }
      return candidate;
    });
  }

  function getProductPrice(product) {
    if (!product) return 0;
    let price = firstMoney(product, [
      'price',
      'currentPrice',
      'variantPrice',
      'unitPrice',
      'variant.price',
      'variant.currentPrice',
      'variant.variantPrice',
      'variant.unitPrice',
      'variantPrice.amount',
      'unitPrice.amount',
      'price.amount',
      'currentPrice.amount',
      'product.price'
    ]);
    
    if (price === null || price === undefined || price === 0) {
      const resolved = findCatalogOrContractProduct(getVariantId(product));
      if (resolved) {
        price = firstMoney(resolved, [
          'price',
          'currentPrice',
          'variantPrice',
          'unitPrice',
          'variant.price',
          'variant.currentPrice',
          'variant.variantPrice',
          'variant.unitPrice',
          'variantPrice.amount',
          'unitPrice.amount',
          'price.amount',
          'currentPrice.amount',
          'product.price'
        ]);
      }
    }
    return price || 0;
  }

  class PortalRequestError extends Error {
    constructor(message, status, payload) {
      super(message);
      this.name = 'PortalRequestError';
      this.status = status;
      this.payload = payload;
    }
  }

  class HarvestApiService {
    constructor(options) {
      this.baseUrl = options.baseUrl;
      this.customerId = options.customerId;
      this.endpointCache = {};
    }

    async request(path, options = {}) {
      const originalMethod = options.method || 'GET';
      const isOverrideMethod = originalMethod === 'PUT' || originalMethod === 'DELETE';

      const makeAttempt = async (useOverride) => {
        let method = originalMethod;
        const url = new URL(`${this.baseUrl}${path}`, window.location.origin);
        const params = Object.assign({}, options.params, { token: rawId(this.customerId) });

        if (useOverride) {
          method = 'POST';
          url.searchParams.set('_method', originalMethod);
        }

        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            url.searchParams.set(key, String(value));
          }
        });

        const requestOptions = {
          method,
          headers: Object.assign({}, options.headers),
        };

        if (useOverride) {
          requestOptions.headers['X-HTTP-Method-Override'] = originalMethod;
          requestOptions.headers['X-Http-Method-Override'] = originalMethod;
        }

        if (options.body !== undefined) {
          requestOptions.headers['Content-Type'] = 'application/json';
          requestOptions.body = JSON.stringify(options.body);
        }

        const response = await (window.__harvestFetch || fetch)(url.toString(), requestOptions);
        const contentType = response.headers.get('content-type') || '';
        let payload = null;

        if (response.status !== 204) {
          if (contentType.includes('json')) {
            payload = await response.json();
          } else {
            const text = await response.text();
            try {
              payload = JSON.parse(text);
            } catch (e) {
              payload = text;
            }
          }
        }

        if (!response.ok) {
          let apiMessage = null;
          if (payload && typeof payload === 'object') {
            apiMessage = payload.message || payload.error || payload.errors?.[0]?.message || payload.title || payload.detail;
            if (typeof apiMessage === 'string' && apiMessage.startsWith('UserGeneratedError:')) {
              apiMessage = apiMessage.replace(/^UserGeneratedError:/, '');
            }
          } else {
            apiMessage = payload;
          }
          throw new PortalRequestError(
            apiMessage || `Request failed with status ${response.status}.`,
            response.status,
            payload
          );
        }

        return payload;
      };

      try {
        // Try direct method (PUT/DELETE/POST) first
        return await makeAttempt(false);
      } catch (error) {
        // Automatically fallback to POST method overriding if PUT/DELETE is not supported by proxy (usually returns 405 or 501)
        const isMethodError = error instanceof PortalRequestError && (error.status === 405 || error.status === 501);
        if (isOverrideMethod && isMethodError) {
          console.warn(`[Harvest Portal] Direct ${originalMethod} request to ${path} failed with ${error.status}. Retrying via POST override...`);
          try {
            return await makeAttempt(true);
          } catch (retryError) {
            throw retryError;
          }
        }
        throw error;
      }
    }

    async getSubscriptionCustomer() {
      const customerIdRaw = rawId(this.customerId);
      const urlCandidates = [
        '/subscription-customers',
        `/subscription-customers-detail/valid/${customerIdRaw}`,
        `/subscription-customers/valid/${customerIdRaw}`
      ];

      // Helper to find pageInfo recursively
      const findPageInfo = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        if (obj.pageInfo && (obj.pageInfo.hasNextPage || obj.pageInfo.endCursor || obj.pageInfo.has_next_page)) {
          return obj.pageInfo;
        }
        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (val && typeof val === 'object') {
            const found = findPageInfo(val);
            if (found) return found;
          }
        }
        return null;
      };

      // Helper to find edges recursively
      const findEdges = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        if (Array.isArray(obj.edges)) {
          return obj.edges;
        }
        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (val && typeof val === 'object') {
            const found = findEdges(val);
            if (found) return found;
          }
        }
        return null;
      };

      let lastError = null;
      for (const path of urlCandidates) {
        try {
          let cursor = null;
          let allContracts = [];
          let hasNextPage = true;
          let pagesFetched = 0;

          while (hasNextPage && pagesFetched < 10) {
            const params = {};
            if (cursor) {
              params.cursor = cursor;
            }

            const payload = await this.request(path, { params });
            pagesFetched++;

            if (!payload) {
              break;
            }

            const customer = extractCustomer(payload);
            const pageContracts = getConnectionItems(customer?.subscriptionContracts);

            if (pageContracts && pageContracts.length > 0) {
              pageContracts.forEach(contract => {
                if (contract && contract.id) {
                  const existingIdx = allContracts.findIndex(c => rawId(c.id) === rawId(contract.id));
                  if (existingIdx === -1) {
                    allContracts.push(contract);
                  }
                }
              });
            } else {
              break;
            }

            const pageInfo = findPageInfo(payload);
            const hasNext = pageInfo ? (pageInfo.hasNextPage || pageInfo.has_next_page || pageInfo.hasNext || pageInfo.has_next) : false;
            const endCursor = pageInfo ? (pageInfo.endCursor || pageInfo.end_cursor || pageInfo.cursor) : null;

            if (hasNext && endCursor) {
              cursor = endCursor;
            } else {
              const edges = findEdges(payload);
              if (edges && edges.length > 0) {
                const lastEdge = edges[edges.length - 1];
                if (lastEdge && lastEdge.cursor && lastEdge.cursor !== cursor) {
                  cursor = lastEdge.cursor;
                } else {
                  hasNextPage = false;
                }
              } else {
                hasNextPage = false;
              }
            }

            if (!cursor) {
              hasNextPage = false;
            }
          }

          if (allContracts.length > 0) {
            return {
              subscriptionContracts: allContracts
            };
          } else if (path === urlCandidates[urlCandidates.length - 1]) {
            return {
              subscriptionContracts: []
            };
          }
        } catch (error) {
          lastError = error;
        }
      }

      throw lastError || new Error('All subscription endpoints failed.');
    }

    updateContractStatus(contractId, status) {
      const contract = rawId(contractId);
      const params = {
        contractId: contract,
        status,
      };
      const body = {
        contractId: contract,
        status,
      };
      return this.requestCandidate(
        `updateContractStatus_${contract}`,
        [
          { path: '/subscription-contracts-update-status', method: 'POST', body },
          { path: '/subscription-contracts-update-status', method: 'PUT', params },
          { path: '/subscription-contracts-update-status', method: 'POST', params },
          { path: '/subscription-contract-details/update-status', method: 'POST', body },
        ],
        { continueStatuses: [400, 404, 405, 501] }
      );
    }

    updateLineItemQuantity(contractId, lineId, variantId, quantity) {
      const contract = rawId(contractId);
      const params = {
        contractId: contract,
        lineId,
        quantity,
        variantId: rawId(variantId),
        isExternal: true,
      };
      const body = {
        contractId: contract,
        lineId,
        quantity,
        variantId: rawId(variantId),
        isExternal: true,
      };
      return this.requestCandidate(
        `updateLineItemQuantity_${contract}`,
        [
          { path: '/subscription-contracts-update-line-item-quantity', method: 'POST', body },
          { path: '/subscription-contracts-update-line-item-quantity', method: 'PUT', params },
          { path: '/subscription-contracts-update-line-item-quantity', method: 'POST', params },
          { path: '/subscription-contract-details/update-line-item-quantity', method: 'POST', body },
        ],
        { continueStatuses: [400, 404, 405, 501] }
      );
    }

    async replaceVariants(contractId, standardPayload, groupSwapPayload) {
      const contract = rawId(contractId);
      const shopDomain = (standardPayload && standardPayload.shop) || getShopDomain();
      const oldVariantId = standardPayload && standardPayload.oldVariants?.[0];
      const newVariantId = standardPayload && standardPayload.newVariants ? Object.keys(standardPayload.newVariants)[0] : null;
      const quantity = (standardPayload && standardPayload.newVariants && newVariantId && standardPayload.newVariants[newVariantId]) || 1;
      const oldLineId = standardPayload && standardPayload.oldLineId;

      const oldLineIdGid = oldLineId && !String(oldLineId).startsWith('gid://') ? `gid://shopify/SubscriptionLine/${rawId(oldLineId)}` : oldLineId;
      const contractGid = contractId && !String(contractId).startsWith('gid://') ? `gid://shopify/SubscriptionContract/${rawId(contractId)}` : contractId;
      const oldVariantGid = oldVariantId && !String(oldVariantId).startsWith('gid://') ? `gid://shopify/ProductVariant/${rawId(oldVariantId)}` : oldVariantId;
      const newVariantGid = newVariantId && !String(newVariantId).startsWith('gid://') ? `gid://shopify/ProductVariant/${rawId(newVariantId)}` : newVariantId;

      // Dynamic payload variations to cover different versions of the Appstle API
      const standardPayloadRawLine = {
        shop: shopDomain,
        contractId: rawId(contractId),
        oldVariants: oldVariantId ? [Number(rawId(oldVariantId)) || oldVariantId] : [],
        newVariants: newVariantId ? {
          [rawId(newVariantId)]: quantity,
        } : {},
        oldLineId: oldLineIdGid,
      };

      const standardPayloadStringLine = {
        shop: shopDomain,
        contractId: rawId(contractId),
        oldVariants: oldVariantId ? [String(rawId(oldVariantId))] : [],
        newVariants: newVariantId ? {
          [String(rawId(newVariantId))]: quantity,
        } : {},
        oldLineId: oldLineIdGid,
      };

      const standardPayloadGidLine = {
        shop: shopDomain,
        contractId: rawId(contractId),
        oldVariants: [oldVariantGid],
        newVariants: {
          [newVariantGid]: quantity
        },
        oldLineId: oldLineIdGid
      };

      const standardPayloadNoLine = {
        shop: shopDomain,
        contractId: rawId(contractId),
        oldVariants: oldVariantId ? [Number(rawId(oldVariantId)) || oldVariantId] : [],
        newVariants: newVariantId ? {
          [rawId(newVariantId)]: quantity,
        } : {},
      };

      const flatPayload = {
        shop: shopDomain,
        contractId: rawId(contractId),
        oldVariantId: oldVariantId ? (Number(rawId(oldVariantId)) || rawId(oldVariantId)) : null,
        newVariantId: newVariantId ? (Number(rawId(newVariantId)) || rawId(newVariantId)) : null,
        quantity: quantity,
        lineId: oldLineIdGid,
      };

      const flatPayloadGid = {
        shop: shopDomain,
        contractId: contractGid,
        oldVariantId: oldVariantGid,
        newVariantId: newVariantGid,
        quantity: quantity,
        lineId: oldLineIdGid,
      };

      const candidates = [];

      // 1. Prioritize standard, direct replace-variants-v3 with clean payloads first
      candidates.push(
        { 
          path: '/subscription-contract-details/replace-variants-v3', 
          method: 'POST', 
          body: standardPayloadStringLine 
        },
        { 
          path: '/subscription-contract-details/replace-variants-v3', 
          method: 'POST', 
          body: standardPayloadRawLine 
        },
        { 
          path: '/subscription-contract-details/replace-variants-v3', 
          method: 'POST', 
          body: standardPayloadGidLine 
        },
        { 
          path: '/subscription-contract-details/replace-variants-v3', 
          method: 'POST', 
          body: flatPayload 
        },
        { 
          path: '/subscription-contract-details/replace-variants-v3', 
          method: 'POST', 
          body: flatPayloadGid 
        },
        
        // 2. Fallbacks to replace-variants (non-v3)
        { 
          path: '/subscription-contract-details/replace-line-item', 
          method: 'POST', 
          body: standardPayloadStringLine 
        },
        { 
          path: '/subscription-contract-details/replace-variants', 
          method: 'POST', 
          body: standardPayloadStringLine 
        },
        { 
          path: '/subscription-contract-details/replace-variants', 
          method: 'POST', 
          body: standardPayloadRawLine 
        },
        
        // 3. Fallbacks to other potential subscription contracts replace variants endpoints
        { 
          path: '/subscription-contracts-replace-variants', 
          method: 'POST', 
          body: standardPayloadStringLine 
        },
        { 
          path: '/subscription-contracts/replace-variants', 
          method: 'POST', 
          body: standardPayloadStringLine 
        },

        // 4. Minimal standard structure without line ID in case contract-wide matching is needed
        {
          path: '/subscription-contract-details/replace-variants-v3',
          method: 'POST',
          body: standardPayloadNoLine
        }
      );

      // 5. Product swaps by variant groups (group swaps) - Last resort fallback
      if (groupSwapPayload) {
        candidates.push({ path: `/product-swaps-by-variant-groups/${contract}`, method: 'POST', body: groupSwapPayload });
      }

      try {
        console.log('[Harvest Portal API] Attempting direct replaceVariants candidates...');
        const result = await this.requestCandidate(
          `replaceVariants_${contract}`,
          candidates,
          { 
            continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
            noCache: true,
            strictValidate: true,
            validate: (payload) => {
              // If we got an empty response but status was successful, treat it as successful
              if (payload === true || (Array.isArray(payload) && payload.length === 0) || (payload && typeof payload === 'object' && Object.keys(payload).length === 0)) {
                return true;
              }
              const contractObj = extractContractFromObject(payload);
              if (!contractObj) return true;
              const lines = getContractLines(contractObj);
              if (Array.isArray(lines)) {
                const found = lines.some(line => rawId(getVariantId(line)) === rawId(newVariantId));
                if (!found) {
                  console.warn('[Harvest Portal API] Validation warning: New variant not found in returned contract');
                  return false;
                }
              }
              return true;
            }
          }
        );

        // Double-check if the returned contract actually updated
        let contractObj = extractContractFromObject(result);
        if (!contractObj) {
          // If the API succeeded but returned empty/no contract, fetch latest contract to verify
          console.log('[Harvest Portal API] Succeeded without returning contract object. Fetching latest contract to verify swap...');
          try {
            const fetched = await this.getSubscriptionContract(contractId, { noCache: true });
            contractObj = extractContractFromObject(fetched);
          } catch (e) {
            console.warn('[Harvest Portal API] Verification: Failed to fetch contract for verification', e);
          }
        }

        if (contractObj) {
          const lines = getContractLines(contractObj);
          if (Array.isArray(lines)) {
            const found = lines.some(line => rawId(getVariantId(line)) === rawId(newVariantId));
            if (!found) {
              throw new Error(`Verification failed: New variant ${newVariantId} not found in verified contract.`);
            }
          }
        } else {
          throw new Error('Succeeded but could not verify contract update.');
        }

        return result;
      } catch (err) {
        console.warn('[Harvest Portal API] Direct replaceVariants failed or failed validation. Error:', err);
        
        // Fallback: Add new product, then remove old product
        if (newVariantId && oldVariantId) {
          console.log('[Harvest Portal API] Initiating swap fallback: Add recurring, then remove old product...', {
            contractId,
            newVariantId,
            oldVariantId,
            quantity
          });
          
          // 1. Add new variant
          const addRes = await this.addRecurringProduct(contractId, newVariantId, quantity);
          
          // 2. Locate the old product details from the contract lines to remove it cleanly
          const updatedContract = extractContractFromObject(addRes);
          let oldProductObj = null;
          if (updatedContract) {
            const lines = getContractLines(updatedContract);
            if (Array.isArray(lines)) {
              oldProductObj = lines.find(line => rawId(getVariantId(line)) === rawId(oldVariantId));
            }
          }
          
          if (!oldProductObj) {
            // Fallback lookup using standard template search
            const portal = window.harvestPortal || window.portal;
            if (portal) {
              const contractObj = portal.findContract ? portal.findContract(contractId) : null;
              if (contractObj) {
                oldProductObj = portal.findProduct ? portal.findProduct(contractObj, oldLineId, false) : null;
              }
            }
          }
          
          if (oldProductObj) {
            console.log('[Harvest Portal API] Swap fallback: Removing old line item...', oldProductObj);
            await this.removeLineItem(contractId, oldProductObj, false);
          } else {
            console.warn('[Harvest Portal API] Swap fallback warning: Could not locate old product object for removal');
          }
          
          return addRes;
        } else {
          throw err;
        }
      }
    }

    async getSubscriptionProducts(contractId) {
      const contract = rawId(contractId);
      const candidates = [
        {
          path: '/data/subscription-products',
          method: 'GET',
        },
        {
          path: '/subscription-products',
          method: 'GET',
        },
        {
          path: '/subscription-products-catalog',
          method: 'GET',
        },
        {
          path: '/subscription-contract-details/subscription-products',
          method: 'GET',
        },
        {
          path: '/subscription-contract-one-offs-by-contractId',
          method: 'GET',
          params: { contractId: contract },
        },
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'GET',
          params: { contractId: contract },
        }
      ];

      try {
        const payload = await this.requestCandidate(
          `subscriptionProducts_${contract}`,
          candidates,
          { optional: true, continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
        );
        return payload;
      } catch (err) {
        console.warn('Error fetching subscription products:', err);
        return null;
      }
    }

    getBundle(handle) {
      return this.request(`/v3/subscription-bundlings/external/get-bundle/${handle}`, {
        method: 'GET',
      });
    }

    getOneTimeProducts(contractId) {
      const contract = rawId(contractId);
      return this.requestCandidate(
        `getOneTimeProducts_${contract}`,
        [
          {
            path: '/upcoming-subscription-contract-one-offs-by-contractId',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-one-offs-by-contractId',
            params: { contractId: contract },
          },
          {
            path: '/upcoming-subscription-contract-one-offs',
            params: { contractId: contract },
          },
          {
            path: '/upcoming-subscription-contract-one-offs',
            params: { subscriptionContractId: contract },
          },
          {
            path: '/subscription-contract-one-offs',
            params: { contractId: contract },
          }
        ],
        { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
      );
    }

    async getSubscriptionContract(contractId, options = {}) {
      const contract = rawId(contractId);
      return await this.requestCandidate(
        `subscriptionContract_${contract}`,
        [
          {
            path: `/subscription-contracts/contract/${contract}`,
            method: 'GET'
          },
          {
            path: `/subscription-contracts/contract-external/${contract}`,
            method: 'GET'
          },
          {
            path: `/subscription-contracts/${contract}`,
            method: 'GET'
          },
          {
            path: `/subscription-contract-raw/${contract}`,
            method: 'GET'
          },
          {
            path: '/subscription-contract-details',
            method: 'GET',
            params: { contractId: contract }
          }
        ],
        Object.assign(
          { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] },
          options
        )
      );
    }

    addRecurringProduct(contractId, variantId, quantity) {
      const contract = rawId(contractId);
      const variant = rawId(variantId);
      const count = Number(quantity) || 1;
      const shopDomain = getShopDomain();

      const rawContract = Number(contract);
      const isNumeric = /^\d+$/.test(String(variant));
      const numVariant = isNumeric ? Number(variant) : variant;
      const rawVariant = String(variant);
      const gidVariant = `gid://shopify/ProductVariant/${variant}`;

      // Query parameter variations for V2 storefront APIs
      const paramsRawNum = {
        contractId: rawContract,
        variantId: numVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      const paramsRawStr = {
        contractId: rawContract,
        variantId: rawVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      const paramsGid = {
        contractId: rawContract,
        variantId: gidVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      // Request body variations for V2 storefront APIs
      const bodyRawNum = {
        contractId: rawContract,
        variantId: numVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      const bodyRawStr = {
        contractId: rawContract,
        variantId: rawVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      const bodyGid = {
        contractId: rawContract,
        variantId: gidVariant,
        quantity: count,
        isOneTimeProduct: false,
        shop: shopDomain,
      };

      // Fallback structures for legacy/alternative endpoints
      const paramsFallbackNum = {
        contractId: rawContract,
        contract_id: rawContract,
        variantId: numVariant,
        variant_id: numVariant,
        product_variant_id: numVariant,
        productVariantId: numVariant,
        quantity: count,
        shop: shopDomain,
        isOneTimeProduct: false,
      };

      const paramsFallbackStr = {
        contractId: rawContract,
        contract_id: rawContract,
        variantId: rawVariant,
        variant_id: rawVariant,
        product_variant_id: rawVariant,
        productVariantId: rawVariant,
        quantity: count,
        shop: shopDomain,
        isOneTimeProduct: false,
      };
      
      const bodyFallbackNum = {
        contractId: rawContract,
        contract_id: rawContract,
        variantId: numVariant,
        variant_id: numVariant,
        product_variant_id: numVariant,
        productVariantId: numVariant,
        quantity: count,
        shop: shopDomain,
        isOneTimeProduct: false,
      };

      const bodyFallbackStr = {
        contractId: rawContract,
        contract_id: rawContract,
        variantId: rawVariant,
        variant_id: rawVariant,
        product_variant_id: rawVariant,
        productVariantId: rawVariant,
        quantity: count,
        shop: shopDomain,
        isOneTimeProduct: false,
      };

      console.log('[Harvest Portal] Attempting addRecurringProduct candidates with values:', {
        contract: rawContract,
        variant: rawVariant,
        numVariant,
        gidVariant,
        count,
        shopDomain
      });

      return this.requestCandidate(
        `addRecurringProduct_${contract}`,
        enrichCandidatesWithExternal([
          // --- GROUP 1: V2 Singular Storefront Endpoint (Primary) ---
          // 1. PUT with query parameters
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid },

          // 2. PUT with JSON request body
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyGid },

          // 3. PUT with both query params and JSON request body
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum, body: bodyRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr, body: bodyRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid, body: bodyGid },

          // 4. POST with query parameters
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid },

          // 5. POST with JSON request body
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyGid },

          // 6. POST with both query params and JSON request body
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum, body: bodyRawNum },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr, body: bodyRawStr },
          { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid, body: bodyGid },

          // --- GROUP 2: Fallback / Older Singular version: /subscription-contracts-add-line-item ---
          { path: '/subscription-contracts-add-line-item', method: 'PUT', params: paramsFallbackNum },
          { path: '/subscription-contracts-add-line-item', method: 'PUT', params: paramsFallbackStr },
          { path: '/subscription-contracts-add-line-item', method: 'POST', params: paramsFallbackNum },
          { path: '/subscription-contracts-add-line-item', method: 'POST', params: paramsFallbackStr },
          { path: '/subscription-contracts-add-line-item', method: 'POST', body: bodyFallbackNum },
          { path: '/subscription-contracts-add-line-item', method: 'POST', body: bodyFallbackStr },

          // --- GROUP 3: Fallback / Details/generic product candidates ---
          { path: '/subscription-contract-details/add-product', method: 'PUT', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-product', method: 'PUT', params: paramsFallbackStr },
          { path: '/subscription-contract-details/add-product', method: 'POST', body: bodyFallbackNum },
          { path: '/subscription-contract-details/add-product', method: 'POST', body: bodyFallbackStr },
          { path: '/subscription-contract-details/add-product', method: 'POST', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-product', method: 'POST', params: paramsFallbackStr },
          
          { path: '/subscription-contracts/add-product', method: 'PUT', params: paramsFallbackNum },
          { path: '/subscription-contracts/add-product', method: 'PUT', params: paramsFallbackStr },
          { path: '/subscription-contracts/add-product', method: 'POST', body: bodyFallbackNum },
          { path: '/subscription-contracts/add-product', method: 'POST', body: bodyFallbackStr },
          { path: '/subscription-contracts/add-product', method: 'POST', params: paramsFallbackNum },
          { path: '/subscription-contracts/add-product', method: 'POST', params: paramsFallbackStr },

          { path: '/subscription-contract-details/add-line-item', method: 'PUT', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-line-item', method: 'PUT', params: paramsFallbackStr },
          { path: '/subscription-contract-details/add-line-item', method: 'POST', body: bodyFallbackNum },
          { path: '/subscription-contract-details/add-line-item', method: 'POST', body: bodyFallbackStr },
          { path: '/subscription-contract-details/add-line-item', method: 'POST', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-line-item', method: 'POST', params: paramsFallbackStr },

          { path: '/subscription-contract-details/add-line-items', method: 'PUT', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-line-items', method: 'PUT', params: paramsFallbackStr },
          { path: '/subscription-contract-details/add-line-items', method: 'POST', body: bodyFallbackNum },
          { path: '/subscription-contract-details/add-line-items', method: 'POST', body: bodyFallbackStr },
          { path: '/subscription-contract-details/add-line-items', method: 'POST', params: paramsFallbackNum },
          { path: '/subscription-contract-details/add-line-items', method: 'POST', params: paramsFallbackStr },
        ]),
        {
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          noCache: true,
          strictValidate: true,
          validate: (payload) => {
            const contractObj = extractContractFromObject(payload);
            if (!contractObj) return false;
            const lines = getContractLines(contractObj);
            if (Array.isArray(lines)) {
              return lines.some(line => rawId(getVariantId(line)) === rawId(variant));
            }
            return false;
          }
        }
      );
    }

    updateShippingAddress(contractId, address) {
      const contract = rawId(contractId);

      // Find the existing contract to preserve first name, last name, phone, company, address2, etc.
      const portal = window.harvestPortal || window.portal;
      let existingContract = null;
      if (portal && portal.contracts) {
        existingContract = portal.contracts.find(c => rawId(c.id) === contract);
      }
      const existingAddress = existingContract ? getContractShippingAddress(existingContract) : {};

      let firstName = address.firstName || existingAddress.firstName || existingAddress.first_name || '';
      let lastName = address.lastName || existingAddress.lastName || existingAddress.last_name || '';
      let phone = address.phone || existingAddress.phone || existingAddress.phoneNumber || existingAddress.phone_number || '';
      const company = address.company || existingAddress.company || '';

      if (!phone) {
        const cust = existingContract?.customer || {};
        phone = cust.phone || cust.phoneNumber || cust.phone_number || '';
      }

      if (!phone) {
        const rootEl = document.getElementById('harvest-portal-root');
        phone = rootEl?.dataset?.customerPhone || '';
      }

      if (!phone) {
        // Safe default fallback phone number so the server-side validator doesn't reject the submission
        phone = '555-555-5555';
      }

      if (!firstName || !lastName) {
        const cust = existingContract?.customer || {};
        firstName = firstName || cust.firstName || cust.first_name || '';
        lastName = lastName || cust.lastName || cust.last_name || '';
      }
      
      if (!firstName || !lastName) {
        const rootEl = document.getElementById('harvest-portal-root');
        firstName = firstName || rootEl?.dataset?.customerFirstName || '';
        lastName = lastName || rootEl?.dataset?.customerLastName || '';
      }

      if (!firstName || !lastName) {
        const rootEl = document.getElementById('harvest-portal-root');
        const fullName = rootEl?.dataset?.customerName || existingContract?.customer?.displayName || existingContract?.customer?.name || '';
        if (fullName) {
          const parts = fullName.trim().split(/\s+/);
          if (parts.length > 0) {
            firstName = firstName || parts[0];
            if (parts.length > 1) {
              lastName = lastName || parts.slice(1).join(' ');
            }
          }
        }
      }

      if (!firstName) firstName = 'Customer';
      if (!lastName) lastName = 'Account';

      // --- Normalize Address and Detect Country/CountryCode ---
      const address1 = address.address1 || '';
      const address2 = address.address2 || existingAddress.address2 || existingAddress.address_2 || '';
      const city = address.city || '';
      let province = address.province || address.state || '';
      let zip = address.zip || address.zipCode || '';
      let country = address.country || '';

      province = String(province).trim();
      zip = String(zip).trim();
      country = String(country).trim();

      // Canadian province list
      const caProvinces = [
        'BC', 'QC', 'ON', 'AB', 'NS', 'NB', 'MB', 'PE', 'SK', 'NL', 'YT', 'NT', 'NU', 
        'BRITISH COLUMBIA', 'QUEBEC', 'ONTARIO', 'ALBERTA', 'NOVA SCOTIA', 'NEW BRUNSWICK', 
        'MANITOBA', 'PRINCE EDWARD ISLAND', 'SASKATCHEWAN', 'NEWFOUNDLAND AND LABRADOR', 
        'YUKON', 'NORTHWEST TERRITORIES', 'NUNAVUT'
      ];
      
      const isCaZip = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/.test(zip.replace(/\s+/g, ''));
      const isCaProvince = caProvinces.includes(province.toUpperCase());

      // Default fallback: if it's a Canadian zip/province, or country is empty/US and looks Canadian, set country to Canada
      if (isCaZip || isCaProvince || !country || country.toUpperCase() === 'UNITED STATES' || country.toUpperCase() === 'US') {
        if (isCaZip || isCaProvince || !country) {
          country = 'Canada';
        }
      }

      // Map to proper name and countryCode/country_code
      let countryCode = 'CA';
      const countryUpper = country.toUpperCase();
      if (countryUpper === 'CANADA' || countryUpper === 'CA') {
        country = 'Canada';
        countryCode = 'CA';
      } else if (countryUpper === 'UNITED STATES' || countryUpper === 'US' || countryUpper === 'USA' || countryUpper === 'UNITED STATES OF AMERICA') {
        country = 'United States';
        countryCode = 'US';
      } else if (countryUpper === 'UNITED KINGDOM' || countryUpper === 'GB' || countryUpper === 'UK') {
        country = 'United Kingdom';
        countryCode = 'GB';
      } else if (countryUpper === 'AUSTRALIA' || countryUpper === 'AU') {
        country = 'Australia';
        countryCode = 'AU';
      } else if (countryUpper === 'FRANCE' || countryUpper === 'FR') {
        country = 'France';
        countryCode = 'FR';
      } else if (countryUpper === 'GERMANY' || countryUpper === 'DE') {
        country = 'Germany';
        countryCode = 'DE';
      } else if (country.length === 2) {
        countryCode = country.toUpperCase();
      }

      // Create flat and nested parameter structures
      const flatPayload = {
        contractId: contract,
        address1,
        address2,
        city,
        province,
        zip,
        country,
        countryCode,
        country_code: countryCode,
        provinceCode: province,
        province_code: province,
        firstName,
        lastName,
        first_name: firstName,
        last_name: lastName,
        phone,
        company,
      };

      const nestedPayload = {
        contractId: contract,
        address: {
          address1,
          address2,
          city,
          province,
          zip,
          country,
          countryCode,
          country_code: countryCode,
          provinceCode: province,
          province_code: province,
          firstName,
          lastName,
          first_name: firstName,
          last_name: lastName,
          phone,
          company,
        }
      };

      return this.requestCandidate(
        `updateShippingAddress_${contract}`,
        [
          // Candidate A: PUT with query parameter contractId and full flat payload in body (The exact correct Shopify format)
          { 
            path: '/subscription-contracts-update-shipping-address', 
            method: 'PUT', 
            params: { contractId: contract }, 
            body: flatPayload 
          },
          // Candidate B: PUT with query parameter contractId and nested address in body
          { 
            path: '/subscription-contracts-update-shipping-address', 
            method: 'PUT', 
            params: { contractId: contract }, 
            body: nestedPayload 
          },
          // Candidate C: PUT with flat payload as body only (no query params)
          { 
            path: '/subscription-contracts-update-shipping-address', 
            method: 'PUT', 
            body: flatPayload 
          },
          // Candidate D: PUT with flat payload as query params
          { 
            path: '/subscription-contracts-update-shipping-address', 
            method: 'PUT', 
            params: flatPayload 
          },
          // Candidate E: POST on details endpoint
          { 
            path: '/subscription-contract-details/update-shipping-address', 
            method: 'POST', 
            params: { contractId: contract },
            body: flatPayload 
          },
          // Candidate F: PUT on subscription-contracts-update-address
          { 
            path: '/subscription-contracts-update-address', 
            method: 'PUT', 
            params: { contractId: contract },
            body: flatPayload 
          }
        ],
        { continueStatuses: [400, 404, 405, 501] }
      );
    }

    async requestCandidate(key, candidates, options = {}) {
      const cachedCandidate = options.noCache ? null : this.endpointCache[key];
      let queue = candidates;
      if (cachedCandidate) {
        // Find matching candidate in the current list to preserve updated parameters
        const matchIdx = candidates.findIndex(
          (c) => c.path === cachedCandidate.path && (c.method || 'GET') === (cachedCandidate.method || 'GET')
        );
        if (matchIdx !== -1) {
          const match = candidates[matchIdx];
          queue = [
            match,
            ...candidates.filter((_, idx) => idx !== matchIdx),
          ];
        }
      }
      const continueStatuses = options.continueStatuses || [404, 405, 501];
      let lastError = null;
      let firstEmptySuccessPayload = null;
      let firstEmptySuccessCandidate = null;

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      // console.group(`%c[Harvest Portal Debug API] Probing candidates for: ${key}`, 'color: #3b82f6; font-weight: bold;');
      // console.log(`• Queue size: ${queue.length} Candidates | Allowed skip statuses:`, continueStatuses);

      let retriesForCurrentIndex = 0;

      for (let index = 0; index < queue.length; index++) {
        const candidate = queue[index];

        // Space out requests by 100ms default to prevent hitting rate limits during sequential probes
        if (index > 0) {
          await sleep(100);
        }

        try {
          // console.log(
          //   `%c[Attempt #${index + 1}/${queue.length}] ${candidate.method || 'GET'} ${candidate.path}`,
          //   'color: #6366f1; font-weight: 500;'
          // );
          // if (candidate.params) console.log('  Params:', candidate.params);
          // if (candidate.body) console.log('  Body:', candidate.body);

          const payload = await this.request(candidate.path, {
            method: candidate.method || 'GET',
            params: candidate.params,
            body: candidate.body,
          });

          if (isHtmlPayload(payload)) {
            throw new PortalRequestError('HTML Redirect received instead of API response', 404, payload);
          }

          if (options.validate && !options.validate(payload)) {
            if (options.strictValidate) {
              throw new PortalRequestError('Validation failed', 422, payload);
            }
            if (!firstEmptySuccessPayload) {
              firstEmptySuccessPayload = payload;
              firstEmptySuccessCandidate = candidate;
            }
            throw new PortalRequestError('Validated empty', 200, payload);
          }

          // console.log(
          //   `%c[SUCCESS] Candidate #${index + 1} succeeded! Cache updated.`,
          //   'color: #10b981; font-weight: bold;'
          // );
          // console.groupEnd();

          this.endpointCache[key] = candidate;
          return payload;
        } catch (error) {
          lastError = error;
          const status = error instanceof PortalRequestError ? error.status : 'Non-API/Local';
          const errorMsg = error.message || error;

          // Robust 429 Rate Limit Handling with exponential backoff retries
          if (status === 429) {
            if (retriesForCurrentIndex < 3) {
              retriesForCurrentIndex++;
              const waitTime = retriesForCurrentIndex * 2000;
              console.warn(
                `%c[RATE LIMITED - 429] Received 429 on candidate #${index + 1}. Waiting for ${waitTime / 1000}s and retrying... (Retry #${retriesForCurrentIndex})`,
                'color: #ca8a04; font-weight: bold; background: #fef9c3; padding: 2px 4px; border-radius: 4px;'
              );
              await sleep(waitTime);
              index--; // Stay on same candidate index for loop's next iteration
              continue;
            } else {
              console.error(`%c[RATE LIMIT EXHAUSTED] Candidate #${index + 1} failed with 429 even after 3 backoff retries. Skipping.`, 'color: #ef4444; font-weight: bold;');
              retriesForCurrentIndex = 0;
            }
          } else {
            retriesForCurrentIndex = 0;
          }

          const isBusinessValidationError = error instanceof PortalRequestError && error.payload && (
            (typeof error.payload === 'object' && error.payload !== null) && (
              error.payload.errorKey === 'restrictedDayOfWeek' ||
              (typeof error.payload.title === 'string' && error.payload.title.includes('restrictedDayOfWeek')) ||
              (typeof error.payload.message === 'string' && error.payload.message.includes('restrictedDayOfWeek')) ||
              (typeof error.payload.title === 'string' && error.payload.title.toLowerCase().includes('not available for scheduling')) ||
              (typeof error.payload.message === 'string' && error.payload.message.toLowerCase().includes('not available for scheduling')) ||
              (key.startsWith('rescheduleDelivery_') && (error.payload.errorKey || error.payload.message || error.payload.title))
            )
          );

          const isIgnorable = !isBusinessValidationError && (!(error instanceof PortalRequestError) || (
            (status === 429) || // Allow continuing even if a candidate rate-limited and exhausted retries
            continueStatuses.includes(error.status) || 
            (error.message === 'Validated empty' && error.status === 200)
          ));

          // console.log(
          //   `%c[FAILED] Candidate #${index + 1} failed with status: ${status}. Error: ${errorMsg} | Ignorable/Skip: ${isIgnorable}`,
          //   isIgnorable ? 'color: #ca8a04; font-style: italic;' : 'color: #ef4444; font-weight: bold;',
          //   error instanceof PortalRequestError ? (error.payload || 'No Payload') : error
          // );

          if (!isIgnorable) {
            // console.groupEnd();
            throw error;
          }
        }
      }

      // console.groupEnd();

      if (firstEmptySuccessPayload !== null) {
        this.endpointCache[key] = firstEmptySuccessCandidate;
        return firstEmptySuccessPayload;
      }

      if (options.optional) return null;
      throw lastError || new Error('Appstle endpoint was not available.');
    }

    async getSchedules(contractId) {
      const contract = rawId(contractId);
      const payload = await this.requestCandidate(
        `schedules_${contract}`,
        [
          {
            path: '/subscription-billing-attempts/top-orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/order-schedule',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/schedules',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-order-schedule',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/upcoming-orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-upcoming-orders-by-contractId',
            params: { contractId: contract },
          },
        ],
        { 
          optional: true, 
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          validate: (data) => extractScheduleItems(data).length > 0
        }
      );

      return {
        available: Boolean(payload),
        items: extractScheduleItems(payload),
        payload,
      };
    }

    async getHistory(contractId) {
      const contract = rawId(contractId);
      const payload = await this.requestCandidate(
        `history_${contract}`,
        [
          {
            path: '/subscription-billing-attempts/past-orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/order-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/billing-attempts',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/subscription-billing-attempts',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/billing-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contract-details/invoice-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-order-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-billing-attempts',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts-billing-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts/orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts/billing-attempts',
            params: { contractId: contract },
          },
          {
            path: '/subscription-contracts/billing-history',
            params: { contractId: contract },
          },
          {
            path: '/subscription-customers/orders',
            params: { contractId: contract },
          },
          {
            path: '/subscription-customers/billing-attempts',
            params: { contractId: contract },
          },
        ],
        { 
          optional: true, 
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          validate: (data) => extractHistoryItems(data).length > 0
        }
      );

      return {
        available: Boolean(payload),
        items: extractHistoryItems(payload),
        payload,
      };
    }

    async skipDelivery(contractId, deliveryDate, billingAttemptId) {
      const contract = rawId(contractId);
      const attemptId = rawId(billingAttemptId) || rawId(await this.seekBillingAttemptId(contract, deliveryDate));

      if (!attemptId) {
        throw new Error('Could not find the upcoming order to skip.');
      }

      return this.requestCandidate(
        `skipDelivery_${contract}`,
        [
          {
            path: `/subscription-billing-attempts/skip-order/${attemptId}`,
            method: 'PUT',
            params: { subscriptionContractId: contract },
          },
        ],
        { continueStatuses: [404, 405, 501], noCache: true }
      );
    }

    rescheduleDelivery(contractId, currentDate, newDate) {
      const contract = rawId(contractId);
      
      // Ensure newDate is formatted as ISO 8601 (with time and UTC timezone) e.g., 2026-06-27T12:00:00Z
      // We append T12:00:00.000Z directly to prevent the browser's local timezone offset from shifting the selected date.
      let nextBillingDateIso = newDate;
      if (newDate) {
        const dateMatch = newDate.match(/^(\d{4}-\d{2}-\d{2})/);
        if (dateMatch) {
          nextBillingDateIso = `${dateMatch[1]}T12:00:00.000Z`;
        } else if (!newDate.includes('T')) {
          try {
            const d = new Date(newDate + 'T00:00:00');
            if (!Number.isNaN(d.getTime())) {
              nextBillingDateIso = d.toISOString();
            }
          } catch (e) {
            console.warn('[Harvest Portal] Error formatting reschedule date:', e);
          }
        }
      }

      const params = {
        contractId: contract,
        billingDate: currentDate || '',
        deliveryDate: currentDate || '',
        nextBillingDate: nextBillingDateIso,
        newBillingDate: nextBillingDateIso,
        newDeliveryDate: nextBillingDateIso,
        rescheduleFutureOrder: true,
      };

      return this.requestCandidate(
        `rescheduleDelivery_${contract}`,
        [
          {
            path: '/subscription-contracts-update-billing-date',
            method: 'PUT',
            params,
          },
          {
            path: '/subscription-contracts-update-next-billing-date',
            method: 'PUT',
            params,
          },
          { path: '/subscription-contract-details/reschedule', method: 'POST', body: params },
          { path: '/subscription-contracts-reschedule', method: 'PUT', params },
          {
            path: '/subscription-contract-details/update-next-billing-date',
            method: 'POST',
            body: params,
          },
        ],
        { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
      );
    }

    applyDiscountCode(contractId, discountCode) {
      const contract = rawId(contractId);
      const code = String(discountCode || '').trim();
      const params = {
        contractId: contract,
        discountCode: code,
        isExternal: true,
      };
      const body = {
        contractId: contract,
        discountCode: code,
        isExternal: true,
      };
      return this.requestCandidate(
        `applyDiscountCode_${contract}`,
        [
          { path: '/subscription-contracts-apply-discount', method: 'PUT', params },
          { path: '/subscription-contracts-apply-discount', method: 'POST', params },
          { path: '/subscription-contracts-apply-discount', method: 'POST', body },
          { path: '/subscription-contract-details/apply-discount', method: 'PUT', params },
          { path: '/subscription-contract-details/apply-discount', method: 'POST', body },
        ],
        { continueStatuses: [404, 405, 501], noCache: true }
      );
    }

    removeDiscount(contractId, discountId) {
      const contract = rawId(contractId);
      const params = {
        contractId: contract,
        discountId,
        isExternal: true,
      };
      const body = {
        contractId: contract,
        discountId,
        isExternal: true,
      };
      return this.requestCandidate(
        `removeDiscount_${contract}`,
        [
          { path: '/subscription-contracts-remove-discount', method: 'PUT', params },
          { path: '/subscription-contracts-remove-discount', method: 'POST', params },
          { path: '/subscription-contracts-remove-discount', method: 'POST', body },
          { path: '/subscription-contract-details/remove-discount', method: 'PUT', params },
          { path: '/subscription-contract-details/remove-discount', method: 'POST', body },
        ],
        { continueStatuses: [404, 405, 501], noCache: true }
      );
    }

    updateOrderNote(contractId, deliveryDate, note) {
      const contract = rawId(contractId);
      
      let dateVal = deliveryDate || '';
      
      // Resilient param-shifting: if only two arguments are passed (contractId and note),
      // or if deliveryDate contains non-date characters (like spaces in "call before delivery")
      if (note === undefined && dateVal && (dateVal.includes(' ') || !/\d{4}[-/]\d{2}[-/]\d{2}/.test(dateVal))) {
        note = dateVal;
        dateVal = '';
      }
      
      // Fallback to today's date if deliveryDate is empty
      if (!dateVal) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        dateVal = `${yyyy}-${mm}-${dd}`;
      }

      // 1. Prepare exact targeted bodies with note and date keys to support both contract-level and order-level updates
      const noteBody = { 
        note: note,
        deliveryDate: dateVal,
        delivery_date: dateVal,
        date: dateVal
      };

      // 2. Prepare unified payload to support different expected key names across Appstle versions
      const unifiedPayload = {
        note: note,
        notes: note,
        orderNote: note,
        order_note: note,
        deliveryInstructions: note,
        delivery_instructions: note,
        contractId: contract,
        contract: contract,
        subscriptionContractId: contract,
        deliveryDate: dateVal,
        delivery_date: dateVal,
        date: dateVal
      };

      // 3. Prepare nested payload in case the endpoint expects a structured contract updates format
      const nestedPayload = {
        contract: {
          note: note,
          notes: note,
          orderNote: note,
          order_note: note,
          deliveryInstructions: note,
          delivery_instructions: note,
          deliveryDate: dateVal,
          delivery_date: dateVal,
          date: dateVal
        },
        contractId: contract,
        deliveryDate: dateVal,
        delivery_date: dateVal,
        date: dateVal
      };

      // Ensure that 'isExternal: true' is present in query params for ALL customer portal write requests.
      const queryParams = { 
        isExternal: true,
        deliveryDate: dateVal,
        delivery_date: dateVal,
        date: dateVal
      };
      const queryParamsWithContract = { 
        contractId: contract, 
        isExternal: true,
        deliveryDate: dateVal,
        delivery_date: dateVal,
        date: dateVal
      };
      
      const candidates = [
        // GROUP 0: Exact endpoint from production traffic (thehonestfarmer.ca)
        {
          path: `/update-contract-order-note/${contract}`,
          method: 'PUT',
          params: { orderNote: note, isExternal: true }
        },
        {
          path: `/update-contract-order-note/${contract}`,
          method: 'PUT',
          params: { order_note: note, isExternal: true }
        },
        {
          path: `/update-contract-order-note/${contract}`,
          method: 'PUT',
          params: { note: note, isExternal: true }
        },
        {
          path: `/update-contract-order-note/${contract}`,
          method: 'POST',
          params: { orderNote: note, isExternal: true }
        },

        // GROUP A: Direct RESTful contract updates on contract-external resource itself (Highly standard for REST)
        // Try with minimal, unified, and nested bodies to be fully compliant with Appstle schemas
        {
          path: `/subscription-contracts/contract-external/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: noteBody
        },
        {
          path: `/subscription-contracts/contract-external/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: unifiedPayload
        },
        {
          path: `/subscription-contracts/contract-external/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: nestedPayload
        },
        {
          path: `/subscription-contracts/contract-external/${contract}`,
          method: 'POST',
          params: queryParams,
          body: noteBody
        },
        {
          path: `/subscription-contracts/contract-external/${contract}`,
          method: 'POST',
          params: queryParams,
          body: unifiedPayload
        },

        // GROUP B: Details endpoints with slashes (Standard in latest Appstle customer portals)
        {
          path: '/subscription-contract-details/update-notes',
          method: 'PUT',
          params: queryParamsWithContract,
          body: noteBody
        },
        {
          path: '/subscription-contract-details/update-notes',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-notes',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-order-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-order-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-delivery-instructions',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contract-details/update-delivery-instructions',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },

        // GROUP C: Flat dashed endpoints (Legacy Appstle customer portal endpoints)
        {
          path: '/subscription-contracts-update-notes',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-notes',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-order-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-order-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-delivery-instructions',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts-update-delivery-instructions',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },

        // GROUP D: Standard slashed endpoints under subscription-contracts
        {
          path: '/subscription-contracts/update-notes',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-notes',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-order-note',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-order-note',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-delivery-instructions',
          method: 'PUT',
          params: queryParamsWithContract,
          body: unifiedPayload
        },
        {
          path: '/subscription-contracts/update-delivery-instructions',
          method: 'POST',
          params: queryParamsWithContract,
          body: unifiedPayload
        },

        // GROUP E: Slashed endpoints on contract (without external)
        {
          path: `/subscription-contracts/contract/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: unifiedPayload
        },
        {
          path: `/subscription-contracts/contract/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: nestedPayload
        },
        {
          path: `/subscription-contracts/contract/${contract}`,
          method: 'POST',
          params: queryParams,
          body: unifiedPayload
        },
        {
          path: `/subscription-contracts/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: unifiedPayload
        },
        {
          path: `/subscription-contracts/${contract}`,
          method: 'PUT',
          params: queryParams,
          body: nestedPayload
        },
        {
          path: `/subscription-contracts/${contract}`,
          method: 'POST',
          params: queryParams,
          body: unifiedPayload
        }
      ];

      return this.requestCandidate(
        `orderNote_${contract}`,
        candidates,
        { 
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          noCache: true,
          strictValidate: true,
          validate: (payload) => {
            // Verify that the candidate returned a payload that is NOT a false-positive success.
            // If the payload contains a note-related field but its value mismatch, skip it!
            if (payload && typeof payload === 'object') {
              const noteKeys = ['note', 'notes', 'orderNote', 'order_note', 'deliveryInstructions', 'delivery_instructions'];
              
              let foundAny = false;
              let matched = false;
              
              for (const key of noteKeys) {
                if (key in payload && typeof payload[key] === 'string') {
                  foundAny = true;
                  if (payload[key] === note) {
                    matched = true;
                  }
                }
              }
              
              if (payload.contract && typeof payload.contract === 'object') {
                for (const key of noteKeys) {
                  if (key in payload.contract && typeof payload.contract[key] === 'string') {
                    foundAny = true;
                    if (payload.contract[key] === note) {
                      matched = true;
                    }
                  }
                }
              }
              
              // If we found some note field, but none matched the new value, then this candidate 
              // is a false-positive (e.g. standard GET response, or ignored PUT payload).
              if (foundAny && !matched) {
                console.warn(`[Harvest Portal] Candidate returned success but note was NOT updated in payload. Expected: "${note}". Skipping this candidate...`);
                return false;
              }
            }
            return true;
          }
        }
      );
    }

    async removeLineItem(contractId, product, isOneTime = false) {
      const contract = rawId(contractId);
      const lineId = getLineId(product);
      const variantId = getVariantId(product);
      const shopDomain = getShopDomain();
      
      let bAttemptId = product?.billingAttemptId || '';
      if (isOneTime && !bAttemptId) {
        try {
          bAttemptId = await this.seekBillingAttemptId(contract);
        } catch (e) {
          console.warn('Error seeking billingAttemptId in removeLineItem:', e);
        }
      }
      const bAttemptIdNum = bAttemptId ? (Number(String(bAttemptId).split('/').pop()) || 0) : 0;

      // Construct clean, spec-compliant candidates for different endpoints
      const recurringCandidates = [];

      if (lineId) {
        // 1. PUT on remove-line-item with GID lineId
        recurringCandidates.push({
          path: '/subscription-contracts-remove-line-item',
          method: 'PUT',
          params: {
            contractId: contract,
            lineId: lineId,
            removeDiscount: true,
            shop: shopDomain,
          }
        });

        // 2. PUT on remove-line-item with numeric rawId
        const rawLine = rawId(lineId);
        if (rawLine !== lineId) {
          recurringCandidates.push({
            path: '/subscription-contracts-remove-line-item',
            method: 'PUT',
            params: {
              contractId: contract,
              lineId: rawLine,
              removeDiscount: true,
              shop: shopDomain,
            }
          });
        }

        // 3. PUT on update-line-item-quantity with GID lineId and quantity 0
        recurringCandidates.push({
          path: '/subscription-contracts-update-line-item-quantity',
          method: 'PUT',
          params: {
            contractId: contract,
            lineId: lineId,
            quantity: 0,
            variantId: rawId(variantId),
            shop: shopDomain,
          }
        });

        // 4. PUT on update-line-item-quantity with numeric rawId and quantity 0
        if (rawLine !== lineId) {
          recurringCandidates.push({
            path: '/subscription-contracts-update-line-item-quantity',
            method: 'PUT',
            params: {
              contractId: contract,
              lineId: rawLine,
              quantity: 0,
              variantId: rawId(variantId),
              shop: shopDomain,
            }
          });
        }
      }

      const oneTimeCandidates = [];

      // DELETE on /subscription-contract-one-offs-by-contractId-and-billing-attempt-id
      // Needs raw numeric IDs for contractId, billingAttemptId, and variantId.
      oneTimeCandidates.push({
        path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
        method: 'DELETE',
        params: {
          contractId: contract,
          billingAttemptId: bAttemptIdNum || undefined,
          variantId: rawId(variantId),
          shop: shopDomain,
        }
      });

      return this.requestCandidate(
        `${isOneTime ? 'removeOneTimeProduct' : 'removeRecurringProduct'}_${contract}`,
        isOneTime ? oneTimeCandidates : recurringCandidates,
        { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503], noCache: true }
      );
    }

    async skipLineItemForNextOrder(contractId, product) {
      const contract = rawId(contractId);
      const lineId = getLineId(product);

      if (!contract || !lineId) {
        throw new Error('Harvest item was not found.');
      }

      return this.requestCandidate(
        `skipProductNextOrder_${contract}_${rawId(lineId) || lineId}`,
        [{
          path: '/skip-unskip-subscription-contracts-product',
          method: 'PUT',
          params: {
            contractId: contract,
            lineId: String(lineId),
            isSkip: true,
          }
        }],
        {
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          noCache: true
        }
      );
    }

    async unskipLineItemForNextOrder(contractId, product) {
      const contract = rawId(contractId);
      const lineId = getLineId(product);

      if (!contract || !lineId) {
        throw new Error('Harvest item was not found.');
      }

      return this.requestCandidate(
        `unskipProductNextOrder_${contract}_${rawId(lineId) || lineId}`,
        [{
          path: '/skip-unskip-subscription-contracts-product',
          method: 'PUT',
          params: {
            contractId: contract,
            lineId: String(lineId),
            isSkip: false,
          }
        }],
        {
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          noCache: true
        }
      );
    }

    async seekBillingAttemptId(contractId, deliveryDate) {
      const contract = rawId(contractId);
      const targetDate = toDateInputValue(deliveryDate);
      
      const findBillingAttemptIdInObject = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        
        if (Array.isArray(obj)) {
          for (const item of obj) {
            const found = findBillingAttemptIdInObject(item);
            if (found) return found;
          }
          return null;
        }
        
        const keys = Object.keys(obj);
        for (const k of keys) {
          const lowerK = k.toLowerCase();
          if (
            lowerK === 'billingattemptid' ||
            lowerK === 'billing_attempt_id' ||
            lowerK === 'shopifybillingattemptid' ||
            lowerK === 'shopify_billing_attempt_id'
          ) {
            const val = obj[k];
            if (val && val !== '0' && val !== 0 && val !== 'null' && val !== 'undefined') {
              return String(val);
            }
          }
        }

        // Check if this object represents a billing attempt itself (has specific attempt indicators)
        const hasAttemptIndicator = keys.some(k => {
          const lk = k.toLowerCase();
          return (
            lk === 'attempttime' ||
            lk === 'attemptcount' ||
            lk === 'orderdisplayfinancialstatus' ||
            lk === 'shopifybillingattemptid' ||
            lk === 'billingattemptid' ||
            lk === 'billing_attempt_id' ||
            lk === 'billingcyclenumber'
          );
        });
        if (hasAttemptIndicator && obj.id) {
          const idStr = String(obj.id);
          if (idStr && idStr !== '0' && idStr !== 'null' && idStr !== 'undefined' && !idStr.includes('SubscriptionContract')) {
            return idStr;
          }
        }
        
        for (const k of keys) {
          const val = obj[k];
          if (val && typeof val === 'string' && val.includes('SubscriptionBillingAttempt')) {
            const match = val.match(/gid:\/\/shopify\/SubscriptionBillingAttempt\/\d+/);
            if (match) return match[0];
            const matchNumeric = val.match(/SubscriptionBillingAttempt\/(\d+)/);
            if (matchNumeric) return `gid://shopify/SubscriptionBillingAttempt/${matchNumeric[1]}`;
          }
          if (val && typeof val === 'object') {
            const found = findBillingAttemptIdInObject(val);
            if (found) return found;
          }
        }
        return null;
      };

      const findBillingAttemptIdForDate = (obj) => {
        if (!obj || typeof obj !== 'object' || !targetDate) return null;

        if (Array.isArray(obj)) {
          for (const item of obj) {
            const found = findBillingAttemptIdForDate(item);
            if (found) return found;
          }
          return null;
        }

        const itemDate = firstValue(obj, [
          'deliveryDate',
          'scheduledDate',
          'billingDate',
          'nextBillingDate',
          'orderDate',
          'date',
          'node.deliveryDate',
          'node.scheduledDate',
          'node.billingDate',
          'node.nextBillingDate',
          'node.orderDate',
          'node.date',
        ]);

        if (toDateInputValue(itemDate) === targetDate) {
          const matchingId = extractBillingAttemptId(obj) || findBillingAttemptIdInObject(obj);
          if (matchingId) return matchingId;
        }

        for (const key of Object.keys(obj)) {
          const val = obj[key];
          if (val && typeof val === 'object') {
            const found = findBillingAttemptIdForDate(val);
            if (found) return found;
          }
        }

        return null;
      };

      // 1. Prefer the schedule record matching the clicked delivery date.
      try {
        const schedResult = await this.getSchedules(contract);
        if (schedResult && schedResult.payload) {
          const datedBid = findBillingAttemptIdForDate(schedResult.payload);
          if (datedBid) return datedBid;

          const bid = findBillingAttemptIdInObject(schedResult.payload);
          if (bid) return bid;
        }
      } catch (e) {
        console.warn('Error fetching schedules for billingAttemptId:', e);
      }

      // 2. Try from already loaded state/portal one-time products
      try {
        const portal = window.harvestPortal || window.portal;
        if (portal && portal.contracts) {
          const matchedContract = portal.contracts.find(c => rawId(c.id) === contract);
          if (matchedContract && matchedContract.oneTimeProducts) {
            for (const item of matchedContract.oneTimeProducts) {
              const bid = findBillingAttemptIdInObject(item);
              if (bid) return bid;
            }
          }
        }
      } catch (e) {
        console.warn('Error reading from state oneTimeProducts:', e);
      }

      // 3. Try fetching one-time products directly to scan recursively
      try {
        const oneTimePayload = await this.getOneTimeProducts(contract);
        if (oneTimePayload) {
          const bid = findBillingAttemptIdInObject(oneTimePayload);
          if (bid) return bid;
        }
      } catch (e) {
        console.warn('Error fetching oneTimePayload for billingAttemptId:', e);
      }

      // 4. Try fetching history as fallback
      try {
        const histResult = await this.getHistory(contract);
        if (histResult && histResult.payload) {
          const bid = findBillingAttemptIdInObject(histResult.payload);
          if (bid) return bid;
        }
      } catch (e) {
        console.warn('Error fetching history for billingAttemptId:', e);
      }

      return '';
    }

    async addOneTimeProduct(contractId, variantId, quantity, deliveryDate) {
      const contract = rawId(contractId);
      const variant = rawId(variantId);
      const count = Number(quantity) || 1;
      const isNumeric = /^\d+$/.test(String(variant));
      const parsedVariant = isNumeric ? Number(variant) : variant;

      // Find a billing attempt ID using our robust async function
      let bAttemptIdRaw = '';
      try {
        bAttemptIdRaw = await this.seekBillingAttemptId(contract);
      } catch (e) {
        console.warn('Error seeking billingAttemptId:', e);
      }

      const bAttemptIdNum = bAttemptIdRaw ? Number(bAttemptIdRaw.split('/').pop()) || 0 : 0;
      const bAttemptIdGid = bAttemptIdRaw.startsWith('gid://') ? bAttemptIdRaw : (bAttemptIdNum ? `gid://shopify/SubscriptionBillingAttempt/${bAttemptIdNum}` : '');

      const shopDomain = getShopDomain();

      // Find variant details from catalogs to enrich the body
      let variantHandleValue = '';
      let priceValueValue = 0;
      try {
        const portal = window.harvestPortal || window.portal;
        if (portal) {
          const sourceProducts = [
            ...SYSTEM_PRODUCTS,
            ...portal.contracts.flatMap((c) => [
              ...getContractLines(c),
              ...(c.oneTimeProducts || []),
            ]),
          ];
          for (const prod of sourceProducts) {
            if (rawId(getVariantId(prod)) === rawId(variantId)) {
              priceValueValue = getProductPrice(prod);
              variantHandleValue = prod?.variant?.handle || prod?.handle || '';
              break;
            }
          }
        }
      } catch (err) {
        console.warn('Error reading variant details:', err);
      }

      const contractGid = `gid://shopify/SubscriptionContract/${contract}`;
      const variantGid = `gid://shopify/ProductVariant/${variant}`;

      const rawContract = Number(contract);
      const numVariant = parsedVariant;
      const rawVariant = String(variant);
      const gidVariant = variantGid;

      // Query parameter variations for V2 storefront APIs
      const paramsRawNum = {
        contractId: rawContract,
        variantId: numVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      const paramsRawStr = {
        contractId: rawContract,
        variantId: rawVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      const paramsGid = {
        contractId: rawContract,
        variantId: gidVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      // Request body variations for V2 storefront APIs
      const bodyRawNum = {
        contractId: rawContract,
        variantId: numVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      const bodyRawStr = {
        contractId: rawContract,
        variantId: rawVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      const bodyGid = {
        contractId: rawContract,
        variantId: gidVariant,
        quantity: count,
        isOneTimeProduct: true,
        shop: shopDomain,
      };

      console.log('[Harvest Portal] Attempting addOneTimeProduct candidates with values:', {
        contract,
        variant,
        count,
        bAttemptIdRaw,
        bAttemptIdNum,
        bAttemptIdGid,
        priceValueValue,
        variantHandleValue
      });

      const formattedDeliveryDate = toDateInputValue(deliveryDate);

      const candidates = [
        // --- GROUP 00: V2 Singular Storefront Endpoint (Primary) ---
        // 1. PUT with query parameters
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid },

        // 2. PUT with JSON request body
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyGid },

        // 3. PUT with both query params and JSON request body
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum, body: bodyRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr, body: bodyRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid, body: bodyGid },

        // 4. POST with query parameters
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid },

        // 5. POST with JSON request body
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyGid },

        // 6. POST with both query params and JSON request body
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum, body: bodyRawNum },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr, body: bodyRawStr },
        { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid, body: bodyGid },

        // --- GROUP 0: Standard Storefront API subscription-contract-one-offs-by-contractId-and-billing-attempt-id ---
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: {
            shop: shopDomain,
            contractId: contract,
            billingAttemptId: bAttemptIdNum || undefined,
            variantId: parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            deliveryDate: formattedDeliveryDate,
            billingDate: formattedDeliveryDate,
          }
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'POST',
          params: {
            shop: shopDomain,
            contractId: contract,
            billingAttemptId: bAttemptIdNum || undefined,
            variantId: parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            deliveryDate: formattedDeliveryDate,
            billingDate: formattedDeliveryDate,
          }
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'POST',
          body: {
            shop: shopDomain,
            contractId: contract,
            billingAttemptId: bAttemptIdNum || undefined,
            variantId: parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            deliveryDate: formattedDeliveryDate,
            billingDate: formattedDeliveryDate,
          }
        },

        // --- GROUP 1: Standard named API operations (High Probability) ---
        {
          path: '/upcoming-subscription-contract-one-offs-create',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: formattedDeliveryDate,
            deliveryDate: formattedDeliveryDate,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-create',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
            variants: { [parsedVariant]: count },
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-create',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-add',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-add',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
          }
        },
        {
          path: '/subscription-contracts-add-one-off',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
          }
        },
        {
          path: '/subscription-contract-one-offs-create',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },
        {
          path: '/subscription-contract-details/add-one-off',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
          }
        },
        {
          path: '/subscription-contract-details/add-product',
          method: 'POST',
          body: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
          }
        },

        // --- GROUP 2: POST on upcoming-subscription-contract-one-offs-by-contractId ---
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'POST',
          body: {
            shop: shopDomain,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            quantity: count,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              quantity: count,
              variantHandle: variantHandleValue || '',
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              quantity: count,
              variantHandle: variantHandleValue || '',
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'POST',
          body: {
            shop: shopDomain,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            quantity: count,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs-by-contractId',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
          }
        },

        // --- GROUP 3: PUT/POST with billingAttemptId on subscription-contract-one-offs-by-contractId-and-billing-attempt-id ---
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: {
            contractId: contract,
            subscriptionContractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingAttemptId: bAttemptIdNum || undefined,
          }
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: { quantity: count },
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdGid || undefined,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: { quantity: count },
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdGid || undefined,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: { quantity: count },
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdNum || undefined,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
          method: 'PUT',
          params: { quantity: count },
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdNum || undefined,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },

        // --- GROUP 4: POST/PUT on /upcoming-subscription-contract-one-offs (GET only mostly, so fallback bottom) ---
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'POST',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdGid || undefined,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdGid || undefined,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'POST',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdNum || undefined,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdNum || undefined,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'PUT',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdGid || undefined,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'PUT',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdGid || undefined,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'PUT',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdNum || undefined,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'PUT',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdNum || undefined,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/upcoming-subscription-contract-one-offs',
          method: 'PUT',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },

        // --- GROUP 5: /subscription-contract-one-offs (PUT and POST) ---
        {
          path: '/subscription-contract-one-offs',
          method: 'POST',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdGid || undefined,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdGid || undefined,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'POST',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdNum || undefined,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'POST',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdNum || undefined,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'POST',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'PUT',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdGid || undefined,
            subscriptionContractId: contractGid,
            variantId: variantGid,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'PUT',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdGid || undefined,
              subscriptionContractId: contractGid,
              variantId: variantGid,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'PUT',
          body: {
            shop: shopDomain,
            billingAttemptId: bAttemptIdNum || undefined,
            subscriptionContractId: Number(contract) || contract,
            variantId: Number(parsedVariant) || parsedVariant,
            variantHandle: variantHandleValue || '',
            quantity: count,
            price: priceValueValue,
          }
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'PUT',
          body: [
            {
              shop: shopDomain,
              billingAttemptId: bAttemptIdNum || undefined,
              subscriptionContractId: Number(contract) || contract,
              variantId: Number(parsedVariant) || parsedVariant,
              variantHandle: variantHandleValue || '',
              quantity: count,
              price: priceValueValue,
            }
          ]
        },
        {
          path: '/subscription-contract-one-offs',
          method: 'PUT',
          params: {
            contractId: contract,
            variantId: parsedVariant,
            quantity: count,
            billingDate: deliveryDate || '',
            deliveryDate: deliveryDate || '',
          }
        }
      ];

      return this.requestCandidate(
        `addOneTimeProduct_${contract}`,
        enrichCandidatesWithExternal(candidates),
        {
          optional: false,
          continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
          noCache: true,
          strictValidate: true,
          validate: (payload) => {
            const contractObj = extractContractFromObject(payload);
            if (contractObj) {
              const lines = getContractLines(contractObj);
              if (Array.isArray(lines) && lines.some(line => rawId(getVariantId(line)) === rawId(variant))) {
                return true;
              }
              if (contractObj.oneTimeProducts && Array.isArray(contractObj.oneTimeProducts)) {
                if (contractObj.oneTimeProducts.some(otp => rawId(getVariantId(otp)) === rawId(variant))) {
                  return true;
                }
              }
            }
            if (Array.isArray(payload)) {
              if (payload.some(otp => rawId(getVariantId(otp)) === rawId(variant))) {
                return true;
              }
            }
            return false;
          }
        }
      );
    }
  }

  class HarvestPortal {
    constructor(root) {
      this.root = root;
      this.customerId = root.dataset.customerId || '';
      this.api = new HarvestApiService({
        baseUrl: '/apps/subscriptions/cp/api',
        customerId: this.customerId,
      });
      this.customer = null;
      this.contracts = [];
      this.noticeTimer = null;
      this.lastFocusedElement = null;
      this.state = {
        loading: false,
        error: '',
        notice: null,
        view: 'list',
        selectedContractId: null,
        activeTab: 'upcoming',
        sortKey: 'id',
        sortDirection: 'desc',
        pendingLines: new Set(),
        couponBusy: null,
        tabData: {
          schedules: {},
          history: {},
        },
        tabLoading: {},
        tabErrors: {},
        historyPages: {},
        productCatalogMode: 'recurring',
        productSearchQuery: '',
        listFilter: 'active',
        contractFilterConfig: 'all',
        isBuildABoxModalOpen: false,
        isSwapModalOpen: false,
      };

      this.root.classList.add('harvest-portal');
      this.hideLegacyModal();
      this.createModalRoot();
      this.bindEvents();
      this.init();
    }

    async init() {
      if (!this.customerId) {
        this.renderLoggedOut();
        return;
      }

      await this.loadPortalData({ showLoading: true });
    }

    async resolveVariantId(variantId) {
      if (!variantId) return variantId;
      
      const product = SYSTEM_PRODUCTS.find(p => 
        rawId(getAddableVariantId(p) || getVariantId(p)) === rawId(variantId) || 
        rawId(p.productId || p.product_id) === rawId(variantId)
      );
      if (!product) {
        console.log(`[Harvest Portal] Product not found in catalog for variant/product ID ${variantId}`);
        return variantId;
      }

      const handle = product.handle;
      const productId = getCatalogProductId(product);
      const catalogVariantId = getAddableVariantId(product);
      if (catalogVariantId && rawId(catalogVariantId) !== rawId(variantId)) {
        console.log(`[Harvest Portal] Resolved ${variantId} to catalog Variant ID ${catalogVariantId}`);
        return String(catalogVariantId);
      }
      
      if (!handle) {
        console.warn(`[Harvest Portal] Product handle not found for variant/product ID ${variantId}, unable to resolve`);
        return variantId;
      }

      const isProductIdFallback = String(rawId(productId)) === String(rawId(variantId));
      if (!isProductIdFallback) {
        return variantId;
      }

      // 1. First, search in SYSTEM_PRODUCTS for any other entry that has matching productId and a different variantId
      const matchingVariantInCatalog = SYSTEM_PRODUCTS.find(p => 
        rawId(getCatalogProductId(p)) === rawId(productId) && 
        rawId(getAddableVariantId(p)) !== rawId(productId) && 
        getAddableVariantId(p)
      );
      if (matchingVariantInCatalog) {
        const foundVarId = getAddableVariantId(matchingVariantInCatalog);
        console.log(`[Harvest Portal] Found matching variant in SYSTEM_PRODUCTS: ${foundVarId}`);
        return String(foundVarId);
      }

      // 2. Try the primary endpoint /products/${handle}.js
      try {
        console.log(`[Harvest Portal] Resolving Variant ID for Product ID ${productId} (${handle})`);
        const response = await fetch(`/products/${handle}.js`);
        if (response.ok) {
          const productJson = await response.json();
          if (productJson && Array.isArray(productJson.variants) && productJson.variants.length > 0) {
            const firstVariantId = productJson.variants[0].id;
            console.log(`[Harvest Portal] Successfully resolved Product ID ${productId} to Variant ID ${firstVariantId}`);
            return String(firstVariantId);
          }
        } else {
          console.warn(`[Harvest Portal] Failed fetching Shopify product details for ${handle}: status ${response.status}`);
        }
      } catch (err) {
        console.warn(`[Harvest Portal] Error resolving variant ID for product ${variantId}:`, err);
      }

      // 2.5 Dynamic search suggestion fallback to get the correct handle or extract variant ID from URL
      const fetchVariantIdByHandle = async (h) => {
        if (!h) return null;
        try {
          const res = await fetch(`/products/${h}.js`);
          if (res.ok) {
            const json = await res.json();
            if (json && Array.isArray(json.variants) && json.variants.length > 0) {
              return String(json.variants[0].id);
            }
          }
        } catch (e) {
          console.warn(`[Harvest Portal] Failed fetching variant ID by handle ${h}:`, e);
        }
        return null;
      };

      const suggestUrls = [
        `/search/suggest.json?q=${productId}&resources[type]=product`,
        `/search/suggest.json?q=${encodeURIComponent(product.title || '')}&resources[type]=product`,
        `/search/suggest.json?q=${encodeURIComponent(handle)}&resources[type]=product`
      ];

      for (const sUrl of suggestUrls) {
        try {
          console.log(`[Harvest Portal] Trying suggest URL fallback to resolve Variant ID: ${sUrl}`);
          const resp = await fetch(sUrl);
          if (resp.ok) {
            const json = await resp.json();
            const suggestions = json?.resources?.results?.products || [];
            const matchedSug = suggestions.find(s => 
              rawId(s.id) === rawId(productId) || 
              String(s.title).toLowerCase() === String(product.title).toLowerCase() ||
              (s.handle && s.handle === handle)
            );
            
            if (matchedSug) {
              if (matchedSug.url) {
                const urlMatch = matchedSug.url.match(/[?&]variant=(\d+)/);
                if (urlMatch) {
                  const foundId = urlMatch[1];
                  console.log(`[Harvest Portal] Successfully resolved variant ID directly from suggestion URL: ${foundId}`);
                  return String(foundId);
                }
              }
              if (matchedSug.handle) {
                const foundId = await fetchVariantIdByHandle(matchedSug.handle);
                if (foundId) {
                  console.log(`[Harvest Portal] Successfully resolved variant ID from suggested handle ${matchedSug.handle}: ${foundId}`);
                  return foundId;
                }
              }
            }
          }
        } catch (e) {
          console.warn(`[Harvest Portal] Suggest URL check failed: ${sUrl}`, e);
        }
      }

      // 3. Robust Fallbacks: Loop over secondary and tertiary candidates to query and extract the variant
      const fallbackUrls = [
        `/products/${handle}.json`,
        `/search/suggest.json?q=${encodeURIComponent(handle)}&resources[type]=product`,
        `/search/suggest.json?q=${encodeURIComponent(product.title || '')}&resources[type]=product`,
        `/search/suggest.json?q=${productId}&resources[type]=product`,
        `/products.json?limit=250`,
        `/collections/all/products.json?limit=250`
      ];

      for (const url of fallbackUrls) {
        try {
          console.log(`[Harvest Portal] Trying fallback URL to resolve Variant ID: ${url}`);
          const response = await fetch(url);
          if (response.ok) {
            const json = await response.json();
            const items = extractProductsList(json);
            const matched = items.find(item => 
              (rawId(getCatalogProductId(item)) === rawId(productId) || (item.handle && item.handle === handle)) && 
              rawId(getAddableVariantId(item)) !== rawId(productId) && 
              getAddableVariantId(item)
            );
            if (matched) {
              const foundVarId = getAddableVariantId(matched);
              console.log(`[Harvest Portal] Successfully resolved Product ID ${productId} to Variant ID ${foundVarId} via fallback ${url}`);
              return String(foundVarId);
            }
          }
        } catch (fallbackErr) {
          console.warn(`[Harvest Portal] Fallback URL failed: ${url}`, fallbackErr);
        }
      }

      return variantId;
    }

    bindEvents() {
      this.root.addEventListener('click', (event) => this.handleClick(event), true);
      this.root.addEventListener('change', (event) => this.handleChange(event));
      this.modalRoot.addEventListener('click', (event) => this.handleModalClick(event));

      this.modalRoot.addEventListener('input', (event) => {
        if (event.target.id === 'catalog-search') {
          this.state.productSearchQuery = event.target.value;
          if (this.state.isBuildABoxModalOpen) {
            this.updateBuildABoxModalContent();
          } else if (this.state.isSwapModalOpen) {
            this.updateSwapModalContent();
          }
        }
      });

      this.modalRoot.addEventListener('change', (event) => {
        if (event.target.id === 'catalog-tag-select') {
          this.state.selectedCategory = event.target.value;
          if (this.state.isBuildABoxModalOpen) {
            this.updateBuildABoxModalContent();
          } else if (this.state.isSwapModalOpen) {
            this.updateSwapModalContent();
          }
        }
      });

      this.root.addEventListener('submit', async (event) => {
        if (event.target.id === 'harvest-shipping-form') {
          event.preventDefault();
          const form = event.target;
          const contractId = form.dataset.contractId;
          const saveBtn = document.getElementById('save-settings-btn');
          if (saveBtn) {
            saveBtn.disabled = true;
            saveBtn.innerText = 'Saving changes...';
          }

          try {
            const address = {
              address1: form.querySelector('#address1')?.value || '',
              city: form.querySelector('#city')?.value || '',
              province: form.querySelector('#province')?.value || '',
              zip: form.querySelector('#zip')?.value || '',
              country: form.querySelector('#country')?.value || 'United States',
              phone: form.querySelector('#phone')?.value || '',
            };
            const deliveryWindow = form.querySelector('#delivery_window')?.value || '';
            const deliveryInstructions = form.querySelector('#delivery_instructions')?.value || '';

            // Update shipping address via API
            await this.api.updateShippingAddress(contractId, address);

            // Update order note / delivery instructions only if they changed
            const contractObj = this.findContract(contractId);
            const oldInstructions = contractObj ? (contractObj.deliveryInstructions || '') : '';
            if (deliveryInstructions !== oldInstructions) {
              const nextDate = contractObj ? (getNextDeliveryDate(contractObj) || getNextPaymentDate(contractObj)) : '';
              await this.api.updateOrderNote(contractId, nextDate, deliveryInstructions);
            }

            // Update state copies
            const contract = this.findContract(contractId);
            if (contract) {
              contract.shippingAddress = address;
              contract.deliveryWindow = deliveryWindow;
              contract.deliveryInstructions = deliveryInstructions;
            }

            this.setNotice('Delivery preferences and address updated successfully!', 'success');
            await this.loadPortalData({ showLoading: false });
          } catch (err) {
            this.setNotice(userFacingError(err, 'Failed to save settings.'), 'error');
            this.render();
          }
        } else if (event.target.classList.contains('harvest-discount-form')) {
          event.preventDefault();
          await this.applyCoupon(event.target);
        }
      });

      // Track typing dynamically on the search box to filter catalog items live
      this.root.addEventListener('input', (event) => {
        if (event.target.id === 'catalog-search') {
          this.state.productSearchQuery = event.target.value;
          this.render();
          const input = document.getElementById('catalog-search');
          if (input) {
            input.focus();
            // Retain cursor location by re-triggering string allocation
            const val = input.value;
            input.value = '';
            input.value = val;
          }
        }
      });

      window.addEventListener('hashchange', () => {
        this.applyRoute();
        this.render();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.modalRoot.hidden) {
          this.closeModal();
        }
      });
    }

    async loadPortalData(options = {}) {
      try {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && (key.startsWith('harvest_local_one_time_products_') || key.startsWith('harvest_local_recurring_products_'))) {
            localStorage.removeItem(key);
            i--;
          }
        }
      } catch (err) {
        console.warn('[Harvest Portal] Error cleaning up local storage:', err);
      }

      const showLoading = options.showLoading !== false;
      if (showLoading) {
        this.state.loading = true;
        this.state.error = '';
        this.render();
      }

      try {
        const payload = await this.api.getSubscriptionCustomer();
        const customer = extractCustomer(payload);
        const contracts = getConnectionItems(customer?.subscriptionContracts);

        await Promise.all(
          contracts.map(async (contract) => {
            const status = normalizeStatus(contract.status);
            if (status !== 'ACTIVE' && status !== 'PAUSED') {
              contract.oneTimeProducts = [];
              return;
            }

            // First fetch the full contract details to override any incomplete data (like from valid/ endpoint or 5-product limit)
            try {
              const detailedPayload = await this.api.getSubscriptionContract(contract.id);
              const detailedContract = extractContractFromObject(detailedPayload);
              if (detailedContract) {
                // Merge detailedContract properties into the contract object
                Object.assign(contract, detailedContract);
              } else {
                console.warn(`[Harvest Portal] Single contract fetch did not return a valid contract structure for ID: ${contract.id}`, detailedPayload);
              }
            } catch (error) {
              console.warn(`[Harvest Portal] Failed to fetch full contract details for ID: ${contract.id}`, error);
            }

            try {
              const oneTimePayload = await this.api.getOneTimeProducts(contract.id);
              contract.oneTimeProducts = extractOneTimeProducts(oneTimePayload);
            } catch (error) {
              console.warn('Unable to load one-time products:', error);
              contract.oneTimeProducts = [];
            }
          })
        );

        // Try to fetch all subscription products to populate SYSTEM_PRODUCTS
        let sysProds = null;
        let extracted = [];
        try {
          const firstContract = contracts.find(c => normalizeStatus(c.status) === 'ACTIVE' || normalizeStatus(c.status) === 'PAUSED');
          const firstContractId = firstContract ? firstContract.id : '';
          sysProds = await this.api.getSubscriptionProducts(firstContractId);
          if (sysProds) {
            extracted = extractProductsList(sysProds);
          }
        } catch (error) {
          console.warn('[Harvest Portal] Could not fetch products from Appstle /data/subscription-products:', error);
        }

        // Appstle can return a valid catalogue whose image field is Shopify's default
        // placeholder. Keep Appstle as the source of product eligibility and pricing,
        // but enrich only missing media from the matching Shopify variant.
        const needsImageEnrichment = extracted.length > 0 && extracted.some(
          (product) => !getUsableProductImage(product)
        );

        // Robust Fallback: If Appstle products are unavailable, or their product media
        // is unavailable, fetch Shopify Storefront using relative/absolute endpoints.
        if (extracted.length === 0 || needsImageEnrichment) {
          const shopDomain = getShopDomain();
          const storefrontCandidates = [
            '/collections/all/products.json?limit=250',
            '/products.json?limit=250',
            '/search/suggest.json?q=*&resources[type]=product&resources[limit]=250',
            `/search/suggest.json?q=&resources[type]=product&resources[limit]=250`,
            `https://${shopDomain}/collections/all/products.json?limit=250`,
            `https://${shopDomain}/products.json?limit=250`,
            `https://${shopDomain}/search/suggest.json?q=*&resources[type]=product&resources[limit]=250`
          ];

          for (const url of storefrontCandidates) {
            try {
              const shResponse = await fetch(url);
              if (shResponse.ok) {
                const shJson = await shResponse.json();
                const candExtracted = extractProductsList(shJson);
                if (candExtracted && candExtracted.length > 0) {
                  if (extracted.length === 0) {
                    extracted = candExtracted;
                    break;
                  }

                  const missingBefore = extracted.filter(
                    (product) => !getUsableProductImage(product)
                  ).length;
                  extracted = mergeProductImages(extracted, candExtracted);
                  const missingAfter = extracted.filter(
                    (product) => !getUsableProductImage(product)
                  ).length;

                  if (missingAfter < missingBefore) {
                    break;
                  }
                }
              }
            } catch (shErr) {
              console.warn(`[Harvest Portal] Storefront fetch candidate failed: ${url}`, shErr);
            }
          }
        }

        if (extracted && extracted.length > 0) {
          SYSTEM_PRODUCTS.length = 0;
          SYSTEM_PRODUCTS.push(...extracted);
        }

        // Whitelist SYSTEM_PRODUCTS against Shopify storefront (only published products have storefront handles)
        if (SYSTEM_PRODUCTS.length > 0) {
          const shopDomain = getShopDomain();
          const storefrontCatalogs = [
            '/collections/all/products.json?limit=250',
            '/products.json?limit=250',
            `https://${shopDomain}/collections/all/products.json?limit=250`,
            `https://${shopDomain}/products.json?limit=250`,
          ];
          for (const url of storefrontCatalogs) {
            try {
              const sfResp = await fetch(url);
              if (sfResp.ok) {
                const sfJson = await sfResp.json();
                const sfProducts = extractProductsList(sfJson);
                if (sfProducts && sfProducts.length > 0) {
                  const publishedHandles = new Set(sfProducts.map(p => p.handle).filter(Boolean));
                  const before = SYSTEM_PRODUCTS.length;
                  const filtered = SYSTEM_PRODUCTS.filter(p => p.handle && publishedHandles.has(p.handle));
                  SYSTEM_PRODUCTS.length = 0;
                  SYSTEM_PRODUCTS.push(...filtered);
                  const removed = before - SYSTEM_PRODUCTS.length;
                  if (removed > 0) {
                    console.log(`[Harvest Portal] Filtered out ${removed} non-published products from catalog via storefront whitelist`);
                  }
                  break;
                }
              }
            } catch (sfErr) {
              console.warn('[Harvest Portal] Storefront whitelist fetch failed:', sfErr);
            }
          }
        }

        console.log('[Harvest Portal Inspection] Fetched contracts and products JSON:', {
          shop: getShopDomain(),
          contracts: contracts.map(c => ({
            id: c.id,
            status: c.status,
            contractDiscounts: getConnectionItems(c.discounts),
            lineDiscounts: getConnectionItems(c.lines).map(line => ({
              id: line?.id,
              discounts: getConnectionItems(line?.discounts),
            })),
            recurringLines: getContractLines(c),
            oneTimeProducts: c.oneTimeProducts
          })),
          catalogProducts: SYSTEM_PRODUCTS
        });

        this.customer = customer || {};
        this.contracts = contracts;
        this.state.tabData = { schedules: {}, history: {} };
        this.state.tabLoading = {};
        this.state.tabErrors = {};
        this.state.error = '';
        this.applyRoute();
      } catch (error) {
        console.error('Harvest portal load error:', error);
        this.state.error = userFacingError(error, 'Unable to load your subscriptions.');
      } finally {
        this.state.loading = false;
        this.render();
      }
    }

    applyRoute() {
      const hash = window.location.hash || '';
      const detailMatch = hash.match(
        /^#harvest\/subscription\/([^/]+)\/(upcoming|schedules|history|settings)$/
      );

      if (detailMatch) {
        const contract = this.findContract(decodeURIComponent(detailMatch[1]));
        if (contract) {
          this.state.view = 'detail';
          this.state.selectedContractId = contract.id;
          this.state.activeTab = detailMatch[2];
          return;
        }
      }

      if (hash === `${ROUTE_PREFIX}/list`) {
        this.state.view = 'list';
        this.state.selectedContractId = null;
        this.state.activeTab = 'upcoming';
      }
    }

    navigateToList() {
      this.setRoute(`${ROUTE_PREFIX}/list`);
    }

    navigateToDetail(contractId, tab = 'upcoming') {
      this.setRoute(
        `${ROUTE_PREFIX}/subscription/${encodeURIComponent(rawId(contractId))}/${tab}`
      );
    }

    setRoute(hash) {
      if (window.location.hash === hash) {
        this.applyRoute();
        this.render();
        return;
      }
      window.location.hash = hash;
    }

    render() {
      if (this.state.loading) {
        this.renderLoading();
        return;
      }

      if (this.state.error) {
        this.renderError();
        return;
      }

      let content;
      if (this.state.view === 'build_a_box') {
        content = this.renderBuildABoxView();
      } else if (this.state.view === 'detail') {
        content = this.renderDetailView();
      } else {
        content = this.renderListView();
      }

      this.root.innerHTML = `
        ${this.renderNotice()}
        ${this.renderCustomerHeader()}
        ${content}
      `;
    }

    renderLoggedOut() {
      this.root.innerHTML = `
        <section class="harvest-state harvest-state--compact" aria-live="polite">
          <h2>Please log in</h2>
          <p>Log in to view and manage your upcoming harvests.</p>
          <a class="harvest-button harvest-button--primary" href="/account/login">Log in</a>
        </section>
      `;
    }

    renderLoading() {
      this.root.innerHTML = `
        <section class="harvest-state" aria-live="polite" aria-busy="true">
          <span class="harvest-spinner" aria-hidden="true"></span>
          <h2>Loading your harvests</h2>
          <p>Gathering your subscriptions and upcoming products.</p>
        </section>
      `;
    }

    renderError() {
      this.root.innerHTML = `
        <section class="harvest-state harvest-state--error" role="alert">
          <h2>We could not load your subscriptions</h2>
          <p>${escapeHtml(this.state.error)}</p>
          <button class="harvest-button harvest-button--primary" type="button" data-action="retry">
            Try again
          </button>
        </section>
      `;
    }

    renderNotice() {
      if (!this.state.notice) return '';
      return `
        <div class="harvest-notice harvest-notice--${escapeAttr(
          this.state.notice.type
        )}" role="${this.state.notice.type === 'error' ? 'alert' : 'status'}">
          <span>${escapeHtml(this.state.notice.message)}</span>
          <button type="button" data-action="dismiss-notice" aria-label="Dismiss message">&times;</button>
        </div>
      `;
    }

    renderCustomerHeader() {
      const name = customerDisplayName(this.customer);
      const initials = getInitials(name);
      return `
        <header class="harvest-customer-header">
          <div class="harvest-customer-header__identity">
            <span class="harvest-avatar" aria-hidden="true">${escapeHtml(initials)}</span>
            <div>
              <p class="harvest-customer-header__name">${escapeHtml(name)}</p>
              <p class="harvest-customer-header__id d-none">Customer ID: ${escapeHtml(
                this.customerId
              )}</p>
            </div>
          </div>
          <a class="harvest-account-link" href="/account">&lsaquo; My Account</a>
        </header>
      `;
    }

    renderListView() {
      if (!this.contracts.length) {
        return `
          <section class="harvest-state harvest-state--compact">
            <h2>No subscriptions yet</h2>
            <p>Your active and previous subscriptions will appear here.</p>
          </section>
        `;
      }

      let contracts = this.getSortedContracts();

      return `
        <section class="harvest-list-view">
          <div class="harvest-list-heading">
            ${this.renderSortControls()}
          </div>

          <div class="harvest-subscription-list">
            ${contracts.length === 0 ? `
              <div class="harvest-state harvest-state--compact" style="grid-column: 1 / -1; padding: 48px;">
                <p>No subscriptions found.</p>
              </div>
            ` : contracts.map((contract) => this.renderSubscriptionCard(contract)).join('')}
          </div>
        </section>
      `;
    }

    renderSortControls() {
      const directionLabel =
        this.state.sortDirection === 'asc' ? 'Ascending' : 'Descending';
      return `
        <div class="harvest-sort-controls d-none" aria-label="Sort subscriptions">
          <label class="harvest-field">
            <span class="visually-hidden">Sort subscriptions by</span>
            <select data-action="change-sort">
              ${selectOption('id', 'Subscription Number', this.state.sortKey)}
              ${selectOption('status', 'Status', this.state.sortKey)}
              ${selectOption('created-at', 'Subscription Created At', this.state.sortKey)}
              ${selectOption('next-payment', 'Next Order Date', this.state.sortKey)}
            </select>
          </label>
          <button
            class="harvest-button harvest-button--primary harvest-sort-direction"
            type="button"
            data-action="toggle-sort-direction"
            aria-label="Change sort direction. Currently ${escapeAttr(directionLabel)}"
          >
            <span>${escapeHtml(directionLabel)}</span>
            <span aria-hidden="true">${this.state.sortDirection === 'asc' ? '&uarr;' : '&darr;'}</span>
          </button>
        </div>
      `;
    }

    renderSubscriptionCard(contract) {
      const status = normalizeStatus(contract.status);
      const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
      const totals = calculateContractTotals(contract, oneTimeProducts);
      const nextPayment = getNextPaymentDate(contract);
      const canManage = status === 'ACTIVE' || status === 'PAUSED';
      const detailsLabel = canManage ? 'Edit Products' : 'View Details';

      // 'Skip this delivery' and 'Add One-time Items' buttons at top of subscription card for ACTIVE
      const topActionsHtml = status === 'ACTIVE' ? `
        <div class="harvest-card-top-actions">
          <button
            class="harvest-button harvest-button--secondary harvest-button--sm"
            type="button"
            data-action="open-skip-delivery"
            data-contract-id="${escapeAttr(contract.id)}"
            data-delivery-date="${escapeAttr(getNextDeliveryDate(contract) || getNextPaymentDate(contract))}"
          >
            Skip This Delivery
          </button>
          <button
            class="harvest-button harvest-button--secondary harvest-button--sm"
            type="button"
            data-action="open-add-one-time"
            data-contract-id="${escapeAttr(contract.id)}"
          >
            Add One-Time Items
          </button>
        </div>
      ` : '';

      return `
        <article class="harvest-subscription-card">
          ${this.renderDeliveryBanner(contract)}
          ${topActionsHtml}
          <header class="harvest-subscription-card__header">
            <div class="harvest-subscription-card__identity d-none">
              <h3 class="d-none">Subscription #${escapeHtml(rawId(contract.id))}</h3>
              ${renderStatusBadge(status)}
              <span class="harvest-badge harvest-badge--box">Build a box</span>
            </div>
            <dl class="harvest-subscription-card__meta">
              ${
                nextPayment && status !== 'CANCELLED'
                  ? `<div><dt>Next Payment:</dt><dd>${escapeHtml(
                      formatDate(nextPayment)
                    )}</dd></div>`
                  : ''
              }
              ${
                nextPayment && status === 'ACTIVE'
                  ? `<div><dt class="harvest-deadline-meta__label">Deadline:</dt><dd class="harvest-deadline-meta__text">Update order by 11:59PM on ${escapeHtml(
                      formatDate(getUpdateDeadlineDate(contract))
                    )}</dd></div>`
                  : ''
              }
              <div><dt>Order frequency:</dt><dd>${escapeHtml(
                formatFrequency(contract)
              )}</dd></div>
            </dl>
          </header>

          <div class="harvest-upcoming-harvest-title-bar">
            <h4>Your Upcoming Harvest</h4>
          </div>

          <div class="harvest-subscription-card__products">
            ${recurringProducts
              .map((product) => this.renderCardProduct(product, contract))
              .join('')}
            ${oneTimeProducts
              .map((product) => this.renderCardProduct(product, contract, true))
              .join('')}
          </div>

          <footer class="harvest-subscription-card__footer">
            ${this.renderTotals(totals, contract)}
            <div class="harvest-subscription-card__actions">
              ${this.renderContractActions(contract, { includeDetails: false })}
              <button
                class="harvest-button harvest-button--secondary"
                type="button"
                data-action="view-detail"
                data-contract-id="${escapeAttr(contract.id)}"
              >
                Edit Order  <span aria-hidden="true">&rsaquo;</span>
              </button>
              ${
                canManage
                  ? `<button
                      class="harvest-button harvest-button--primary"
                      type="button"
                      data-action="open-build-a-box"
                      data-contract-id="${escapeAttr(contract.id)}"
                    >
                      Edit Order
                    </button>`
                  : ''
              }
            </div>
          </footer>
        </article>
      `;
    }

    renderCardProduct(product, contract, isOneTime = false) {
      const status = normalizeStatus(contract.status);
      return this.renderProductCard(product, contract, {
        editable: status === 'ACTIVE' || status === 'PAUSED',
        isOneTime,
        context: 'list',
      });
    }

    renderDeliveryBanner(contract) {
      if (normalizeStatus(contract.status) !== 'ACTIVE') return '';
      const nextDelivery = getNextDeliveryDate(contract);
      if (!nextDelivery) return '';

      return `
        <div class="harvest-delivery-banner harvest-delivery-banner--active">
          <strong>Next order processes ${escapeHtml(new Date(nextDelivery).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }))} for same week delivery.</strong>          <span class="d-none">Update your order by 11:59 PM on ${escapeHtml(
            formatDate(getUpdateDeadlineDate(contract))
          )}</span>
        </div>
      `;
    }

    renderTotals(totals, contract) {
      const currency = getCurrency(contract);
      return `
        <dl class="harvest-totals">
          <div><dt>Sub Total:</dt><dd>${escapeHtml(
            formatMoney(totals.subtotal, currency)
          )}</dd></div>
          <div><dt>Delivery Price:</dt><dd>${escapeHtml(
            formatMoney(totals.delivery, currency)
          )}</dd></div>
          ${
            totals.discount > 0
              ? `<div><dt>Discount:</dt><dd>${escapeHtml(
                  formatMoney(totals.discount, currency)
                )}</dd></div>`
              : ''
          }
          <div class="harvest-totals__grand"><dt>Total:</dt><dd>${escapeHtml(
            formatMoney(totals.total, currency)
          )}</dd></div>
        </dl>
      `;
    }

    renderContractActions(contract, options = {}) {
      const status = normalizeStatus(contract.status);
      const buttons = [];

      if (status === 'ACTIVE') {
        buttons.push(actionButton('pause-subscription', 'Pause Subscription', contract.id));
      }

      if (status === 'PAUSED') {
        buttons.push(actionButton('resume-subscription', 'Resume Subscription', contract.id));
      }

      if (status !== 'CANCELLED') {
        buttons.push(
          actionButton('cancel-subscription', 'Cancel Subscription', contract.id, 'danger')
        );
      }

      if (options.includeDetails) {
        buttons.push(
          actionButton('view-detail', 'View Details', contract.id, 'primary')
        );
      }

      return buttons.join('');
    }

    renderDetailView() {
      const contract = this.getSelectedContract();
      if (!contract) {
        return `
          <section class="harvest-state harvest-state--error">
            <h2>Subscription not found</h2>
            <button class="harvest-button harvest-button--primary" type="button" data-action="back-list">
              Back to all harvests
            </button>
          </section>
        `;
      }

      return `
        <section class="harvest-detail-view">
          <button class="harvest-back-button" type="button" data-action="back-list">
            &lsaquo; Go Back
          </button>
          ${this.renderDetailHeader(contract)}
          ${this.renderDeliveryBanner(contract)}
          ${this.renderTabs(contract)}
          ${this.renderActiveTab(contract)}
        </section>
      `;
    }

    renderDetailHeader(contract) {
      const createdAt = contract.createdAt || contract.createdDate || '2026-04-30T10:00:00Z';
      let formattedDateStr = formatDate(createdAt);
      try {
        const d = new Date(createdAt);
        if (!Number.isNaN(d.getTime())) {
          const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
          const day = d.getDate();
          const month = d.toLocaleDateString('en-US', { month: 'long' });
          const year = d.getFullYear();
          formattedDateStr = `${weekday}, ${day} ${month} ${year}`;
        }
      } catch (e) {}

      return `
        <header class="harvest-detail-header d-none">
          <div class="harvest-detail-header__title d-none">
            <h2 class="subscription-id-inside-upcoming">Subscription #${escapeHtml(rawId(contract.id))}</h2>
            ${renderStatusBadge(normalizeStatus(contract.status))}
            <span class="harvest-badge harvest-badge--box">Build a box</span>
          </div>
          <p class="d-none">
            Created At ${escapeHtml(formattedDateStr)} | Current billing cycle 2<sup>nd</sup>
          </p>
        </header>
      `;
    }

    renderTabs(contract) {
      const tabs = [
        ['upcoming', 'Upcoming'],
        ['schedules', 'Schedules'],
        ['history', 'History'],
        ['settings', 'Settings'],
      ];

      return `
        <nav class="harvest-tabs" aria-label="Subscription details">
          ${tabs
            .map(
              ([key, label]) => `
                <button
                  type="button"
                  class="${key === this.state.activeTab ? 'is-active' : ''}"
                  data-action="select-tab"
                  data-contract-id="${escapeAttr(contract.id)}"
                  data-tab="${key}"
                  aria-current="${key === this.state.activeTab ? 'page' : 'false'}"
                >
                  ${label}
                </button>
              `
            )
            .join('')}
        </nav>
      `;
    }

    renderActiveTab(contract) {
      if (this.state.activeTab === 'schedules') {
        return this.renderSchedulesTab(contract);
      }

      if (this.state.activeTab === 'history') {
        return this.renderHistoryTab(contract);
      }

      if (this.state.activeTab === 'settings') {
        return this.renderSettingsTab(contract);
      }

      return this.renderUpcomingTab(contract);
    }

    renderSettingsTab(contract) {
      const status = normalizeStatus(contract.status);
      const isCancelled = status === 'CANCELLED';
      const address = getContractShippingAddress(contract);
      
      // Ensure we have schedule data (which contains the order note) to populate delivery instructions
      this.ensureTabData(contract, 'schedules');
      
      const delInstructions = contract.deliveryInstructions || '';
      const frequency = contract.frequency || 1;
      const frequencyUnit = contract.frequencyUnit || 'WEEK';
      const last4 = contract.paymentMethod?.card?.last4 || '••••';

      return `
        <div class="harvest-settings-tab-container">
          <div class="harvest-settings-layout">
            
            <!-- Address & Preference Fields Form -->
            <form id="harvest-shipping-form" class="harvest-settings-form" data-contract-id="${escapeAttr(contract.id)}">
              <div class="harvest-settings-section-card">
                <h3 class="harvest-settings-section-title mb-5">Shipping Address</h3>
                <p class="harvest-settings-section-subtitle d-none">Manage where your gourmet harvest box will be delivered.</p>
                
                <div class="harvest-settings-grid">
                  <div class="harvest-settings-col-12">
                    <label class="harvest-label-element" for="address1">Street Address</label>
                    <input type="text" id="address1" name="address1" class="harvest-input-element" 
                           value="${escapeAttr(address.address1 || '')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>
                  
                  <div class="harvest-settings-col-6">
                    <label class="harvest-label-element" for="city">City</label>
                    <input type="text" id="city" name="city" class="harvest-input-element" 
                           value="${escapeAttr(address.city || '')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>
                  
                  <div class="harvest-settings-col-3">
                    <label class="harvest-label-element" for="province">State / Province</label>
                    <input type="text" id="province" name="province" class="harvest-input-element" 
                           value="${escapeAttr(address.province || address.provinceCode || '')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>
                  
                  <div class="harvest-settings-col-3">
                    <label class="harvest-label-element" for="zip">ZIP / Postal Code</label>
                    <input type="text" id="zip" name="zip" class="harvest-input-element" 
                           value="${escapeAttr(address.zip || address.zipCode || '')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>

                  <div class="harvest-settings-col-6">
                    <label class="harvest-label-element" for="country">Country</label>
                    <input type="text" id="country" name="country" class="harvest-input-element" 
                           value="${escapeAttr(address.country || address.countryCode || 'Canada')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>

                  <div class="harvest-settings-col-6">
                    <label class="harvest-label-element" for="phone">Phone Number</label>
                    <input type="tel" id="phone" name="phone" class="harvest-input-element" 
                           value="${escapeAttr(address.phone || address.phoneNumber || address.phone_number || contract.customer?.phone || contract.customer?.phoneNumber || '')}" ${isCancelled ? 'disabled' : ''} required>
                  </div>
                </div>
              </div>

              <div class="harvest-settings-section-card" style="margin-top: 24px;">
                <h3 class="harvest-settings-section-title mb-5">Delivery Instructions</h3>
                <p class="harvest-settings-section-subtitle d-none">Help our drivers deliver your harvest box perfectly.</p>
                
                <div class="harvest-settings-grid">
                  <div class="harvest-settings-col-12">
                    <label class="harvest-label-element" for="delivery_instructions">Special Driver Notes</label>
                    <textarea id="delivery_instructions" name="delivery_instructions" rows="3" class="harvest-input-element" 
                              placeholder="e.g. Leave inside the wooden crate on patio..." ${isCancelled ? 'disabled' : ''}>${escapeHtml(delInstructions)}</textarea>
                  </div>
                </div>
              </div>

              <div class="harvest-settings-section-card" style="margin-top: 24px;">
                <h3 class="harvest-settings-section-title mb-5">Frequency settings</h3>
                <p class="harvest-settings-section-subtitle d-none">Your subscription delivery schedule.</p>
                <div class="harvest-settings-grid">
                  <div class="harvest-settings-col-12">
                    <p style="font-size: 14.4px; font-weight: 550; color: var(--harvest-text);">
                      Current Frequency: <strong>${escapeHtml(formatFrequency(contract))}</strong>
                    </p>
                  </div>
                </div>
              </div>

              ${!isCancelled ? `
                <div class="harvest-settings-actions-footer">
                  <button type="submit" class="harvest-button harvest-button--primary" id="save-settings-btn">
                    Save Changes & Preferences
                  </button>
                </div>
              ` : ''}

            </form>

            <!-- Bill Detail Sidebar Panel -->
            <div class="harvest-settings-sidebar">
              <div class="harvest-settings-section-card">
                <h3 class="harvest-settings-section-title mb-5">Payment Method</h3>
                <p class="harvest-settings-section-subtitle d-none">Connected card used for recurring cycles.</p>
                
                <div class="harvest-payment-preview-card">
                  <div class="harvest-payment-logo-row">
                    <span class="harvest-payment-icon-symbol">💳</span>
                    <span class="harvest-payment-card-brand">Visa</span>
                  </div>
                  <div class="harvest-payment-number-row">
                    •••• •••• •••• ${escapeHtml(last4)}
                  </div>
                  <div class="harvest-payment-disclaimer">
                     Secure checkout powered by Shopify and Appstle.
                  </div>
                </div>

                <div class="harvest-callout-box" style="margin-top: 16px;">
                  <p class="harvest-callout-text">To update your credentials, payment card, or billing intervals, please access your Shopify login details or contact customer care at <a href="mailto:care@harvest.com" style="color:var(--harvest-primary); font-weight:600;">care@harvest.com</a>.</p>
                </div>
              </div>

              <div class="harvest-settings-section-card" style="margin-top: 24px;">
                <h3 class="harvest-settings-section-title mb-5">Subscription Actions</h3>
                <p class="harvest-settings-section-subtitle d-none">Pause, skip, or cancel your active deliveries.</p>
                
                <div class="harvest-settings-action-buttons-list">
                  ${status === 'ACTIVE' ? `
                    <button type="button" class="harvest-button harvest-button--secondary harvest-button-full" 
                            data-action="pause-subscription" data-contract-id="${escapeAttr(contract.id)}">
                      Pause deliveries
                    </button>
                  ` : ''}
                  
                  ${status === 'PAUSED' ? `
                    <button type="button" class="harvest-button harvest-button--secondary harvest-button-full" 
                            data-action="reactivate-contract" data-contract-id="${escapeAttr(contract.id)}">
                      Resume deliveries
                    </button>
                  ` : ''}
                  
                  ${!isCancelled ? `
                    <button type="button" class="harvest-button harvest-button-danger harvest-button-full" 
                            data-action="cancel-subscription" data-contract-id="${escapeAttr(contract.id)}" style="margin-top: 12px;">
                      Cancel Subscription
                    </button>
                  ` : `
                    <div class="harvest-cancelled-badge-card">
                      This plan is closed and inactive.
                    </div>
                  `}
                </div>
              </div>
            </div>

          </div>
        </div>
      `;
    }

    tabKey(contract, tab) {
      return `${tab}:${rawId(contract.id)}`;
    }

    ensureTabData(contract, tab) {
      const key = this.tabKey(contract, tab);
      if (this.state.tabData[tab]?.[rawId(contract.id)] || this.state.tabLoading[key]) return;

      this.state.tabLoading[key] = true;
      window.setTimeout(() => this.loadTabData(contract.id, tab), 0);
    }

    async loadTabData(contractId, tab) {
      const contract = this.findContract(contractId);
      if (!contract) return;

      const id = rawId(contract.id);
      const key = this.tabKey(contract, tab);
      this.state.tabLoading[key] = true;
      this.state.tabErrors[key] = '';
      this.render();

      try {
        if (tab === 'schedules') {
          const result = await this.api.getSchedules(contract.id);

          const items = result ? (result.items || []) : [];
          const apiItems = items.map((item, index) =>
            normalizeScheduleItem(item, contract, index)
          );
          
          // Pre-populate contract's deliveryInstructions from the first upcoming note
          if (apiItems.length > 0) {
            const firstWithNote = apiItems.find(item => item.note);
            if (firstWithNote) {
              contract.deliveryInstructions = firstWithNote.note;
            }
          }

          this.state.tabData.schedules[id] = {
            available: result ? result.available : false,
            projected: apiItems.length === 0,
            items: apiItems.length ? apiItems : buildProjectedSchedules(contract),
          };
        } else if (tab === 'history') {
          const result = await this.api.getHistory(contract.id);

          const items = result ? (result.items || []) : [];
          this.state.tabData.history[id] = {
            available: result ? result.available : false,
            items: items.map((item) => normalizeHistoryItem(item, contract)),
          };
          this.state.historyPages[id] = this.state.historyPages[id] || 1;
        }
      } catch (error) {
        this.state.tabErrors[key] = userFacingError(
          error,
          `Unable to load ${tab === 'schedules' ? 'delivery schedules' : 'order history'}.`
        );
      } finally {
        this.state.tabLoading[key] = false;
        this.render();
      }
    }

    renderTabState(title, message, options = {}) {
      return `
        <section class="harvest-tab-state ${options.error ? 'harvest-tab-state--error' : ''}" aria-live="polite">
          ${options.loading ? '<span class="harvest-spinner" aria-hidden="true"></span>' : ''}
          <h3>${escapeHtml(title)}</h3>
          <p>${escapeHtml(message)}</p>
          ${
            options.retry
              ? `<button class="harvest-button harvest-button--primary" type="button" data-action="reload-tab" data-tab="${escapeAttr(
                  options.retry
                )}">Try Again</button>`
              : ''
          }
        </section>
      `;
    }

    renderSchedulesTab(contract) {
      const id = rawId(contract.id);
      const key = this.tabKey(contract, 'schedules');
      const data = this.state.tabData.schedules[id];

      if (this.state.tabErrors[key]) {
        return this.renderTabState('Schedules', this.state.tabErrors[key], {
          error: true,
          retry: 'schedules',
        });
      }

      if (!data) {
        this.ensureTabData(contract, 'schedules');
        return this.renderTabState('Loading schedules', 'Checking your upcoming deliveries.', {
          loading: true,
        });
      }

      if (!data.items.length) {
        return this.renderTabState(
          'No upcoming deliveries',
          'There are no future delivery dates for this harvest right now.'
        );
      }

      return `
        <section class="harvest-schedule-list" aria-label="Delivery schedules">
          ${
            data.projected
              ? `<p class="harvest-tab-note">Showing upcoming deliveries from your current frequency.</p>`
              : ''
          }
          ${data.items
            .map((item, index) => this.renderScheduleDelivery(item, contract, index))
            .join('')}
        </section>
      `;
    }

    renderScheduleDelivery(item, contract, index) {
      const status = normalizeScheduleStatus(item.status);
      const date = item.date || getNextPaymentDate(contract);
      const products = item.products?.length
        ? item.products
        : scheduleProductsForContract(contract, index);
      const canManage = normalizeStatus(contract.status) === 'ACTIVE';

      return `
        <article class="harvest-schedule-card">
          <header class="harvest-schedule-card__header">
            <div>
              <p class="harvest-eyebrow">Delivery</p>
              <h3>${escapeHtml(formatDate(date))}</h3>
              ${status ? `<span class="harvest-badge harvest-badge--queued">${escapeHtml(status)}</span>` : ''}
            </div>
            ${
              canManage
                ? `<div class="harvest-schedule-card__actions">
                    <button class="harvest-text-action" type="button" data-action="open-skip-delivery" data-contract-id="${escapeAttr(
                      contract.id
                    )}" data-delivery-date="${escapeAttr(date)}" data-billing-attempt-id="${escapeAttr(
                      item.billingAttemptId || ''
                    )}">Skip This Delivery</button>
                    <button class="harvest-text-action" type="button" data-action="open-order-note" data-contract-id="${escapeAttr(
                      contract.id
                    )}" data-delivery-date="${escapeAttr(date)}" data-note="${escapeAttr(
                    item.note || ''
                  )}">Order Note</button>
                  </div>`
                : ''
            }
          </header>
          <div class="harvest-schedule-card__products">
            ${products
              .map((product) =>
                this.renderProductCard(product, contract, {
                  editable: false,
                  isOneTime: isOneTimeProduct(product, contract),
                  context: 'schedule',
                })
              )
              .join('')}
          </div>
        </article>
      `;
    }

    renderHistoryTab(contract) {
      const id = rawId(contract.id);
      const key = this.tabKey(contract, 'history');
      const data = this.state.tabData.history[id];

      if (this.state.tabErrors[key]) {
        return this.renderTabState('History', this.state.tabErrors[key], {
          error: true,
          retry: 'history',
        });
      }

      if (!data) {
        this.ensureTabData(contract, 'history');
        return this.renderTabState('Loading history', 'Checking completed orders.', {
          loading: true,
        });
      }

      if (!data.items.length) {
        return this.renderTabState(
          'No order history',
          'No completed orders or cancelled attempts were returned for this harvest.'
        );
      }

      const page = this.state.historyPages[id] || 1;
      const pageCount = Math.max(1, Math.ceil(data.items.length / HISTORY_PAGE_SIZE));
      const safePage = Math.min(page, pageCount);
      const start = (safePage - 1) * HISTORY_PAGE_SIZE;
      const visibleItems = data.items.slice(start, start + HISTORY_PAGE_SIZE);

      return `
        <section class="harvest-history-list" aria-label="Order history">
          ${visibleItems.map((item) => this.renderHistoryOrder(item, contract)).join('')}
          ${this.renderHistoryPagination(contract, safePage, pageCount)}
        </section>
      `;
    }

    renderHistoryOrder(item, contract) {
      const products = item.products?.length ? item.products : [];
      const showBillingAttempt = item.status && !item.status.toLowerCase().includes('cancel');

      return `
        <article class="harvest-history-card">
          <header class="harvest-history-card__header">
            <div>
              ${
                item.orderNumber
                  ? `<p class="harvest-eyebrow d-none">Order #${escapeHtml(item.orderNumber)}</p>`
                  : '<p class="harvest-eyebrow d-none">Order</p>'
              }
              <h3 style="margin: 0; font-size: 1.15rem; font-weight: 500;">Order Date: ${escapeHtml(formatDate(item.date))}</h3>
              ${
                showBillingAttempt
                  ? `<p class="harvest-history-card__billing-attempt d-none" style="font-size: 0.9rem; color: #4b5563; margin-top: 4px; margin-bottom: 0;">Billing Attempt: ${escapeHtml(formatDate(item.billingDate || item.date))}</p>`
                  : ''
              }
            </div>
            <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
              ${
                item.status
                  ? `<span class="harvest-badge ${
                      item.status.toLowerCase().includes('cancel')
                        ? ''
                        : 'harvest-badge--queued'
                    }" style="${
                      item.status.toLowerCase().includes('cancel')
                        ? 'background-color: #fef08a; color: #854d0e; border: 1px solid #fde047; font-weight: 500; padding: 4px 10px; border-radius: 9999px; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.05em;'
                        : ''
                    }">${escapeHtml(item.status)}</span>`
                  : ''
              }
              ${
                item.orderUrl
                  ? `<a class="harvest-button harvest-button--secondary" href="${escapeAttr(
                      item.orderUrl
                    )}">View Order Details</a>`
                  : ''
              }
            </div>
          </header>
          ${
            products.length
              ? `<div class="harvest-history-card__products">
                  ${products
                    .map((product) =>
                      this.renderProductCard(product, contract, {
                        editable: false,
                        isOneTime: isOneTimeProduct(product, contract),
                        context: 'history',
                      })
                    )
                    .join('')}
                </div>`
              : ''
          }
          <footer class="harvest-history-card__footer">
            <strong>Order Total:</strong>
            <span>${escapeHtml(formatMoney(item.total, getCurrency(contract)))}</span>
          </footer>
        </article>
      `;
    }

    renderHistoryPagination(contract, page, pageCount) {
      if (pageCount <= 1) return '';

      return `
        <nav class="harvest-pagination" aria-label="History pages">
          <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
            contract.id
          )}" data-page="1" ${page === 1 ? 'disabled' : ''} aria-label="First page">&laquo;</button>
          <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
            contract.id
          )}" data-page="${page - 1}" ${page === 1 ? 'disabled' : ''} aria-label="Previous page">&lsaquo;</button>
          <span>${page}</span>
          <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
            contract.id
          )}" data-page="${page + 1}" ${page === pageCount ? 'disabled' : ''} aria-label="Next page">&rsaquo;</button>
          <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
            contract.id
          )}" data-page="${pageCount}" ${page === pageCount ? 'disabled' : ''} aria-label="Last page">&raquo;</button>
        </nav>
      `;
    }

    renderBuildABoxView() {
      const contract = this.getSelectedContract();
      if (!contract) {
        return `
          <section class="harvest-state harvest-state--error">
            <h2>Subscription not found</h2>
            <button class="harvest-button harvest-button--primary" type="button" data-action="back-list">
              Back to all harvests
            </button>
          </section>
        `;
      }

      const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
      const totals = calculateContractTotals(contract, oneTimeProducts);
      const status = normalizeStatus(contract.status);
      const editable = status === 'ACTIVE' || status === 'PAUSED';
      const availableItems = this.getOneTimeCandidates(contract);

      // Filter availableItems based on search query
      let filteredAvailable = availableItems;
      if (this.state.productSearchQuery) {
        const query = this.state.productSearchQuery.toLowerCase().trim();
        filteredAvailable = availableItems.filter(p =>
          getProductTitle(p).toLowerCase().includes(query) ||
          (p.sku && p.sku.toLowerCase().includes(query))
        );
      }

      return `
        <section class="harvest-build-box-view">
          <div class="harvest-build-box-header">
            <button class="harvest-back-button" type="button" data-action="view-detail" data-contract-id="${escapeAttr(contract.id)}">
              &lsaquo; Back to Details
            </button>
            <div class="harvest-build-box-title">
              <h2>Edit Products & Catalog</h2>
              <p class="harvest-eyebrow">Subscription #${escapeHtml(rawId(contract.id))}</p>
            </div>
            <p class="harvest-build-box-desc">
              Search the full catalog and add items to your subscription as a recurring product or as a one-time purchase.
            </p>
          </div>

          <div class="harvest-build-box-layout">
            <div class="harvest-build-box-main">
              
              <!-- Left Section: Current Items in Coming Harvest -->
              <div class="harvest-build-box-section">
                <h3 class="harvest-section-title">In Your Coming Harvest</h3>
                <p class="harvest-section-subtitle">These items are currently scheduled to deliver next. Adjust quantities as needed.</p>
                
                <div class="harvest-detail-products">
                  ${recurringProducts
                    .map((product) =>
                      this.renderProductCard(product, contract, {
                        editable: true,
                        isOneTime: false,
                        context: 'build-a-box',
                      })
                    )
                    .join('')}
                  ${oneTimeProducts
                    .map((product) =>
                      this.renderProductCard(product, contract, {
                        editable: true,
                        isOneTime: true,
                        context: 'build-a-box',
                      })
                    )
                    .join('')}
                  ${recurringProducts.length === 0 && oneTimeProducts.length === 0 ? `
                    <div class="harvest-empty-box-state">
                      <p>Your box is empty! Add sweet harvests from the catalog below.</p>
                    </div>
                  ` : ''}
                </div>
              </div>

              <!-- Product Catalog / Browse Section -->
              <div class="harvest-build-box-section harvest-build-box-section--browse">
                
                <!-- Catalog Actions, Search, and Switches Bar -->
                <div class="harvest-catalog-controls-container">
                  <div class="harvest-catalog-search-wrapper">
                    <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
                           placeholder="Search product catalog..." value="${escapeAttr(this.state.productSearchQuery)}">
                    ${this.state.productSearchQuery ? `
                      <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search">&times;</button>
                    ` : ''}
                  </div>

                  <div class="harvest-catalog-toggle-container">
                    <label class="harvest-catalog-toggle-label">Clicking "Add" inserts product as:</label>
                    <div class="harvest-segmented-control">
                      <button class="harvest-segment-btn ${this.state.productCatalogMode === 'recurring' ? 'is-active' : ''}" 
                              type="button" data-action="change-catalog-mode" data-mode="recurring">
                        Subscription Product (Recurring)
                      </button>
                      <button class="harvest-segment-btn ${this.state.productCatalogMode === 'one_time' ? 'is-active' : ''}" 
                              type="button" data-action="change-catalog-mode" data-mode="one_time">
                        One-Time Delivery (Next Order)
                      </button>
                    </div>
                  </div>
                </div>

                <h3 class="harvest-section-title" style="margin-top: 16px;">Browse Product Catalog</h3>
                <p class="harvest-section-subtitle">Click "+ Add" to include the selected type of product in your next shipment.</p>
                
                <div class="harvest-detail-products">
                  ${filteredAvailable.length === 0 ? `
                    <div class="harvest-catalog-empty-filtered" style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
                      <p style="color: var(--harvest-text-muted); font-size: 1.1rem;">No results in catalog match your search.</p>
                      <button type="button" class="harvest-button harvest-button--secondary" data-action="clear-catalog-search" style="margin-top: 12px;">
                        Reset filter
                      </button>
                    </div>
                  ` : filteredAvailable
                    .map((product) => {
                      const variantId = getAddableVariantId(product);
                      const inBoxOfRecurring = recurringProducts.some(
                        (p) => rawId(getVariantId(p)) === rawId(variantId)
                      );
                      const inBoxOfOneTime = oneTimeProducts.some(
                        (p) => rawId(getVariantId(p)) === rawId(variantId)
                      );
                      const inBox = inBoxOfRecurring || inBoxOfOneTime;
                      
                      const badgeLabel = inBoxOfRecurring 
                        ? 'Added (Recurring)' 
                        : (inBoxOfOneTime ? 'Added (One-Time)' : '');

                      const actionLabel = this.state.productCatalogMode === 'recurring' 
                        ? '+ Add Subscription' 
                        : '+ Add One-Time';
                      
                      return `
                        <article class="harvest-product-card harvest-product-card--available">
                          <div class="harvest-product-card__media">
                            <img
                              src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
                              alt="${escapeAttr(getProductTitle(product))}"
                              loading="lazy"
                            >
                            ${badgeLabel ? `
                              <div class="harvest-badge-overlay">
                                <span class="harvest-badge ${inBoxOfRecurring ? 'harvest-badge--in-box' : 'harvest-badge--one-time'}">${escapeHtml(badgeLabel)}</span>
                              </div>
                            ` : ''}
                          </div>
                          <div class="harvest-product-card__body">
                            <div class="harvest-product-card__copy">
                              <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
                              <p class="harvest-product-card__price">
                                ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
                              </p>
                            </div>
                            <button
                              class="harvest-button ${inBox ? 'harvest-button--secondary' : 'harvest-button--primary'} harvest-add-box-btn"
                              type="button"
                              data-action="build-a-box-add-item"
                              data-contract-id="${escapeAttr(contract.id)}"
                              data-variant-id="${escapeAttr(variantId)}"
                              data-price="${getProductPrice(product)}"
                            >
                              ${actionLabel}
                            </button>
                          </div>
                        </article>
                      `;
                    })
                    .join('')}
                </div>
              </div>
            </div>

            <!-- Sidebar Column: Totals Summary -->
            <aside class="harvest-build-box-sidebar">
              <div class="harvest-sidebar-card harvest-settings-card">
                <header class="harvest-sidebar-card__heading">
                  <h3>Order Summary</h3>
                  <span>Box total</span>
                </header>
                
                <div class="harvest-box-summary-stats">
                  <div class="harvest-summary-qty-row">
                    <span>Recurring items:</span>
                    <strong>${recurringProducts.length}</strong>
                  </div>
                  <div class="harvest-summary-qty-row">
                    <span>One-time items:</span>
                    <strong>${oneTimeProducts.length}</strong>
                  </div>
                </div>

                <div class="harvest-sidebar-totals-block">
                  ${this.renderTotals(totals, contract)}
                </div>

                <div class="harvest-sidebar-actions">
                  <button
                    class="harvest-button harvest-button--primary w-full"
                    type="button"
                    data-action="view-detail"
                    data-contract-id="${escapeAttr(contract.id)}"
                  >
                    View Updated Order &rsaquo;
                  </button>
                </div>
              </div>
            </aside>
          </div>
        </section>
      `;
    }

    renderUpcomingTab(contract) {
      const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
      const totals = calculateContractTotals(contract, oneTimeProducts);
      const status = normalizeStatus(contract.status);
      const editable = status === 'ACTIVE' || status === 'PAUSED';
      const futureDeliveries = this.getFutureDeliveries(contract);

      return `
        <div class="harvest-upcoming-layout">
          <section class="harvest-upcoming-panel">
            <header class="harvest-panel-heading">
              <div>
                <p class="harvest-eyebrow">Your Upcoming Harvest</p>
                <h3>${escapeHtml(formatDate(getNextDeliveryDate(contract) || getNextPaymentDate(contract)))}</h3>
              </div>
              ${
                editable
                  ? `<div class="harvest-panel-actions">
                      <button class="harvest-button harvest-button--primary" type="button" data-action="open-build-a-box" data-contract-id="${escapeAttr(contract.id)}">Edit Order</button>
                      <button class="harvest-button harvest-button--secondary" type="button" data-action="open-skip-delivery" data-contract-id="${escapeAttr(
                        contract.id
                      )}" data-delivery-date="${escapeAttr(
                      getNextDeliveryDate(contract) || getNextPaymentDate(contract)
                    )}">Skip This Delivery</button>
                      <button class="harvest-button harvest-button--secondary" type="button" data-action="open-add-one-time" data-contract-id="${escapeAttr(
                        contract.id
                      )}">Add One-Time Items</button>
                    </div>`
                  : '<span class="harvest-badge harvest-badge--box">Build a box</span>'
            }
          </header>

            ${
              editable
                ? `<div class="harvest-mobile-item-action-legend" aria-label="Item action legend">
                    <span class="harvest-mobile-item-action-legend__item">
                      <span class="harvest-mobile-item-action-legend__icon" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M5 4l10 8-10 8V4z"/>
                          <path d="M19 5v14"/>
                        </svg>
                      </span>
                      <span>Skip item for next order</span>
                    </span>
                    <span class="harvest-mobile-item-action-legend__item">
                      <span class="harvest-mobile-item-action-legend__icon" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
                          <path d="M21 2v6h-6"/>
                          <path d="M12 7v5l3 2"/>
                        </svg>
                      </span>
                      <span>Unskip item for next order</span>
                    </span>
                  </div>`
                : ''
            }

            <div class="harvest-detail-products">
              ${recurringProducts
                .map((product) =>
                  this.renderProductCard(product, contract, {
                    editable,
                    isOneTime: false,
                    context: 'detail',
                  })
                )
                .join('')}
              ${oneTimeProducts
                .map((product) =>
                  this.renderProductCard(product, contract, {
                    editable,
                    isOneTime: true,
                    context: 'detail',
                  })
                )
                .join('')}
            </div>

            <div class="harvest-upcoming-panel__totals">
              ${this.renderTotals(totals, contract)}
            </div>

            ${
              futureDeliveries.length
                ? `<section class="harvest-future-deliveries d-none">
                    <header class="harvest-future-deliveries__heading">
                      <p class="harvest-eyebrow">Upcoming Deliveries</p>
                      <h3>Future Shipment Timeline</h3>
                    </header>
                    
                    <div class="harvest-timeline-container">
                      <div class="harvest-timeline-line"></div>
                      <div class="harvest-timeline-list">
                        ${futureDeliveries
                          .map(
                            (delivery, index) => {
                              const deliveryDateStr = delivery.date;
                              return `
                                <div class="harvest-timeline-node">
                                  <div class="harvest-timeline-marker-wrapper">
                                    <div class="harvest-timeline-marker ${index === 0 ? 'is-next' : ''}"></div>
                                  </div>
                                  <div class="harvest-timeline-content">
                                    <div class="harvest-timeline-header-row">
                                      <span class="harvest-timeline-date">${escapeHtml(formatDate(deliveryDateStr))}</span>
                                      ${index === 0 ? `<span class="harvest-badge-timeline-upcoming">Next Shipment</span>` : ''}
                                    </div>
                                    <div class="harvest-timeline-details-row">
                                      <span class="harvest-timeline-products-count">${delivery.productCount} product${delivery.productCount !== 1 ? 's' : ''} scheduled</span>
                                      ${editable ? `
                                        <div class="harvest-timeline-action-buttons">
                                          <button class="harvest-timeline-link-btn" type="button" 
                                                  data-action="open-skip-delivery" data-contract-id="${escapeAttr(contract.id)}" 
                                                  data-delivery-date="${escapeAttr(deliveryDateStr)}"
                                                  data-billing-attempt-id="${escapeAttr(delivery.billingAttemptId || '')}">
                                            Skip
                                          </button>
                                        </div>
                                      ` : ''}
                                    </div>
                                  </div>
                                </div>
                              `;
                            }
                          )
                          .join('')}
                      </div>
                    </div>

                    <footer class="harvest-future-deliveries__footer">
                      <button class="harvest-button harvest-button--secondary" type="button" data-action="view-past-orders" data-contract-id="${escapeAttr(
                        contract.id
                      )}">View Order History</button>
                    </footer>
                  </section>`
                : ''
            }
          </section>

          <aside class="harvest-detail-sidebar">
            ${this.renderUpcomingSidebar(contract, totals)}
          </aside>
        </div>
      `;
    }

    getFutureDeliveries(contract) {
      const id = rawId(contract.id);
      const data = this.state.tabData.schedules[id];
      if (data && data.items && data.items.length) {
        const items = data.available ? data.items : buildProjectedSchedules(contract);
        return items.slice(0, 4).map((item) => ({
          date: item.date || getNextPaymentDate(contract),
          billingAttemptId: item.billingAttemptId || '',
          productCount: (item.products || scheduleProductsForContract(contract, 0)).length,
        }));
      }
      if (normalizeStatus(contract.status) === 'CANCELLED') return [];
      const projected = buildProjectedSchedules(contract);
      return projected.slice(0, 4).map((item) => ({
        date: item.date,
        billingAttemptId: item.billingAttemptId || '',
        productCount: item.products.length,
      }));
    }

    renderProductCard(product, contract, options = {}) {
      const quantity = getQuantity(product);
      const lineId = getLineId(product);
      const variantId = getVariantId(product);
      const lineKey = pendingLineKey(contract.id, lineId);
      const isPending = this.state.pendingLines.has(lineKey);
      const editable = Boolean(options.editable && lineId);
      const canChangeQuantity = editable;
      const canSwap = canChangeQuantity;
      const canRemove = editable;
      
      let isOneTime = Boolean(options.isOneTime);
      if (!isOneTime && contract && contract.oneTimeProducts) {
        const vId = rawId(getVariantId(product));
        if (vId) {
          isOneTime = contract.oneTimeProducts.some(otp => rawId(getVariantId(otp)) === vId);
        }
      }
      if (!isOneTime) {
        isOneTime = isOneTimeProduct(product, contract);
      }
      const isSkipped = !isOneTime && isProductSkippedForNextOrderForContract(contract, product);
      const canSkipNextOrder = editable && !isOneTime && !isSkipped;
      const canUnskipNextOrder = editable && !isOneTime && isSkipped;
      const classes = [
        'harvest-product-card',
        `harvest-product-card--${options.context || 'detail'}`,
        isPending ? 'is-pending' : '',
        editable ? 'is-editable' : '',
        isSkipped ? 'harvest-product-card--skipped' : '',
      ]
        .filter(Boolean)
        .join(' ');

      return `
        <article class="${classes}" data-action="${canSwap ? 'open-swap' : ''}" data-contract-id="${escapeAttr(contract.id)}" data-line-id="${escapeAttr(lineId)}" data-variant-id="${escapeAttr(variantId)}" data-one-time="${isOneTime ? 'true' : 'false'}">
          <div class="harvest-product-card__media">
            <img
              src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
              alt="${escapeAttr(getProductTitle(product))}"
              loading="lazy"
            >
            ${
              isSkipped
                ? '<span class="harvest-product-card__skipped-overlay" aria-label="Skipped">Skipped</span>'
                : ''
            }
            ${
              isOneTime
                ? `<span class="harvest-product-card__one-time-tag">One-Time</span>`
                : ''
            }
            
            <!-- Top Action Icons Overlay: Skip, Swap, and Remove -->
            ${
              canSkipNextOrder || canUnskipNextOrder || canSwap || canRemove
                ? `<div class="harvest-image-action-overlay">
                    ${
                      canSkipNextOrder
                        ? `<button
                            class="harvest-image-action-btn harvest-image-skip-btn"
                            type="button"
                            data-action="open-skip-product-next-order"
                            data-contract-id="${escapeAttr(contract.id)}"
                            data-line-id="${escapeAttr(lineId)}"
                            title="Skip this item for next order"
                            aria-label="Skip ${escapeAttr(getProductTitle(product))} for next order"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M5 4l10 8-10 8V4z"/>
                              <path d="M19 5v14"/>
                            </svg>
                          </button>`
                        : ''
                    }
                    ${
                      canUnskipNextOrder
                        ? `<button
                            class="harvest-image-action-btn harvest-image-skip-btn"
                            type="button"
                            data-action="open-unskip-product-next-order"
                            data-contract-id="${escapeAttr(contract.id)}"
                            data-line-id="${escapeAttr(lineId)}"
                            title="Unskip this item for next order"
                            aria-label="Unskip ${escapeAttr(getProductTitle(product))} for next order"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
                              <path d="M21 2v6h-6"/>
                              <path d="M12 7v5l3 2"/>
                            </svg>
                          </button>`
                        : ''
                    }
                    ${
                      canSwap
                        ? `<button
                            class="harvest-image-action-btn harvest-image-swap-btn d-none"
                            type="button"
                            data-action="open-swap"
                            data-contract-id="${escapeAttr(contract.id)}"
                            data-line-id="${escapeAttr(lineId)}"
                            data-variant-id="${escapeAttr(variantId)}"
                            data-one-time="${isOneTime ? 'true' : 'false'}"
                            title="Swap product"
                            aria-label="Swap ${escapeAttr(getProductTitle(product))}"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"/>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
                              <path d="M3 22v-6h6"/>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"/>
                            </svg>
                          </button>`
                        : ''
                    }
                    ${
                      canRemove
                        ? `<button
                            class="harvest-image-action-btn harvest-image-remove-btn"
                            type="button"
                            data-action="open-remove-product"
                            data-contract-id="${escapeAttr(contract.id)}"
                            data-line-id="${escapeAttr(lineId)}"
                            data-one-time="${isOneTime ? 'true' : 'false'}"
                            title="Remove item"
                            aria-label="Remove ${escapeAttr(getProductTitle(product))}"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M3 6h18"/>
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                            </svg>
                          </button>`
                        : ''
                    }
                  </div>`
                : ''
            }

            <!-- Bottom Floating Quantity Counter Overlay -->
            ${
              canChangeQuantity
                ? `
                  <div class="harvest-image-quantity-overlay" data-action="none">
                    <button
                      type="button"
                      data-action="change-quantity"
                      data-change="-1"
                      data-contract-id="${escapeAttr(contract.id)}"
                      data-line-id="${escapeAttr(lineId)}"
                      data-variant-id="${escapeAttr(variantId)}"
                      data-one-time="${isOneTime ? 'true' : 'false'}"
                      ${quantity <= 1 || isPending ? 'disabled' : ''}
                      aria-label="Decrease quantity"
                    >&minus;</button>
                    <output class="harvest-image-qty-value">${quantity}</output>
                    <button
                      type="button"
                      data-action="change-quantity"
                      data-change="1"
                      data-contract-id="${escapeAttr(contract.id)}"
                      data-line-id="${escapeAttr(lineId)}"
                      data-variant-id="${escapeAttr(variantId)}"
                      data-one-time="${isOneTime ? 'true' : 'false'}"
                      ${isPending ? 'disabled' : ''}
                      aria-label="Increase quantity"
                    >+</button>
                  </div>
                `
                : ''
            }

            <div class="harvest-product-card__badges">
              ${
                isOneTime
                  ? '<span class="d-none harvest-badge harvest-badge--one-time">One-Time</span>'
                  : ''
              }
              ${
                isProductOutOfStock(product)
                  ? '<span class="harvest-badge harvest-badge--stock">Out of stock</span>'
                  : ''
              }
            </div>
          </div>
          <div class="harvest-product-card__body">
            <div class="harvest-product-card__copy">
              <h4>${escapeHtml(getProductTitle(product))}</h4>
              <p class="harvest-product-card__price">${quantity > 1 ? `${quantity} x ` : ''}${escapeHtml(
                formatMoney(getLineTotal(product), getCurrency(contract, product))
              )}</p>
            </div>
            ${
              !canChangeQuantity
                ? `<span class="harvest-quantity-label">Quantity: ${quantity}</span>`
                : ''
            }
          </div>
        </article>
      `;
    }

    renderUpcomingSidebar(contract, totals) {
      const nextDelivery = getNextDeliveryDate(contract);
      const status = normalizeStatus(contract.status);
      const delivery = totals.delivery;
      const currency = getCurrency(contract);
      const paymentDetails = getPaymentDetails(contract);
      const deliveryText = getHumanizedDeliveryText(contract);

      return `
        <section class="harvest-sidebar-card harvest-settings-card">
          <header class="harvest-sidebar-card__heading">
            <h3>Subscription Settings</h3>
            ${nextDelivery ? `<span>${escapeHtml(formatDate(nextDelivery))}</span>` : ''}
          </header>

          <div class="harvest-setting-row harvest-setting-row--stacked d-none">
            <span>Delivering / Shipping Window</span>
            <p>${deliveryText}</p>
          </div>

          <div class="harvest-setting-row">
            <span>Frequency settings</span>
            <strong>${escapeHtml(formatFrequency(contract))}</strong>
          </div>

          <div class="harvest-setting-row harvest-setting-row--stacked">
            <span>Payment method</span>
            <p>${escapeHtml(paymentDetails)}</p>
            <p class="harvest-sidebar-card__muted d-none">Delivery fee: ${escapeHtml(
              formatMoney(delivery, currency)
            )}</p>
          </div>

          <div class="harvest-sidebar-actions d-none">
            ${this.renderContractActions(contract)}
          </div>
          ${
            status === 'CANCELLED'
              ? '<p class="harvest-sidebar-card__muted">This subscription is closed and can only be viewed.</p>'
              : ''
          }
        </section>

        ${this.renderDiscountCouponsCard(contract, totals)}
      `;
    }

    renderDiscountCouponsCard(contract, totals) {
      const discounts = extractContractDiscounts(contract);
      const status = normalizeStatus(contract.status);
      const editable = status === 'ACTIVE' || status === 'PAUSED';
      const contractKey = rawId(contract.id);
      const isApplying =
        this.state.couponBusy &&
        this.state.couponBusy.action === 'apply' &&
        this.state.couponBusy.id === contractKey;
      const removingDiscountId =
        this.state.couponBusy &&
        this.state.couponBusy.action === 'remove' &&
        this.state.couponBusy.id === contractKey
          ? this.state.couponBusy.discountId
          : null;

      return `
        <section class="harvest-sidebar-card harvest-settings-card harvest-discount-card">
          <header class="harvest-sidebar-card__heading">
            <h3>Discount Coupons</h3>
            ${discounts.length ? `<span>${discounts.length}</span>` : ''}
          </header>

          ${
            discounts.length
              ? discounts
                  .map((discount) =>
                    this.renderDiscountRow(discount, contract, editable, removingDiscountId)
                  )
                  .join('')
              : '<p class="harvest-discount-empty">No discounts applied.</p>'
          }

          ${
            editable
              ? `<form class="harvest-discount-form" data-contract-id="${escapeAttr(contract.id)}">
                  <div class="harvest-discount-form__row">
                    <input
                      class="harvest-discount-input"
                      type="text"
                      name="discount-code"
                      placeholder="Enter discount code"
                      autocomplete="off"
                      aria-label="Enter discount code"
                      ${isApplying ? 'disabled' : ''}
                    >
                    <button class="harvest-button harvest-button--primary harvest-discount-apply" type="submit" ${isApplying ? 'disabled' : ''}>
                      ${isApplying ? 'Applying...' : 'Apply'}
                    </button>
                  </div>
                </form>`
              : ''
          }
        </section>
      `;
    }

    renderDiscountRow(discount, contract, editable, removingDiscountId) {
      const title = discount.title || 'Discount';
      const description =
        discount.description && discount.description !== title ? discount.description : '';
      const value = discount.valueText || '';
      const type = discount.typeLabel || '';
      const discountId = discount.id;
      const isRemoving =
        removingDiscountId &&
        (String(removingDiscountId) === String(discountId) ||
          rawId(removingDiscountId) === rawId(discountId));
      const canRemove = editable && discountId && !discount.rejectionReason;

      return `
        <div class="harvest-discount-row ${isRemoving ? 'is-pending' : ''}">
          <div class="harvest-discount-row__info">
            <strong class="harvest-discount-row__title">${escapeHtml(title)}</strong>
            ${description ? `<p class="harvest-discount-row__desc">${escapeHtml(description)}</p>` : ''}
            <div class="harvest-discount-row__meta">
              ${value ? `<span class="harvest-discount-row__value">${escapeHtml(value)}</span>` : ''}
              ${type ? `<span class="harvest-discount-row__type">${escapeHtml(type)}</span>` : ''}
            </div>
          </div>
          ${
            canRemove
              ? `<button
                  class="harvest-discount-row__remove"
                  type="button"
                  data-action="remove-coupon"
                  data-contract-id="${escapeAttr(contract.id)}"
                  data-discount-id="${escapeAttr(discountId)}"
                  title="Remove discount"
                  aria-label="Remove ${escapeAttr(title)}"
                  ${isRemoving ? 'disabled' : ''}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M3 6h18"/>
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                  </svg>
                </button>`
              : ''
          }
        </div>
      `;
    }

    getSortedContracts() {
      return [...this.contracts].sort((a, b) => {
        const direction = this.state.sortDirection === 'asc' ? 1 : -1;
        let result = 0;

        if (this.state.sortKey === 'status') {
          result = normalizeStatus(a.status).localeCompare(normalizeStatus(b.status));
        } else if (this.state.sortKey === 'id') {
          result = rawId(a.id).localeCompare(rawId(b.id), undefined, { numeric: true });
        } else if (this.state.sortKey === 'created-at') {
          const dateA = a.createdAt || a.createdDate;
          const dateB = b.createdAt || b.createdDate;
          result = dateValue(dateA) - dateValue(dateB);
        } else if (this.state.sortKey === 'next-payment') {
          result = dateValue(getNextPaymentDate(a)) - dateValue(getNextPaymentDate(b));
        } else {
          // 'default' - ACTIVE (0) first, then PAUSED (1), then CLOSED/CANCELLED (2), then next order date
          const rankA = statusRank(a.status);
          const rankB = statusRank(b.status);
          if (rankA !== rankB) {
            return rankA - rankB;
          }
          result = dateValue(getNextPaymentDate(a)) - dateValue(getNextPaymentDate(b));
        }

        return result * direction;
      });
    }

    findContract(id) {
      return this.contracts.find(
        (contract) => String(contract.id) === String(id) || rawId(contract.id) === rawId(id)
      );
    }

    getSelectedContract() {
      return this.findContract(this.state.selectedContractId);
    }

    findLine(contract, lineId) {
      const recurring = getContractLines(contract).find(
        (line) => String(getLineId(line)) === String(lineId) || rawId(getLineId(line)) === rawId(lineId)
      );
      if (recurring) return recurring;
      return (contract.oneTimeProducts || []).find(
        (line) => String(getLineId(line)) === String(lineId) || rawId(getLineId(line)) === rawId(lineId)
      );
    }

    findProduct(contract, lineId, isOneTime = false) {
      const primaryProducts = isOneTime ? contract?.oneTimeProducts || [] : getContractLines(contract);
      const found = primaryProducts.find(
        (product) => String(getLineId(product)) === String(lineId) || rawId(getLineId(product)) === rawId(lineId)
      );
      if (found) return found;

      const secondaryProducts = isOneTime ? getContractLines(contract) : contract?.oneTimeProducts || [];
      return secondaryProducts.find(
        (product) => String(getLineId(product)) === String(lineId) || rawId(getLineId(product)) === rawId(lineId)
      );
    }

    isOneTimeApiProduct(contract, product) {
      if (!contract || !product) return false;
      const lineId = getLineId(product);
      const variantId = getVariantId(product);
      return (contract.oneTimeProducts || []).some((item) => {
        const itemLineId = getLineId(item);
        if (lineId && itemLineId) {
          return String(itemLineId) === String(lineId) || rawId(itemLineId) === rawId(lineId);
        }
        return variantId && rawId(getVariantId(item)) === rawId(variantId);
      });
    }

    getSwapCandidates(currentProduct) {
      const currentVariant = rawId(getVariantId(currentProduct));
      const sourceProducts = [
        ...SYSTEM_PRODUCTS,
        ...this.contracts.flatMap((contract) => [
          ...getContractLines(contract),
          ...(contract.oneTimeProducts || []),
        ])
      ];
      return uniqueProductsByVariant(sourceProducts).filter(
        (product) =>
          rawId(getAddableVariantId(product)) &&
          rawId(getAddableVariantId(product)) !== currentVariant &&
          !isProductOutOfStock(product)
      );
    }

    getOneTimeCandidates(contract) {
      const sourceProducts = [
        ...SYSTEM_PRODUCTS,
        ...getContractLines(contract),
        ...(contract?.oneTimeProducts || []),
        ...this.contracts.flatMap((item) => [
          ...getContractLines(item),
          ...(item?.oneTimeProducts || []),
        ]),
      ];

      return uniqueProductsByVariant(sourceProducts).filter(
        (product) => rawId(getAddableVariantId(product)) && !isProductOutOfStock(product)
      );
    }

    async reloadActiveTab(tab) {
      const contract = this.getSelectedContract();
      if (!contract || !['schedules', 'history'].includes(tab)) return;
      delete this.state.tabData[tab][rawId(contract.id)];
      await this.loadTabData(contract.id, tab);
    }

    changeHistoryPage(contractId, page) {
      const contract = this.findContract(contractId);
      if (!contract) return;
      this.state.historyPages[rawId(contract.id)] = Math.max(1, Number(page) || 1);
      this.render();
    }

    async handleClick(event) {
      const actionElement = event.target.closest('[data-action]');
      if (!actionElement || !this.root.contains(actionElement)) return;

      const action = actionElement.dataset.action;
      const contractId = actionElement.dataset.contractId;

      try {
        switch (action) {
          case 'retry':
            await this.loadPortalData({ showLoading: true });
            break;
          case 'open-build-a-box':
            this.openBuildABoxModal(contractId);
            break;
          case 'build-a-box-add-item': {
            let variantId = actionElement.dataset.variantId;
            const contract = this.getSelectedContract();
            if (!contract) break;
            
            const isModal = this.state.isBuildABoxModalOpen;
            if (isModal) {
              this.setModalBusy(true);
              actionElement.textContent = 'Adding...';
            } else {
              this.state.loading = true;
              this.render();
            }

            try {
              const product = findCatalogOrContractProduct(variantId);
              const addableVariantId = product ? (getAddableVariantId(product) || variantId) : variantId;
              variantId = await this.resolveVariantId(addableVariantId);
              if (product && isProductIdValue(product, variantId)) {
                throw new Error(`Variant ID not found for ${getProductTitle(product)}.`);
              }
              if (this.state.productCatalogMode === 'recurring') {
                // Add as subscription product (recurring)
                await this.api.addRecurringProduct(contract.id, variantId, 1);
                this.setNotice('Successfully added subscription product to your box!', 'success');
              } else {
                // Add as one-off delivery product (one-time)
                const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
                await this.api.addOneTimeProduct(contract.id, variantId, 1, deliveryDate);
                this.setNotice('Successfully added one-time product to your box!', 'success');
              }
              await this.loadPortalData({ showLoading: false });
              if (isModal) {
                this.updateBuildABoxModalContent();
              }
            } catch (error) {
              this.setNotice(userFacingError(error, 'Could not add item to box.'), 'error');
            } finally {
              if (isModal) {
                this.setModalBusy(false);
              } else {
                this.state.loading = false;
                this.render();
              }
            }
            break;
          }
          case 'change-catalog-mode': {
            this.state.productCatalogMode = actionElement.dataset.mode;
            if (this.state.isBuildABoxModalOpen) {
              this.updateBuildABoxModalContent();
            } else {
              this.render();
            }
            break;
          }
          case 'clear-catalog-search': {
            this.state.productSearchQuery = '';
            if (this.state.isBuildABoxModalOpen) {
              this.updateBuildABoxModalContent();
            } else {
              this.render();
            }
            break;
          }
          case 'filter-list': {
            this.state.listFilter = actionElement.dataset.filter;
            this.render();
            break;
          }
          case 'reactivate-contract': {
            this.state.loading = true;
            this.render();
            try {
              await this.api.updateContractStatus(contractId || this.state.selectedContractId, 'ACTIVE');
              this.setNotice('Subscription resumed successfully!', 'success');
              await this.loadPortalData({ showLoading: false });
            } catch (error) {
              this.setNotice(userFacingError(error, 'Could not resume subscription.'), 'error');
            } finally {
              this.state.loading = false;
              this.render();
            }
            break;
          }
          case 'dismiss-notice':
            this.clearNotice();
            break;
          case 'toggle-sort-direction':
            this.state.sortDirection =
              this.state.sortDirection === 'asc' ? 'desc' : 'asc';
            this.render();
            break;
          case 'view-detail':
            this.navigateToDetail(contractId);
            break;
          case 'back-list':
            this.navigateToList();
            break;
          case 'select-tab':
            this.navigateToDetail(contractId, actionElement.dataset.tab);
            break;
          case 'reload-tab':
            await this.reloadActiveTab(actionElement.dataset.tab);
            break;
          case 'history-page':
            this.changeHistoryPage(contractId, actionElement.dataset.page);
            break;
          case 'pause-subscription':
            this.openPauseRetentionModal(contractId);
            break;
          case 'resume-subscription':
            this.openResumeModal(contractId);
            break;
          case 'cancel-subscription':
            this.openCancelModal(contractId);
            break;
          case 'change-quantity':
            await this.changeQuantity(actionElement);
            break;
          case 'open-swap':
            this.openSwapModal(actionElement);
            break;
          case 'open-skip-product-next-order':
            this.openSkipProductNextOrderModal(actionElement);
            break;
          case 'open-unskip-product-next-order':
            this.openUnskipProductNextOrderModal(actionElement);
            break;
          case 'open-remove-product':
            this.openRemoveProductModal(actionElement);
            break;
          case 'open-skip-delivery':
            this.openSkipDeliveryModal(actionElement);
            break;
          case 'open-order-note':
            this.openOrderNoteModal(actionElement);
            break;
          case 'open-add-one-time':
            this.openAddOneTimeModal(contractId);
            break;
          case 'view-past-orders':
            this.navigateToDetail(contractId, 'history');
            break;
          case 'remove-coupon':
            await this.removeCoupon(actionElement);
            break;
          default:
            break;
        }
      } catch (error) {
        console.error('Harvest portal action error:', error);
        this.setNotice(userFacingError(error, 'That action could not be completed.'), 'error');
      }
    }

    handleChange(event) {
      const action = event.target.dataset.action;
      if (action === 'change-sort') {
        this.state.sortKey = event.target.value;
        this.render();
      }
    }

    async handleModalClick(event) {
      if (
        event.target.matches('[data-modal-close]') ||
        event.target.matches('.harvest-modal__backdrop') ||
        event.target === this.modalRoot
      ) {
        this.closeModal();
        return;
      }

      const actionElement = event.target.closest('[data-action], [data-modal-action]');
      if (!actionElement) return;

      const action = actionElement.dataset.action || actionElement.dataset.modalAction;
      const contractId = actionElement.dataset.contractId;

      try {
        if (action === 'modal-qty-change') {
          const variantId = actionElement.dataset.variantId;
          const change = Number(actionElement.dataset.change) || 0;
          const input = document.getElementById(`modal-qty-${variantId}`);
          if (input) {
            let currentVal = Number(input.value) || 0;
            let nextVal = currentVal + change;
            if (nextVal < 0) nextVal = 0;
            input.value = nextVal;
            this.state.modalQuantities[variantId] = nextVal;
            this.updateEditProductsButtonState();
          }
          return;
        } else if (action === 'toggle-purchase-type') {
          this.state.productCatalogMode = this.state.productCatalogMode === 'recurring' ? 'one_time' : 'recurring';
          this.updateBuildABoxModalContent();
          this.updateEditProductsButtonState();
          return;
        } else if (action === 'toggle-catalog-filter') {
          this.state.isFilterExpanded = !this.state.isFilterExpanded;
          if (this.state.isBuildABoxModalOpen) {
            this.updateBuildABoxModalContent();
            this.updateEditProductsButtonState();
          } else if (this.state.isSwapModalOpen) {
            this.updateSwapModalContent();
          }
          return;
        } else if (action === 'confirm-add-multiple') {
          await this.executeAddMultipleProducts(contractId, actionElement);
          return;
        } else if (action === 'clear-catalog-search') {
          this.state.productSearchQuery = '';
          if (this.state.isBuildABoxModalOpen) {
            this.updateBuildABoxModalContent();
            this.updateEditProductsButtonState();
          } else if (this.state.isSwapModalOpen) {
            this.updateSwapModalContent();
          }
          return;
        } else if (action === 'confirm-card-swap') {
          const lineId = actionElement.dataset.lineId;
          const oldVariantId = actionElement.dataset.oldVariantId;
          const quantity = Number(actionElement.dataset.quantity) || 1;
          const newVariantId = actionElement.dataset.newVariantId;
          const isOneTime = actionElement.dataset.oneTime === 'true';
          this.openSwapConfirmationModal(contractId, lineId, oldVariantId, quantity, newVariantId, isOneTime);
          return;
        } else if (action === 'go-back-to-swap-list') {
          const mockElement = {
            dataset: {
              contractId: actionElement.dataset.contractId,
              lineId: actionElement.dataset.lineId,
              variantId: actionElement.dataset.variantId,
              oneTime: actionElement.dataset.oneTime
            }
          };
          this.openSwapModal(mockElement);
          return;
        } else if (action === 'execute-actual-swap') {
          const lineId = actionElement.dataset.lineId;
          const oldVariantId = actionElement.dataset.oldVariantId;
          const quantity = Number(actionElement.dataset.quantity) || 1;
          const unresolvedVariantId = actionElement.dataset.newVariantId;
          const isOneTime = actionElement.dataset.oneTime === 'true';
          
          this.setModalBusy(true);
          actionElement.textContent = 'Swapping...';
          
          const contract = this.findContract(contractId);
          if (!contract) throw new Error('Contract not found.');

          const selectedProduct = findCatalogOrContractProduct(unresolvedVariantId);
          const addableVariantId = selectedProduct ? (getAddableVariantId(selectedProduct) || unresolvedVariantId) : unresolvedVariantId;
          const newVariantId = await this.resolveVariantId(addableVariantId);
          if (selectedProduct && isProductIdValue(selectedProduct, newVariantId)) {
            throw new Error(`Variant ID not found for ${getProductTitle(selectedProduct)}.`);
          }

          if (isOneTime) {
            const oldProduct = this.findProduct(contract, lineId, true);
            if (oldProduct) {
              const removeAsOneTime = this.isOneTimeApiProduct(contract, oldProduct);
              await this.api.removeLineItem(contract.id, oldProduct, removeAsOneTime);
            }
            const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
            await this.api.addOneTimeProduct(contract.id, newVariantId, quantity, deliveryDate);
          } else {
            const shopDomain = getShopDomain();
            const oldLineIdGid = lineId && !lineId.startsWith('gid://') ? `gid://shopify/SubscriptionContractLine/${lineId}` : lineId;

            const standardPayload = {
              shop: shopDomain,
              contractId: rawId(contractId),
              oldVariants: [Number(rawId(oldVariantId))],
              newVariants: {
                [rawId(newVariantId)]: quantity,
              },
              oldLineId: oldLineIdGid,
            };

            let newProductObj = null;
            try {
              const portal = window.harvestPortal || window.portal || this;
              const sourceProducts = [
                ...SYSTEM_PRODUCTS,
                ...(portal.contracts || []).flatMap((c) => [
                  ...getContractLines(c),
                  ...(c.oneTimeProducts || []),
                ])
              ];
              newProductObj = sourceProducts.find(p => rawId(getAddableVariantId(p) || getVariantId(p)) === rawId(newVariantId));
            } catch (err) {
              console.warn('Error fetching sourceProducts for swap details:', err);
            }

            const pTitle = newProductObj ? getProductTitle(newProductObj) : 'Product';
            const pImage = newProductObj ? getProductImage(newProductObj) : PLACEHOLDER_IMAGE;
            const pId = newProductObj ? rawId(newProductObj?.productId || newProductObj?.product?.id || '') : '';
            const vTitle = newProductObj ? (newProductObj?.variant?.title || newProductObj?.variantTitle || '') : '';

            const groupSwapPayload = {
              variantQuantityList: [
                {
                  variantId: Number(rawId(newVariantId)) || newVariantId,
                  quantity: quantity,
                  title: vTitle || pTitle,
                  image: pImage,
                  productTitle: pTitle,
                  productId: Number(pId) || pId || undefined,
                  variantTitle: vTitle || pTitle,
                  swapId: isNaN(Number(rawId(oldVariantId))) ? oldVariantId : (Number(rawId(oldVariantId)) || oldVariantId)
                }
              ]
            };

            await this.api.replaceVariants(contractId, standardPayload, groupSwapPayload);
          }

          await this.loadPortalData({ showLoading: false });
          this.state.isSwapModalOpen = false;
          this.closeModal();
          this.setNotice('Product swapped successfully.', 'success');
          return;
        } else if (action === 'show-pause-reason') {
          this.openPauseReasonModal(contractId);
        } else if (action === 'confirm-pause') {
          const select = this.modalRoot.querySelector('[name="pause-reason"]');
          if (!select?.value) {
            this.setModalMessage('Please select a pause reason.', 'error');
            return;
          }
          await this.executeStatusChange(contractId, 'PAUSED', 'Subscription paused.');
        } else if (action === 'confirm-resume') {
          await this.executeStatusChange(contractId, 'ACTIVE', 'Subscription resumed.');
        } else if (action === 'confirm-cancel') {
          await this.executeStatusChange(contractId, 'CANCELLED', 'Subscription cancelled.');
        } else if (action === 'confirm-swap') {
          await this.executeSwap(actionElement);
        } else if (action === 'confirm-skip-product-next-order') {
          await this.executeSkipProductNextOrder(actionElement);
        } else if (action === 'confirm-unskip-product-next-order') {
          await this.executeUnskipProductNextOrder(actionElement);
        } else if (action === 'confirm-remove-product') {
          await this.executeRemoveProduct(actionElement);
        } else if (action === 'confirm-skip-delivery') {
          await this.executeSkipDelivery(actionElement);
        } else if (action === 'confirm-reschedule') {
          await this.executeReschedule(actionElement);
        } else if (action === 'confirm-order-note') {
          await this.executeOrderNote(actionElement);
        } else if (action === 'confirm-add-one-time') {
          await this.executeAddOneTime(actionElement);
        }
      } catch (error) {
        console.error('Harvest portal modal action error:', error);
        this.setModalBusy(false);
        this.setModalMessage(
          userFacingError(error, 'That action could not be completed.'),
          'error'
        );
      }
    }

    openPauseRetentionModal(contractId) {
      this.openModal({
        title: 'Pause Subscription',
        body: `
          <p>Need a break? You can continue to pause this subscription. Skipping individual orders will be available in a future portal update.</p>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>
            Keep Subscription Active
          </button>
          <button class="harvest-button harvest-button--primary" type="button" data-modal-action="show-pause-reason" data-contract-id="${escapeAttr(
            contractId
          )}">
            Continue to Pause
          </button>
        `,
      });
    }

    openPauseReasonModal(contractId) {
      this.openModal({
        title: 'Pause Subscription',
        body: `
          <label class="harvest-field harvest-field--stacked">
            <span>Why are you pausing?</span>
            <select name="pause-reason">
              <option value="">Select Pause Reason</option>
              <option value="budget">I have more than I need right now</option>
              <option value="away">I will be out of town or unavailable</option>
              <option value="break">Just taking a short break</option>
              <option value="other">Other</option>
            </select>
          </label>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Go Back</button>
          <button class="harvest-button harvest-button--primary" type="button" data-modal-action="confirm-pause" data-contract-id="${escapeAttr(
            contractId
          )}">Pause Subscription</button>
        `,
      });
    }

    openResumeModal(contractId) {
      this.openModal({
        title: 'Resume Subscription',
        body: '<p>Your subscription will become active again and continue on its existing schedule.</p>',
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Not Now</button>
          <button class="harvest-button harvest-button--primary" type="button" data-modal-action="confirm-resume" data-contract-id="${escapeAttr(
            contractId
          )}">Resume Subscription</button>
        `,
      });
    }

    openCancelModal(contractId) {
      this.openModal({
        title: 'Cancel Subscription',
        body: '<p>Are you sure you want to cancel this subscription? This action may not be reversible from the portal.</p>',
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Subscription</button>
          <button class="harvest-button harvest-button--danger" type="button" data-modal-action="confirm-cancel" data-contract-id="${escapeAttr(
            contractId
          )}">Cancel Subscription</button>
        `,
      });
    }

    openRemoveProductModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const isOneTime = actionElement.dataset.oneTime === 'true';
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);

      if (!contract || !product) {
        this.setNotice('That harvest item was not found.', 'error');
        return;
      }

      this.openModal({
        title: 'Remove Item',
        body: `
          <p>Remove <strong>${escapeHtml(getProductTitle(product))}</strong> from this harvest?</p>
          <p class="harvest-modal-note">This updates the upcoming delivery after Appstle confirms the change.</p>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Item</button>
          <button
            class="harvest-button harvest-button--danger"
            type="button"
            data-modal-action="confirm-remove-product"
            data-contract-id="${escapeAttr(contract.id)}"
            data-line-id="${escapeAttr(getLineId(product))}"
            data-one-time="${isOneTime ? 'true' : 'false'}"
          >Remove Item</button>
        `,
      });
    }

    openSkipProductNextOrderModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, false);

      if (!contract || !product) {
        this.setNotice('That harvest item was not found.', 'error');
        return;
      }

      this.openModal({
        title: 'Skip Item',
        body: `
          <p>Skip <strong>${escapeHtml(getProductTitle(product))}</strong> for your next order?</p>
          <p class="harvest-modal-note">This item returns on following deliveries. The rest of your order stays unchanged.</p>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Item</button>
          <button
            class="harvest-button harvest-button--primary"
            type="button"
            data-modal-action="confirm-skip-product-next-order"
            data-contract-id="${escapeAttr(contract.id)}"
            data-line-id="${escapeAttr(getLineId(product))}"
          >Skip Item</button>
        `,
      });
    }

    openUnskipProductNextOrderModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, false);

      if (!contract || !product) {
        this.setNotice('That harvest item was not found.', 'error');
        return;
      }

      this.openModal({
        title: 'Unskip Item',
        body: `
          <p>Unskip <strong>${escapeHtml(getProductTitle(product))}</strong> for your next order?</p>
          <p class="harvest-modal-note">This item will be included in your next order again.</p>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Skipped</button>
          <button
            class="harvest-button harvest-button--primary"
            type="button"
            data-modal-action="confirm-unskip-product-next-order"
            data-contract-id="${escapeAttr(contract.id)}"
            data-line-id="${escapeAttr(getLineId(product))}"
          >Unskip Item</button>
        `,
      });
    }

    openSkipDeliveryModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
      if (!contract || !deliveryDate) {
        this.setNotice('No delivery date was found to skip.', 'error');
        return;
      }

      this.openModal({
        title: 'Skip This Delivery',
        body: `
          <p>Skip the delivery scheduled for <strong>${escapeHtml(
            formatDate(deliveryDate)
          )}</strong>?</p>
          <p class="harvest-modal-note">Your following deliveries stay on their current frequency.</p>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Delivery</button>
          <button
            class="harvest-button harvest-button--primary"
            type="button"
            data-modal-action="confirm-skip-delivery"
            data-contract-id="${escapeAttr(contract.id)}"
            data-delivery-date="${escapeAttr(deliveryDate)}"
            data-billing-attempt-id="${escapeAttr(actionElement.dataset.billingAttemptId || '')}"
          >Skip This Delivery</button>
        `,
      });
    }

    openRescheduleModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
      if (!contract || !deliveryDate) {
        this.setNotice('No delivery date was found to reschedule.', 'error');
        return;
      }

      const expectedWeekday = getWeekdayName(deliveryDate);

      this.openModal({
        title: 'Reschedule Delivery',
        body: `
          <p>Choose a new date for <strong>${escapeHtml(formatDate(deliveryDate))}</strong>.</p>
          ${expectedWeekday ? `
            <div style="margin-bottom: 12px; font-size: 13px; padding: 10px; border-radius: 6px; background-color: #f0f7ff; color: #004085; border: 1px solid #b8daff; line-height: 1.4;">
              <strong>Note:</strong> Your subscription is configured for <strong>${expectedWeekday}</strong> deliveries. Please select a <strong>${expectedWeekday}</strong> to avoid Appstle rescheduling restrictions.
            </div>
          ` : ''}
          <label class="harvest-field harvest-field--stacked">
            <span>New delivery date</span>
            <input type="date" name="reschedule-date" min="${escapeAttr(
              toDateInputValue(new Date())
            )}" value="${escapeAttr(toDateInputValue(deliveryDate))}">
          </label>
          <div class="reschedule-warning" style="margin-top: 8px;"></div>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Cancel</button>
          <button
            class="harvest-button harvest-button--primary"
            type="button"
            data-modal-action="confirm-reschedule"
            data-contract-id="${escapeAttr(contract.id)}"
            data-delivery-date="${escapeAttr(deliveryDate)}"
          >Reschedule</button>
        `,
      });

      const dateInput = this.modalRoot.querySelector('[name="reschedule-date"]');
      if (dateInput && expectedWeekday) {
        const warningDiv = this.modalRoot.querySelector('.reschedule-warning');
        dateInput.addEventListener('change', () => {
          const selectedDate = dateInput.value;
          const selectedWeekday = getWeekdayName(selectedDate);
          if (selectedWeekday && selectedWeekday !== expectedWeekday) {
            warningDiv.innerHTML = `
              <div style="font-size: 13px; padding: 10px; border-radius: 6px; background-color: #fff3cd; color: #856404; border: 1px solid #ffeeba; line-height: 1.4;">
                <strong>Warning:</strong> You selected a <strong>${selectedWeekday}</strong>, but your subscription's allowed delivery day is <strong>${expectedWeekday}</strong>. Appstle may reject this date.
              </div>
            `;
          } else {
            warningDiv.innerHTML = '';
          }
        });
      }
    }

    openOrderNoteModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
      if (!contract || !deliveryDate) {
        this.setNotice('No delivery date was found for this note.', 'error');
        return;
      }

      this.openModal({
        title: 'Order Note',
        body: `
          <p>Add a note for <strong>${escapeHtml(formatDate(deliveryDate))}</strong>.</p>
          <label class="harvest-field harvest-field--stacked">
            <span>Note</span>
            <textarea name="order-note" rows="4">${escapeHtml(
              actionElement.dataset.note || ''
            )}</textarea>
          </label>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Cancel</button>
          <button
            class="harvest-button harvest-button--primary"
            type="button"
            data-modal-action="confirm-order-note"
            data-contract-id="${escapeAttr(contract.id)}"
            data-delivery-date="${escapeAttr(deliveryDate)}"
          >Save Note</button>
        `,
      });
    }

    openAddOneTimeModal(contractId) {
      this.openBuildABoxModal(contractId, 'one_time');
    }

    async executeStatusChange(contractId, status, successMessage) {
      this.setModalBusy(true);
      await this.api.updateContractStatus(contractId, status);
      await this.loadPortalData({ showLoading: false });
      this.closeModal();
      this.setNotice(successMessage, 'success');
    }

    async executeRemoveProduct(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const isOneTime = actionElement.dataset.oneTime === 'true';
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);
      if (!contract || !product) throw new Error('Harvest item was not found.');

      this.setModalBusy(true);
      try {
        const removeAsOneTime = isOneTime && this.isOneTimeApiProduct(contract, product);
        await this.api.removeLineItem(contract.id, product, removeAsOneTime);
        await this.loadPortalData({ showLoading: false });
        this.closeModal();
        this.setNotice('Item removed from your upcoming harvest.', 'success');
      } catch (err) {
        this.setNotice(userFacingError(err, 'Could not remove item.'), 'error');
      }
    }

    async executeSkipProductNextOrder(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, false);
      if (!contract || !product) throw new Error('Harvest item was not found.');

      this.setModalBusy(true);
      const payload = await this.api.skipLineItemForNextOrder(contract.id, product);
      product._harvestSkippedForNextOrder = true;
      rememberLineSkippedForNextOrder(contract, product);
      const updatedContract = extractContractFromObject(payload);
      if (updatedContract) {
        Object.assign(contract, updatedContract);
      }
      markLineSkippedForNextOrder(contract, actionElement.dataset.lineId, product);
      this.invalidateTabData(contract.id, 'schedules');
      this.closeModal();
      this.setNotice('Item skipped for your next order.', 'success');
    }

    async executeUnskipProductNextOrder(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const product = contract && this.findProduct(contract, actionElement.dataset.lineId, false);
      if (!contract || !product) throw new Error('Harvest item was not found.');

      this.setModalBusy(true);
      const payload = await this.api.unskipLineItemForNextOrder(contract.id, product);
      forgetLineSkippedForNextOrder(contract, product);
      markLineUnskippedForNextOrder(contract, actionElement.dataset.lineId, product);
      const updatedContract = extractContractFromObject(payload);
      if (updatedContract) {
        Object.assign(contract, updatedContract);
        markLineUnskippedForNextOrder(contract, actionElement.dataset.lineId, product);
      }
      this.invalidateTabData(contract.id, 'schedules');
      this.closeModal();
      this.setNotice('Item unskipped for your next order.', 'success');
    }

    async executeSkipDelivery(actionElement) {
      const contractId = actionElement.dataset.contractId;
      const contract = this.findContract(contractId);
      const deliveryDate = actionElement.dataset.deliveryDate || (contract ? getNextDeliveryDate(contract) : '');
      const billingAttemptId = actionElement.dataset.billingAttemptId || '';
      
      this.setModalBusy(true);
      await this.api.skipDelivery(contractId, deliveryDate, billingAttemptId);
      this.invalidateTabData(contractId, 'schedules');
      await this.loadPortalData({ showLoading: false });
      this.closeModal();
      this.setNotice('Delivery skipped.', 'success');
    }

    async executeReschedule(actionElement) {
      const newDate = this.modalRoot.querySelector('[name="reschedule-date"]')?.value;
      if (!newDate) {
        this.setModalMessage('Please choose a delivery date.', 'error');
        return;
      }

      this.setModalBusy(true);
      await this.api.rescheduleDelivery(
        actionElement.dataset.contractId,
        actionElement.dataset.deliveryDate,
        newDate
      );
      this.invalidateTabData(actionElement.dataset.contractId, 'schedules');
      await this.loadPortalData({ showLoading: false });
      this.closeModal();
      this.setNotice('Delivery rescheduled.', 'success');
    }

    async executeOrderNote(actionElement) {
      const note = this.modalRoot.querySelector('[name="order-note"]')?.value || '';
      this.setModalBusy(true);
      try {
        await this.api.updateOrderNote(
          actionElement.dataset.contractId,
          actionElement.dataset.deliveryDate,
          note
        );
        this.invalidateTabData(actionElement.dataset.contractId, 'schedules');
        await this.loadPortalData({ showLoading: false });
        this.closeModal();
        this.setNotice('Order note saved.', 'success');
      } catch (error) {
        console.error('Error saving order note:', error);
        this.setModalBusy(false);
        this.setModalMessage(error.message || 'Failed to save order note.', 'error');
      }
    }


    async executeAddOneTime(actionElement) {
      const variantId = this.modalRoot.querySelector('[name="one-time-variant"]')?.value;
      const quantity = Number(this.modalRoot.querySelector('[name="one-time-quantity"]')?.value || 1);
      if (!variantId || quantity < 1) {
        this.setModalMessage('Please choose an item and quantity.', 'error');
        return;
      }

      this.setModalBusy(true);
      try {
        await this.api.addOneTimeProduct(
          actionElement.dataset.contractId,
          variantId,
          quantity,
          actionElement.dataset.deliveryDate
        );
        await this.loadPortalData({ showLoading: false });
        this.closeModal();
        this.setNotice('One-time item added to your upcoming harvest.', 'success');
      } catch (error) {
        this.setNotice(userFacingError(error, 'Could not add item to box.'), 'error');
      }
    }

    async applyCoupon(form) {
      const contractId = form.dataset.contractId;
      const input = form.querySelector('[name="discount-code"]');
      const code = (input && input.value ? String(input.value).trim() : '');
      if (!code) {
        this.setNotice('Please enter a discount code.', 'error');
        return;
      }

      this.state.couponBusy = { id: rawId(contractId), action: 'apply' };
      this.render();

      try {
        const payload = await this.api.applyDiscountCode(contractId, code);
        const apiMessage =
          payload && typeof payload === 'object'
            ? payload.message || payload.error || payload.title
            : null;
        if (
          payload &&
          typeof payload === 'object' &&
          (payload.success === false || payload.status === 'error' || payload.errorKey)
        ) {
          throw new Error(apiMessage || 'That discount code could not be applied.');
        }
        this.setNotice('Discount code applied successfully.', 'success');
        await this.loadPortalData({ showLoading: false });
      } catch (error) {
        this.setNotice(userFacingError(error, 'Could not apply that discount code.'), 'error');
      } finally {
        this.state.couponBusy = null;
        this.render();
      }
    }

    async removeCoupon(actionElement) {
      const contractId = actionElement.dataset.contractId;
      const discountId = actionElement.dataset.discountId;
      if (!contractId || !discountId) return;

      this.state.couponBusy = { id: rawId(contractId), action: 'remove', discountId };
      this.render();

      try {
        const payload = await this.api.removeDiscount(contractId, discountId);
        const apiMessage =
          payload && typeof payload === 'object'
            ? payload.message || payload.error || payload.title
            : null;
        if (
          payload &&
          typeof payload === 'object' &&
          (payload.success === false || payload.status === 'error' || payload.errorKey)
        ) {
          throw new Error(apiMessage || 'That discount could not be removed.');
        }
        this.setNotice('Discount removed successfully.', 'success');
        await this.loadPortalData({ showLoading: false });
      } catch (error) {
        this.setNotice(userFacingError(error, 'Could not remove that discount.'), 'error');
      } finally {
        this.state.couponBusy = null;
        this.render();
      }
    }

    invalidateTabData(contractId, tab) {
      const id = rawId(contractId);
      if (this.state.tabData[tab]) delete this.state.tabData[tab][id];
    }

    async changeQuantity(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const isOneTime = actionElement.dataset.oneTime === 'true';
      const line = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);
      if (!contract || !line) throw new Error('Harvest item was not found.');

      const lineId = String(actionElement.dataset.lineId);
      const lineKey = pendingLineKey(contract.id, lineId);
      if (this.state.pendingLines.has(lineKey)) return;

      const oldQuantity = getQuantity(line);
      const nextQuantity = oldQuantity + Number(actionElement.dataset.change || 0);
      if (nextQuantity < 1) return;

      this.state.pendingLines.add(lineKey);
      line.quantity = nextQuantity;
      this.render();

      try {
        if (isOneTime) {
          const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
          const variantId = getVariantId(line);
          await this.api.addOneTimeProduct(
            contract.id,
            variantId,
            nextQuantity,
            deliveryDate
          );
        } else {
          await this.api.updateLineItemQuantity(
            contract.id,
            actionElement.dataset.lineId,
            actionElement.dataset.variantId,
            nextQuantity
          );
        }
        this.setNotice('Product quantity updated.', 'success');
      } catch (error) {
        line.quantity = oldQuantity;
        throw error;
      } finally {
        this.state.pendingLines.delete(lineKey);
        this.render();
      }
    }

    openSwapModal(actionElement) {
      const contract = this.findContract(actionElement.dataset.contractId);
      const isOneTime = actionElement.dataset.oneTime === 'true' || (typeof actionElement.closest === 'function' && actionElement.closest('.harvest-product-card')?.dataset.oneTime === 'true') || false;
      const line = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime, actionElement.dataset.variantId);
      if (!contract || !line) {
        this.setNotice('Harvest item was not found.', 'error');
        return;
      }

      this.state.selectedContractId = contract.id;
      this.state.swappingLineId = actionElement.dataset.lineId || getLineId(line);
      this.state.swappingOldVariantId = actionElement.dataset.variantId || getVariantId(line);
      this.state.swappingQuantity = getQuantity(line);
      this.state.swappingIsOneTime = isOneTime;
      this.state.isSwapModalOpen = true;
      this.state.selectedCategory = '';
      this.state.isFilterExpanded = false;

      const candidates = this.getSwapCandidates(line);
      if (!candidates.length) {
        this.openModal({
          title: 'Swap Item',
          body: '<p>No eligible swap items were returned from your current harvests.</p>',
          actions:
            '<button class="harvest-button harvest-button--primary" type="button" data-modal-close>Close</button>',
        });
        return;
      }

      this.openModal({
        title: 'Select Product',
        dialogClass: 'harvest-modal__dialog--large',
        body: this.renderSwapModalBody(contract, line),
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-modal-close style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
            Cancel
          </button>
        `
      });
    }

    updateSwapModalContent() {
      const contract = this.getSelectedContract();
      const line = contract && this.findLine(contract, this.state.swappingLineId);
      if (!contract || !line) return;
      
      const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
      if (bodyContainer) {
        bodyContainer.innerHTML = `
          <div class="harvest-modal__message" hidden></div>
          ${this.renderSwapModalBody(contract, line)}
        `;
      }

      // Keep search input focused
      const input = this.modalRoot.querySelector('#catalog-search');
      if (input) {
        input.focus();
        const val = input.value;
        input.value = '';
        input.value = val;
      }
    }

    renderSwapModalBody(contract, line) {
      const candidates = this.getSwapCandidates(line);

      // Collect all unique tags for the filter
      const uniqueTags = new Set();
      candidates.forEach(p => {
        if (p.tags && Array.isArray(p.tags)) {
          p.tags.forEach(t => {
            if (t && t.length > 1) {
              uniqueTags.add(t.charAt(0).toUpperCase() + t.slice(1));
            }
          });
        }
        if (p.productType) {
          uniqueTags.add(p.productType.charAt(0).toUpperCase() + p.productType.slice(1));
        }
      });
      const tagList = Array.from(uniqueTags).sort();

      // Filter swap candidates by search query
      let filteredCandidates = candidates;
      if (this.state.productSearchQuery) {
        const query = this.state.productSearchQuery.toLowerCase().trim();
        filteredCandidates = candidates.filter(p =>
          getProductTitle(p).toLowerCase().includes(query) ||
          (p.sku && p.sku.toLowerCase().includes(query))
        );
      }

      // Filter by selected tag category
      if (this.state.selectedCategory) {
        const cat = this.state.selectedCategory.toLowerCase();
        filteredCandidates = filteredCandidates.filter(p =>
          (p.productType && p.productType.toLowerCase() === cat) ||
          (p.tags && p.tags.some(t => t.toLowerCase() === cat))
        );
      }

      return `
        <!-- Search bar inside swap modal -->
        <div class="harvest-catalog-controls-container" style="margin-bottom: 12px; padding: 0; background: transparent; border: none;">
          <div class="harvest-catalog-search-row" style="display: flex; align-items: center; gap: 8px; width: 100%;">
            <div class="harvest-catalog-search-wrapper" style="position: relative; flex: 1; max-width: 100%;">
              <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
                     placeholder="Search a product to swap..." value="${escapeAttr(this.state.productSearchQuery || '')}"
                     style="padding-left: 36px; height: 42px; box-sizing: border-box;">
              <!-- Magnifying Glass Icon -->
              <svg class="harvest-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--harvest-text-muted);">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              ${this.state.productSearchQuery ? `
                <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search" style="right: 10px;">&times;</button>
              ` : ''}
            </div>
            <button class="harvest-catalog-filter-btn one-time" type="button" data-action="toggle-catalog-filter" style="display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; background: var(--harvest-surface); cursor: pointer; color: var(--harvest-text);">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="4" y1="21" x2="4" y2="14"></line>
                <line x1="4" y1="10" x2="4" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12" y2="3"></line>
                <line x1="20" y1="21" x2="20" y2="16"></line>
                <line x1="20" y1="12" x2="20" y2="3"></line>
                <line x1="1" y1="14" x2="7" y2="14"></line>
                <line x1="9" y1="8" x2="15" y2="8"></line>
                <line x1="17" y1="16" x2="23" y2="16"></line>
              </svg>
            </button>
          </div>
          
          <div class="harvest-catalog-filter-container" style="margin-top: 12px; display: ${this.state.isFilterExpanded ? 'block' : 'none'};">
            <label style="display: block; font-size: 13px; font-weight: 600; color: var(--harvest-text-muted); margin-bottom: 4px;">Tags</label>
            <select id="catalog-tag-select" class="harvest-select" style="width: 100%; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; padding: 0 12px; background: #fff;">
              <option value="">Select...</option>
              ${tagList.map(tag => `<option value="${escapeAttr(tag)}" ${this.state.selectedCategory === tag ? 'selected' : ''}>${escapeHtml(tag)}</option>`).join('')}
            </select>
          </div>
        </div>

        <p class="harvest-section-subtitle" style="margin-top: 12px; margin-bottom: 12px;">
          Select a product below to confirm the swap:
        </p>

        <div class="harvest-detail-products harvest-catalog-modal-grid">
          ${filteredCandidates.length === 0 ? `
            <div style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
              <p style="color: var(--harvest-text-muted);">No products match your search.</p>
            </div>
          ` : filteredCandidates
            .map((product) => {
              const variantId = getAddableVariantId(product);
              return `
                <article class="harvest-product-card harvest-product-card--available">
                  <div class="harvest-product-card__media">
                    <img
                      src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
                      alt="${escapeAttr(getProductTitle(product))}"
                      loading="lazy"
                    >
                  </div>
                  <div class="harvest-product-card__body">
                    <div class="harvest-product-card__copy">
                      <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
                      <p class="harvest-product-card__price">
                        ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
                      </p>
                    </div>
                    <button
                      class="harvest-button harvest-button--primary"
                      type="button"
                      data-action="confirm-card-swap"
                      data-contract-id="${escapeAttr(contract.id)}"
                      data-line-id="${escapeAttr(this.state.swappingLineId)}"
                      data-old-variant-id="${escapeAttr(this.state.swappingOldVariantId)}"
                      data-new-variant-id="${escapeAttr(variantId)}"
                      data-quantity="${this.state.swappingQuantity}"
                      data-one-time="${this.state.swappingIsOneTime ? 'true' : 'false'}"
                      style="width: 100%; margin-top: 12px; background: #000000 !important; border-color: #000000 !important; color: #ffffff !important;"
                    >
                      Confirm Swap
                    </button>
                  </div>
                </article>
              `;
            })
            .join('')}
        </div>
      `;
    }

    openSwapConfirmationModal(contractId, lineId, oldVariantId, quantity, newVariantId, isOneTime = false) {
      this.state.swappingNewVariantId = newVariantId;
      
      const contract = this.findContract(contractId);
      const line = contract && this.findProduct(contract, lineId, isOneTime, oldVariantId);
      
      const oldProduct = line;
      const newProduct = findCatalogOrContractProduct(newVariantId);
      
      const oldTitle = oldProduct ? getProductTitle(oldProduct) : 'Current Item';
      const oldImage = oldProduct ? getProductImage(oldProduct) : PLACEHOLDER_IMAGE;
      const oldPrice = oldProduct ? getProductPrice(oldProduct) : 0;
      
      const newTitle = newProduct ? getProductTitle(newProduct) : 'New Item';
      const newImage = newProduct ? getProductImage(newProduct) : PLACEHOLDER_IMAGE;
      const newPrice = newProduct ? getProductPrice(newProduct) : 0;
      const currency = getCurrency(contract, newProduct);

      this.openModal({
        title: 'Swap Product',
        dialogClass: 'harvest-modal__dialog--medium',
        body: `
          <div class="harvest-swap-confirm-container" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; padding: 12px 0;">
            <!-- Current Product -->
            <div class="harvest-swap-confirm-box" style="border: 1px solid var(--harvest-border); border-radius: 8px; padding: 12px; background: var(--harvest-surface-muted);">
              <span class="harvest-eyebrow" style="display: block; font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--harvest-text-muted); margin-bottom: 8px;">Current Product</span>
              <div style="display: flex; gap: 12px; align-items: start;">
                <img src="${escapeAttr(safeImageUrl(oldImage))}" alt="${escapeAttr(oldTitle)}" style="width: 56px; height: 56px; object-fit: cover; border-radius: 4px;">
                <div>
                  <h4 style="margin: 0; font-size: 13.6px; font-weight: 600; line-height: 1.3;">${escapeHtml(oldTitle)}</h4>
                  <div style="font-size: 13px; color: var(--harvest-text-muted); margin-top: 4px;">Qty: ${quantity}</div>
                  <div style="font-size: 13.6px; font-weight: 600; margin-top: 4px;">${escapeHtml(formatMoney(oldPrice, currency))}</div>
                </div>
              </div>
            </div>

            <!-- Swapping To -->
            <div class="harvest-swap-confirm-box" style="border: 1px solid var(--harvest-border); border-radius: 8px; padding: 12px; background: var(--harvest-surface-muted);">
              <span class="harvest-eyebrow" style="display: block; font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--harvest-text-muted); margin-bottom: 8px;">Swapping To</span>
              <div style="display: flex; gap: 12px; align-items: start;">
                <img src="${escapeAttr(safeImageUrl(newImage))}" alt="${escapeAttr(newTitle)}" style="width: 56px; height: 56px; object-fit: cover; border-radius: 4px;">
                <div>
                  <h4 style="margin: 0; font-size: 13.6px; font-weight: 600; line-height: 1.3;">${escapeHtml(newTitle)}</h4>
                  <div style="font-size: 13px; color: var(--harvest-text-muted); margin-top: 4px;">Qty: ${quantity}</div>
                  <div style="font-size: 13.6px; font-weight: 600; margin-top: 4px;">${escapeHtml(formatMoney(newPrice, currency))}</div>
                </div>
              </div>
            </div>
          </div>
        `,
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-action="go-back-to-swap-list" 
                  data-contract-id="${escapeAttr(contractId)}" data-line-id="${escapeAttr(lineId)}" 
                  data-variant-id="${escapeAttr(oldVariantId)}" data-one-time="${isOneTime ? 'true' : 'false'}"
                  style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
            Choose different product
          </button>
          <button class="harvest-button harvest-button--primary" type="button" data-action="execute-actual-swap" 
                  data-contract-id="${escapeAttr(contractId)}" data-line-id="${escapeAttr(lineId)}" 
                  data-old-variant-id="${escapeAttr(oldVariantId)}" data-new-variant-id="${escapeAttr(newVariantId)}" 
                  data-quantity="${quantity}" data-one-time="${isOneTime ? 'true' : 'false'}"
                  style="background: #000000 !important; border-color: #000000 !important; color: #ffffff !important;">
            Confirm Swap
          </button>
        `
      });
    }

    renderModalAddingProgress() {
      return `
        <div class="harvest-adding-progress-container" style="display: flex; flex-direction: column; gap: 16px; padding: 20px;">
          ${(this.state.addingItems || []).map(item => {
            const product = findCatalogOrContractProduct(item.variantId);
            const title = product ? getProductTitle(product) : 'Product';
            const image = product ? getProductImage(product) : PLACEHOLDER_IMAGE;
            const isDone = item.status === 'success';
            return `
              <div class="harvest-adding-progress-row" style="display: flex; align-items: center; justify-content: space-between; padding: 12px; border: 1px solid var(--harvest-border); border-radius: 8px; background: var(--harvest-surface);">
                <div style="display: flex; align-items: center; gap: 12px;">
                  <img src="${escapeAttr(safeImageUrl(image))}" alt="${escapeAttr(title)}" style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px;">
                  <strong style="font-size: 14px;">${escapeHtml(title)}</strong>
                </div>
                <div style="font-size: 13px; font-weight: 600; color: ${isDone ? 'var(--harvest-active, #2e7d32)' : 'var(--harvest-text-muted)'}; display: flex; align-items: center; gap: 6px;">
                  ${isDone ? `
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="color: #2e7d32;">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    Added
                  ` : `
                    <div class="harvest-inline-spinner" style="width: 14px; height: 14px; border: 2px solid rgba(0,0,0,0.1); border-top-color: #000; border-radius: 50%; animation: harvest-spin 0.6s linear infinite; box-sizing: border-box;"></div>
                    Adding
                  `}
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;
    }

    async executeAddMultipleProducts(contractId, actionElement) {
      const contract = this.findContract(contractId);
      if (!contract) return;
      
      const toAdd = [];
      Object.entries(this.state.modalQuantities).forEach(([variantId, qty]) => {
        if (qty > 0) {
          toAdd.push({ variantId, quantity: qty });
        }
      });
      
      if (toAdd.length === 0) {
        this.setModalMessage('Please select a quantity > 0 for at least one item.', 'error');
        return;
      }
      
      this.state.addingItems = toAdd.map(item => ({ ...item, status: 'pending' }));
      
      // Update modal body to display adding progress checklist
      const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
      if (bodyContainer) {
        bodyContainer.innerHTML = this.renderModalAddingProgress();
      }
      
      // Disable modal action footer buttons
      this.setModalBusy(true);
      
      try {
        const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
        
        for (const item of this.state.addingItems) {
          const product = findCatalogOrContractProduct(item.variantId);
          const addableVariantId = product ? (getAddableVariantId(product) || item.variantId) : item.variantId;
          const resolvedVariantId = await this.resolveVariantId(addableVariantId);
          if (product && isProductIdValue(product, resolvedVariantId)) {
            throw new Error(`Variant ID not found for ${getProductTitle(product)}.`);
          }
          if (this.state.productCatalogMode === 'recurring') {
            await this.api.addRecurringProduct(contract.id, resolvedVariantId, item.quantity);
          } else {
            await this.api.addOneTimeProduct(contract.id, resolvedVariantId, item.quantity, deliveryDate);
          }
          item.status = 'success';
          
          // Re-render checklist with green checkmark for the added item
          if (bodyContainer) {
            bodyContainer.innerHTML = this.renderModalAddingProgress();
          }
        }
        
        await this.loadPortalData({ showLoading: false });
        this.state.isBuildABoxModalOpen = false;
        this.state.addingItems = null;
        this.closeModal();
        this.setNotice('Successfully updated products in your box!', 'success');
      } catch (error) {
        console.error('Error adding multiple products:', error);
        this.setModalMessage(userFacingError(error, 'Could not add items to box.'), 'error');
        this.setModalBusy(false);
      }
    }

    async executeSwap(actionElement) {
      const selectedRadio = this.modalRoot.querySelector('[name="swap-variant"]:checked');
      const unresolvedVariantId = selectedRadio ? selectedRadio.value : '';
      if (!unresolvedVariantId) {
        this.setModalMessage('Please choose a replacement item.', 'error');
        return;
      }

      this.setModalBusy(true);

      const contractId = rawId(actionElement.dataset.contractId);
      const oldVariantId = rawId(actionElement.dataset.variantId);
      const oldLineId = actionElement.dataset.lineId;
      const quantity = Number(actionElement.dataset.quantity) || 1;

      // Look up newProductObj using unresolvedVariantId
      let newProductObj = null;
      try {
        const portal = window.harvestPortal || window.portal || this;
        const sourceProducts = [
          ...SYSTEM_PRODUCTS,
          ...(portal.contracts || []).flatMap((c) => [
            ...getContractLines(c),
            ...(c.oneTimeProducts || []),
          ])
        ];
        newProductObj = sourceProducts.find(p => rawId(getVariantId(p)) === rawId(unresolvedVariantId));
      } catch (err) {
        console.warn('Error fetching sourceProducts for swap details:', err);
      }

      // Resolve the variant ID
      const selectedProduct = findCatalogOrContractProduct(unresolvedVariantId);
      const addableVariantId = selectedProduct ? (getAddableVariantId(selectedProduct) || unresolvedVariantId) : unresolvedVariantId;
      const newVariantId = await this.resolveVariantId(addableVariantId);
      if (selectedProduct && isProductIdValue(selectedProduct, newVariantId)) {
        throw new Error(`Variant ID not found for ${getProductTitle(selectedProduct)}.`);
      }

      const shopDomain = getShopDomain();

      const oldLineIdGid = oldLineId && !oldLineId.startsWith('gid://') ? `gid://shopify/SubscriptionContractLine/${oldLineId}` : oldLineId;

      const standardPayload = {
        shop: shopDomain,
        contractId: contractId,
        oldVariants: [Number(oldVariantId)],
        newVariants: {
          [rawId(newVariantId)]: quantity,
        },
        oldLineId: oldLineIdGid,
      };

      const pTitle = newProductObj ? getProductTitle(newProductObj) : 'Product';
      const pImage = newProductObj ? getProductImage(newProductObj) : PLACEHOLDER_IMAGE;
      const pId = newProductObj ? rawId(newProductObj?.productId || newProductObj?.product?.id || '') : '';
      const vTitle = newProductObj ? (newProductObj?.variant?.title || newProductObj?.variantTitle || '') : '';

      const groupSwapPayload = {
        variantQuantityList: [
          {
            variantId: Number(rawId(newVariantId)) || newVariantId,
            quantity: quantity,
            title: vTitle || pTitle,
            image: pImage,
            productTitle: pTitle,
            productId: Number(pId) || pId || undefined,
            variantTitle: vTitle || pTitle,
            swapId: isNaN(Number(rawId(oldVariantId))) ? oldVariantId : (Number(rawId(oldVariantId)) || oldVariantId)
          }
        ]
      };

      try {
        await this.api.replaceVariants(contractId, standardPayload, groupSwapPayload);
        await this.loadPortalData({ showLoading: false });
        this.closeModal();
        this.setNotice('Product swapped successfully.', 'success');
      } catch (error) {
        console.error('Swap execution failed:', error);
        this.setModalMessage(userFacingError(error, 'Could not swap product.'), 'error');
        this.setModalBusy(false);
      }
    }

    // Compatibility aliases for integrations that previously called portal methods directly.
    loadEditView(contractId) {
      this.navigateToDetail(contractId);
    }

    pauseSub(contractId) {
      this.openPauseRetentionModal(contractId);
    }

    resumeSub(contractId) {
      this.openResumeModal(contractId);
    }

    cancelSub(contractId) {
      this.openCancelModal(contractId);
    }    updateEditProductsButtonState() {
      const editBtn = this.modalRoot.querySelector('[data-action="confirm-add-multiple"]');
      if (editBtn) {
        const hasQty = Object.values(this.state.modalQuantities || {}).some(qty => qty > 0);
        if (hasQty) {
          editBtn.disabled = false;
          editBtn.style.setProperty('background-color', '#000000', 'important');
          editBtn.style.setProperty('border-color', '#000000', 'important');
          editBtn.style.setProperty('color', '#ffffff', 'important');
          editBtn.style.opacity = '1';
          editBtn.style.cursor = 'pointer';
        } else {
          editBtn.disabled = true;
          editBtn.style.setProperty('background-color', '#9ca3af', 'important');
          editBtn.style.setProperty('border-color', '#9ca3af', 'important');
          editBtn.style.setProperty('color', '#ffffff', 'important');
          editBtn.style.opacity = '0.6';
          editBtn.style.cursor = 'not-allowed';
        }
      }
    }

    openBuildABoxModal(contractId, defaultMode = 'recurring') {
      this.state.selectedContractId = contractId;
      this.state.isBuildABoxModalOpen = true;
      this.state.modalQuantities = {};
      this.state.selectedCategory = '';
      this.state.isFilterExpanded = false;
      this.state.productCatalogMode = defaultMode;

      const contract = this.getSelectedContract();
      if (!contract) return;

      this.openModal({
        title: defaultMode === 'one_time' ? 'Add One-Time Items' : 'Select Product',
        dialogClass: 'harvest-modal__dialog--large',
        body: this.renderBuildABoxModalBody(contract),
        actions: `
          <button class="harvest-button harvest-button--secondary" type="button" data-action="toggle-purchase-type" style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
            Change purchase type
          </button>
          <button class="harvest-button harvest-button--primary" type="button" data-action="confirm-add-multiple" data-contract-id="${escapeAttr(contract.id)}">
            Edit Products
          </button>
        `
      });

      this.updateEditProductsButtonState();
    }

    updateBuildABoxModalContent() {
      const contract = this.getSelectedContract();
      if (!contract) return;
      
      const titleElement = this.modalRoot.querySelector('#harvest-modal-title');
      if (titleElement) {
        titleElement.textContent = this.state.productCatalogMode === 'one_time' ? 'Add One-Time Items' : 'Select Product';
      }

      const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
      if (bodyContainer) {
        bodyContainer.innerHTML = `
          <div class="harvest-modal__message" hidden></div>
          ${this.renderBuildABoxModalBody(contract)}
        `;
      }
      
      // Keep search input focused and cursor at the end
      const input = this.modalRoot.querySelector('#catalog-search');
      if (input) {
        input.focus();
        const val = input.value;
        input.value = '';
        input.value = val;
      }
    }

    renderBuildABoxModalBody(contract) {
      const availableItems = this.getOneTimeCandidates(contract);
      const recurringProducts = getContractLines(contract);
      const oneTimeProducts = contract.oneTimeProducts || [];

      // Collect all unique tags for the filter
      const uniqueTags = new Set();
      availableItems.forEach(p => {
        if (p.tags && Array.isArray(p.tags)) {
          p.tags.forEach(t => {
            if (t && t.length > 1) {
              uniqueTags.add(t.charAt(0).toUpperCase() + t.slice(1));
            }
          });
        }
        if (p.productType) {
          uniqueTags.add(p.productType.charAt(0).toUpperCase() + p.productType.slice(1));
        }
      });
      const tagList = Array.from(uniqueTags).sort();

      // Filter availableItems based on search query
      let filteredAvailable = availableItems;
      if (this.state.productSearchQuery) {
        const query = this.state.productSearchQuery.toLowerCase().trim();
        filteredAvailable = availableItems.filter(p =>
          getProductTitle(p).toLowerCase().includes(query) ||
          (p.sku && p.sku.toLowerCase().includes(query))
        );
      }

      // Filter by selected tag category
      if (this.state.selectedCategory) {
        const cat = this.state.selectedCategory.toLowerCase();
        filteredAvailable = filteredAvailable.filter(p =>
          (p.productType && p.productType.toLowerCase() === cat) ||
          (p.tags && p.tags.some(t => t.toLowerCase() === cat))
        );
      }

      return `
        <!-- Catalog Actions, Search, and Switches Bar -->
        <div class="harvest-catalog-controls-container" style="margin-bottom: 12px; padding: 0; background: transparent; border: none;">
          <div class="harvest-catalog-search-row" style="display: flex; align-items: center; gap: 8px; width: 100%;">
            <div class="harvest-catalog-search-wrapper" style="position: relative; flex: 1; max-width: 100%;">
              <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
                     placeholder="Search a product to add..." value="${escapeAttr(this.state.productSearchQuery || '')}"
                     style="padding-left: 36px; height: 42px; box-sizing: border-box;">
              <!-- Magnifying Glass Icon -->
              <svg class="harvest-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--harvest-text-muted);">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              ${this.state.productSearchQuery ? `
                <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search" style="right: 10px;">&times;</button>
              ` : ''}
            </div>
            <button class="harvest-catalog-filter-btn ${this.state.productCatalogMode === 'recurring' ? '' : 'd-none'}" type="button" data-action="toggle-catalog-filter" style="display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; background: var(--harvest-surface); cursor: pointer; color: var(--harvest-text);">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="4" y1="21" x2="4" y2="14"></line>
                <line x1="4" y1="10" x2="4" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12" y2="3"></line>
                <line x1="20" y1="21" x2="20" y2="16"></line>
                <line x1="20" y1="12" x2="20" y2="3"></line>
                <line x1="1" y1="14" x2="7" y2="14"></line>
                <line x1="9" y1="8" x2="15" y2="8"></line>
                <line x1="17" y1="16" x2="23" y2="16"></line>
              </svg>
            </button>
          </div>
          
          <div class="harvest-catalog-filter-container ${this.state.productCatalogMode === 'recurring' ? '' : 'd-none'}" style="margin-top: 12px; display: ${this.state.isFilterExpanded ? 'block' : 'none'};">
            <label style="display: block; font-size: 13px; font-weight: 600; color: var(--harvest-text-muted); margin-bottom: 4px;">Tags</label>
            <select id="catalog-tag-select" class="harvest-select" style="width: 100%; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; padding: 0 12px; background: #fff;">
              <option value="">Select...</option>
              ${tagList.map(tag => `<option value="${escapeAttr(tag)}" ${this.state.selectedCategory === tag ? 'selected' : ''}>${escapeHtml(tag)}</option>`).join('')}
            </select>
          </div>
        </div>

        <div style="margin-bottom: 16px; font-size: 14px; display: flex; align-items: center; justify-content: space-between; border: 1px solid var(--harvest-border); padding: 12px; border-radius: 8px; background: var(--harvest-surface-muted);">
          <span>Adding items as: <strong style="color: var(--harvest-primary, #22c55e);">${this.state.productCatalogMode === 'recurring' ? 'Subscription (Recurring)' : 'One-Time Delivery'}</strong></span>
        </div>
        
        <div class="harvest-detail-products harvest-catalog-modal-grid">
          ${filteredAvailable.length === 0 ? `
            <div class="harvest-catalog-empty-filtered" style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
              <p style="color: var(--harvest-text-muted); font-size: 1.1rem;">No results in catalog match your search.</p>
              <button type="button" class="harvest-button harvest-button--secondary" data-action="clear-catalog-search" style="margin-top: 12px;">
                Reset filter
              </button>
            </div>
          ` : filteredAvailable
            .map((product) => {
              const variantId = getAddableVariantId(product);
              const alreadyInBox = checkIfProductInContract(product, recurringProducts, oneTimeProducts);
              
              return `
                <article class="harvest-product-card harvest-product-card--available">
                  <div class="harvest-product-card__media">
                    ${alreadyInBox ? '<span class="harvest-product-card__badge">Already in Box</span>' : ''}
                    <img
                      src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
                      alt="${escapeAttr(getProductTitle(product))}"
                      loading="lazy"
                    >
                  </div>
                  <div class="harvest-product-card__body">
                    <div class="harvest-product-card__copy">
                      <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
                      <p class="harvest-product-card__price">
                        ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
                      </p>
                    </div>
                    <div class="harvest-quantity-control">
                      <button class="harvest-qty-btn" type="button" data-action="modal-qty-change" data-variant-id="${escapeAttr(variantId)}" data-change="-1">&minus;</button>
                      <input class="harvest-qty-input" type="number" id="modal-qty-${escapeAttr(variantId)}" min="0" value="${this.state.modalQuantities[variantId] || 0}" readonly>
                      <button class="harvest-qty-btn" type="button" data-action="modal-qty-change" data-variant-id="${escapeAttr(variantId)}" data-change="1">+</button>
                    </div>
                  </div>
                </article>
              `;
            })
            .join('')}
        </div>
      `;
    }

    closeModal() {
      this.modalRoot.hidden = true;
      this.modalRoot.innerHTML = '';
      document.body.classList.remove('harvest-modal-open');
      this.lastFocusedElement?.focus?.();
      this.lastFocusedElement = null;
    }

    createModalRoot() {
      this.modalRoot = document.createElement('div');
      this.modalRoot.className = 'harvest-modal';
      this.modalRoot.hidden = true;
      document.body.appendChild(this.modalRoot);
    }

    openModal(options) {
      this.lastFocusedElement = document.activeElement;
      const dClass = options.dialogClass ? ` ${options.dialogClass}` : '';
      this.modalRoot.innerHTML = `
        <div class="harvest-modal__backdrop" data-modal-close></div>
        <section class="harvest-modal__dialog${dClass}" role="dialog" aria-modal="true" aria-labelledby="harvest-modal-title">
          <header class="harvest-modal__header">
            <h2 id="harvest-modal-title">${escapeHtml(options.title)}</h2>
            <button class="harvest-modal__close" type="button" data-modal-close aria-label="Close modal">&times;</button>
          </header>
          <div class="harvest-modal__body">
            <div class="harvest-modal__message" hidden></div>
            ${options.body}
          </div>
          <footer class="harvest-modal__actions">${options.actions}</footer>
        </section>
      `;
      this.modalRoot.hidden = false;
      document.body.classList.add('harvest-modal-open');
      const focusTarget = this.modalRoot.querySelector('select, input, button');
      focusTarget?.focus();
    }

    setModalBusy(isBusy) {
      this.modalRoot
        .querySelectorAll('button, input, select, textarea')
        .forEach((element) => (element.disabled = isBusy));
      const dialog = this.modalRoot.querySelector('.harvest-modal__dialog');
      if (dialog) dialog.setAttribute('aria-busy', String(isBusy));
    }

    setModalMessage(message, type) {
      const messageElement = this.modalRoot.querySelector('.harvest-modal__message');
      if (!messageElement) return;
      messageElement.hidden = false;
      messageElement.className = `harvest-modal__message harvest-modal__message--${type}`;
      messageElement.textContent = message;
    }

    setNotice(message, type = 'success') {
      window.clearTimeout(this.noticeTimer);
      this.state.notice = { message, type };
      this.render();
      this.noticeTimer = window.setTimeout(() => this.clearNotice(), 6000);
    }

    clearNotice() {
      window.clearTimeout(this.noticeTimer);
      this.state.notice = null;
      this.render();
    }

    hideLegacyModal() {
      const legacyModal = document.getElementById('swap-modal-overlay');
      if (legacyModal) {
        legacyModal.hidden = true;
        legacyModal.setAttribute('aria-hidden', 'true');
        legacyModal.querySelectorAll('[onclick]').forEach((element) => {
          element.removeAttribute('onclick');
        });
      }
    }
  }

  function isContract(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return Boolean(
      obj.id ||
      obj.contractId ||
      obj.status ||
      obj.lines ||
      obj.nextBillingDate ||
      obj.shopifyContractId ||
      obj.subscriptionContractId
    );
  }

  function extractContractFromObject(obj) {
    if (!obj || typeof obj !== 'object') return null;
    if (isContract(obj)) return obj;
    if (obj.subscriptionContract && isContract(obj.subscriptionContract)) return obj.subscriptionContract;
    if (obj.contract && isContract(obj.contract)) return obj.contract;
    if (obj.node && isContract(obj.node)) return obj.node;
    return null;
  }

  function extractCustomer(payload) {
    if (!payload) return null;

    // Recursive helper to look for subscriptionContracts or a contracts array inside nested structures
    function findCustomerOrContracts(obj) {
      if (!obj || typeof obj !== 'object') return null;

      // Case 1: The object directly matches the target structure
      if (obj.subscriptionContracts) {
        return obj;
      }

      // Case 2: Array structures
      if (Array.isArray(obj)) {
        // Try to map objects in the array that look like contracts
        const extractedContracts = obj
          .map(extractContractFromObject)
          .filter(Boolean);

        if (extractedContracts.length > 0) {
          return { subscriptionContracts: extractedContracts };
        }

        // Check if elements are lists of contract objects
        if (obj[0] && (obj[0].id || obj[0].status || obj[0].lines || obj[0].nextBillingDate)) {
          return { subscriptionContracts: obj };
        }

        // Recursively check elements of the array
        for (const item of obj) {
          const found = findCustomerOrContracts(item);
          if (found) return found;
        }
      } else {
        // Case 3: Standard object - recursively check all nested keys
        for (const key of Object.keys(obj)) {
          // Skip known non-object / basic values
          if (key === '__typename' || key === 'id' || key === 'status') continue;
          
          const val = obj[key];
          if (val && typeof val === 'object') {
            const found = findCustomerOrContracts(val);
            if (found) return found;
          }
        }
      }
      return null;
    }

    const found = findCustomerOrContracts(payload);
    if (found) return found;

    // Fallback: Try manual paths
    const contractPaths = [
      payload.data?.subscriptionCustomers,
      payload.data?.subscriptionCustomer,
      payload.data?.subscriptionContracts,
      payload.subscriptionCustomers,
      payload.subscriptionCustomer,
      payload.data?.customers,
      payload.customers,
      payload.data,
    ];

    for (const candidate of contractPaths) {
      if (!candidate) continue;
      // If candidate has contracts directly
      const contracts = getConnectionItems(
        candidate.subscriptionContracts || candidate
      );
      if (contracts.length) {
        return { subscriptionContracts: contracts };
      }
      // If candidate is an array, try each item
      const arr = Array.isArray(candidate) ? candidate : [candidate];
      for (const item of arr) {
        const itemContracts = getConnectionItems(
          item?.subscriptionContracts || item
        );
        if (itemContracts.length) {
          return { subscriptionContracts: itemContracts };
        }
      }
    }

    return null;
  }

  function extractOneTimeProducts(payload) {
    if (!payload) return [];
    
    function collectOneOffs(obj, results = []) {
      if (!obj || typeof obj !== 'object') return results;
      
      if (Array.isArray(obj)) {
        for (const item of obj) {
          collectOneOffs(item, results);
        }
        return results;
      }
      
      const varId = obj.variantId || 
                    obj.variant_id || 
                    obj.productVariantId || 
                    obj.product_variant_id || 
                    obj.variant?.id || 
                    obj.variant?.variantId || 
                    obj.productVariant?.id || 
                    obj.productVariant?.variantId || 
                    (obj.id && !String(obj.id).includes('SubscriptionContract') && !String(obj.id).includes('SubscriptionLine') ? obj.id : null);

      if (varId && (obj.title || obj.quantity !== undefined || obj.price !== undefined || obj.lineId || obj.variantTitle || obj.variant?.title)) {
        const exists = results.some(p => rawId(getVariantId(p)) === rawId(varId) && (p.lineId || p.id) === (obj.lineId || obj.id));
        if (!exists) {
          results.push(obj);
        }
        return results;
      }
      
      for (const key of Object.keys(obj)) {
        if (key === '__typename' || key === 'status') continue;
        const val = obj[key];
        if (val && typeof val === 'object') {
          collectOneOffs(val, results);
        }
      }
      return results;
    }
    
    const items = collectOneOffs(payload);
    return items.map((product) =>
      Object.assign({ _harvestOneTime: true }, product)
    );
  }

  function extractScheduleItems(payload) {
    if (!payload) return [];
    const candidates = [
      payload?.data?.schedules,
      payload?.data?.schedule,
      payload?.data?.upcomingOrders,
      payload?.data?.upcomingSubscriptions,
      payload?.data?.orders,
      payload?.schedules,
      payload?.schedule,
      payload?.upcomingOrders,
      payload?.upcomingSubscriptions,
      payload?.orders,
      payload,
    ];

    return firstCollection(candidates);
  }

  function extractHistoryItems(payload) {
    if (!payload) return [];

    const historyKeys = [
      'history',
      'orders',
      'billingAttempts',
      'subscriptionBillingAttempts',
      'orderHistory',
      'billingHistory',
      'invoiceHistory',
      'subscriptionContractsOrderHistory',
      'subscriptionContractsOrders',
      'billing_attempts',
      'order_history',
    ];

    function findHistoryCollection(obj) {
      if (!obj || typeof obj !== 'object') return null;

      // If it's an array, check elements
      if (Array.isArray(obj)) {
        for (const item of obj) {
          const found = findHistoryCollection(item);
          if (found && found.length) return found;
        }
        return null;
      }

      // Check direct keys first
      for (const key of historyKeys) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const items = getConnectionItems(obj[key]);
          if (items && items.length > 0) {
            return items;
          }
        }
      }

      // If not found, recursively search nested keys
      for (const key of Object.keys(obj)) {
        if (key === '__typename' || key === 'id' || key === 'status') continue;
        
        const val = obj[key];
        if (val && typeof val === 'object') {
          const found = findHistoryCollection(val);
          if (found && found.length) return found;
        }
      }

      return null;
    }

    const recursiveItems = findHistoryCollection(payload);
    if (recursiveItems && recursiveItems.length > 0) {
      return recursiveItems;
    }

    const candidates = [
      payload?.data?.history,
      payload?.data?.orders,
      payload?.data?.billingAttempts,
      payload?.data?.subscriptionBillingAttempts,
      payload?.history,
      payload?.orders,
      payload?.billingAttempts,
      payload?.subscriptionBillingAttempts,
      payload,
    ];

    return firstCollection(candidates);
  }

  function firstCollection(candidates) {
    for (const candidate of candidates) {
      const items = getConnectionItems(candidate);
      if (items.length) return items;
      if (candidate && typeof candidate === 'object' && !Array.isArray(candidate)) {
        const values = Object.values(candidate);
        for (const value of values) {
          const nestedItems = getConnectionItems(value);
          if (nestedItems.length) return nestedItems;
        }
      }
    }
    return [];
  }

  function extractBillingAttemptId(item) {
    const direct = firstValue(item, [
      'billingAttemptId',
      'billing_attempt_id',
      'shopifyBillingAttemptId',
      'shopify_billing_attempt_id',
      'billingAttempt.id',
      'subscriptionBillingAttempt.id',
      'node.billingAttemptId',
      'node.billing_attempt_id',
      'node.shopifyBillingAttemptId',
      'node.shopify_billing_attempt_id',
      'node.billingAttempt.id',
      'node.subscriptionBillingAttempt.id',
    ]);
    if (direct) return direct;

    const id = firstValue(item, ['id', 'node.id']);
    if (id && String(id).includes('SubscriptionBillingAttempt')) return id;

    return '';
  }

  function normalizeScheduleItem(item, contract, index) {
    const date =
      firstValue(item, [
        'deliveryDate',
        'scheduledDate',
        'billingDate',
        'nextBillingDate',
        'orderDate',
        'date',
      ]) || addScheduleInterval(getNextDeliveryDate(contract), contract, index);
    const products = extractProductsFromRecord(item);

    return {
      date,
      billingAttemptId: extractBillingAttemptId(item),
      status: firstValue(item, ['status', 'orderStatus', 'billingStatus']) || 'Queued',
      note: firstValue(item, ['note', 'orderNote', 'customerNote']) || '',
      products: products.length ? products : scheduleProductsForContract(contract, index),
    };
  }

  function normalizeHistoryItem(item, contract) {
    const date =
      firstValue(item, [
        'processedAt',
        'orderDate',
        'billingDate',
        'createdAt',
        'createdDate',
        'date',
      ]) || getNextDeliveryDate(contract);

    const billingDate = firstValue(item, [
      'billingDate',
      'processedAt',
      'createdAt',
      'date'
    ]);

    const extractedProducts = extractProductsFromRecord(item);

    return {
      date,
      billingDate: billingDate || date,
      orderNumber:
        firstValue(item, ['orderNumber', 'name', 'orderName', 'orderId', 'id']) || '',
      status: normalizeScheduleStatus(
        firstValue(item, ['status', 'orderStatus', 'financialStatus']) || 'Completed'
      ),
      orderUrl: firstValue(item, ['orderStatusUrl', 'statusUrl', 'orderUrl', 'url']) || '',
      total:
        firstMoney(item, ['totalPrice', 'total', 'totalAmount', 'amount']) ??
        firstMoney(contract, ['totalPrice', 'total', 'nextBillingAmount']) ??
        0,
      products: extractedProducts.length ? extractedProducts : getContractLines(contract),
    };
  }

  function extractProductsFromRecord(record) {
    if (!record) return [];
    const candidates = [
      record.lineItems,
      record.lines,
      record.items,
      record.products,
      record.variants,
      record.order?.lineItems,
      record.node?.lineItems,
      record.node?.order?.lineItems,
      record.node?.products,
      record.node?.variants,
      record.node?.lines,
      record.subscriptionContractProductHistory,
      record.node?.subscriptionContractProductHistory,
      record.order,
      record.node?.order,
      record.node,
    ];
    for (const candidate of candidates) {
      if (candidate) {
        const items = getConnectionItems(candidate);
        if (items && items.length > 0) {
          return items;
        }
      }
    }
    return findLineItemsRecursively(record);
  }

  function buildProjectedSchedules(contract) {
    const firstDate = getNextDeliveryDate(contract);
    if (!firstDate) return [];

    return Array.from({ length: SCHEDULE_DELIVERY_COUNT }, (_, index) => ({
      date: addScheduleInterval(firstDate, contract, index),
      status: 'Queued',
      note: '',
      projected: true,
      products: scheduleProductsForContract(contract, index),
    }));
  }

  function scheduleProductsForContract(contract, index) {
    return [
      ...(index === 0
        ? getContractLines(contract).filter((product) => !isProductSkippedForNextOrder(product))
        : getContractLines(contract)),
      ...(index === 0
        ? (contract.oneTimeProducts || []).map((product) =>
            Object.assign({ _harvestOneTime: true }, product)
          )
        : []),
    ];
  }

  function addScheduleInterval(value, contract, index) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value || '';
    if (!index) return date.toISOString();

    const policy = contract?.deliveryPolicy || contract?.billingPolicy || {};
    const count = Number(policy.intervalCount || policy.frequency || 1) || 1;
    const interval = String(policy.interval || policy.intervalType || 'MONTH').toLowerCase();

    if (interval.startsWith('day')) date.setDate(date.getDate() + count * index);
    else if (interval.startsWith('week')) date.setDate(date.getDate() + count * 7 * index);
    else if (interval.startsWith('year')) date.setFullYear(date.getFullYear() + count * index);
    else date.setMonth(date.getMonth() + count * index);

    return date.toISOString();
  }

  function normalizeScheduleStatus(status) {
    const value = String(status || '').replace(/_/g, ' ').trim();
    if (!value) return 'Queued';
    return value
      .toLowerCase()
      .split(/\s+/)
      .map(capitalize)
      .join(' ');
  }

  function findVariantIdInObject(obj) {
    if (!obj || typeof obj !== 'object') return null;
    
    // 1. Direct standard fields
    const directFields = [
      'variantId', 'variant_id', 'productVariantId', 'product_variant_id',
      'shopifyVariantId', 'shopify_variant_id', 'variant_database_id',
      'variantDatabaseId', 'variant_gid', 'variantGid', 'shopifyVariant', 'shopify_variant'
    ];
    for (const f of directFields) {
      if (obj[f]) {
        if (typeof obj[f] === 'object' && obj[f].id) return String(obj[f].id);
        if (typeof obj[f] === 'string' || typeof obj[f] === 'number') return String(obj[f]);
      }
    }
    
    // 2. Nested objects
    if (obj.variant && (obj.variant.id || obj.variant.variantId || obj.variant.variant_id)) {
      return String(obj.variant.id || obj.variant.variantId || obj.variant.variant_id);
    }
    if (obj.productVariant && (obj.productVariant.id || obj.productVariant.variantId || obj.productVariant.variant_id)) {
      return String(obj.productVariant.id || obj.productVariant.variantId || obj.productVariant.variant_id);
    }
    if (obj.shopify_variant && (obj.shopify_variant.id || obj.shopify_variant.variant_id)) {
      return String(obj.shopify_variant.id || obj.shopify_variant.variant_id);
    }
    
    // 3. Scan all keys for containing 'variant' (excluding 'variants', 'product_variants')
    for (const key of Object.keys(obj)) {
      const lowerKey = key.toLowerCase();
      if (lowerKey.includes('variant') && !lowerKey.includes('variants') && lowerKey !== 'productvariant' && lowerKey !== 'shopifyvariant') {
        const val = obj[key];
        if (val && (typeof val === 'string' || typeof val === 'number')) {
          // Make sure it doesn't look like a GID for product itself
          if (!String(val).includes('Product/')) {
            return String(val);
          }
        }
      }
    }
    return null;
  }

  function getCatalogProductId(product) {
    if (!product) return '';
    const productId =
      product.productId ||
      product.product_id ||
      product.shopifyProductId ||
      product.shopify_product_id ||
      product.product?.id ||
      product.product?.productId ||
      product.product?.product_id;
    if (productId) return String(productId);

    if (product.id && String(product.id).includes('Product/')) {
      return String(product.id);
    }
    return '';
  }

  function normalizeVariantCollection(rawVariants) {
    if (!rawVariants) return [];
    if (Array.isArray(rawVariants)) {
      return rawVariants.map((item) => item?.node || item).filter(Boolean);
    }
    if (typeof rawVariants !== 'object') return [];
    if (Array.isArray(rawVariants.edges)) {
      return rawVariants.edges.map((edge) => edge?.node || edge).filter(Boolean);
    }
    if (Array.isArray(rawVariants.nodes)) {
      return rawVariants.nodes.filter(Boolean);
    }
    return Object.values(rawVariants)
      .flatMap((value) => normalizeVariantCollection(value))
      .filter(Boolean);
  }

  function getVariantIdFromCollection(product) {
    if (!product || typeof product !== 'object') return '';
    const productId = rawId(getCatalogProductId(product));
    const variantCollections = [
      product.variants,
      product.productVariants,
      product.product_variants,
      product.variantList,
      product.variant_list,
      product.variantsList,
      product.productVariantList,
      product.shopifyVariants,
      product.product?.variants,
      product.product?.productVariants,
      product.product?.product_variants
    ];

    for (const collection of variantCollections) {
      for (const variant of normalizeVariantCollection(collection)) {
        if (!variant || typeof variant !== 'object') continue;
        const variantId = findVariantIdInObject(variant) ||
          variant.id ||
          variant.admin_graphql_api_id ||
          variant.legacyResourceId;
        if (!variantId) continue;
        if (String(variantId).includes('Product/')) continue;
        if (productId && rawId(variantId) === productId) continue;
        return String(variantId);
      }
    }
    return '';
  }

  function isProductIdValue(product, value) {
    const productId = rawId(getCatalogProductId(product));
    return Boolean(productId && value && rawId(value) === productId);
  }

  function getAddableVariantId(product) {
    if (!product) return '';

    const collectionVariantId = getVariantIdFromCollection(product);
    if (collectionVariantId) return collectionVariantId;

    const directVariantId = findVariantIdInObject(product);
    if (directVariantId) {
      return directVariantId;
    }

    return getVariantId(product);
  }

  function isOneTimeProduct(product, contract) {
    if (!product) return false;
    
    let isOneTime = false;
    let reason = '';

    // 1. Robust fuzzy helpers
    const isOneTimeKey = (key) => {
      if (!key) return false;
      const normalized = String(key).toLowerCase().replace(/[-_ ]/g, '');
      return (
        normalized.includes('onetime') ||
        normalized.includes('oneoff') ||
        normalized.includes('harvestonetime') ||
        normalized.includes('is_one_time')
      );
    };

    const checkValue = (val) => {
      if (val === true || val === 1) return true;
      if (typeof val === 'string') {
        const normalized = val.toLowerCase().trim().replace(/[-_ ]/g, '');
        return (
          normalized === 'true' ||
          normalized === 'yes' ||
          normalized === '1' ||
          normalized === 'onetime' ||
          normalized === 'oneoff'
        );
      }
      return false;
    };

    // 2. Explicit direct and nested flags
    const targets = [
      product,
      product.variant,
      product.product,
      product.productVariant,
      product.shopify_variant,
      product.shopifyVariant
    ].filter(Boolean);

    // Direct keys check (all keys case-insensitive matching)
    for (const target of targets) {
      for (const key of Object.keys(target)) {
        const val = target[key];
        if (isOneTimeKey(key) && checkValue(val)) {
          isOneTime = true;
          reason = `Direct target property match: key=${key}, val=${val}`;
          break;
        }
      }
      if (isOneTime) break;
    }

    // 3. Fallback: Check tags
    if (!isOneTime) {
      for (const target of targets) {
        const tags = target.tags;
        if (Array.isArray(tags)) {
          const hasTag = tags.some(t => {
            const norm = String(t).toLowerCase().replace(/[-_ ]/g, '');
            return norm === 'onetime' || norm === 'oneoff';
          });
          if (hasTag) {
            isOneTime = true;
            reason = 'Matched in product/variant tags array';
            break;
          }
        } else if (typeof tags === 'string') {
          const norm = tags.toLowerCase().replace(/[-_ ]/g, '');
          if (norm.includes('onetime') || norm.includes('oneoff')) {
            isOneTime = true;
            reason = 'Matched in product/variant tags string';
            break;
          }
        }
      }
    }

    // 4. Custom attributes / properties check (supporting array and object formats)
    if (!isOneTime) {
      for (const target of targets) {
        const customAttrs = target.customAttributes || target.custom_attributes || target.properties || target.line_item_properties || target.attributes;
        if (Array.isArray(customAttrs)) {
          const hasOneTimeAttr = customAttrs.some(attr => {
            const key = String(attr?.key || attr?.name || '');
            const val = attr?.value;
            return isOneTimeKey(key) && checkValue(val);
          });
          if (hasOneTimeAttr) {
            isOneTime = true;
            reason = 'custom attribute array match';
            break;
          }
        } else if (customAttrs && typeof customAttrs === 'object') {
          for (const key of Object.keys(customAttrs)) {
            const val = customAttrs[key];
            if (isOneTimeKey(key) && checkValue(val)) {
              isOneTime = true;
              reason = `custom attribute object match: key=${key}`;
              break;
            }
          }
        }
        if (isOneTime) break;
      }
    }

    // 5. Check if variant exists in contract's oneTimeProducts
    if (!isOneTime && contract && contract.oneTimeProducts) {
      const vId = rawId(getVariantId(product));
      if (vId) {
        const foundInOneTime = contract.oneTimeProducts.some(otp => {
          const otvId = rawId(getVariantId(otp));
          return otvId === vId;
        });
        if (foundInOneTime) {
          isOneTime = true;
          reason = 'found in contract.oneTimeProducts';
        }
      }
    }

    if (isOneTime) {
      console.log(`[isOneTimeProduct] Product "${product.title || getProductTitle(product)}" is determined to be a ONE-TIME product. Reason: ${reason}`);
    }

    return isOneTime;
  }

  function getSplitProducts(contract) {
    if (!contract) return { recurringProducts: [], oneTimeProducts: [] };
    const rawLines = getContractLines(contract);
    const oneTimeRaw = contract.oneTimeProducts || [];
    
    const recurringProducts = [];
    const oneTimeProducts = [...oneTimeRaw];
    
    rawLines.forEach(p => {
      if (isOneTimeProduct(p, contract)) {
        const vId = rawId(getVariantId(p));
        const exists = oneTimeProducts.some(otp => rawId(getVariantId(otp)) === vId);
        if (!exists) {
          oneTimeProducts.push(p);
        }
      } else {
        recurringProducts.push(p);
      }
    });

    console.log('[Harvest Portal Box Inspection] Products currently in subscription box:', {
      contractId: contract.id,
      recurringLines: rawLines.map(p => ({
        id: p.id,
        variantId: getVariantId(p),
        title: p.title || p.productTitle || p.product?.title,
        isOneTime: isOneTimeProduct(p, contract)
      })),
      oneTimeProducts: oneTimeRaw.map(p => ({
        id: p.id,
        variantId: getVariantId(p),
        title: p.title || p.productTitle || p.product?.title,
        isOneTime: isOneTimeProduct(p, contract)
      }))
    });
    
    return { recurringProducts, oneTimeProducts };
  }

  function checkIfProductInContract(product, recurringLines, oneTimeLines) {
    const variantId = rawId(getAddableVariantId(product));
    if (!variantId) return false;

    const matchInRecurring = recurringLines.some(
      (p) => rawId(getVariantId(p)) === variantId
    );
    const matchInOneTime = oneTimeLines.some(
      (p) => rawId(getVariantId(p)) === variantId
    );
    if (matchInRecurring || matchInOneTime) return true;

    const catalogProductId = rawId(getCatalogProductId(product));
    if (catalogProductId) {
      const matchProductInRecurring = recurringLines.some(
        (p) => rawId(getCatalogProductId(p)) === catalogProductId
      );
      const matchProductInOneTime = oneTimeLines.some(
        (p) => rawId(getCatalogProductId(p)) === catalogProductId
      );
      return matchProductInRecurring || matchProductInOneTime;
    }

    return false;
  }

  function parseTagsString(tags) {
    if (typeof tags !== 'string' || !tags) return [];
    const trimmed = tags.trim();
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed.map(t => String(t).trim()).filter(Boolean);
      } catch (e) {}
    }
    return trimmed.split(',').map(t => t.trim().replace(/^\[|]$|^"|"$/g, '')).filter(Boolean);
  }

  function extractProductsList(payload) {
    if (!payload) return [];
    
    // Support Shopify Predictive Search suggestion payload structure directly
    if (payload && payload.resources && payload.resources.results && payload.resources.results.products) {
      payload = payload.resources.results.products;
    }

    // Support single product object pattern (e.g. from /products/handle.json)
    if (payload && payload.product && typeof payload.product === 'object' && !Array.isArray(payload.product)) {
      payload = [payload.product];
    }
    
    const items = [];
    
    // Helper to extract variants from a single product item
    const processSingleRawProduct = (prod) => {
      if (!prod || typeof prod !== 'object') return;
      
      const productId = prod.id || prod.productId || prod.product_id;
      const productTitle = prod.title || prod.productTitle || prod.product_title || '';
      const productHandle = prod.handle || prod.productHandle || '';
      
      // If there are explicit variants under this product
      const rawVariants =
        prod.variants ||
        prod.productVariants ||
        prod.product_variants ||
        prod.variantList ||
        prod.variant_list ||
        prod.variantsList ||
        prod.productVariantList ||
        prod.shopifyVariants ||
        [];
      const variantsArr = normalizeVariantCollection(rawVariants);
      
      if (variantsArr.length > 0) {
        variantsArr.forEach(v => {
          if (!v || typeof v !== 'object') return;
          const varId = findVariantIdInObject(v) || v.id || v.variantId || v.variant_id;
          if (!varId) return;
          
          const variantTitle = v.title || v.variantTitle || '';
          let combinedTitle = productTitle;
          if (variantTitle && variantTitle !== 'Default' && variantTitle !== 'Default Title' && variantTitle !== productTitle) {
            combinedTitle = `${productTitle} - ${variantTitle}`;
          }
          
          const vImg = getUsableProductImage(v);
          const pImg = getUsableProductImage(prod);

          items.push({
            id: varId,
            variantId: varId,
            variant_id: varId,
            productId: productId,
            product_id: productId,
            title: combinedTitle || productTitle || variantTitle || '',
            productTitle: productTitle,
            variantTitle: variantTitle,
            handle: productHandle || v.handle || '',
            price: v.price || v.variantPrice || v.variant_price || prod.price || 0,
            image: vImg || pImg || null,
            available: v.available !== undefined ? v.available : (prod.available !== undefined ? prod.available : true),
            inventoryQuantity: v.inventory_quantity !== undefined ? v.inventory_quantity : (v.inventoryQuantity !== undefined ? v.inventoryQuantity : (prod.inventory_quantity !== undefined ? prod.inventory_quantity : null)),
            tags: Array.isArray(prod.tags) ? prod.tags : parseTagsString(prod.tags),
            productType: prod.product_type || prod.productType || '',
          });
        });
      } else {
        // If it's a flat product/variant representation itself
        const varId = findVariantIdInObject(prod) || prod.variantId || prod.variant_id || prod.id;
        if (varId) {
          const variantTitle = prod.variantTitle || prod.title || '';
          let combinedTitle = productTitle || prod.title || '';
          if (variantTitle && variantTitle !== 'Default' && variantTitle !== 'Default Title' && variantTitle !== combinedTitle) {
            combinedTitle = `${combinedTitle} - ${variantTitle}`;
          }
          
          const pImg = getUsableProductImage(prod);
          
          items.push({
            id: varId,
            variantId: varId,
            variant_id: varId,
            productId: productId,
            product_id: productId,
            title: combinedTitle || productTitle || variantTitle || '',
            productTitle: productTitle || prod.title || '',
            variantTitle: variantTitle,
            handle: productHandle,
            price: prod.price || prod.variantPrice || 0,
            image: pImg || null,
            available: prod.available !== undefined ? prod.available : true,
            inventoryQuantity: prod.inventory_quantity !== undefined ? prod.inventory_quantity : (prod.inventoryQuantity !== undefined ? prod.inventoryQuantity : null),
            tags: Array.isArray(prod.tags) ? prod.tags : parseTagsString(prod.tags),
            productType: prod.product_type || prod.productType || '',
          });
        }
      }
    };

    // If payload is an array directly
    if (Array.isArray(payload)) {
      payload.forEach(processSingleRawProduct);
    } else if (payload && typeof payload === 'object') {
      // Check popular object property patterns
      const possibleArrays = [
        payload.products,
        payload.data,
        payload.subscriptionProducts,
        payload.subscription_products,
        payload.items,
        payload.results,
        payload.nodes
      ];
      
      let foundArray = false;
      for (const arr of possibleArrays) {
        if (Array.isArray(arr)) {
          arr.forEach(processSingleRawProduct);
          foundArray = true;
          break;
        }
      }
      
      // Fallback: search all object keys for any arrays
      if (!foundArray) {
        for (const key of Object.keys(payload)) {
          const val = payload[key];
          if (Array.isArray(val) && val.length > 0) {
            val.forEach(processSingleRawProduct);
            foundArray = true;
            break;
          }
        }
      }
      
      // One more fallback: if payload itself is a single flat product object
      if (!foundArray) {
        processSingleRawProduct(payload);
      }
    }
    
    return items;
  }

  function uniqueProductsByVariant(products) {
    const seen = new Set();
    return products.filter((product) => {
      const variantId = rawId(getAddableVariantId(product) || getVariantId(product));
      if (!variantId || seen.has(variantId)) return false;
      seen.add(variantId);
      return true;
    });
  }

  function mergeProductImages(products, imageSourceProducts) {
    const imagesByVariant = new Map();

    imageSourceProducts.forEach((product) => {
      const variantId = rawId(getVariantId(product));
      const image = getUsableProductImage(product);
      if (variantId && image) imagesByVariant.set(variantId, image);
    });

    return products.map((product) => {
      if (getUsableProductImage(product)) return product;

      const image = imagesByVariant.get(rawId(getVariantId(product)));
      return image ? Object.assign({}, product, { image }) : product;
    });
  }

  function getConnectionItems(connection) {
    if (!connection) return [];
    if (Array.isArray(connection)) return connection;
    if (Array.isArray(connection.nodes)) return connection.nodes;
    if (Array.isArray(connection.edges)) {
      return connection.edges.map((edge) => edge?.node || edge).filter(Boolean);
    }
    return [];
  }

  function findLineItemsRecursively(obj) {
    if (!obj || typeof obj !== 'object') return [];
    
    if (Array.isArray(obj)) {
      const looksLikeLines = obj.every(item => item && typeof item === 'object' && (item.variantId || item.variant_id || item.productId || item.title));
      if (looksLikeLines && obj.length > 0) {
        return obj;
      }
      let found = [];
      for (const item of obj) {
        const res = findLineItemsRecursively(item);
        if (res.length > 0) {
          found = found.concat(res);
        }
      }
      return found;
    }

    if (obj.nodes && Array.isArray(obj.nodes)) {
      return findLineItemsRecursively(obj.nodes);
    }
    if (obj.edges && Array.isArray(obj.edges)) {
      return findLineItemsRecursively(obj.edges.map(e => e?.node || e).filter(Boolean));
    }

    const lineKeys = ['lines', 'lineItems', 'subscriptionContractLineItems', 'subscriptionLines', 'line_items'];
    for (const key of lineKeys) {
      if (obj[key]) {
        const res = findLineItemsRecursively(obj[key]);
        if (res.length > 0) return res;
      }
    }

    for (const key of Object.keys(obj)) {
      if (key === '__typename' || key === 'id' || key === 'status') continue;
      const val = obj[key];
      if (val && typeof val === 'object') {
        const res = findLineItemsRecursively(val);
        if (res.length > 0) return res;
      }
    }
    return [];
  }

  function getContractLines(contract) {
    if (!contract) return [];
    return extractProductsFromRecord(contract);
  }

  function isProductSkippedForNextOrder(product) {
    if (!product || typeof product !== 'object') return false;
    if (product._harvestUnskippedForNextOrder === true || product._harvestSkippedForNextOrder === false) {
      return false;
    }

    const truthySkipValue = (value) => {
      if (value === true || value === 1) return true;
      if (typeof value === 'string') {
        const normalized = value.toLowerCase().trim();
        return (
          normalized === 'true' ||
          normalized === 'yes' ||
          normalized === '1' ||
          normalized === 'skip' ||
          normalized === 'skipped' ||
          normalized === 'skipped_for_next_order' ||
          normalized === 'skipped for next order' ||
          normalized === 'skipped_for_upcoming_order' ||
          normalized === 'skipped for upcoming order'
        );
      }
      return false;
    };

    const targets = [
      product,
      product.variant,
      product.product,
      product.productVariant,
      product.shopify_variant,
      product.shopifyVariant
    ].filter(Boolean);

    const skipKeys = new Set([
      '_harvestskippedfornextorder',
      'isskip',
      'isskipped',
      'skip',
      'skipped',
      'skipfornextorder',
      'skippedfornextorder',
      'skipnextorder',
      'skippednextorder',
      'nextorderskip',
      'nextorderskipped',
      'upcomingorderskip',
      'upcomingorderskipped',
      'lineitemstatus',
      'linestatus',
      'status'
    ]);

    const normalizeKey = (key) => String(key || '').toLowerCase().replace(/[-_ ]/g, '');

    for (const target of targets) {
      for (const key of Object.keys(target)) {
        if (skipKeys.has(normalizeKey(key)) && truthySkipValue(target[key])) {
          return true;
        }
      }

      const customAttrs = target.customAttributes || target.custom_attributes || target.properties || target.attributes;
      if (Array.isArray(customAttrs)) {
        if (customAttrs.some((attr) => skipKeys.has(normalizeKey(attr?.key || attr?.name)) && truthySkipValue(attr?.value))) {
          return true;
        }
      } else if (customAttrs && typeof customAttrs === 'object') {
        for (const key of Object.keys(customAttrs)) {
          if (skipKeys.has(normalizeKey(key)) && truthySkipValue(customAttrs[key])) {
            return true;
          }
        }
      }
    }

    return false;
  }

  function localSkipStorageKeys(contract, product) {
    const contractId = rawId(contract?.id);
    const deliveryDate = toDateInputValue(getNextDeliveryDate(contract) || getNextPaymentDate(contract));
    const ids = [getLineId(product), getVariantId(product)]
      .map(rawId)
      .filter(Boolean);

    if (!contractId || !deliveryDate || !ids.length) return [];

    return ids.map((id) => `harvestPortal:skippedNextOrder:${contractId}:${deliveryDate}:${id}`);
  }

  function rememberLineSkippedForNextOrder(contract, product) {
    try {
      localSkipStorageKeys(contract, product).forEach((key) => {
        window.localStorage.setItem(key, 'true');
      });
    } catch (error) {
      // Local storage is only a visual fallback; Appstle remains the source of truth.
    }
  }

  function forgetLineSkippedForNextOrder(contract, product) {
    try {
      localSkipStorageKeys(contract, product).forEach((key) => {
        window.localStorage.removeItem(key);
      });
    } catch (error) {
      // Local storage is only a visual fallback; Appstle remains the source of truth.
    }
  }

  function isLocallySkippedForNextOrder(contract, product) {
    try {
      return localSkipStorageKeys(contract, product).some((key) => window.localStorage.getItem(key) === 'true');
    } catch (error) {
      return false;
    }
  }

  function isProductSkippedForNextOrderForContract(contract, product) {
    return isProductSkippedForNextOrder(product) || isLocallySkippedForNextOrder(contract, product);
  }

  function markLineSkippedForNextOrder(contract, lineId, product) {
    if (product && typeof product === 'object') {
      product._harvestSkippedForNextOrder = true;
      delete product._harvestUnskippedForNextOrder;
    }
    const targetLineId = rawId(lineId);
    for (const line of getContractLines(contract)) {
      if (rawId(getLineId(line)) === targetLineId || (product && rawId(getVariantId(line)) === rawId(getVariantId(product)))) {
        line._harvestSkippedForNextOrder = true;
        delete line._harvestUnskippedForNextOrder;
        return true;
      }
    }
    return false;
  }

  function markLineUnskippedForNextOrder(contract, lineId, product) {
    if (product && typeof product === 'object') {
      product._harvestSkippedForNextOrder = false;
      product._harvestUnskippedForNextOrder = true;
    }
    const targetLineId = rawId(lineId);
    for (const line of getContractLines(contract)) {
      if (rawId(getLineId(line)) === targetLineId || (product && rawId(getVariantId(line)) === rawId(getVariantId(product)))) {
        line._harvestSkippedForNextOrder = false;
        line._harvestUnskippedForNextOrder = true;
        return true;
      }
    }
    return false;
  }

  function productsForNextOrder(contract) {
    return [
      ...getContractLines(contract).filter((product) => !isProductSkippedForNextOrderForContract(contract, product)),
      ...(contract?.oneTimeProducts || []).map((product) =>
        Object.assign({ _harvestOneTime: true }, product)
      ),
    ];
  }

  function calculateContractTotals(contract, oneTimeProducts) {
    const hasSkippedProducts = getContractLines(contract).some((product) =>
      isProductSkippedForNextOrderForContract(contract, product)
    );
    const products = productsForNextOrder(contract);
    const calculatedSubtotal = products.reduce(
      (sum, product) => sum + getLineTotal(product),
      0
    );
    const subtotal =
      hasSkippedProducts
        ? calculatedSubtotal
        : firstMoney(contract, [
            'subtotalPrice',
            'subtotal',
            'lineItemsSubtotalPrice',
            'discountedSubtotal',
          ]) ?? calculatedSubtotal;
    const delivery =
      firstMoney(contract, ['deliveryPrice', 'shippingPrice', 'deliveryAmount']) ?? 0;
    const explicitTotal = hasSkippedProducts
      ? null
      : firstMoney(contract, [
          'totalPrice',
          'total',
          'totalAmount',
          'nextBillingAmount',
        ]);
    let discount =
      firstMoney(contract, ['discountAmount', 'totalDiscounts', 'totalDiscountAmount']) ??
      calculateDiscounts(contract, subtotal, delivery);

    if (!discount && explicitTotal !== null) {
      discount = Math.max(0, subtotal + delivery - explicitTotal);
    }

    const total =
      explicitTotal !== null ? explicitTotal : Math.max(0, subtotal + delivery - discount);

    return {
      subtotal: roundMoney(subtotal),
      delivery: roundMoney(delivery),
      discount: roundMoney(discount),
      total: roundMoney(total),
    };
  }

  function calculateDiscounts(contract, subtotal, delivery) {
    return getConnectionItems(contract?.discounts).reduce((sum, discount) => {
      const fixed = firstMoney(discount, [
        'amount',
        'discountAmount',
        'value.amount',
        'value.fixedAmount',
      ]);
      if (fixed !== null) return sum + fixed;

      const percentage =
        numberValue(deepGet(discount, 'value.percentage')) ??
        numberValue(discount.percentage);
      if (percentage === null) return sum;

      const target = String(
        discount.targetType || discount.type || discount.title || ''
      ).toUpperCase();
      const base = /DELIVERY|SHIPPING/.test(target) ? delivery : subtotal;
      return sum + base * (percentage / 100);
    }, 0);
  }

  function findAppliedDiscounts(contract) {
    if (!contract || typeof contract !== 'object') return [];
    const source =
      contract.discounts ||
      contract.appliedDiscounts ||
      contract.discountsApplied ||
      contract.discountCodes ||
      contract.appliedDiscountCodes ||
      contract.subscriptionContract?.discounts ||
      contract.discount;
    if (source && typeof source === 'object') {
      const items = getConnectionItems(source);
      if (items.length) return items;
      if (source.discounts) {
        const nested = getConnectionItems(source.discounts);
        if (nested.length) return nested;
      }
      if (
        source.id ||
        source.code ||
        source.discountCode ||
        source.discount_code ||
        source.title ||
        source.discountAmount
      ) {
        return [source];
      }
    }

    const lineDiscounts = [];
    const lines = contract.lines ? getConnectionItems(contract.lines) : [];
    for (const line of lines) {
      if (!line || typeof line !== 'object' || !line.discounts) continue;
      const items = getConnectionItems(line.discounts);
      for (const item of items) lineDiscounts.push(item);
    }
    if (lineDiscounts.length) return lineDiscounts;

    if (typeof contract.contractDetailsJSON === 'string') {
      try {
        const parsed = JSON.parse(contract.contractDetailsJSON);
        const items = findAppliedDiscounts(parsed);
        if (items.length) return items;
      } catch (error) {
        return [];
      }
    }
    return [];
  }

  function extractContractDiscounts(contract) {
    const currency = getCurrency(contract);
    const items = findAppliedDiscounts(contract);
    if (!items.length && contract && contract.id) {
      const lineSummary = (contract.lines ? getConnectionItems(contract.lines) : []).map(
        (line) => ({
          id: line?.id,
          lineDiscounts: line?.discounts ? getConnectionItems(line.discounts).length : 0,
        })
      );
      console.warn(
        `[Harvest Portal] No applied discounts found for contract ${rawId(contract.id)}.`,
        'line discounts:', lineSummary,
        'contract:', contract
      );
    }
    return items.map((discount) => normalizeDiscountRow(discount, currency)).filter(Boolean);
  }

  function normalizeDiscountRow(discount, currency) {
    if (!discount || typeof discount !== 'object') return null;
    const id = discount.id || discount.discountId || discount.discount_id || discount.gid || '';
    const title =
      discount.title ||
      discount.name ||
      discount.code ||
      discount.discountCode ||
      discount.discount_code ||
      discount.couponCode ||
      discount.value?.title ||
      'Discount';
    const description =
      discount.description ||
      discount.summary ||
      discount.value?.description ||
      discount.value?.title ||
      '';

    let fixed = firstMoney(discount, [
      'amount',
      'discountAmount',
      'discount_amount',
      'discountValue',
      'discount_value',
      'fixedAmount',
      'value.amount',
      'value.fixedAmount',
      'value.price',
      'value.moneyAmount',
    ]);
    let percentage =
      numberValue(deepGet(discount, 'value.percentage')) ??
      numberValue(discount.percentage) ??
      numberValue(discount.discountPercentage) ??
      numberValue(discount.discount_percentage);

    if (fixed === null && percentage === null && discount.value !== undefined && discount.value !== null) {
      const raw = discount.value;
      if (typeof raw === 'number') {
        percentage = raw;
      } else if (typeof raw === 'string') {
        const trimmed = String(raw).trim();
        if (/%$/.test(trimmed)) {
          percentage = numberValue(trimmed.replace(/%/g, ''));
        } else if (/^[$€£]/.test(trimmed)) {
          fixed = numberValue(trimmed.replace(/[^0-9.-]/g, ''));
        } else if (/^\d/.test(trimmed)) {
          fixed = numberValue(trimmed);
        }
      }
    }

    const targetType = String(discount.targetType || discount.target_type || '').toUpperCase();
    const type = String(discount.type || discount.discountType || '').toUpperCase();
    const rejectionReason = discount.rejectionReason || '';

    const isShipping =
      targetType === 'SHIPPING_LINE' ||
      targetType === 'SHIPPING' ||
      /SHIPPING|DELIVERY/.test(`${title} ${description}`.toUpperCase());

    let valueText = '';
    let typeLabel = '';

    if (percentage !== null && percentage !== undefined) {
      if (isShipping) {
        valueText = `${percentage}% Shipping Discount`;
        typeLabel = 'Free Shipping';
      } else {
        valueText = `${percentage}% Off`;
        typeLabel = 'Percentage';
      }
    } else if (fixed !== null && fixed !== undefined) {
      if (isShipping) {
        valueText =
          fixed === 0
            ? 'Free Shipping'
            : `${formatMoney(fixed, currency)} Shipping Discount`;
        typeLabel = 'Free Shipping';
      } else {
        valueText = `${formatMoney(fixed, currency)} Off`;
        typeLabel = 'Fixed';
      }
    } else {
      valueText =
        discount.valueText || discount.formattedValue || discount.discountDescription || 'Discount applied';
    }

    return {
      id,
      title,
      description,
      valueText,
      typeLabel,
      type,
      targetType,
      rejectionReason,
    };
  }

  function getLineTotal(product) {
    const discounted = firstMoney(product, [
      'lineDiscountedPrice',
      'discountedPrice',
      'linePrice',
      'totalPrice',
      'totalAmount',
      'discountedPrice.amount',
      'lineDiscountedPrice.amount',
    ]);
    if (discounted !== null && discounted !== 0) return discounted;

    const unit = firstMoney(product, [
      'price',
      'currentPrice',
      'variantPrice',
      'unitPrice',
      'variant.price',
      'variant.currentPrice',
      'variant.variantPrice',
      'variant.unitPrice',
      'variantPrice.amount',
      'unitPrice.amount',
      'price.amount',
      'currentPrice.amount',
      'product.price'
    ]);
    return unit !== null ? unit * getQuantity(product) : 0;
  }

  function getLineId(product) {
    return product?.id || product?.lineId || product?.line_item_id || '';
  }

  function getVariantId(product) {
    if (!product) return '';
    const vId = product?.variantId || 
                product?.variant_id || 
                product?.variant?.id || 
                product?.variant?.variantId || 
                product?.productVariantId || 
                product?.product_variant_id || 
                product?.product_variant?.id;
    if (vId) return vId;
    
    // Only fallback to product.id if it's not a SubscriptionLine GID
    if (product?.id && !String(product.id).includes('SubscriptionLine') && !String(product.id).includes('SubscriptionContractLine')) {
      return product.id;
    }
    return '';
  }

  function firstValue(object, paths) {
    if (!object) return null;
    for (const path of paths) {
      const value = deepGet(object, path);
      if (value !== undefined && value !== null && value !== '') return value;
    }
    return null;
  }

  function getQuantity(product) {
    const quantity = Number(product?.quantity || product?.qty || 1);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getProductTitle(product) {
    if (!product) return 'Product';
    let title = product?.title ||
      product?.productTitle ||
      product?.variantTitle ||
      product?.variant?.title ||
      product?.product?.title;
      
    if (!title || title === 'Product' || title === 'Added Product') {
      const resolved = findCatalogOrContractProduct(getVariantId(product));
      if (resolved) {
        title = resolved.title || resolved.productTitle || resolved.variantTitle || resolved.product?.title;
      }
    }
    return title || 'Product';
  }

  function isPlaceholderImageSource(url) {
    return url === PLACEHOLDER_IMAGE ||
      /(?:placeholder[-_]?image|image[-_]?placeholder|no[-_]?image)/i.test(url);
  }

  function imageUrlFromValue(value, seen = new Set(), depth = 0, skipPlaceholders = false) {
    if (!value || depth > 5) return null;
    if (typeof value === 'string') {
      const url = value.trim();
      return url && (!skipPlaceholders || !isPlaceholderImageSource(url)) ? url : null;
    }
    if (typeof value !== 'object' || seen.has(value)) return null;
    seen.add(value);

    const values = Array.isArray(value) ? value : [value];
    for (const item of values) {
      if (!item) continue;
      if (typeof item === 'string') {
        const url = item.trim();
        if (url && (!skipPlaceholders || !isPlaceholderImageSource(url))) return url;
        continue;
      }
      if (typeof item !== 'object') continue;

      // Appstle and Shopify use different naming conventions for the same media URL.
      for (const key of [
        'url', 'src', 'originalSrc', 'original_src', 'originalUrl', 'original_url',
        'transformedSrc', 'transformed_src', 'imageUrl', 'imageURL', 'image_url',
        'imageSrc', 'image_src', 'secureUrl', 'secure_url'
      ]) {
        if (typeof item[key] === 'string' && item[key].trim()) {
          const url = item[key].trim();
          if (!skipPlaceholders || !isPlaceholderImageSource(url)) return url;
        }
      }

      for (const key of [
        'image', 'featuredImage', 'featured_image', 'variantImage', 'variant_image',
        'productImage', 'product_image', 'previewImage', 'preview_image', 'preview',
        'media', 'images', 'nodes', 'edges', 'node'
      ]) {
        const nested = imageUrlFromValue(item[key], seen, depth + 1, skipPlaceholders);
        if (nested) return nested;
      }
    }
    return null;
  }

  function isPlaceholderImageUrl(value) {
    const url = imageUrlFromValue(value);
    return !url || isPlaceholderImageSource(url);
  }

  function getUsableProductImage(product) {
    if (!product) return null;

    const imageSources = [
      product.variantImage,
      product.variant_image,
      product.variantImageUrl,
      product.variant_image_url,
      product.image,
      product.imageUrl,
      product.imageURL,
      product.image_url,
      product.imageSrc,
      product.image_src,
      product.featuredImage,
      product.featured_image,
      product.featuredImageUrl,
      product.featured_image_url,
      product.productImage,
      product.product_image,
      product.productImageUrl,
      product.product_image_url,
      product.featuredMedia,
      product.featured_media,
      product.media,
      product.images,
      product.variant?.image,
      product.variant?.imageUrl,
      product.variant?.imageURL,
      product.variant?.image_url,
      product.variant?.variantImageUrl,
      product.variant?.variant_image_url,
      product.variant?.featuredImage,
      product.variant?.featured_image,
      product.variant?.featuredImageUrl,
      product.variant?.featured_image_url,
      product.variant?.featuredMedia,
      product.variant?.featured_media,
      product.variant?.media,
      product.variant?.images,
      product.product?.image,
      product.product?.imageUrl,
      product.product?.imageURL,
      product.product?.image_url,
      product.product?.featuredImage,
      product.product?.featured_image,
      product.product?.featuredImageUrl,
      product.product?.featured_image_url,
      product.product?.featuredMedia,
      product.product?.featured_media,
      product.product?.media,
      product.product?.images,
    ];

    for (const source of imageSources) {
      const image = imageUrlFromValue(source, new Set(), 0, true);
      if (image) return image;
    }
    return null;
  }

  function getProductImage(product) {
    if (!product) return PLACEHOLDER_IMAGE;

    let image = getUsableProductImage(product);
    if (!image) {
      const resolved = findCatalogOrContractProduct(getVariantId(product));
      if (resolved && resolved !== product) image = getUsableProductImage(resolved);
    }
    return image || PLACEHOLDER_IMAGE;
  }

  function getNextPaymentDate(contract) {
    return (
      contract?.nextBillingDate ||
      contract?.nextBillingDateTime ||
      contract?.nextPaymentDate ||
      contract?.nextOrderDate ||
      contract?.billingPolicy?.nextBillingDate ||
      ''
    );
  }

  function getNextDeliveryDate(contract) {
    return (
      contract?.nextDeliveryDate ||
      contract?.deliveryDate ||
      contract?.nextBillingDate ||
      contract?.nextPaymentDate ||
      contract?.nextOrderDate ||
      ''
    );
  }

  function getHumanizedDeliveryText(contract) {
    const details = getDeliveryDetails(contract);
    let windowStr = String(details.window || 'Thursday Morning Delivery').toLowerCase();
    
    // Clean up window string such as "Thursday Morning Delivery" -> "Thursday morning"
    if (windowStr.includes('delivery')) {
      windowStr = windowStr.replace('delivery', '').trim();
    }
    
    let suffix = 's';
    if (!windowStr.endsWith('s')) {
      suffix = 's';
    } else {
      suffix = '';
    }
    
    return `Delivering to <strong class="harvest-humanized-address">${escapeHtml(details.address)}</strong> on ${escapeHtml(windowStr)}${suffix}`;
  }

  function getContractShippingAddress(contract) {
    if (!contract) return {};
    
    // Check various common paths where Appstle/Shopify store the address
    const address = contract.shippingAddress || 
                    contract.deliveryAddress || 
                    contract.deliveryMethod?.shippingAddress || 
                    contract.deliveryMethod?.address || 
                    contract.deliveryMethod || 
                    {};
    
    // If the found object has address fields (like address1, city, or zip), return it
    if (address.address1 || address.city || address.zip) {
      return address;
    }
    
    // Check if there's an address list in the customer object
    if (contract.customer?.defaultAddress) {
      return contract.customer.defaultAddress;
    }
    if (contract.customer?.addresses?.[0]) {
      return contract.customer.addresses[0];
    }
    
    return {};
  }

  function getDeliveryDetails(contract) {
    const shipping = getContractShippingAddress(contract);
    const address = [
      shipping.address1,
      shipping.address2,
      shipping.city,
      shipping.province,
      shipping.zip,
      shipping.country
    ]
      .filter(Boolean)
      .join(', ');

    let windowVal = contract?.deliveryWindow;
    if (!windowVal) {
      const attrs = getConnectionItems(contract?.attributes) || getConnectionItems(contract?.customAttributes) || [];
      const winAttr = attrs.find(a => a.key?.toLowerCase() === 'delivery_window' || a.key?.toLowerCase() === 'delivery window');
      if (winAttr) {
        windowVal = winAttr.value;
      }
    }
    if (!windowVal) {
      windowVal = contract?.deliveryInstructions || 'Thursday Morning Delivery';
    }

    return {
      address: address || contract?.address || 'Default shipping address',
      window: windowVal,
    };
  }

  function getPaymentDetails(contract) {
    const payment = contract?.paymentMethod || {};
    const masked = payment?.maskedNumber || payment?.card?.last4 || payment?.lastDigits || '';
    if (masked) return `Ending in ${masked}`;
    if (payment?.type) return `${payment.type} ${masked}`.trim();
    return 'Default payment method';
  }

  function formatMultiline(value) {
    if (!value) return '';
    return String(value).replace(/\n/g, '<br>');
  }

  function getUpdateDeadlineDate(contract) {
    const nextDelivery = getNextDeliveryDate(contract);
    if (!nextDelivery) return '';
    const date = new Date(nextDelivery);
    if (Number.isNaN(date.getTime())) return '';
    date.setDate(date.getDate() - 1);
    date.setHours(23, 59, 0, 0);
    return date.toISOString();
  }

  function pendingLineKey(contractId, lineId) {
    return `${rawId(contractId)}:${rawId(lineId)}`;
  }

  function toDateInputValue(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
  }

  function getWeekdayName(dateStr) {
    if (!dateStr) return '';
    let dateObj;
    if (String(dateStr).includes('T')) {
      dateObj = new Date(dateStr);
    } else {
      const parts = String(dateStr).split('-');
      if (parts.length === 3) {
        dateObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      } else {
        dateObj = new Date(dateStr);
      }
    }
    if (Number.isNaN(dateObj.getTime())) return '';
    return dateObj.toLocaleDateString('en-US', { weekday: 'long' });
  }

  function isProductOutOfStock(product) {
    const inventory =
      product?.inventoryQuantity ??
      product?.availableQuantity ??
      product?.inventory ??
      product?.available;
    if (inventory === undefined || inventory === null) return false;
    return Number(inventory) <= 0;
  }

  function formatFrequency(contract) {
    const policy = contract?.billingPolicy || contract?.deliveryPolicy || {};
    const count = Number(policy.intervalCount || policy.frequency || 1);
    const interval = String(policy.interval || policy.intervalType || 'MONTH').toLowerCase();
    const normalized = interval.endsWith('s') ? interval.slice(0, -1) : interval;
    const label = count === 1 ? normalized : `${normalized}s`;
    return `Every ${count} ${capitalize(label)}`;
  }

  function getCurrency(contract, product) {
    return (
      product?.lineDiscountedPrice?.currencyCode ||
      product?.currentPrice?.currencyCode ||
      contract?.currencyCode ||
      contract?.deliveryPrice?.currencyCode ||
      'USD'
    );
  }

  function customerDisplayName(customer) {
    const rootEl = document.getElementById('harvest-portal-root');
    const liquidName = rootEl?.dataset?.customerName;
    if (liquidName && liquidName.trim() !== '') {
      return liquidName;
    }
    const liquidFirstName = rootEl?.dataset?.customerFirstName;
    const liquidLastName = rootEl?.dataset?.customerLastName;
    if (liquidFirstName || liquidLastName) {
      return [liquidFirstName, liquidLastName].filter(Boolean).join(' ');
    }
    const liquidEmail = rootEl?.dataset?.customerEmail;
    if (liquidEmail && liquidEmail.trim() !== '') {
      return liquidEmail;
    }

    const composed = [customer?.firstName, customer?.lastName].filter(Boolean).join(' ');
    return (
      customer?.displayName ||
      customer?.name ||
      composed ||
      customer?.email ||
      'Customer Account'
    );
  }

  function renderStatusBadge(status) {
    const label = status === 'CANCELLED' ? 'Closed' : capitalize(status.toLowerCase());
    return `<span class="harvest-badge harvest-badge--${status.toLowerCase()}">${escapeHtml(
      label
    )}</span>`;
  }

  function normalizeStatus(status) {
    const normalized = String(status || 'UNKNOWN').toUpperCase();
    if (['CANCELLED', 'CANCELED', 'CLOSED', 'EXPIRED'].includes(normalized)) {
      return 'CANCELLED';
    }
    return normalized;
  }

  function statusRank(status) {
    const normalized = normalizeStatus(status);
    if (normalized === 'ACTIVE') return 0;
    if (normalized === 'PAUSED') return 1;
    if (normalized === 'CANCELLED') return 2;
    return 3;
  }

  function actionButton(action, label, contractId, variant = 'secondary') {
    return `
      <button
        class="harvest-button harvest-button--${variant}"
        type="button"
        data-action="${escapeAttr(action)}"
        data-contract-id="${escapeAttr(contractId)}"
      >${escapeHtml(label)}</button>
    `;
  }

  function selectOption(value, label, selectedValue) {
    return `<option value="${escapeAttr(value)}" ${
      value === selectedValue ? 'selected' : ''
    }>${escapeHtml(label)}</option>`;
  }

  function firstMoney(object, paths) {
    for (const path of paths) {
      const value = moneyValue(deepGet(object, path));
      if (value !== null) return value;
    }
    return null;
  }

  function moneyValue(value) {
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'object') {
      return moneyValue(value.amount ?? value.value ?? value.price);
    }
    return numberValue(value);
  }

  function numberValue(value) {
    if (value === undefined || value === null || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function deepGet(object, path) {
    return String(path)
      .split('.')
      .reduce((value, key) => (value == null ? undefined : value[key]), object);
  }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
      }).format(Number(amount) || 0);
    } catch (error) {
      return `$${(Number(amount) || 0).toFixed(2)}`;
    }
  }

  function formatDate(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Date TBD';
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }

  function dateValue(value) {
    const timestamp = new Date(value || 0).getTime();
    return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
  }

  function rawId(id) {
    return String(id || '').split('/').pop();
  }

  function roundMoney(value) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  }

  function capitalize(value) {
    return String(value || '').charAt(0).toUpperCase() + String(value || '').slice(1);
  }

  function getInitials(value) {
    const initials = String(value || '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');
    return initials || 'CA';
  }

  function safeImageUrl(value) {
    const url = imageUrlFromValue(value);
    if (!url || isPlaceholderImageUrl(url)) return PLACEHOLDER_IMAGE;
    if (/^\/\//.test(url)) return `https:${url}`;
    if (/^(https?:\/\/|\/|data:image\/)/i.test(url)) return url;
    return PLACEHOLDER_IMAGE;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&')
      .replace(/</g, '<')
      .replace(/>/g, '>')
      .replace(/"/g, '"')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function userFacingError(error, fallback) {
    if (error instanceof PortalRequestError && error.status === 401) {
      return 'Your session has expired. Please log in again.';
    }
    return error?.message || fallback;
  }

  const root = document.getElementById('harvest-portal-root');
  if (root) {
    const portal = new HarvestPortal(root);
    window.harvestPortal = portal;
    window.portal = portal;
  }
})();


// (function () {
//   'use strict';

//   const PLACEHOLDER_IMAGE =
//     'data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 300 300%22%3E%3Crect width%3D%22100%25%22 height%3D%22100%25%22 fill%3D%22%23f2f5f7%22%2F%3E%3Cpath d%3D%22M150 135c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20zm50 45H100c-8.284 0-15 6.716-15 15v10h130v-10c0-8.284-6.716-15-15-15z%22 fill%3D%22%23bcc7cf%22%2F%3E%3C%2Fsvg%3E';

//   const ROUTE_PREFIX = '#harvest';
//   const SCHEDULE_DELIVERY_COUNT = 12;
//   const HISTORY_PAGE_SIZE = 3;

//   const SYSTEM_PRODUCTS = [];

//   function getShopDomain() {
//     if (window.Shopify && window.Shopify.shop) {
//       return window.Shopify.shop;
//     }
//     const urlParams = new URLSearchParams(window.location.search);
//     const shopParam = urlParams.get('shop');
//     if (shopParam) return shopParam;

//     const script = document.querySelector('script[src*="shop="]');
//     if (script) {
//       const srcUrl = new URL(script.src, window.location.origin);
//       const srcShop = srcUrl.searchParams.get('shop');
//       if (srcShop) return srcShop;
//     }

//     const host = window.location.hostname;
//     if (host && host !== 'localhost' && !host.includes('127.0.0.1') && !host.includes('gitpod') && !host.includes('webcontainer') && !host.includes('aistudio')) {
//       return host;
//     }

//     return 'sm1s08-03.myshopify.com';
//   }

//   function findCatalogOrContractProduct(variantId) {
//     if (!variantId) return null;
//     const vId = rawId(variantId);
    
//     if (typeof SYSTEM_PRODUCTS !== 'undefined' && SYSTEM_PRODUCTS.length > 0) {
//       const found = SYSTEM_PRODUCTS.find(p => 
//         rawId(getAddableVariantId(p) || getVariantId(p)) === vId ||
//         rawId(getCatalogProductId(p)) === vId
//       );
//       if (found) return found;
//     }
    
//     const portal = window.harvestPortal || window.portal;
//     if (portal && portal.contracts) {
//       for (const contract of portal.contracts) {
//         const lines = [
//           ...getContractLines(contract),
//           ...(contract.oneTimeProducts || [])
//         ];
//         const found = lines.find(p => 
//           rawId(getAddableVariantId(p) || getVariantId(p)) === vId ||
//           rawId(getCatalogProductId(p)) === vId
//         );
//         if (found) return found;
//       }
//     }
//     return null;
//   }

//   function isHtmlPayload(payload) {
//     if (typeof payload === 'string') {
//       const trimmed = payload.trim().toLowerCase();
//       return (
//         trimmed.startsWith('<!doctype') ||
//         trimmed.startsWith('<html') ||
//         trimmed.includes('<body') ||
//         trimmed.includes('class="no-js"')
//       );
//     }
//     return false;
//   }

//   function enrichCandidatesWithExternal(candidates) {
//     return candidates.map(candidate => {
//       if (candidate.params) {
//         candidate.params = Object.assign({ isExternal: true }, candidate.params);
//       } else if (candidate.body) {
//         if (Array.isArray(candidate.body)) {
//           candidate.body = candidate.body.map(item => Object.assign({ isExternal: true }, item));
//         } else {
//           candidate.body = Object.assign({ isExternal: true }, candidate.body);
//         }
//       } else {
//         candidate.params = { isExternal: true };
//       }
//       return candidate;
//     });
//   }

//   function getProductPrice(product) {
//     if (!product) return 0;
//     let price = firstMoney(product, [
//       'price',
//       'currentPrice',
//       'variantPrice',
//       'unitPrice',
//       'variant.price',
//       'variant.currentPrice',
//       'variant.variantPrice',
//       'variant.unitPrice',
//       'variantPrice.amount',
//       'unitPrice.amount',
//       'price.amount',
//       'currentPrice.amount',
//       'product.price'
//     ]);
    
//     if (price === null || price === undefined || price === 0) {
//       const resolved = findCatalogOrContractProduct(getVariantId(product));
//       if (resolved) {
//         price = firstMoney(resolved, [
//           'price',
//           'currentPrice',
//           'variantPrice',
//           'unitPrice',
//           'variant.price',
//           'variant.currentPrice',
//           'variant.variantPrice',
//           'variant.unitPrice',
//           'variantPrice.amount',
//           'unitPrice.amount',
//           'price.amount',
//           'currentPrice.amount',
//           'product.price'
//         ]);
//       }
//     }
//     return price || 0;
//   }

//   class PortalRequestError extends Error {
//     constructor(message, status, payload) {
//       super(message);
//       this.name = 'PortalRequestError';
//       this.status = status;
//       this.payload = payload;
//     }
//   }

//   class HarvestApiService {
//     constructor(options) {
//       this.baseUrl = options.baseUrl;
//       this.customerId = options.customerId;
//       this.endpointCache = {};
//     }

//     async request(path, options = {}) {
//       const originalMethod = options.method || 'GET';
//       const isOverrideMethod = originalMethod === 'PUT' || originalMethod === 'DELETE';

//       const makeAttempt = async (useOverride) => {
//         let method = originalMethod;
//         const url = new URL(`${this.baseUrl}${path}`, window.location.origin);
//         const params = Object.assign({}, options.params, { token: rawId(this.customerId) });

//         if (useOverride) {
//           method = 'POST';
//           url.searchParams.set('_method', originalMethod);
//         }

//         Object.entries(params).forEach(([key, value]) => {
//           if (value !== undefined && value !== null && value !== '') {
//             url.searchParams.set(key, String(value));
//           }
//         });

//         const requestOptions = {
//           method,
//           headers: Object.assign({}, options.headers),
//         };

//         if (useOverride) {
//           requestOptions.headers['X-HTTP-Method-Override'] = originalMethod;
//           requestOptions.headers['X-Http-Method-Override'] = originalMethod;
//         }

//         if (options.body !== undefined) {
//           requestOptions.headers['Content-Type'] = 'application/json';
//           requestOptions.body = JSON.stringify(options.body);
//         }

//         const response = await (window.__harvestFetch || fetch)(url.toString(), requestOptions);
//         const contentType = response.headers.get('content-type') || '';
//         let payload = null;

//         if (response.status !== 204) {
//           if (contentType.includes('json')) {
//             payload = await response.json();
//           } else {
//             const text = await response.text();
//             try {
//               payload = JSON.parse(text);
//             } catch (e) {
//               payload = text;
//             }
//           }
//         }

//         if (!response.ok) {
//           let apiMessage = null;
//           if (payload && typeof payload === 'object') {
//             apiMessage = payload.message || payload.error || payload.errors?.[0]?.message || payload.title || payload.detail;
//             if (typeof apiMessage === 'string' && apiMessage.startsWith('UserGeneratedError:')) {
//               apiMessage = apiMessage.replace(/^UserGeneratedError:/, '');
//             }
//           } else {
//             apiMessage = payload;
//           }
//           throw new PortalRequestError(
//             apiMessage || `Request failed with status ${response.status}.`,
//             response.status,
//             payload
//           );
//         }

//         return payload;
//       };

//       try {
//         // Try direct method (PUT/DELETE/POST) first
//         return await makeAttempt(false);
//       } catch (error) {
//         // Automatically fallback to POST method overriding if PUT/DELETE is not supported by proxy (usually returns 405 or 501)
//         const isMethodError = error instanceof PortalRequestError && (error.status === 405 || error.status === 501);
//         if (isOverrideMethod && isMethodError) {
//           console.warn(`[Harvest Portal] Direct ${originalMethod} request to ${path} failed with ${error.status}. Retrying via POST override...`);
//           try {
//             return await makeAttempt(true);
//           } catch (retryError) {
//             throw retryError;
//           }
//         }
//         throw error;
//       }
//     }

//     async getSubscriptionCustomer() {
//       const customerIdRaw = rawId(this.customerId);
//       const urlCandidates = [
//         '/subscription-customers',
//         `/subscription-customers-detail/valid/${customerIdRaw}`,
//         `/subscription-customers/valid/${customerIdRaw}`
//       ];

//       // Helper to find pageInfo recursively
//       const findPageInfo = (obj) => {
//         if (!obj || typeof obj !== 'object') return null;
//         if (obj.pageInfo && (obj.pageInfo.hasNextPage || obj.pageInfo.endCursor || obj.pageInfo.has_next_page)) {
//           return obj.pageInfo;
//         }
//         for (const key of Object.keys(obj)) {
//           const val = obj[key];
//           if (val && typeof val === 'object') {
//             const found = findPageInfo(val);
//             if (found) return found;
//           }
//         }
//         return null;
//       };

//       // Helper to find edges recursively
//       const findEdges = (obj) => {
//         if (!obj || typeof obj !== 'object') return null;
//         if (Array.isArray(obj.edges)) {
//           return obj.edges;
//         }
//         for (const key of Object.keys(obj)) {
//           const val = obj[key];
//           if (val && typeof val === 'object') {
//             const found = findEdges(val);
//             if (found) return found;
//           }
//         }
//         return null;
//       };

//       let lastError = null;
//       for (const path of urlCandidates) {
//         try {
//           let cursor = null;
//           let allContracts = [];
//           let hasNextPage = true;
//           let pagesFetched = 0;

//           while (hasNextPage && pagesFetched < 10) {
//             const params = {};
//             if (cursor) {
//               params.cursor = cursor;
//             }

//             const payload = await this.request(path, { params });
//             pagesFetched++;

//             if (!payload) {
//               break;
//             }

//             const customer = extractCustomer(payload);
//             const pageContracts = getConnectionItems(customer?.subscriptionContracts);

//             if (pageContracts && pageContracts.length > 0) {
//               pageContracts.forEach(contract => {
//                 if (contract && contract.id) {
//                   const existingIdx = allContracts.findIndex(c => rawId(c.id) === rawId(contract.id));
//                   if (existingIdx === -1) {
//                     allContracts.push(contract);
//                   }
//                 }
//               });
//             } else {
//               break;
//             }

//             const pageInfo = findPageInfo(payload);
//             const hasNext = pageInfo ? (pageInfo.hasNextPage || pageInfo.has_next_page || pageInfo.hasNext || pageInfo.has_next) : false;
//             const endCursor = pageInfo ? (pageInfo.endCursor || pageInfo.end_cursor || pageInfo.cursor) : null;

//             if (hasNext && endCursor) {
//               cursor = endCursor;
//             } else {
//               const edges = findEdges(payload);
//               if (edges && edges.length > 0) {
//                 const lastEdge = edges[edges.length - 1];
//                 if (lastEdge && lastEdge.cursor && lastEdge.cursor !== cursor) {
//                   cursor = lastEdge.cursor;
//                 } else {
//                   hasNextPage = false;
//                 }
//               } else {
//                 hasNextPage = false;
//               }
//             }

//             if (!cursor) {
//               hasNextPage = false;
//             }
//           }

//           if (allContracts.length > 0) {
//             return {
//               subscriptionContracts: allContracts
//             };
//           } else if (path === urlCandidates[urlCandidates.length - 1]) {
//             return {
//               subscriptionContracts: []
//             };
//           }
//         } catch (error) {
//           lastError = error;
//         }
//       }

//       throw lastError || new Error('All subscription endpoints failed.');
//     }

//     updateContractStatus(contractId, status) {
//       const contract = rawId(contractId);
//       const params = {
//         contractId: contract,
//         status,
//       };
//       const body = {
//         contractId: contract,
//         status,
//       };
//       return this.requestCandidate(
//         `updateContractStatus_${contract}`,
//         [
//           { path: '/subscription-contracts-update-status', method: 'POST', body },
//           { path: '/subscription-contracts-update-status', method: 'PUT', params },
//           { path: '/subscription-contracts-update-status', method: 'POST', params },
//           { path: '/subscription-contract-details/update-status', method: 'POST', body },
//         ],
//         { continueStatuses: [400, 404, 405, 501] }
//       );
//     }

//     updateLineItemQuantity(contractId, lineId, variantId, quantity) {
//       const contract = rawId(contractId);
//       const params = {
//         contractId: contract,
//         lineId,
//         quantity,
//         variantId: rawId(variantId),
//         isExternal: true,
//       };
//       const body = {
//         contractId: contract,
//         lineId,
//         quantity,
//         variantId: rawId(variantId),
//         isExternal: true,
//       };
//       return this.requestCandidate(
//         `updateLineItemQuantity_${contract}`,
//         [
//           { path: '/subscription-contracts-update-line-item-quantity', method: 'POST', body },
//           { path: '/subscription-contracts-update-line-item-quantity', method: 'PUT', params },
//           { path: '/subscription-contracts-update-line-item-quantity', method: 'POST', params },
//           { path: '/subscription-contract-details/update-line-item-quantity', method: 'POST', body },
//         ],
//         { continueStatuses: [400, 404, 405, 501] }
//       );
//     }

//     async replaceVariants(contractId, standardPayload, groupSwapPayload) {
//       const contract = rawId(contractId);
//       const shopDomain = (standardPayload && standardPayload.shop) || getShopDomain();
//       const oldVariantId = standardPayload && standardPayload.oldVariants?.[0];
//       const newVariantId = standardPayload && standardPayload.newVariants ? Object.keys(standardPayload.newVariants)[0] : null;
//       const quantity = (standardPayload && standardPayload.newVariants && newVariantId && standardPayload.newVariants[newVariantId]) || 1;
//       const oldLineId = standardPayload && standardPayload.oldLineId;

//       const oldLineIdGid = oldLineId && !String(oldLineId).startsWith('gid://') ? `gid://shopify/SubscriptionLine/${rawId(oldLineId)}` : oldLineId;
//       const contractGid = contractId && !String(contractId).startsWith('gid://') ? `gid://shopify/SubscriptionContract/${rawId(contractId)}` : contractId;
//       const oldVariantGid = oldVariantId && !String(oldVariantId).startsWith('gid://') ? `gid://shopify/ProductVariant/${rawId(oldVariantId)}` : oldVariantId;
//       const newVariantGid = newVariantId && !String(newVariantId).startsWith('gid://') ? `gid://shopify/ProductVariant/${rawId(newVariantId)}` : newVariantId;

//       // Dynamic payload variations to cover different versions of the Appstle API
//       const standardPayloadRawLine = {
//         shop: shopDomain,
//         contractId: rawId(contractId),
//         oldVariants: oldVariantId ? [Number(rawId(oldVariantId)) || oldVariantId] : [],
//         newVariants: newVariantId ? {
//           [rawId(newVariantId)]: quantity,
//         } : {},
//         oldLineId: oldLineIdGid,
//       };

//       const standardPayloadStringLine = {
//         shop: shopDomain,
//         contractId: rawId(contractId),
//         oldVariants: oldVariantId ? [String(rawId(oldVariantId))] : [],
//         newVariants: newVariantId ? {
//           [String(rawId(newVariantId))]: quantity,
//         } : {},
//         oldLineId: oldLineIdGid,
//       };

//       const standardPayloadGidLine = {
//         shop: shopDomain,
//         contractId: rawId(contractId),
//         oldVariants: [oldVariantGid],
//         newVariants: {
//           [newVariantGid]: quantity
//         },
//         oldLineId: oldLineIdGid
//       };

//       const standardPayloadNoLine = {
//         shop: shopDomain,
//         contractId: rawId(contractId),
//         oldVariants: oldVariantId ? [Number(rawId(oldVariantId)) || oldVariantId] : [],
//         newVariants: newVariantId ? {
//           [rawId(newVariantId)]: quantity,
//         } : {},
//       };

//       const flatPayload = {
//         shop: shopDomain,
//         contractId: rawId(contractId),
//         oldVariantId: oldVariantId ? (Number(rawId(oldVariantId)) || rawId(oldVariantId)) : null,
//         newVariantId: newVariantId ? (Number(rawId(newVariantId)) || rawId(newVariantId)) : null,
//         quantity: quantity,
//         lineId: oldLineIdGid,
//       };

//       const flatPayloadGid = {
//         shop: shopDomain,
//         contractId: contractGid,
//         oldVariantId: oldVariantGid,
//         newVariantId: newVariantGid,
//         quantity: quantity,
//         lineId: oldLineIdGid,
//       };

//       const candidates = [];

//       // 1. Prioritize standard, direct replace-variants-v3 with clean payloads first
//       candidates.push(
//         { 
//           path: '/subscription-contract-details/replace-variants-v3', 
//           method: 'POST', 
//           body: standardPayloadStringLine 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants-v3', 
//           method: 'POST', 
//           body: standardPayloadRawLine 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants-v3', 
//           method: 'POST', 
//           body: standardPayloadGidLine 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants-v3', 
//           method: 'POST', 
//           body: flatPayload 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants-v3', 
//           method: 'POST', 
//           body: flatPayloadGid 
//         },
        
//         // 2. Fallbacks to replace-variants (non-v3)
//         { 
//           path: '/subscription-contract-details/replace-line-item', 
//           method: 'POST', 
//           body: standardPayloadStringLine 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants', 
//           method: 'POST', 
//           body: standardPayloadStringLine 
//         },
//         { 
//           path: '/subscription-contract-details/replace-variants', 
//           method: 'POST', 
//           body: standardPayloadRawLine 
//         },
        
//         // 3. Fallbacks to other potential subscription contracts replace variants endpoints
//         { 
//           path: '/subscription-contracts-replace-variants', 
//           method: 'POST', 
//           body: standardPayloadStringLine 
//         },
//         { 
//           path: '/subscription-contracts/replace-variants', 
//           method: 'POST', 
//           body: standardPayloadStringLine 
//         },

//         // 4. Minimal standard structure without line ID in case contract-wide matching is needed
//         {
//           path: '/subscription-contract-details/replace-variants-v3',
//           method: 'POST',
//           body: standardPayloadNoLine
//         }
//       );

//       // 5. Product swaps by variant groups (group swaps) - Last resort fallback
//       if (groupSwapPayload) {
//         candidates.push({ path: `/product-swaps-by-variant-groups/${contract}`, method: 'POST', body: groupSwapPayload });
//       }

//       try {
//         console.log('[Harvest Portal API] Attempting direct replaceVariants candidates...');
//         const result = await this.requestCandidate(
//           `replaceVariants_${contract}`,
//           candidates,
//           { 
//             continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//             noCache: true,
//             strictValidate: true,
//             validate: (payload) => {
//               // If we got an empty response but status was successful, treat it as successful
//               if (payload === true || (Array.isArray(payload) && payload.length === 0) || (payload && typeof payload === 'object' && Object.keys(payload).length === 0)) {
//                 return true;
//               }
//               const contractObj = extractContractFromObject(payload);
//               if (!contractObj) return true;
//               const lines = getContractLines(contractObj);
//               if (Array.isArray(lines)) {
//                 const found = lines.some(line => rawId(getVariantId(line)) === rawId(newVariantId));
//                 if (!found) {
//                   console.warn('[Harvest Portal API] Validation warning: New variant not found in returned contract');
//                   return false;
//                 }
//               }
//               return true;
//             }
//           }
//         );

//         // Double-check if the returned contract actually updated
//         let contractObj = extractContractFromObject(result);
//         if (!contractObj) {
//           // If the API succeeded but returned empty/no contract, fetch latest contract to verify
//           console.log('[Harvest Portal API] Succeeded without returning contract object. Fetching latest contract to verify swap...');
//           try {
//             const fetched = await this.getSubscriptionContract(contractId, { noCache: true });
//             contractObj = extractContractFromObject(fetched);
//           } catch (e) {
//             console.warn('[Harvest Portal API] Verification: Failed to fetch contract for verification', e);
//           }
//         }

//         if (contractObj) {
//           const lines = getContractLines(contractObj);
//           if (Array.isArray(lines)) {
//             const found = lines.some(line => rawId(getVariantId(line)) === rawId(newVariantId));
//             if (!found) {
//               throw new Error(`Verification failed: New variant ${newVariantId} not found in verified contract.`);
//             }
//           }
//         } else {
//           throw new Error('Succeeded but could not verify contract update.');
//         }

//         return result;
//       } catch (err) {
//         console.warn('[Harvest Portal API] Direct replaceVariants failed or failed validation. Error:', err);
        
//         // Fallback: Add new product, then remove old product
//         if (newVariantId && oldVariantId) {
//           console.log('[Harvest Portal API] Initiating swap fallback: Add recurring, then remove old product...', {
//             contractId,
//             newVariantId,
//             oldVariantId,
//             quantity
//           });
          
//           // 1. Add new variant
//           const addRes = await this.addRecurringProduct(contractId, newVariantId, quantity);
          
//           // 2. Locate the old product details from the contract lines to remove it cleanly
//           const updatedContract = extractContractFromObject(addRes);
//           let oldProductObj = null;
//           if (updatedContract) {
//             const lines = getContractLines(updatedContract);
//             if (Array.isArray(lines)) {
//               oldProductObj = lines.find(line => rawId(getVariantId(line)) === rawId(oldVariantId));
//             }
//           }
          
//           if (!oldProductObj) {
//             // Fallback lookup using standard template search
//             const portal = window.harvestPortal || window.portal;
//             if (portal) {
//               const contractObj = portal.findContract ? portal.findContract(contractId) : null;
//               if (contractObj) {
//                 oldProductObj = portal.findProduct ? portal.findProduct(contractObj, oldLineId, false) : null;
//               }
//             }
//           }
          
//           if (oldProductObj) {
//             console.log('[Harvest Portal API] Swap fallback: Removing old line item...', oldProductObj);
//             await this.removeLineItem(contractId, oldProductObj, false);
//           } else {
//             console.warn('[Harvest Portal API] Swap fallback warning: Could not locate old product object for removal');
//           }
          
//           return addRes;
//         } else {
//           throw err;
//         }
//       }
//     }

//     async getSubscriptionProducts(contractId) {
//       const contract = rawId(contractId);
//       const candidates = [
//         {
//           path: '/data/subscription-products',
//           method: 'GET',
//         },
//         {
//           path: '/subscription-products',
//           method: 'GET',
//         },
//         {
//           path: '/subscription-products-catalog',
//           method: 'GET',
//         },
//         {
//           path: '/subscription-contract-details/subscription-products',
//           method: 'GET',
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId',
//           method: 'GET',
//           params: { contractId: contract },
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'GET',
//           params: { contractId: contract },
//         }
//       ];

//       try {
//         const payload = await this.requestCandidate(
//           `subscriptionProducts_${contract}`,
//           candidates,
//           { optional: true, continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
//         );
//         return payload;
//       } catch (err) {
//         console.warn('Error fetching subscription products:', err);
//         return null;
//       }
//     }

//     getBundle(handle) {
//       return this.request(`/v3/subscription-bundlings/external/get-bundle/${handle}`, {
//         method: 'GET',
//       });
//     }

//     getOneTimeProducts(contractId) {
//       const contract = rawId(contractId);
//       return this.requestCandidate(
//         `getOneTimeProducts_${contract}`,
//         [
//           {
//             path: '/upcoming-subscription-contract-one-offs-by-contractId',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-one-offs-by-contractId',
//             params: { contractId: contract },
//           },
//           {
//             path: '/upcoming-subscription-contract-one-offs',
//             params: { contractId: contract },
//           },
//           {
//             path: '/upcoming-subscription-contract-one-offs',
//             params: { subscriptionContractId: contract },
//           },
//           {
//             path: '/subscription-contract-one-offs',
//             params: { contractId: contract },
//           }
//         ],
//         { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
//       );
//     }

//     async getSubscriptionContract(contractId, options = {}) {
//       const contract = rawId(contractId);
//       return await this.requestCandidate(
//         `subscriptionContract_${contract}`,
//         [
//           {
//             path: `/subscription-contracts/contract/${contract}`,
//             method: 'GET'
//           },
//           {
//             path: `/subscription-contracts/contract-external/${contract}`,
//             method: 'GET'
//           },
//           {
//             path: `/subscription-contracts/${contract}`,
//             method: 'GET'
//           },
//           {
//             path: `/subscription-contract-raw/${contract}`,
//             method: 'GET'
//           },
//           {
//             path: '/subscription-contract-details',
//             method: 'GET',
//             params: { contractId: contract }
//           }
//         ],
//         Object.assign(
//           { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] },
//           options
//         )
//       );
//     }

//     addRecurringProduct(contractId, variantId, quantity) {
//       const contract = rawId(contractId);
//       const variant = rawId(variantId);
//       const count = Number(quantity) || 1;
//       const shopDomain = getShopDomain();

//       const rawContract = Number(contract);
//       const isNumeric = /^\d+$/.test(String(variant));
//       const numVariant = isNumeric ? Number(variant) : variant;
//       const rawVariant = String(variant);
//       const gidVariant = `gid://shopify/ProductVariant/${variant}`;

//       // Query parameter variations for V2 storefront APIs
//       const paramsRawNum = {
//         contractId: rawContract,
//         variantId: numVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       const paramsRawStr = {
//         contractId: rawContract,
//         variantId: rawVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       const paramsGid = {
//         contractId: rawContract,
//         variantId: gidVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       // Request body variations for V2 storefront APIs
//       const bodyRawNum = {
//         contractId: rawContract,
//         variantId: numVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       const bodyRawStr = {
//         contractId: rawContract,
//         variantId: rawVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       const bodyGid = {
//         contractId: rawContract,
//         variantId: gidVariant,
//         quantity: count,
//         isOneTimeProduct: false,
//         shop: shopDomain,
//       };

//       // Fallback structures for legacy/alternative endpoints
//       const paramsFallbackNum = {
//         contractId: rawContract,
//         contract_id: rawContract,
//         variantId: numVariant,
//         variant_id: numVariant,
//         product_variant_id: numVariant,
//         productVariantId: numVariant,
//         quantity: count,
//         shop: shopDomain,
//         isOneTimeProduct: false,
//       };

//       const paramsFallbackStr = {
//         contractId: rawContract,
//         contract_id: rawContract,
//         variantId: rawVariant,
//         variant_id: rawVariant,
//         product_variant_id: rawVariant,
//         productVariantId: rawVariant,
//         quantity: count,
//         shop: shopDomain,
//         isOneTimeProduct: false,
//       };
      
//       const bodyFallbackNum = {
//         contractId: rawContract,
//         contract_id: rawContract,
//         variantId: numVariant,
//         variant_id: numVariant,
//         product_variant_id: numVariant,
//         productVariantId: numVariant,
//         quantity: count,
//         shop: shopDomain,
//         isOneTimeProduct: false,
//       };

//       const bodyFallbackStr = {
//         contractId: rawContract,
//         contract_id: rawContract,
//         variantId: rawVariant,
//         variant_id: rawVariant,
//         product_variant_id: rawVariant,
//         productVariantId: rawVariant,
//         quantity: count,
//         shop: shopDomain,
//         isOneTimeProduct: false,
//       };

//       console.log('[Harvest Portal] Attempting addRecurringProduct candidates with values:', {
//         contract: rawContract,
//         variant: rawVariant,
//         numVariant,
//         gidVariant,
//         count,
//         shopDomain
//       });

//       return this.requestCandidate(
//         `addRecurringProduct_${contract}`,
//         enrichCandidatesWithExternal([
//           // --- GROUP 1: V2 Singular Storefront Endpoint (Primary) ---
//           // 1. PUT with query parameters
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid },

//           // 2. PUT with JSON request body
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyGid },

//           // 3. PUT with both query params and JSON request body
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum, body: bodyRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr, body: bodyRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid, body: bodyGid },

//           // 4. POST with query parameters
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid },

//           // 5. POST with JSON request body
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyGid },

//           // 6. POST with both query params and JSON request body
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum, body: bodyRawNum },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr, body: bodyRawStr },
//           { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid, body: bodyGid },

//           // --- GROUP 2: Fallback / Older Singular version: /subscription-contracts-add-line-item ---
//           { path: '/subscription-contracts-add-line-item', method: 'PUT', params: paramsFallbackNum },
//           { path: '/subscription-contracts-add-line-item', method: 'PUT', params: paramsFallbackStr },
//           { path: '/subscription-contracts-add-line-item', method: 'POST', params: paramsFallbackNum },
//           { path: '/subscription-contracts-add-line-item', method: 'POST', params: paramsFallbackStr },
//           { path: '/subscription-contracts-add-line-item', method: 'POST', body: bodyFallbackNum },
//           { path: '/subscription-contracts-add-line-item', method: 'POST', body: bodyFallbackStr },

//           // --- GROUP 3: Fallback / Details/generic product candidates ---
//           { path: '/subscription-contract-details/add-product', method: 'PUT', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-product', method: 'PUT', params: paramsFallbackStr },
//           { path: '/subscription-contract-details/add-product', method: 'POST', body: bodyFallbackNum },
//           { path: '/subscription-contract-details/add-product', method: 'POST', body: bodyFallbackStr },
//           { path: '/subscription-contract-details/add-product', method: 'POST', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-product', method: 'POST', params: paramsFallbackStr },
          
//           { path: '/subscription-contracts/add-product', method: 'PUT', params: paramsFallbackNum },
//           { path: '/subscription-contracts/add-product', method: 'PUT', params: paramsFallbackStr },
//           { path: '/subscription-contracts/add-product', method: 'POST', body: bodyFallbackNum },
//           { path: '/subscription-contracts/add-product', method: 'POST', body: bodyFallbackStr },
//           { path: '/subscription-contracts/add-product', method: 'POST', params: paramsFallbackNum },
//           { path: '/subscription-contracts/add-product', method: 'POST', params: paramsFallbackStr },

//           { path: '/subscription-contract-details/add-line-item', method: 'PUT', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-line-item', method: 'PUT', params: paramsFallbackStr },
//           { path: '/subscription-contract-details/add-line-item', method: 'POST', body: bodyFallbackNum },
//           { path: '/subscription-contract-details/add-line-item', method: 'POST', body: bodyFallbackStr },
//           { path: '/subscription-contract-details/add-line-item', method: 'POST', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-line-item', method: 'POST', params: paramsFallbackStr },

//           { path: '/subscription-contract-details/add-line-items', method: 'PUT', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-line-items', method: 'PUT', params: paramsFallbackStr },
//           { path: '/subscription-contract-details/add-line-items', method: 'POST', body: bodyFallbackNum },
//           { path: '/subscription-contract-details/add-line-items', method: 'POST', body: bodyFallbackStr },
//           { path: '/subscription-contract-details/add-line-items', method: 'POST', params: paramsFallbackNum },
//           { path: '/subscription-contract-details/add-line-items', method: 'POST', params: paramsFallbackStr },
//         ]),
//         {
//           continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//           noCache: true,
//           strictValidate: true,
//           validate: (payload) => {
//             const contractObj = extractContractFromObject(payload);
//             if (!contractObj) return false;
//             const lines = getContractLines(contractObj);
//             if (Array.isArray(lines)) {
//               return lines.some(line => rawId(getVariantId(line)) === rawId(variant));
//             }
//             return false;
//           }
//         }
//       );
//     }

//     updateShippingAddress(contractId, address) {
//       const contract = rawId(contractId);

//       // Find the existing contract to preserve first name, last name, phone, company, address2, etc.
//       const portal = window.harvestPortal || window.portal;
//       let existingContract = null;
//       if (portal && portal.contracts) {
//         existingContract = portal.contracts.find(c => rawId(c.id) === contract);
//       }
//       const existingAddress = existingContract ? getContractShippingAddress(existingContract) : {};

//       let firstName = address.firstName || existingAddress.firstName || existingAddress.first_name || '';
//       let lastName = address.lastName || existingAddress.lastName || existingAddress.last_name || '';
//       let phone = address.phone || existingAddress.phone || existingAddress.phoneNumber || existingAddress.phone_number || '';
//       const company = address.company || existingAddress.company || '';

//       if (!phone) {
//         const cust = existingContract?.customer || {};
//         phone = cust.phone || cust.phoneNumber || cust.phone_number || '';
//       }

//       if (!phone) {
//         const rootEl = document.getElementById('harvest-portal-root');
//         phone = rootEl?.dataset?.customerPhone || '';
//       }

//       if (!phone) {
//         // Safe default fallback phone number so the server-side validator doesn't reject the submission
//         phone = '555-555-5555';
//       }

//       if (!firstName || !lastName) {
//         const cust = existingContract?.customer || {};
//         firstName = firstName || cust.firstName || cust.first_name || '';
//         lastName = lastName || cust.lastName || cust.last_name || '';
//       }
      
//       if (!firstName || !lastName) {
//         const rootEl = document.getElementById('harvest-portal-root');
//         firstName = firstName || rootEl?.dataset?.customerFirstName || '';
//         lastName = lastName || rootEl?.dataset?.customerLastName || '';
//       }

//       if (!firstName || !lastName) {
//         const rootEl = document.getElementById('harvest-portal-root');
//         const fullName = rootEl?.dataset?.customerName || existingContract?.customer?.displayName || existingContract?.customer?.name || '';
//         if (fullName) {
//           const parts = fullName.trim().split(/\s+/);
//           if (parts.length > 0) {
//             firstName = firstName || parts[0];
//             if (parts.length > 1) {
//               lastName = lastName || parts.slice(1).join(' ');
//             }
//           }
//         }
//       }

//       if (!firstName) firstName = 'Customer';
//       if (!lastName) lastName = 'Account';

//       // --- Normalize Address and Detect Country/CountryCode ---
//       const address1 = address.address1 || '';
//       const address2 = address.address2 || existingAddress.address2 || existingAddress.address_2 || '';
//       const city = address.city || '';
//       let province = address.province || address.state || '';
//       let zip = address.zip || address.zipCode || '';
//       let country = address.country || '';

//       province = String(province).trim();
//       zip = String(zip).trim();
//       country = String(country).trim();

//       // Canadian province list
//       const caProvinces = [
//         'BC', 'QC', 'ON', 'AB', 'NS', 'NB', 'MB', 'PE', 'SK', 'NL', 'YT', 'NT', 'NU', 
//         'BRITISH COLUMBIA', 'QUEBEC', 'ONTARIO', 'ALBERTA', 'NOVA SCOTIA', 'NEW BRUNSWICK', 
//         'MANITOBA', 'PRINCE EDWARD ISLAND', 'SASKATCHEWAN', 'NEWFOUNDLAND AND LABRADOR', 
//         'YUKON', 'NORTHWEST TERRITORIES', 'NUNAVUT'
//       ];
      
//       const isCaZip = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/.test(zip.replace(/\s+/g, ''));
//       const isCaProvince = caProvinces.includes(province.toUpperCase());

//       // Default fallback: if it's a Canadian zip/province, or country is empty/US and looks Canadian, set country to Canada
//       if (isCaZip || isCaProvince || !country || country.toUpperCase() === 'UNITED STATES' || country.toUpperCase() === 'US') {
//         if (isCaZip || isCaProvince || !country) {
//           country = 'Canada';
//         }
//       }

//       // Map to proper name and countryCode/country_code
//       let countryCode = 'CA';
//       const countryUpper = country.toUpperCase();
//       if (countryUpper === 'CANADA' || countryUpper === 'CA') {
//         country = 'Canada';
//         countryCode = 'CA';
//       } else if (countryUpper === 'UNITED STATES' || countryUpper === 'US' || countryUpper === 'USA' || countryUpper === 'UNITED STATES OF AMERICA') {
//         country = 'United States';
//         countryCode = 'US';
//       } else if (countryUpper === 'UNITED KINGDOM' || countryUpper === 'GB' || countryUpper === 'UK') {
//         country = 'United Kingdom';
//         countryCode = 'GB';
//       } else if (countryUpper === 'AUSTRALIA' || countryUpper === 'AU') {
//         country = 'Australia';
//         countryCode = 'AU';
//       } else if (countryUpper === 'FRANCE' || countryUpper === 'FR') {
//         country = 'France';
//         countryCode = 'FR';
//       } else if (countryUpper === 'GERMANY' || countryUpper === 'DE') {
//         country = 'Germany';
//         countryCode = 'DE';
//       } else if (country.length === 2) {
//         countryCode = country.toUpperCase();
//       }

//       // Create flat and nested parameter structures
//       const flatPayload = {
//         contractId: contract,
//         address1,
//         address2,
//         city,
//         province,
//         zip,
//         country,
//         countryCode,
//         country_code: countryCode,
//         provinceCode: province,
//         province_code: province,
//         firstName,
//         lastName,
//         first_name: firstName,
//         last_name: lastName,
//         phone,
//         company,
//       };

//       const nestedPayload = {
//         contractId: contract,
//         address: {
//           address1,
//           address2,
//           city,
//           province,
//           zip,
//           country,
//           countryCode,
//           country_code: countryCode,
//           provinceCode: province,
//           province_code: province,
//           firstName,
//           lastName,
//           first_name: firstName,
//           last_name: lastName,
//           phone,
//           company,
//         }
//       };

//       return this.requestCandidate(
//         `updateShippingAddress_${contract}`,
//         [
//           // Candidate A: PUT with query parameter contractId and full flat payload in body (The exact correct Shopify format)
//           { 
//             path: '/subscription-contracts-update-shipping-address', 
//             method: 'PUT', 
//             params: { contractId: contract }, 
//             body: flatPayload 
//           },
//           // Candidate B: PUT with query parameter contractId and nested address in body
//           { 
//             path: '/subscription-contracts-update-shipping-address', 
//             method: 'PUT', 
//             params: { contractId: contract }, 
//             body: nestedPayload 
//           },
//           // Candidate C: PUT with flat payload as body only (no query params)
//           { 
//             path: '/subscription-contracts-update-shipping-address', 
//             method: 'PUT', 
//             body: flatPayload 
//           },
//           // Candidate D: PUT with flat payload as query params
//           { 
//             path: '/subscription-contracts-update-shipping-address', 
//             method: 'PUT', 
//             params: flatPayload 
//           },
//           // Candidate E: POST on details endpoint
//           { 
//             path: '/subscription-contract-details/update-shipping-address', 
//             method: 'POST', 
//             params: { contractId: contract },
//             body: flatPayload 
//           },
//           // Candidate F: PUT on subscription-contracts-update-address
//           { 
//             path: '/subscription-contracts-update-address', 
//             method: 'PUT', 
//             params: { contractId: contract },
//             body: flatPayload 
//           }
//         ],
//         { continueStatuses: [400, 404, 405, 501] }
//       );
//     }

//     async requestCandidate(key, candidates, options = {}) {
//       const cachedCandidate = options.noCache ? null : this.endpointCache[key];
//       let queue = candidates;
//       if (cachedCandidate) {
//         // Find matching candidate in the current list to preserve updated parameters
//         const matchIdx = candidates.findIndex(
//           (c) => c.path === cachedCandidate.path && (c.method || 'GET') === (cachedCandidate.method || 'GET')
//         );
//         if (matchIdx !== -1) {
//           const match = candidates[matchIdx];
//           queue = [
//             match,
//             ...candidates.filter((_, idx) => idx !== matchIdx),
//           ];
//         }
//       }
//       const continueStatuses = options.continueStatuses || [404, 405, 501];
//       let lastError = null;
//       let firstEmptySuccessPayload = null;
//       let firstEmptySuccessCandidate = null;

//       const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//       // console.group(`%c[Harvest Portal Debug API] Probing candidates for: ${key}`, 'color: #3b82f6; font-weight: bold;');
//       // console.log(`• Queue size: ${queue.length} Candidates | Allowed skip statuses:`, continueStatuses);

//       let retriesForCurrentIndex = 0;

//       for (let index = 0; index < queue.length; index++) {
//         const candidate = queue[index];

//         // Space out requests by 100ms default to prevent hitting rate limits during sequential probes
//         if (index > 0) {
//           await sleep(100);
//         }

//         try {
//           // console.log(
//           //   `%c[Attempt #${index + 1}/${queue.length}] ${candidate.method || 'GET'} ${candidate.path}`,
//           //   'color: #6366f1; font-weight: 500;'
//           // );
//           // if (candidate.params) console.log('  Params:', candidate.params);
//           // if (candidate.body) console.log('  Body:', candidate.body);

//           const payload = await this.request(candidate.path, {
//             method: candidate.method || 'GET',
//             params: candidate.params,
//             body: candidate.body,
//           });

//           if (isHtmlPayload(payload)) {
//             throw new PortalRequestError('HTML Redirect received instead of API response', 404, payload);
//           }

//           if (options.validate && !options.validate(payload)) {
//             if (options.strictValidate) {
//               throw new PortalRequestError('Validation failed', 422, payload);
//             }
//             if (!firstEmptySuccessPayload) {
//               firstEmptySuccessPayload = payload;
//               firstEmptySuccessCandidate = candidate;
//             }
//             throw new PortalRequestError('Validated empty', 200, payload);
//           }

//           // console.log(
//           //   `%c[SUCCESS] Candidate #${index + 1} succeeded! Cache updated.`,
//           //   'color: #10b981; font-weight: bold;'
//           // );
//           // console.groupEnd();

//           this.endpointCache[key] = candidate;
//           return payload;
//         } catch (error) {
//           lastError = error;
//           const status = error instanceof PortalRequestError ? error.status : 'Non-API/Local';
//           const errorMsg = error.message || error;

//           // Robust 429 Rate Limit Handling with exponential backoff retries
//           if (status === 429) {
//             if (retriesForCurrentIndex < 3) {
//               retriesForCurrentIndex++;
//               const waitTime = retriesForCurrentIndex * 2000;
//               console.warn(
//                 `%c[RATE LIMITED - 429] Received 429 on candidate #${index + 1}. Waiting for ${waitTime / 1000}s and retrying... (Retry #${retriesForCurrentIndex})`,
//                 'color: #ca8a04; font-weight: bold; background: #fef9c3; padding: 2px 4px; border-radius: 4px;'
//               );
//               await sleep(waitTime);
//               index--; // Stay on same candidate index for loop's next iteration
//               continue;
//             } else {
//               console.error(`%c[RATE LIMIT EXHAUSTED] Candidate #${index + 1} failed with 429 even after 3 backoff retries. Skipping.`, 'color: #ef4444; font-weight: bold;');
//               retriesForCurrentIndex = 0;
//             }
//           } else {
//             retriesForCurrentIndex = 0;
//           }

//           const isBusinessValidationError = error instanceof PortalRequestError && error.payload && (
//             (typeof error.payload === 'object' && error.payload !== null) && (
//               error.payload.errorKey === 'restrictedDayOfWeek' ||
//               (typeof error.payload.title === 'string' && error.payload.title.includes('restrictedDayOfWeek')) ||
//               (typeof error.payload.message === 'string' && error.payload.message.includes('restrictedDayOfWeek')) ||
//               (typeof error.payload.title === 'string' && error.payload.title.toLowerCase().includes('not available for scheduling')) ||
//               (typeof error.payload.message === 'string' && error.payload.message.toLowerCase().includes('not available for scheduling')) ||
//               (key.startsWith('rescheduleDelivery_') && (error.payload.errorKey || error.payload.message || error.payload.title))
//             )
//           );

//           const isIgnorable = !isBusinessValidationError && (!(error instanceof PortalRequestError) || (
//             (status === 429) || // Allow continuing even if a candidate rate-limited and exhausted retries
//             continueStatuses.includes(error.status) || 
//             (error.message === 'Validated empty' && error.status === 200)
//           ));

//           // console.log(
//           //   `%c[FAILED] Candidate #${index + 1} failed with status: ${status}. Error: ${errorMsg} | Ignorable/Skip: ${isIgnorable}`,
//           //   isIgnorable ? 'color: #ca8a04; font-style: italic;' : 'color: #ef4444; font-weight: bold;',
//           //   error instanceof PortalRequestError ? (error.payload || 'No Payload') : error
//           // );

//           if (!isIgnorable) {
//             // console.groupEnd();
//             throw error;
//           }
//         }
//       }

//       // console.groupEnd();

//       if (firstEmptySuccessPayload !== null) {
//         this.endpointCache[key] = firstEmptySuccessCandidate;
//         return firstEmptySuccessPayload;
//       }

//       if (options.optional) return null;
//       throw lastError || new Error('Appstle endpoint was not available.');
//     }

//     async getSchedules(contractId) {
//       const contract = rawId(contractId);
//       const payload = await this.requestCandidate(
//         `schedules_${contract}`,
//         [
//           {
//             path: '/subscription-billing-attempts/top-orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/order-schedule',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/schedules',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-order-schedule',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/upcoming-orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-upcoming-orders-by-contractId',
//             params: { contractId: contract },
//           },
//         ],
//         { 
//           optional: true, 
//           continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//           validate: (data) => extractScheduleItems(data).length > 0
//         }
//       );

//       return {
//         available: Boolean(payload),
//         items: extractScheduleItems(payload),
//         payload,
//       };
//     }

//     async getHistory(contractId) {
//       const contract = rawId(contractId);
//       const payload = await this.requestCandidate(
//         `history_${contract}`,
//         [
//           {
//             path: '/subscription-billing-attempts/past-orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/order-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/billing-attempts',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/subscription-billing-attempts',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/billing-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contract-details/invoice-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-order-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-billing-attempts',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts-billing-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts/orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts/billing-attempts',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-contracts/billing-history',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-customers/orders',
//             params: { contractId: contract },
//           },
//           {
//             path: '/subscription-customers/billing-attempts',
//             params: { contractId: contract },
//           },
//         ],
//         { 
//           optional: true, 
//           continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//           validate: (data) => extractHistoryItems(data).length > 0
//         }
//       );

//       return {
//         available: Boolean(payload),
//         items: extractHistoryItems(payload),
//         payload,
//       };
//     }

//     skipDelivery(contractId, deliveryDate) {
//       const contract = rawId(contractId);
//       const date = deliveryDate || '';
//       const params = {
//         contractId: contract,
//         billingDate: date,
//         deliveryDate: date,
//         nextBillingDate: date,
//       };

//       return this.requestCandidate(
//         `skipDelivery_${contract}`,
//         [
//           { path: '/subscription-contracts-skip-order', method: 'PUT', params },
//           { path: '/subscription-contract-details/skip-order', method: 'POST', body: params },
//           { path: '/subscription-contracts-skip-billing', method: 'PUT', params },
//           { path: '/subscription-contract-details/skip-billing', method: 'POST', body: params },
//           { path: '/subscription-contract-details/skip-next-order', method: 'POST', body: params },
//         ],
//         { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503], noCache: true }
//       );
//     }

//     rescheduleDelivery(contractId, currentDate, newDate) {
//       const contract = rawId(contractId);
      
//       // Ensure newDate is formatted as ISO 8601 (with time and UTC timezone) e.g., 2026-06-27T12:00:00Z
//       // We append T12:00:00.000Z directly to prevent the browser's local timezone offset from shifting the selected date.
//       let nextBillingDateIso = newDate;
//       if (newDate) {
//         const dateMatch = newDate.match(/^(\d{4}-\d{2}-\d{2})/);
//         if (dateMatch) {
//           nextBillingDateIso = `${dateMatch[1]}T12:00:00.000Z`;
//         } else if (!newDate.includes('T')) {
//           try {
//             const d = new Date(newDate + 'T00:00:00');
//             if (!Number.isNaN(d.getTime())) {
//               nextBillingDateIso = d.toISOString();
//             }
//           } catch (e) {
//             console.warn('[Harvest Portal] Error formatting reschedule date:', e);
//           }
//         }
//       }

//       const params = {
//         contractId: contract,
//         billingDate: currentDate || '',
//         deliveryDate: currentDate || '',
//         nextBillingDate: nextBillingDateIso,
//         newBillingDate: nextBillingDateIso,
//         newDeliveryDate: nextBillingDateIso,
//         rescheduleFutureOrder: true,
//       };

//       return this.requestCandidate(
//         `rescheduleDelivery_${contract}`,
//         [
//           {
//             path: '/subscription-contracts-update-billing-date',
//             method: 'PUT',
//             params,
//           },
//           {
//             path: '/subscription-contracts-update-next-billing-date',
//             method: 'PUT',
//             params,
//           },
//           { path: '/subscription-contract-details/reschedule', method: 'POST', body: params },
//           { path: '/subscription-contracts-reschedule', method: 'PUT', params },
//           {
//             path: '/subscription-contract-details/update-next-billing-date',
//             method: 'POST',
//             body: params,
//           },
//         ],
//         { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503] }
//       );
//     }

//     updateOrderNote(contractId, deliveryDate, note) {
//       const contract = rawId(contractId);
      
//       let dateVal = deliveryDate || '';
      
//       // Resilient param-shifting: if only two arguments are passed (contractId and note),
//       // or if deliveryDate contains non-date characters (like spaces in "call before delivery")
//       if (note === undefined && dateVal && (dateVal.includes(' ') || !/\d{4}[-/]\d{2}[-/]\d{2}/.test(dateVal))) {
//         note = dateVal;
//         dateVal = '';
//       }
      
//       // Fallback to today's date if deliveryDate is empty
//       if (!dateVal) {
//         const today = new Date();
//         const yyyy = today.getFullYear();
//         const mm = String(today.getMonth() + 1).padStart(2, '0');
//         const dd = String(today.getDate()).padStart(2, '0');
//         dateVal = `${yyyy}-${mm}-${dd}`;
//       }

//       // 1. Prepare exact targeted bodies with note and date keys to support both contract-level and order-level updates
//       const noteBody = { 
//         note: note,
//         deliveryDate: dateVal,
//         delivery_date: dateVal,
//         date: dateVal
//       };

//       // 2. Prepare unified payload to support different expected key names across Appstle versions
//       const unifiedPayload = {
//         note: note,
//         notes: note,
//         orderNote: note,
//         order_note: note,
//         deliveryInstructions: note,
//         delivery_instructions: note,
//         contractId: contract,
//         contract: contract,
//         subscriptionContractId: contract,
//         deliveryDate: dateVal,
//         delivery_date: dateVal,
//         date: dateVal
//       };

//       // 3. Prepare nested payload in case the endpoint expects a structured contract updates format
//       const nestedPayload = {
//         contract: {
//           note: note,
//           notes: note,
//           orderNote: note,
//           order_note: note,
//           deliveryInstructions: note,
//           delivery_instructions: note,
//           deliveryDate: dateVal,
//           delivery_date: dateVal,
//           date: dateVal
//         },
//         contractId: contract,
//         deliveryDate: dateVal,
//         delivery_date: dateVal,
//         date: dateVal
//       };

//       // Ensure that 'isExternal: true' is present in query params for ALL customer portal write requests.
//       const queryParams = { 
//         isExternal: true,
//         deliveryDate: dateVal,
//         delivery_date: dateVal,
//         date: dateVal
//       };
//       const queryParamsWithContract = { 
//         contractId: contract, 
//         isExternal: true,
//         deliveryDate: dateVal,
//         delivery_date: dateVal,
//         date: dateVal
//       };
      
//       const candidates = [
//         // GROUP 0: Exact endpoint from production traffic (thehonestfarmer.ca)
//         {
//           path: `/update-contract-order-note/${contract}`,
//           method: 'PUT',
//           params: { orderNote: note, isExternal: true }
//         },
//         {
//           path: `/update-contract-order-note/${contract}`,
//           method: 'PUT',
//           params: { order_note: note, isExternal: true }
//         },
//         {
//           path: `/update-contract-order-note/${contract}`,
//           method: 'PUT',
//           params: { note: note, isExternal: true }
//         },
//         {
//           path: `/update-contract-order-note/${contract}`,
//           method: 'POST',
//           params: { orderNote: note, isExternal: true }
//         },

//         // GROUP A: Direct RESTful contract updates on contract-external resource itself (Highly standard for REST)
//         // Try with minimal, unified, and nested bodies to be fully compliant with Appstle schemas
//         {
//           path: `/subscription-contracts/contract-external/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: noteBody
//         },
//         {
//           path: `/subscription-contracts/contract-external/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: unifiedPayload
//         },
//         {
//           path: `/subscription-contracts/contract-external/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: nestedPayload
//         },
//         {
//           path: `/subscription-contracts/contract-external/${contract}`,
//           method: 'POST',
//           params: queryParams,
//           body: noteBody
//         },
//         {
//           path: `/subscription-contracts/contract-external/${contract}`,
//           method: 'POST',
//           params: queryParams,
//           body: unifiedPayload
//         },

//         // GROUP B: Details endpoints with slashes (Standard in latest Appstle customer portals)
//         {
//           path: '/subscription-contract-details/update-notes',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: noteBody
//         },
//         {
//           path: '/subscription-contract-details/update-notes',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-notes',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-order-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-order-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-delivery-instructions',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contract-details/update-delivery-instructions',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },

//         // GROUP C: Flat dashed endpoints (Legacy Appstle customer portal endpoints)
//         {
//           path: '/subscription-contracts-update-notes',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-notes',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-order-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-order-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-delivery-instructions',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts-update-delivery-instructions',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },

//         // GROUP D: Standard slashed endpoints under subscription-contracts
//         {
//           path: '/subscription-contracts/update-notes',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-notes',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-order-note',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-order-note',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-delivery-instructions',
//           method: 'PUT',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },
//         {
//           path: '/subscription-contracts/update-delivery-instructions',
//           method: 'POST',
//           params: queryParamsWithContract,
//           body: unifiedPayload
//         },

//         // GROUP E: Slashed endpoints on contract (without external)
//         {
//           path: `/subscription-contracts/contract/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: unifiedPayload
//         },
//         {
//           path: `/subscription-contracts/contract/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: nestedPayload
//         },
//         {
//           path: `/subscription-contracts/contract/${contract}`,
//           method: 'POST',
//           params: queryParams,
//           body: unifiedPayload
//         },
//         {
//           path: `/subscription-contracts/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: unifiedPayload
//         },
//         {
//           path: `/subscription-contracts/${contract}`,
//           method: 'PUT',
//           params: queryParams,
//           body: nestedPayload
//         },
//         {
//           path: `/subscription-contracts/${contract}`,
//           method: 'POST',
//           params: queryParams,
//           body: unifiedPayload
//         }
//       ];

//       return this.requestCandidate(
//         `orderNote_${contract}`,
//         candidates,
//         { 
//           continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//           noCache: true,
//           strictValidate: true,
//           validate: (payload) => {
//             // Verify that the candidate returned a payload that is NOT a false-positive success.
//             // If the payload contains a note-related field but its value mismatch, skip it!
//             if (payload && typeof payload === 'object') {
//               const noteKeys = ['note', 'notes', 'orderNote', 'order_note', 'deliveryInstructions', 'delivery_instructions'];
              
//               let foundAny = false;
//               let matched = false;
              
//               for (const key of noteKeys) {
//                 if (key in payload && typeof payload[key] === 'string') {
//                   foundAny = true;
//                   if (payload[key] === note) {
//                     matched = true;
//                   }
//                 }
//               }
              
//               if (payload.contract && typeof payload.contract === 'object') {
//                 for (const key of noteKeys) {
//                   if (key in payload.contract && typeof payload.contract[key] === 'string') {
//                     foundAny = true;
//                     if (payload.contract[key] === note) {
//                       matched = true;
//                     }
//                   }
//                 }
//               }
              
//               // If we found some note field, but none matched the new value, then this candidate 
//               // is a false-positive (e.g. standard GET response, or ignored PUT payload).
//               if (foundAny && !matched) {
//                 console.warn(`[Harvest Portal] Candidate returned success but note was NOT updated in payload. Expected: "${note}". Skipping this candidate...`);
//                 return false;
//               }
//             }
//             return true;
//           }
//         }
//       );
//     }

//     async removeLineItem(contractId, product, isOneTime = false) {
//       const contract = rawId(contractId);
//       const lineId = getLineId(product);
//       const variantId = getVariantId(product);
//       const shopDomain = getShopDomain();
      
//       let bAttemptId = product?.billingAttemptId || '';
//       if (isOneTime && !bAttemptId) {
//         try {
//           bAttemptId = await this.seekBillingAttemptId(contract);
//         } catch (e) {
//           console.warn('Error seeking billingAttemptId in removeLineItem:', e);
//         }
//       }
//       const bAttemptIdNum = bAttemptId ? (Number(String(bAttemptId).split('/').pop()) || 0) : 0;

//       // Construct clean, spec-compliant candidates for different endpoints
//       const recurringCandidates = [];

//       if (lineId) {
//         // 1. PUT on remove-line-item with GID lineId
//         recurringCandidates.push({
//           path: '/subscription-contracts-remove-line-item',
//           method: 'PUT',
//           params: {
//             contractId: contract,
//             lineId: lineId,
//             removeDiscount: true,
//             shop: shopDomain,
//           }
//         });

//         // 2. PUT on remove-line-item with numeric rawId
//         const rawLine = rawId(lineId);
//         if (rawLine !== lineId) {
//           recurringCandidates.push({
//             path: '/subscription-contracts-remove-line-item',
//             method: 'PUT',
//             params: {
//               contractId: contract,
//               lineId: rawLine,
//               removeDiscount: true,
//               shop: shopDomain,
//             }
//           });
//         }

//         // 3. PUT on update-line-item-quantity with GID lineId and quantity 0
//         recurringCandidates.push({
//           path: '/subscription-contracts-update-line-item-quantity',
//           method: 'PUT',
//           params: {
//             contractId: contract,
//             lineId: lineId,
//             quantity: 0,
//             variantId: rawId(variantId),
//             shop: shopDomain,
//           }
//         });

//         // 4. PUT on update-line-item-quantity with numeric rawId and quantity 0
//         if (rawLine !== lineId) {
//           recurringCandidates.push({
//             path: '/subscription-contracts-update-line-item-quantity',
//             method: 'PUT',
//             params: {
//               contractId: contract,
//               lineId: rawLine,
//               quantity: 0,
//               variantId: rawId(variantId),
//               shop: shopDomain,
//             }
//           });
//         }
//       }

//       const oneTimeCandidates = [];

//       // DELETE on /subscription-contract-one-offs-by-contractId-and-billing-attempt-id
//       // Needs raw numeric IDs for contractId, billingAttemptId, and variantId.
//       oneTimeCandidates.push({
//         path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//         method: 'DELETE',
//         params: {
//           contractId: contract,
//           billingAttemptId: bAttemptIdNum || undefined,
//           variantId: rawId(variantId),
//           shop: shopDomain,
//         }
//       });

//       return this.requestCandidate(
//         `${isOneTime ? 'removeOneTimeProduct' : 'removeRecurringProduct'}_${contract}`,
//         isOneTime ? oneTimeCandidates : recurringCandidates,
//         { continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503], noCache: true }
//       );
//     }

//     async seekBillingAttemptId(contractId) {
//       const contract = rawId(contractId);
      
//       const findBillingAttemptIdInObject = (obj) => {
//         if (!obj || typeof obj !== 'object') return null;
        
//         if (Array.isArray(obj)) {
//           for (const item of obj) {
//             const found = findBillingAttemptIdInObject(item);
//             if (found) return found;
//           }
//           return null;
//         }
        
//         const keys = Object.keys(obj);
//         for (const k of keys) {
//           const lowerK = k.toLowerCase();
//           if (
//             lowerK === 'billingattemptid' ||
//             lowerK === 'billing_attempt_id' ||
//             lowerK === 'shopifybillingattemptid' ||
//             lowerK === 'shopify_billing_attempt_id'
//           ) {
//             const val = obj[k];
//             if (val && val !== '0' && val !== 0 && val !== 'null' && val !== 'undefined') {
//               return String(val);
//             }
//           }
//         }

//         // Check if this object represents a billing attempt itself (has specific attempt indicators)
//         const hasAttemptIndicator = keys.some(k => {
//           const lk = k.toLowerCase();
//           return (
//             lk === 'attempttime' ||
//             lk === 'attemptcount' ||
//             lk === 'orderdisplayfinancialstatus' ||
//             lk === 'shopifybillingattemptid' ||
//             lk === 'billingattemptid' ||
//             lk === 'billing_attempt_id' ||
//             lk === 'billingcyclenumber'
//           );
//         });
//         if (hasAttemptIndicator && obj.id) {
//           const idStr = String(obj.id);
//           if (idStr && idStr !== '0' && idStr !== 'null' && idStr !== 'undefined' && !idStr.includes('SubscriptionContract')) {
//             return idStr;
//           }
//         }
        
//         for (const k of keys) {
//           const val = obj[k];
//           if (val && typeof val === 'string' && val.includes('SubscriptionBillingAttempt')) {
//             const match = val.match(/gid:\/\/shopify\/SubscriptionBillingAttempt\/\d+/);
//             if (match) return match[0];
//             const matchNumeric = val.match(/SubscriptionBillingAttempt\/(\d+)/);
//             if (matchNumeric) return `gid://shopify/SubscriptionBillingAttempt/${matchNumeric[1]}`;
//           }
//           if (val && typeof val === 'object') {
//             const found = findBillingAttemptIdInObject(val);
//             if (found) return found;
//           }
//         }
//         return null;
//       };

//       // 1. Try from already loaded state/portal one-time products
//       try {
//         const portal = window.harvestPortal || window.portal;
//         if (portal && portal.contracts) {
//           const matchedContract = portal.contracts.find(c => rawId(c.id) === contract);
//           if (matchedContract && matchedContract.oneTimeProducts) {
//             for (const item of matchedContract.oneTimeProducts) {
//               const bid = findBillingAttemptIdInObject(item);
//               if (bid) return bid;
//             }
//           }
//         }
//       } catch (e) {
//         console.warn('Error reading from state oneTimeProducts:', e);
//       }

//       // 2. Try fetching schedules first
//       try {
//         const schedResult = await this.getSchedules(contract);
//         if (schedResult && schedResult.payload) {
//           const bid = findBillingAttemptIdInObject(schedResult.payload);
//           if (bid) return bid;
//         }
//       } catch (e) {
//         console.warn('Error fetching schedules for billingAttemptId:', e);
//       }

//       // 3. Try fetching one-time products directly to scan recursively
//       try {
//         const oneTimePayload = await this.getOneTimeProducts(contract);
//         if (oneTimePayload) {
//           const bid = findBillingAttemptIdInObject(oneTimePayload);
//           if (bid) return bid;
//         }
//       } catch (e) {
//         console.warn('Error fetching oneTimePayload for billingAttemptId:', e);
//       }

//       // 4. Try fetching history as fallback
//       try {
//         const histResult = await this.getHistory(contract);
//         if (histResult && histResult.payload) {
//           const bid = findBillingAttemptIdInObject(histResult.payload);
//           if (bid) return bid;
//         }
//       } catch (e) {
//         console.warn('Error fetching history for billingAttemptId:', e);
//       }

//       return '';
//     }

//     async addOneTimeProduct(contractId, variantId, quantity, deliveryDate) {
//       const contract = rawId(contractId);
//       const variant = rawId(variantId);
//       const count = Number(quantity) || 1;
//       const isNumeric = /^\d+$/.test(String(variant));
//       const parsedVariant = isNumeric ? Number(variant) : variant;

//       // Find a billing attempt ID using our robust async function
//       let bAttemptIdRaw = '';
//       try {
//         bAttemptIdRaw = await this.seekBillingAttemptId(contract);
//       } catch (e) {
//         console.warn('Error seeking billingAttemptId:', e);
//       }

//       const bAttemptIdNum = bAttemptIdRaw ? Number(bAttemptIdRaw.split('/').pop()) || 0 : 0;
//       const bAttemptIdGid = bAttemptIdRaw.startsWith('gid://') ? bAttemptIdRaw : (bAttemptIdNum ? `gid://shopify/SubscriptionBillingAttempt/${bAttemptIdNum}` : '');

//       const shopDomain = getShopDomain();

//       // Find variant details from catalogs to enrich the body
//       let variantHandleValue = '';
//       let priceValueValue = 0;
//       try {
//         const portal = window.harvestPortal || window.portal;
//         if (portal) {
//           const sourceProducts = [
//             ...SYSTEM_PRODUCTS,
//             ...portal.contracts.flatMap((c) => [
//               ...getContractLines(c),
//               ...(c.oneTimeProducts || []),
//             ]),
//           ];
//           for (const prod of sourceProducts) {
//             if (rawId(getVariantId(prod)) === rawId(variantId)) {
//               priceValueValue = getProductPrice(prod);
//               variantHandleValue = prod?.variant?.handle || prod?.handle || '';
//               break;
//             }
//           }
//         }
//       } catch (err) {
//         console.warn('Error reading variant details:', err);
//       }

//       const contractGid = `gid://shopify/SubscriptionContract/${contract}`;
//       const variantGid = `gid://shopify/ProductVariant/${variant}`;

//       const rawContract = Number(contract);
//       const numVariant = parsedVariant;
//       const rawVariant = String(variant);
//       const gidVariant = variantGid;

//       // Query parameter variations for V2 storefront APIs
//       const paramsRawNum = {
//         contractId: rawContract,
//         variantId: numVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       const paramsRawStr = {
//         contractId: rawContract,
//         variantId: rawVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       const paramsGid = {
//         contractId: rawContract,
//         variantId: gidVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       // Request body variations for V2 storefront APIs
//       const bodyRawNum = {
//         contractId: rawContract,
//         variantId: numVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       const bodyRawStr = {
//         contractId: rawContract,
//         variantId: rawVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       const bodyGid = {
//         contractId: rawContract,
//         variantId: gidVariant,
//         quantity: count,
//         isOneTimeProduct: true,
//         shop: shopDomain,
//       };

//       console.log('[Harvest Portal] Attempting addOneTimeProduct candidates with values:', {
//         contract,
//         variant,
//         count,
//         bAttemptIdRaw,
//         bAttemptIdNum,
//         bAttemptIdGid,
//         priceValueValue,
//         variantHandleValue
//       });

//       const formattedDeliveryDate = toDateInputValue(deliveryDate);

//       const candidates = [
//         // --- GROUP 00: V2 Singular Storefront Endpoint (Primary) ---
//         // 1. PUT with query parameters
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid },

//         // 2. PUT with JSON request body
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', body: bodyGid },

//         // 3. PUT with both query params and JSON request body
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawNum, body: bodyRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsRawStr, body: bodyRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'PUT', params: paramsGid, body: bodyGid },

//         // 4. POST with query parameters
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid },

//         // 5. POST with JSON request body
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', body: bodyGid },

//         // 6. POST with both query params and JSON request body
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawNum, body: bodyRawNum },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsRawStr, body: bodyRawStr },
//         { path: '/v2/subscription-contracts-add-line-item', method: 'POST', params: paramsGid, body: bodyGid },

//         // --- GROUP 0: Standard Storefront API subscription-contract-one-offs-by-contractId-and-billing-attempt-id ---
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: {
//             shop: shopDomain,
//             contractId: contract,
//             billingAttemptId: bAttemptIdNum || undefined,
//             variantId: parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             deliveryDate: formattedDeliveryDate,
//             billingDate: formattedDeliveryDate,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'POST',
//           params: {
//             shop: shopDomain,
//             contractId: contract,
//             billingAttemptId: bAttemptIdNum || undefined,
//             variantId: parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             deliveryDate: formattedDeliveryDate,
//             billingDate: formattedDeliveryDate,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             contractId: contract,
//             billingAttemptId: bAttemptIdNum || undefined,
//             variantId: parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             deliveryDate: formattedDeliveryDate,
//             billingDate: formattedDeliveryDate,
//           }
//         },

//         // --- GROUP 1: Standard named API operations (High Probability) ---
//         {
//           path: '/upcoming-subscription-contract-one-offs-create',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: formattedDeliveryDate,
//             deliveryDate: formattedDeliveryDate,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-create',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//             variants: { [parsedVariant]: count },
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-create',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-add',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-add',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//           }
//         },
//         {
//           path: '/subscription-contracts-add-one-off',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-create',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },
//         {
//           path: '/subscription-contract-details/add-one-off',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//           }
//         },
//         {
//           path: '/subscription-contract-details/add-product',
//           method: 'POST',
//           body: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//           }
//         },

//         // --- GROUP 2: POST on upcoming-subscription-contract-one-offs-by-contractId ---
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             quantity: count,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               quantity: count,
//               variantHandle: variantHandleValue || '',
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               quantity: count,
//               variantHandle: variantHandleValue || '',
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             quantity: count,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs-by-contractId',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//           }
//         },

//         // --- GROUP 3: PUT/POST with billingAttemptId on subscription-contract-one-offs-by-contractId-and-billing-attempt-id ---
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: {
//             contractId: contract,
//             subscriptionContractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingAttemptId: bAttemptIdNum || undefined,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: { quantity: count },
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdGid || undefined,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: { quantity: count },
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdGid || undefined,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: { quantity: count },
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdNum || undefined,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs-by-contractId-and-billing-attempt-id',
//           method: 'PUT',
//           params: { quantity: count },
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdNum || undefined,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },

//         // --- GROUP 4: POST/PUT on /upcoming-subscription-contract-one-offs (GET only mostly, so fallback bottom) ---
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdGid || undefined,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdGid || undefined,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdNum || undefined,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdNum || undefined,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'PUT',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdGid || undefined,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'PUT',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdGid || undefined,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'PUT',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdNum || undefined,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'PUT',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdNum || undefined,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/upcoming-subscription-contract-one-offs',
//           method: 'PUT',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },

//         // --- GROUP 5: /subscription-contract-one-offs (PUT and POST) ---
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdGid || undefined,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdGid || undefined,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'POST',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdNum || undefined,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'POST',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdNum || undefined,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'POST',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'PUT',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdGid || undefined,
//             subscriptionContractId: contractGid,
//             variantId: variantGid,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'PUT',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdGid || undefined,
//               subscriptionContractId: contractGid,
//               variantId: variantGid,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'PUT',
//           body: {
//             shop: shopDomain,
//             billingAttemptId: bAttemptIdNum || undefined,
//             subscriptionContractId: Number(contract) || contract,
//             variantId: Number(parsedVariant) || parsedVariant,
//             variantHandle: variantHandleValue || '',
//             quantity: count,
//             price: priceValueValue,
//           }
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'PUT',
//           body: [
//             {
//               shop: shopDomain,
//               billingAttemptId: bAttemptIdNum || undefined,
//               subscriptionContractId: Number(contract) || contract,
//               variantId: Number(parsedVariant) || parsedVariant,
//               variantHandle: variantHandleValue || '',
//               quantity: count,
//               price: priceValueValue,
//             }
//           ]
//         },
//         {
//           path: '/subscription-contract-one-offs',
//           method: 'PUT',
//           params: {
//             contractId: contract,
//             variantId: parsedVariant,
//             quantity: count,
//             billingDate: deliveryDate || '',
//             deliveryDate: deliveryDate || '',
//           }
//         }
//       ];

//       return this.requestCandidate(
//         `addOneTimeProduct_${contract}`,
//         enrichCandidatesWithExternal(candidates),
//         {
//           optional: false,
//           continueStatuses: [400, 401, 402, 403, 404, 405, 422, 500, 501, 502, 503],
//           noCache: true,
//           strictValidate: true,
//           validate: (payload) => {
//             const contractObj = extractContractFromObject(payload);
//             if (contractObj) {
//               const lines = getContractLines(contractObj);
//               if (Array.isArray(lines) && lines.some(line => rawId(getVariantId(line)) === rawId(variant))) {
//                 return true;
//               }
//               if (contractObj.oneTimeProducts && Array.isArray(contractObj.oneTimeProducts)) {
//                 if (contractObj.oneTimeProducts.some(otp => rawId(getVariantId(otp)) === rawId(variant))) {
//                   return true;
//                 }
//               }
//             }
//             if (Array.isArray(payload)) {
//               if (payload.some(otp => rawId(getVariantId(otp)) === rawId(variant))) {
//                 return true;
//               }
//             }
//             return false;
//           }
//         }
//       );
//     }
//   }

//   class HarvestPortal {
//     constructor(root) {
//       this.root = root;
//       this.customerId = root.dataset.customerId || '';
//       this.api = new HarvestApiService({
//         baseUrl: '/apps/subscriptions/cp/api',
//         customerId: this.customerId,
//       });
//       this.customer = null;
//       this.contracts = [];
//       this.noticeTimer = null;
//       this.lastFocusedElement = null;
//       this.state = {
//         loading: false,
//         error: '',
//         notice: null,
//         view: 'list',
//         selectedContractId: null,
//         activeTab: 'upcoming',
//         sortKey: 'id',
//         sortDirection: 'desc',
//         pendingLines: new Set(),
//         tabData: {
//           schedules: {},
//           history: {},
//         },
//         tabLoading: {},
//         tabErrors: {},
//         historyPages: {},
//         productCatalogMode: 'recurring',
//         productSearchQuery: '',
//         listFilter: 'active',
//         contractFilterConfig: 'all',
//         isBuildABoxModalOpen: false,
//         isSwapModalOpen: false,
//       };

//       this.root.classList.add('harvest-portal');
//       this.hideLegacyModal();
//       this.createModalRoot();
//       this.bindEvents();
//       this.init();
//     }

//     async init() {
//       if (!this.customerId) {
//         this.renderLoggedOut();
//         return;
//       }

//       await this.loadPortalData({ showLoading: true });
//     }

//     async resolveVariantId(variantId) {
//       if (!variantId) return variantId;
      
//       const product = SYSTEM_PRODUCTS.find(p => 
//         rawId(getAddableVariantId(p) || getVariantId(p)) === rawId(variantId) || 
//         rawId(p.productId || p.product_id) === rawId(variantId)
//       );
//       if (!product) {
//         console.log(`[Harvest Portal] Product not found in catalog for variant/product ID ${variantId}`);
//         return variantId;
//       }

//       const handle = product.handle;
//       const productId = getCatalogProductId(product);
//       const catalogVariantId = getAddableVariantId(product);
//       if (catalogVariantId && rawId(catalogVariantId) !== rawId(variantId)) {
//         console.log(`[Harvest Portal] Resolved ${variantId} to catalog Variant ID ${catalogVariantId}`);
//         return String(catalogVariantId);
//       }
      
//       if (!handle) {
//         console.warn(`[Harvest Portal] Product handle not found for variant/product ID ${variantId}, unable to resolve`);
//         return variantId;
//       }

//       const isProductIdFallback = String(rawId(productId)) === String(rawId(variantId));
//       if (!isProductIdFallback) {
//         return variantId;
//       }

//       // 1. First, search in SYSTEM_PRODUCTS for any other entry that has matching productId and a different variantId
//       const matchingVariantInCatalog = SYSTEM_PRODUCTS.find(p => 
//         rawId(getCatalogProductId(p)) === rawId(productId) && 
//         rawId(getAddableVariantId(p)) !== rawId(productId) && 
//         getAddableVariantId(p)
//       );
//       if (matchingVariantInCatalog) {
//         const foundVarId = getAddableVariantId(matchingVariantInCatalog);
//         console.log(`[Harvest Portal] Found matching variant in SYSTEM_PRODUCTS: ${foundVarId}`);
//         return String(foundVarId);
//       }

//       // 2. Try the primary endpoint /products/${handle}.js
//       try {
//         console.log(`[Harvest Portal] Resolving Variant ID for Product ID ${productId} (${handle})`);
//         const response = await fetch(`/products/${handle}.js`);
//         if (response.ok) {
//           const productJson = await response.json();
//           if (productJson && Array.isArray(productJson.variants) && productJson.variants.length > 0) {
//             const firstVariantId = productJson.variants[0].id;
//             console.log(`[Harvest Portal] Successfully resolved Product ID ${productId} to Variant ID ${firstVariantId}`);
//             return String(firstVariantId);
//           }
//         } else {
//           console.warn(`[Harvest Portal] Failed fetching Shopify product details for ${handle}: status ${response.status}`);
//         }
//       } catch (err) {
//         console.warn(`[Harvest Portal] Error resolving variant ID for product ${variantId}:`, err);
//       }

//       // 2.5 Dynamic search suggestion fallback to get the correct handle or extract variant ID from URL
//       const fetchVariantIdByHandle = async (h) => {
//         if (!h) return null;
//         try {
//           const res = await fetch(`/products/${h}.js`);
//           if (res.ok) {
//             const json = await res.json();
//             if (json && Array.isArray(json.variants) && json.variants.length > 0) {
//               return String(json.variants[0].id);
//             }
//           }
//         } catch (e) {
//           console.warn(`[Harvest Portal] Failed fetching variant ID by handle ${h}:`, e);
//         }
//         return null;
//       };

//       const suggestUrls = [
//         `/search/suggest.json?q=${productId}&resources[type]=product`,
//         `/search/suggest.json?q=${encodeURIComponent(product.title || '')}&resources[type]=product`,
//         `/search/suggest.json?q=${encodeURIComponent(handle)}&resources[type]=product`
//       ];

//       for (const sUrl of suggestUrls) {
//         try {
//           console.log(`[Harvest Portal] Trying suggest URL fallback to resolve Variant ID: ${sUrl}`);
//           const resp = await fetch(sUrl);
//           if (resp.ok) {
//             const json = await resp.json();
//             const suggestions = json?.resources?.results?.products || [];
//             const matchedSug = suggestions.find(s => 
//               rawId(s.id) === rawId(productId) || 
//               String(s.title).toLowerCase() === String(product.title).toLowerCase() ||
//               (s.handle && s.handle === handle)
//             );
            
//             if (matchedSug) {
//               if (matchedSug.url) {
//                 const urlMatch = matchedSug.url.match(/[?&]variant=(\d+)/);
//                 if (urlMatch) {
//                   const foundId = urlMatch[1];
//                   console.log(`[Harvest Portal] Successfully resolved variant ID directly from suggestion URL: ${foundId}`);
//                   return String(foundId);
//                 }
//               }
//               if (matchedSug.handle) {
//                 const foundId = await fetchVariantIdByHandle(matchedSug.handle);
//                 if (foundId) {
//                   console.log(`[Harvest Portal] Successfully resolved variant ID from suggested handle ${matchedSug.handle}: ${foundId}`);
//                   return foundId;
//                 }
//               }
//             }
//           }
//         } catch (e) {
//           console.warn(`[Harvest Portal] Suggest URL check failed: ${sUrl}`, e);
//         }
//       }

//       // 3. Robust Fallbacks: Loop over secondary and tertiary candidates to query and extract the variant
//       const fallbackUrls = [
//         `/products/${handle}.json`,
//         `/search/suggest.json?q=${encodeURIComponent(handle)}&resources[type]=product`,
//         `/search/suggest.json?q=${encodeURIComponent(product.title || '')}&resources[type]=product`,
//         `/search/suggest.json?q=${productId}&resources[type]=product`,
//         `/products.json?limit=250`,
//         `/collections/all/products.json?limit=250`
//       ];

//       for (const url of fallbackUrls) {
//         try {
//           console.log(`[Harvest Portal] Trying fallback URL to resolve Variant ID: ${url}`);
//           const response = await fetch(url);
//           if (response.ok) {
//             const json = await response.json();
//             const items = extractProductsList(json);
//             const matched = items.find(item => 
//               (rawId(getCatalogProductId(item)) === rawId(productId) || (item.handle && item.handle === handle)) && 
//               rawId(getAddableVariantId(item)) !== rawId(productId) && 
//               getAddableVariantId(item)
//             );
//             if (matched) {
//               const foundVarId = getAddableVariantId(matched);
//               console.log(`[Harvest Portal] Successfully resolved Product ID ${productId} to Variant ID ${foundVarId} via fallback ${url}`);
//               return String(foundVarId);
//             }
//           }
//         } catch (fallbackErr) {
//           console.warn(`[Harvest Portal] Fallback URL failed: ${url}`, fallbackErr);
//         }
//       }

//       return variantId;
//     }

//     bindEvents() {
//       this.root.addEventListener('click', (event) => this.handleClick(event), true);
//       this.root.addEventListener('change', (event) => this.handleChange(event));
//       this.modalRoot.addEventListener('click', (event) => this.handleModalClick(event));

//       this.modalRoot.addEventListener('input', (event) => {
//         if (event.target.id === 'catalog-search') {
//           this.state.productSearchQuery = event.target.value;
//           if (this.state.isBuildABoxModalOpen) {
//             this.updateBuildABoxModalContent();
//           } else if (this.state.isSwapModalOpen) {
//             this.updateSwapModalContent();
//           }
//         }
//       });

//       this.modalRoot.addEventListener('change', (event) => {
//         if (event.target.id === 'catalog-tag-select') {
//           this.state.selectedCategory = event.target.value;
//           if (this.state.isBuildABoxModalOpen) {
//             this.updateBuildABoxModalContent();
//           } else if (this.state.isSwapModalOpen) {
//             this.updateSwapModalContent();
//           }
//         }
//       });

//       this.root.addEventListener('submit', async (event) => {
//         if (event.target.id === 'harvest-shipping-form') {
//           event.preventDefault();
//           const form = event.target;
//           const contractId = form.dataset.contractId;
//           const saveBtn = document.getElementById('save-settings-btn');
//           if (saveBtn) {
//             saveBtn.disabled = true;
//             saveBtn.innerText = 'Saving changes...';
//           }

//           try {
//             const address = {
//               address1: form.querySelector('#address1')?.value || '',
//               city: form.querySelector('#city')?.value || '',
//               province: form.querySelector('#province')?.value || '',
//               zip: form.querySelector('#zip')?.value || '',
//               country: form.querySelector('#country')?.value || 'United States',
//               phone: form.querySelector('#phone')?.value || '',
//             };
//             const deliveryWindow = form.querySelector('#delivery_window')?.value || '';
//             const deliveryInstructions = form.querySelector('#delivery_instructions')?.value || '';

//             // Update shipping address via API
//             await this.api.updateShippingAddress(contractId, address);

//             // Update order note / delivery instructions only if they changed
//             const contractObj = this.findContract(contractId);
//             const oldInstructions = contractObj ? (contractObj.deliveryInstructions || '') : '';
//             if (deliveryInstructions !== oldInstructions) {
//               const nextDate = contractObj ? (getNextDeliveryDate(contractObj) || getNextPaymentDate(contractObj)) : '';
//               await this.api.updateOrderNote(contractId, nextDate, deliveryInstructions);
//             }

//             // Update state copies
//             const contract = this.findContract(contractId);
//             if (contract) {
//               contract.shippingAddress = address;
//               contract.deliveryWindow = deliveryWindow;
//               contract.deliveryInstructions = deliveryInstructions;
//             }

//             this.setNotice('Delivery preferences and address updated successfully!', 'success');
//             await this.loadPortalData({ showLoading: false });
//           } catch (err) {
//             this.setNotice(userFacingError(err, 'Failed to save settings.'), 'error');
//             this.render();
//           }
//         }
//       });

//       // Track typing dynamically on the search box to filter catalog items live
//       this.root.addEventListener('input', (event) => {
//         if (event.target.id === 'catalog-search') {
//           this.state.productSearchQuery = event.target.value;
//           this.render();
//           const input = document.getElementById('catalog-search');
//           if (input) {
//             input.focus();
//             // Retain cursor location by re-triggering string allocation
//             const val = input.value;
//             input.value = '';
//             input.value = val;
//           }
//         }
//       });

//       window.addEventListener('hashchange', () => {
//         this.applyRoute();
//         this.render();
//       });

//       document.addEventListener('keydown', (event) => {
//         if (event.key === 'Escape' && !this.modalRoot.hidden) {
//           this.closeModal();
//         }
//       });
//     }

//     async loadPortalData(options = {}) {
//       try {
//         for (let i = 0; i < localStorage.length; i++) {
//           const key = localStorage.key(i);
//           if (key && (key.startsWith('harvest_local_one_time_products_') || key.startsWith('harvest_local_recurring_products_'))) {
//             localStorage.removeItem(key);
//             i--;
//           }
//         }
//       } catch (err) {
//         console.warn('[Harvest Portal] Error cleaning up local storage:', err);
//       }

//       const showLoading = options.showLoading !== false;
//       if (showLoading) {
//         this.state.loading = true;
//         this.state.error = '';
//         this.render();
//       }

//       try {
//         const payload = await this.api.getSubscriptionCustomer();
//         const customer = extractCustomer(payload);
//         const contracts = getConnectionItems(customer?.subscriptionContracts);

//         await Promise.all(
//           contracts.map(async (contract) => {
//             const status = normalizeStatus(contract.status);
//             if (status !== 'ACTIVE' && status !== 'PAUSED') {
//               contract.oneTimeProducts = [];
//               return;
//             }

//             // First fetch the full contract details to override any incomplete data (like from valid/ endpoint or 5-product limit)
//             try {
//               const detailedPayload = await this.api.getSubscriptionContract(contract.id);
//               const detailedContract = extractContractFromObject(detailedPayload);
//               if (detailedContract) {
//                 // Merge detailedContract properties into the contract object
//                 Object.assign(contract, detailedContract);
//               } else {
//                 console.warn(`[Harvest Portal] Single contract fetch did not return a valid contract structure for ID: ${contract.id}`, detailedPayload);
//               }
//             } catch (error) {
//               console.warn(`[Harvest Portal] Failed to fetch full contract details for ID: ${contract.id}`, error);
//             }

//             try {
//               const oneTimePayload = await this.api.getOneTimeProducts(contract.id);
//               contract.oneTimeProducts = extractOneTimeProducts(oneTimePayload);
//             } catch (error) {
//               console.warn('Unable to load one-time products:', error);
//               contract.oneTimeProducts = [];
//             }
//           })
//         );

//         // Try to fetch all subscription products to populate SYSTEM_PRODUCTS
//         let sysProds = null;
//         let extracted = [];
//         try {
//           const firstContract = contracts.find(c => normalizeStatus(c.status) === 'ACTIVE' || normalizeStatus(c.status) === 'PAUSED');
//           const firstContractId = firstContract ? firstContract.id : '';
//           sysProds = await this.api.getSubscriptionProducts(firstContractId);
//           if (sysProds) {
//             extracted = extractProductsList(sysProds);
//           }
//         } catch (error) {
//           console.warn('[Harvest Portal] Could not fetch products from Appstle /data/subscription-products:', error);
//         }

//         // Appstle can return a valid catalogue whose image field is Shopify's default
//         // placeholder. Keep Appstle as the source of product eligibility and pricing,
//         // but enrich only missing media from the matching Shopify variant.
//         const needsImageEnrichment = extracted.length > 0 && extracted.some(
//           (product) => !getUsableProductImage(product)
//         );

//         // Robust Fallback: If Appstle products are unavailable, or their product media
//         // is unavailable, fetch Shopify Storefront using relative/absolute endpoints.
//         if (extracted.length === 0 || needsImageEnrichment) {
//           const shopDomain = getShopDomain();
//           const storefrontCandidates = [
//             '/collections/all/products.json?limit=250',
//             '/products.json?limit=250',
//             '/search/suggest.json?q=*&resources[type]=product&resources[limit]=250',
//             `/search/suggest.json?q=&resources[type]=product&resources[limit]=250`,
//             `https://${shopDomain}/collections/all/products.json?limit=250`,
//             `https://${shopDomain}/products.json?limit=250`,
//             `https://${shopDomain}/search/suggest.json?q=*&resources[type]=product&resources[limit]=250`
//           ];

//           for (const url of storefrontCandidates) {
//             try {
//               const shResponse = await fetch(url);
//               if (shResponse.ok) {
//                 const shJson = await shResponse.json();
//                 const candExtracted = extractProductsList(shJson);
//                 if (candExtracted && candExtracted.length > 0) {
//                   if (extracted.length === 0) {
//                     extracted = candExtracted;
//                     break;
//                   }

//                   const missingBefore = extracted.filter(
//                     (product) => !getUsableProductImage(product)
//                   ).length;
//                   extracted = mergeProductImages(extracted, candExtracted);
//                   const missingAfter = extracted.filter(
//                     (product) => !getUsableProductImage(product)
//                   ).length;

//                   if (missingAfter < missingBefore) {
//                     break;
//                   }
//                 }
//               }
//             } catch (shErr) {
//               console.warn(`[Harvest Portal] Storefront fetch candidate failed: ${url}`, shErr);
//             }
//           }
//         }

//         if (extracted && extracted.length > 0) {
//           SYSTEM_PRODUCTS.length = 0;
//           SYSTEM_PRODUCTS.push(...extracted);
//         }

//         // Whitelist SYSTEM_PRODUCTS against Shopify storefront (only published products have storefront handles)
//         if (SYSTEM_PRODUCTS.length > 0) {
//           const shopDomain = getShopDomain();
//           const storefrontCatalogs = [
//             '/collections/all/products.json?limit=250',
//             '/products.json?limit=250',
//             `https://${shopDomain}/collections/all/products.json?limit=250`,
//             `https://${shopDomain}/products.json?limit=250`,
//           ];
//           for (const url of storefrontCatalogs) {
//             try {
//               const sfResp = await fetch(url);
//               if (sfResp.ok) {
//                 const sfJson = await sfResp.json();
//                 const sfProducts = extractProductsList(sfJson);
//                 if (sfProducts && sfProducts.length > 0) {
//                   const publishedHandles = new Set(sfProducts.map(p => p.handle).filter(Boolean));
//                   const before = SYSTEM_PRODUCTS.length;
//                   const filtered = SYSTEM_PRODUCTS.filter(p => p.handle && publishedHandles.has(p.handle));
//                   SYSTEM_PRODUCTS.length = 0;
//                   SYSTEM_PRODUCTS.push(...filtered);
//                   const removed = before - SYSTEM_PRODUCTS.length;
//                   if (removed > 0) {
//                     console.log(`[Harvest Portal] Filtered out ${removed} non-published products from catalog via storefront whitelist`);
//                   }
//                   break;
//                 }
//               }
//             } catch (sfErr) {
//               console.warn('[Harvest Portal] Storefront whitelist fetch failed:', sfErr);
//             }
//           }
//         }

//         console.log('[Harvest Portal Inspection] Fetched contracts and products JSON:', {
//           shop: getShopDomain(),
//           contracts: contracts.map(c => ({
//             id: c.id,
//             status: c.status,
//             recurringLines: getContractLines(c),
//             oneTimeProducts: c.oneTimeProducts
//           })),
//           catalogProducts: SYSTEM_PRODUCTS
//         });

//         this.customer = customer || {};
//         this.contracts = contracts;
//         this.state.tabData = { schedules: {}, history: {} };
//         this.state.tabLoading = {};
//         this.state.tabErrors = {};
//         this.state.error = '';
//         this.applyRoute();
//       } catch (error) {
//         console.error('Harvest portal load error:', error);
//         this.state.error = userFacingError(error, 'Unable to load your subscriptions.');
//       } finally {
//         this.state.loading = false;
//         this.render();
//       }
//     }

//     applyRoute() {
//       const hash = window.location.hash || '';
//       const detailMatch = hash.match(
//         /^#harvest\/subscription\/([^/]+)\/(upcoming|schedules|history|settings)$/
//       );

//       if (detailMatch) {
//         const contract = this.findContract(decodeURIComponent(detailMatch[1]));
//         if (contract) {
//           this.state.view = 'detail';
//           this.state.selectedContractId = contract.id;
//           this.state.activeTab = detailMatch[2];
//           return;
//         }
//       }

//       if (hash === `${ROUTE_PREFIX}/list`) {
//         this.state.view = 'list';
//         this.state.selectedContractId = null;
//         this.state.activeTab = 'upcoming';
//       }
//     }

//     navigateToList() {
//       this.setRoute(`${ROUTE_PREFIX}/list`);
//     }

//     navigateToDetail(contractId, tab = 'upcoming') {
//       this.setRoute(
//         `${ROUTE_PREFIX}/subscription/${encodeURIComponent(rawId(contractId))}/${tab}`
//       );
//     }

//     setRoute(hash) {
//       if (window.location.hash === hash) {
//         this.applyRoute();
//         this.render();
//         return;
//       }
//       window.location.hash = hash;
//     }

//     render() {
//       if (this.state.loading) {
//         this.renderLoading();
//         return;
//       }

//       if (this.state.error) {
//         this.renderError();
//         return;
//       }

//       let content;
//       if (this.state.view === 'build_a_box') {
//         content = this.renderBuildABoxView();
//       } else if (this.state.view === 'detail') {
//         content = this.renderDetailView();
//       } else {
//         content = this.renderListView();
//       }

//       this.root.innerHTML = `
//         ${this.renderNotice()}
//         ${this.renderCustomerHeader()}
//         ${content}
//       `;
//     }

//     renderLoggedOut() {
//       this.root.innerHTML = `
//         <section class="harvest-state harvest-state--compact" aria-live="polite">
//           <h2>Please log in</h2>
//           <p>Log in to view and manage your upcoming harvests.</p>
//           <a class="harvest-button harvest-button--primary" href="/account/login">Log in</a>
//         </section>
//       `;
//     }

//     renderLoading() {
//       this.root.innerHTML = `
//         <section class="harvest-state" aria-live="polite" aria-busy="true">
//           <span class="harvest-spinner" aria-hidden="true"></span>
//           <h2>Loading your harvests</h2>
//           <p>Gathering your subscriptions and upcoming products.</p>
//         </section>
//       `;
//     }

//     renderError() {
//       this.root.innerHTML = `
//         <section class="harvest-state harvest-state--error" role="alert">
//           <h2>We could not load your subscriptions</h2>
//           <p>${escapeHtml(this.state.error)}</p>
//           <button class="harvest-button harvest-button--primary" type="button" data-action="retry">
//             Try again
//           </button>
//         </section>
//       `;
//     }

//     renderNotice() {
//       if (!this.state.notice) return '';
//       return `
//         <div class="harvest-notice harvest-notice--${escapeAttr(
//           this.state.notice.type
//         )}" role="${this.state.notice.type === 'error' ? 'alert' : 'status'}">
//           <span>${escapeHtml(this.state.notice.message)}</span>
//           <button type="button" data-action="dismiss-notice" aria-label="Dismiss message">&times;</button>
//         </div>
//       `;
//     }

//     renderCustomerHeader() {
//       const name = customerDisplayName(this.customer);
//       const initials = getInitials(name);
//       return `
//         <header class="harvest-customer-header">
//           <div class="harvest-customer-header__identity">
//             <span class="harvest-avatar" aria-hidden="true">${escapeHtml(initials)}</span>
//             <div>
//               <p class="harvest-customer-header__name">${escapeHtml(name)}</p>
//               <p class="harvest-customer-header__id d-none">Customer ID: ${escapeHtml(
//                 this.customerId
//               )}</p>
//             </div>
//           </div>
//           <a class="harvest-account-link" href="/account">&lsaquo; My Account</a>
//         </header>
//       `;
//     }

//     renderListView() {
//       if (!this.contracts.length) {
//         return `
//           <section class="harvest-state harvest-state--compact">
//             <h2>No subscriptions yet</h2>
//             <p>Your active and previous subscriptions will appear here.</p>
//           </section>
//         `;
//       }

//       let contracts = this.getSortedContracts();

//       return `
//         <section class="harvest-list-view">
//           <div class="harvest-list-heading">
//             ${this.renderSortControls()}
//           </div>

//           <div class="harvest-subscription-list">
//             ${contracts.length === 0 ? `
//               <div class="harvest-state harvest-state--compact" style="grid-column: 1 / -1; padding: 48px;">
//                 <p>No subscriptions found.</p>
//               </div>
//             ` : contracts.map((contract) => this.renderSubscriptionCard(contract)).join('')}
//           </div>
//         </section>
//       `;
//     }

//     renderSortControls() {
//       const directionLabel =
//         this.state.sortDirection === 'asc' ? 'Ascending' : 'Descending';
//       return `
//         <div class="harvest-sort-controls d-none" aria-label="Sort subscriptions">
//           <label class="harvest-field">
//             <span class="visually-hidden">Sort subscriptions by</span>
//             <select data-action="change-sort">
//               ${selectOption('id', 'Subscription Number', this.state.sortKey)}
//               ${selectOption('status', 'Status', this.state.sortKey)}
//               ${selectOption('created-at', 'Subscription Created At', this.state.sortKey)}
//               ${selectOption('next-payment', 'Next Order Date', this.state.sortKey)}
//             </select>
//           </label>
//           <button
//             class="harvest-button harvest-button--primary harvest-sort-direction"
//             type="button"
//             data-action="toggle-sort-direction"
//             aria-label="Change sort direction. Currently ${escapeAttr(directionLabel)}"
//           >
//             <span>${escapeHtml(directionLabel)}</span>
//             <span aria-hidden="true">${this.state.sortDirection === 'asc' ? '&uarr;' : '&darr;'}</span>
//           </button>
//         </div>
//       `;
//     }

//     renderSubscriptionCard(contract) {
//       const status = normalizeStatus(contract.status);
//       const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
//       const totals = calculateContractTotals(contract, oneTimeProducts);
//       const nextPayment = getNextPaymentDate(contract);
//       const canManage = status === 'ACTIVE' || status === 'PAUSED';
//       const detailsLabel = canManage ? 'Edit Products' : 'View Details';

//       // 'Skip this delivery' and 'Add One-time Items' buttons at top of subscription card for ACTIVE
//       const topActionsHtml = status === 'ACTIVE' ? `
//         <div class="harvest-card-top-actions">
//           <button
//             class="harvest-button harvest-button--secondary harvest-button--sm"
//             type="button"
//             data-action="open-skip-delivery"
//             data-contract-id="${escapeAttr(contract.id)}"
//             data-delivery-date="${escapeAttr(getNextDeliveryDate(contract) || getNextPaymentDate(contract))}"
//           >
//             Skip This Delivery
//           </button>
//           <button
//             class="harvest-button harvest-button--secondary harvest-button--sm"
//             type="button"
//             data-action="open-add-one-time"
//             data-contract-id="${escapeAttr(contract.id)}"
//           >
//             Add One-Time Items
//           </button>
//         </div>
//       ` : '';

//       return `
//         <article class="harvest-subscription-card">
//           ${this.renderDeliveryBanner(contract)}
//           ${topActionsHtml}
//           <header class="harvest-subscription-card__header">
//             <div class="harvest-subscription-card__identity d-none">
//               <h3 class="d-none">Subscription #${escapeHtml(rawId(contract.id))}</h3>
//               ${renderStatusBadge(status)}
//               <span class="harvest-badge harvest-badge--box">Build a box</span>
//             </div>
//             <dl class="harvest-subscription-card__meta">
//               ${
//                 nextPayment && status !== 'CANCELLED'
//                   ? `<div><dt>Next Payment:</dt><dd>${escapeHtml(
//                       formatDate(nextPayment)
//                     )}</dd></div>`
//                   : ''
//               }
//               ${
//                 nextPayment && status === 'ACTIVE'
//                   ? `<div><dt class="harvest-deadline-meta__label">Deadline:</dt><dd class="harvest-deadline-meta__text">Update order by 11:59PM on ${escapeHtml(
//                       formatDate(getUpdateDeadlineDate(contract))
//                     )}</dd></div>`
//                   : ''
//               }
//               <div><dt>Order frequency:</dt><dd>${escapeHtml(
//                 formatFrequency(contract)
//               )}</dd></div>
//             </dl>
//           </header>

//           <div class="harvest-upcoming-harvest-title-bar">
//             <h4>Your Upcoming Harvest</h4>
//           </div>

//           <div class="harvest-subscription-card__products">
//             ${recurringProducts
//               .map((product) => this.renderCardProduct(product, contract))
//               .join('')}
//             ${oneTimeProducts
//               .map((product) => this.renderCardProduct(product, contract, true))
//               .join('')}
//           </div>

//           <footer class="harvest-subscription-card__footer">
//             ${this.renderTotals(totals, contract)}
//             <div class="harvest-subscription-card__actions">
//               ${this.renderContractActions(contract, { includeDetails: false })}
//               <button
//                 class="harvest-button harvest-button--secondary"
//                 type="button"
//                 data-action="view-detail"
//                 data-contract-id="${escapeAttr(contract.id)}"
//               >
//                 Edit Order  <span aria-hidden="true">&rsaquo;</span>
//               </button>
//               ${
//                 canManage
//                   ? `<button
//                       class="harvest-button harvest-button--primary"
//                       type="button"
//                       data-action="open-build-a-box"
//                       data-contract-id="${escapeAttr(contract.id)}"
//                     >
//                       Edit Order
//                     </button>`
//                   : ''
//               }
//             </div>
//           </footer>
//         </article>
//       `;
//     }

//     renderCardProduct(product, contract, isOneTime = false) {
//       const status = normalizeStatus(contract.status);
//       return this.renderProductCard(product, contract, {
//         editable: status === 'ACTIVE' || status === 'PAUSED',
//         isOneTime,
//         context: 'list',
//       });
//     }

//     renderDeliveryBanner(contract) {
//       if (normalizeStatus(contract.status) !== 'ACTIVE') return '';
//       const nextDelivery = getNextDeliveryDate(contract);
//       if (!nextDelivery) return '';

//       return `
//         <div class="harvest-delivery-banner harvest-delivery-banner--active">
//           <strong>Next order processes: ${escapeHtml(formatDate(nextDelivery))}</strong>
//           <span class="d-none">Update your order by 11:59 PM on ${escapeHtml(
//             formatDate(getUpdateDeadlineDate(contract))
//           )}</span>
//         </div>
//       `;
//     }

//     renderTotals(totals, contract) {
//       const currency = getCurrency(contract);
//       return `
//         <dl class="harvest-totals">
//           <div><dt>Sub Total:</dt><dd>${escapeHtml(
//             formatMoney(totals.subtotal, currency)
//           )}</dd></div>
//           <div><dt>Delivery Price:</dt><dd>${escapeHtml(
//             formatMoney(totals.delivery, currency)
//           )}</dd></div>
//           ${
//             totals.discount > 0
//               ? `<div><dt>Discount:</dt><dd>${escapeHtml(
//                   formatMoney(totals.discount, currency)
//                 )}</dd></div>`
//               : ''
//           }
//           <div class="harvest-totals__grand"><dt>Total:</dt><dd>${escapeHtml(
//             formatMoney(totals.total, currency)
//           )}</dd></div>
//         </dl>
//       `;
//     }

//     renderContractActions(contract, options = {}) {
//       const status = normalizeStatus(contract.status);
//       const buttons = [];

//       if (status === 'ACTIVE') {
//         buttons.push(actionButton('pause-subscription', 'Pause Subscription', contract.id));
//       }

//       if (status === 'PAUSED') {
//         buttons.push(actionButton('resume-subscription', 'Resume Subscription', contract.id));
//       }

//       if (status !== 'CANCELLED') {
//         buttons.push(
//           actionButton('cancel-subscription', 'Cancel Subscription', contract.id, 'danger')
//         );
//       }

//       if (options.includeDetails) {
//         buttons.push(
//           actionButton('view-detail', 'View Details', contract.id, 'primary')
//         );
//       }

//       return buttons.join('');
//     }

//     renderDetailView() {
//       const contract = this.getSelectedContract();
//       if (!contract) {
//         return `
//           <section class="harvest-state harvest-state--error">
//             <h2>Subscription not found</h2>
//             <button class="harvest-button harvest-button--primary" type="button" data-action="back-list">
//               Back to all harvests
//             </button>
//           </section>
//         `;
//       }

//       return `
//         <section class="harvest-detail-view">
//           <button class="harvest-back-button" type="button" data-action="back-list">
//             &lsaquo; Go Back
//           </button>
//           ${this.renderDetailHeader(contract)}
//           ${this.renderDeliveryBanner(contract)}
//           ${this.renderTabs(contract)}
//           ${this.renderActiveTab(contract)}
//         </section>
//       `;
//     }

//     renderDetailHeader(contract) {
//       const createdAt = contract.createdAt || contract.createdDate || '2026-04-30T10:00:00Z';
//       let formattedDateStr = formatDate(createdAt);
//       try {
//         const d = new Date(createdAt);
//         if (!Number.isNaN(d.getTime())) {
//           const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
//           const day = d.getDate();
//           const month = d.toLocaleDateString('en-US', { month: 'long' });
//           const year = d.getFullYear();
//           formattedDateStr = `${weekday}, ${day} ${month} ${year}`;
//         }
//       } catch (e) {}

//       return `
//         <header class="harvest-detail-header d-none">
//           <div class="harvest-detail-header__title d-none">
//             <h2 class="subscription-id-inside-upcoming">Subscription #${escapeHtml(rawId(contract.id))}</h2>
//             ${renderStatusBadge(normalizeStatus(contract.status))}
//             <span class="harvest-badge harvest-badge--box">Build a box</span>
//           </div>
//           <p class="d-none">
//             Created At ${escapeHtml(formattedDateStr)} | Current billing cycle 2<sup>nd</sup>
//           </p>
//         </header>
//       `;
//     }

//     renderTabs(contract) {
//       const tabs = [
//         ['upcoming', 'Upcoming'],
//         ['schedules', 'Schedules'],
//         ['history', 'History'],
//         ['settings', 'Settings'],
//       ];

//       return `
//         <nav class="harvest-tabs" aria-label="Subscription details">
//           ${tabs
//             .map(
//               ([key, label]) => `
//                 <button
//                   type="button"
//                   class="${key === this.state.activeTab ? 'is-active' : ''}"
//                   data-action="select-tab"
//                   data-contract-id="${escapeAttr(contract.id)}"
//                   data-tab="${key}"
//                   aria-current="${key === this.state.activeTab ? 'page' : 'false'}"
//                 >
//                   ${label}
//                 </button>
//               `
//             )
//             .join('')}
//         </nav>
//       `;
//     }

//     renderActiveTab(contract) {
//       if (this.state.activeTab === 'schedules') {
//         return this.renderSchedulesTab(contract);
//       }

//       if (this.state.activeTab === 'history') {
//         return this.renderHistoryTab(contract);
//       }

//       if (this.state.activeTab === 'settings') {
//         return this.renderSettingsTab(contract);
//       }

//       return this.renderUpcomingTab(contract);
//     }

//     renderSettingsTab(contract) {
//       const status = normalizeStatus(contract.status);
//       const isCancelled = status === 'CANCELLED';
//       const address = getContractShippingAddress(contract);
      
//       // Ensure we have schedule data (which contains the order note) to populate delivery instructions
//       this.ensureTabData(contract, 'schedules');
      
//       const delInstructions = contract.deliveryInstructions || '';
//       const frequency = contract.frequency || 1;
//       const frequencyUnit = contract.frequencyUnit || 'WEEK';
//       const last4 = contract.paymentMethod?.card?.last4 || '••••';

//       return `
//         <div class="harvest-settings-tab-container">
//           <div class="harvest-settings-layout">
            
//             <!-- Address & Preference Fields Form -->
//             <form id="harvest-shipping-form" class="harvest-settings-form" data-contract-id="${escapeAttr(contract.id)}">
//               <div class="harvest-settings-section-card">
//                 <h3 class="harvest-settings-section-title mb-5">Shipping Address</h3>
//                 <p class="harvest-settings-section-subtitle d-none">Manage where your gourmet harvest box will be delivered.</p>
                
//                 <div class="harvest-settings-grid">
//                   <div class="harvest-settings-col-12">
//                     <label class="harvest-label-element" for="address1">Street Address</label>
//                     <input type="text" id="address1" name="address1" class="harvest-input-element" 
//                            value="${escapeAttr(address.address1 || '')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>
                  
//                   <div class="harvest-settings-col-6">
//                     <label class="harvest-label-element" for="city">City</label>
//                     <input type="text" id="city" name="city" class="harvest-input-element" 
//                            value="${escapeAttr(address.city || '')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>
                  
//                   <div class="harvest-settings-col-3">
//                     <label class="harvest-label-element" for="province">State / Province</label>
//                     <input type="text" id="province" name="province" class="harvest-input-element" 
//                            value="${escapeAttr(address.province || address.provinceCode || '')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>
                  
//                   <div class="harvest-settings-col-3">
//                     <label class="harvest-label-element" for="zip">ZIP / Postal Code</label>
//                     <input type="text" id="zip" name="zip" class="harvest-input-element" 
//                            value="${escapeAttr(address.zip || address.zipCode || '')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>

//                   <div class="harvest-settings-col-6">
//                     <label class="harvest-label-element" for="country">Country</label>
//                     <input type="text" id="country" name="country" class="harvest-input-element" 
//                            value="${escapeAttr(address.country || address.countryCode || 'Canada')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>

//                   <div class="harvest-settings-col-6">
//                     <label class="harvest-label-element" for="phone">Phone Number</label>
//                     <input type="tel" id="phone" name="phone" class="harvest-input-element" 
//                            value="${escapeAttr(address.phone || address.phoneNumber || address.phone_number || contract.customer?.phone || contract.customer?.phoneNumber || '')}" ${isCancelled ? 'disabled' : ''} required>
//                   </div>
//                 </div>
//               </div>

//               <div class="harvest-settings-section-card" style="margin-top: 24px;">
//                 <h3 class="harvest-settings-section-title mb-5">Delivery Instructions</h3>
//                 <p class="harvest-settings-section-subtitle d-none">Help our drivers deliver your harvest box perfectly.</p>
                
//                 <div class="harvest-settings-grid">
//                   <div class="harvest-settings-col-12">
//                     <label class="harvest-label-element" for="delivery_instructions">Special Driver Notes</label>
//                     <textarea id="delivery_instructions" name="delivery_instructions" rows="3" class="harvest-input-element" 
//                               placeholder="e.g. Leave inside the wooden crate on patio..." ${isCancelled ? 'disabled' : ''}>${escapeHtml(delInstructions)}</textarea>
//                   </div>
//                 </div>
//               </div>

//               <div class="harvest-settings-section-card" style="margin-top: 24px;">
//                 <h3 class="harvest-settings-section-title mb-5">Frequency settings</h3>
//                 <p class="harvest-settings-section-subtitle d-none">Your subscription delivery schedule.</p>
//                 <div class="harvest-settings-grid">
//                   <div class="harvest-settings-col-12">
//                     <p style="font-size: 14.4px; font-weight: 550; color: var(--harvest-text);">
//                       Current Frequency: <strong>${escapeHtml(formatFrequency(contract))}</strong>
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               ${!isCancelled ? `
//                 <div class="harvest-settings-actions-footer">
//                   <button type="submit" class="harvest-button harvest-button--primary" id="save-settings-btn">
//                     Save Changes & Preferences
//                   </button>
//                 </div>
//               ` : ''}

//             </form>

//             <!-- Bill Detail Sidebar Panel -->
//             <div class="harvest-settings-sidebar">
//               <div class="harvest-settings-section-card">
//                 <h3 class="harvest-settings-section-title mb-5">Payment Method</h3>
//                 <p class="harvest-settings-section-subtitle d-none">Connected card used for recurring cycles.</p>
                
//                 <div class="harvest-payment-preview-card">
//                   <div class="harvest-payment-logo-row">
//                     <span class="harvest-payment-icon-symbol">💳</span>
//                     <span class="harvest-payment-card-brand">Visa</span>
//                   </div>
//                   <div class="harvest-payment-number-row">
//                     •••• •••• •••• ${escapeHtml(last4)}
//                   </div>
//                   <div class="harvest-payment-disclaimer">
//                      Secure checkout powered by Shopify and Appstle.
//                   </div>
//                 </div>

//                 <div class="harvest-callout-box" style="margin-top: 16px;">
//                   <p class="harvest-callout-text">To update your credentials, payment card, or billing intervals, please access your Shopify login details or contact customer care at <a href="mailto:care@harvest.com" style="color:var(--harvest-primary); font-weight:600;">care@harvest.com</a>.</p>
//                 </div>
//               </div>

//               <div class="harvest-settings-section-card" style="margin-top: 24px;">
//                 <h3 class="harvest-settings-section-title mb-5">Subscription Actions</h3>
//                 <p class="harvest-settings-section-subtitle d-none">Pause, skip, or cancel your active deliveries.</p>
                
//                 <div class="harvest-settings-action-buttons-list">
//                   ${status === 'ACTIVE' ? `
//                     <button type="button" class="harvest-button harvest-button--secondary harvest-button-full" 
//                             data-action="pause-subscription" data-contract-id="${escapeAttr(contract.id)}">
//                       Pause deliveries
//                     </button>
//                   ` : ''}
                  
//                   ${status === 'PAUSED' ? `
//                     <button type="button" class="harvest-button harvest-button--secondary harvest-button-full" 
//                             data-action="reactivate-contract" data-contract-id="${escapeAttr(contract.id)}">
//                       Resume deliveries
//                     </button>
//                   ` : ''}
                  
//                   ${!isCancelled ? `
//                     <button type="button" class="harvest-button harvest-button-danger harvest-button-full" 
//                             data-action="cancel-subscription" data-contract-id="${escapeAttr(contract.id)}" style="margin-top: 12px;">
//                       Cancel Subscription
//                     </button>
//                   ` : `
//                     <div class="harvest-cancelled-badge-card">
//                       This plan is closed and inactive.
//                     </div>
//                   `}
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       `;
//     }

//     tabKey(contract, tab) {
//       return `${tab}:${rawId(contract.id)}`;
//     }

//     ensureTabData(contract, tab) {
//       const key = this.tabKey(contract, tab);
//       if (this.state.tabData[tab]?.[rawId(contract.id)] || this.state.tabLoading[key]) return;

//       this.state.tabLoading[key] = true;
//       window.setTimeout(() => this.loadTabData(contract.id, tab), 0);
//     }

//     async loadTabData(contractId, tab) {
//       const contract = this.findContract(contractId);
//       if (!contract) return;

//       const id = rawId(contract.id);
//       const key = this.tabKey(contract, tab);
//       this.state.tabLoading[key] = true;
//       this.state.tabErrors[key] = '';
//       this.render();

//       try {
//         if (tab === 'schedules') {
//           const result = await this.api.getSchedules(contract.id);

//           const items = result ? (result.items || []) : [];
//           const apiItems = items.map((item, index) =>
//             normalizeScheduleItem(item, contract, index)
//           );
          
//           // Pre-populate contract's deliveryInstructions from the first upcoming note
//           if (apiItems.length > 0) {
//             const firstWithNote = apiItems.find(item => item.note);
//             if (firstWithNote) {
//               contract.deliveryInstructions = firstWithNote.note;
//             }
//           }

//           this.state.tabData.schedules[id] = {
//             available: result ? result.available : false,
//             projected: apiItems.length === 0,
//             items: apiItems.length ? apiItems : buildProjectedSchedules(contract),
//           };
//         } else if (tab === 'history') {
//           const result = await this.api.getHistory(contract.id);

//           const items = result ? (result.items || []) : [];
//           this.state.tabData.history[id] = {
//             available: result ? result.available : false,
//             items: items.map((item) => normalizeHistoryItem(item, contract)),
//           };
//           this.state.historyPages[id] = this.state.historyPages[id] || 1;
//         }
//       } catch (error) {
//         this.state.tabErrors[key] = userFacingError(
//           error,
//           `Unable to load ${tab === 'schedules' ? 'delivery schedules' : 'order history'}.`
//         );
//       } finally {
//         this.state.tabLoading[key] = false;
//         this.render();
//       }
//     }

//     renderTabState(title, message, options = {}) {
//       return `
//         <section class="harvest-tab-state ${options.error ? 'harvest-tab-state--error' : ''}" aria-live="polite">
//           ${options.loading ? '<span class="harvest-spinner" aria-hidden="true"></span>' : ''}
//           <h3>${escapeHtml(title)}</h3>
//           <p>${escapeHtml(message)}</p>
//           ${
//             options.retry
//               ? `<button class="harvest-button harvest-button--primary" type="button" data-action="reload-tab" data-tab="${escapeAttr(
//                   options.retry
//                 )}">Try Again</button>`
//               : ''
//           }
//         </section>
//       `;
//     }

//     renderSchedulesTab(contract) {
//       const id = rawId(contract.id);
//       const key = this.tabKey(contract, 'schedules');
//       const data = this.state.tabData.schedules[id];

//       if (this.state.tabErrors[key]) {
//         return this.renderTabState('Schedules', this.state.tabErrors[key], {
//           error: true,
//           retry: 'schedules',
//         });
//       }

//       if (!data) {
//         this.ensureTabData(contract, 'schedules');
//         return this.renderTabState('Loading schedules', 'Checking your upcoming deliveries.', {
//           loading: true,
//         });
//       }

//       if (!data.items.length) {
//         return this.renderTabState(
//           'No upcoming deliveries',
//           'There are no future delivery dates for this harvest right now.'
//         );
//       }

//       return `
//         <section class="harvest-schedule-list" aria-label="Delivery schedules">
//           ${
//             data.projected
//               ? `<p class="harvest-tab-note">Showing upcoming deliveries from your current frequency.</p>`
//               : ''
//           }
//           ${data.items
//             .map((item, index) => this.renderScheduleDelivery(item, contract, index))
//             .join('')}
//         </section>
//       `;
//     }

//     renderScheduleDelivery(item, contract, index) {
//       const status = normalizeScheduleStatus(item.status);
//       const date = item.date || getNextPaymentDate(contract);
//       const products = item.products?.length
//         ? item.products
//         : scheduleProductsForContract(contract, index);
//       const canManage = normalizeStatus(contract.status) === 'ACTIVE';

//       return `
//         <article class="harvest-schedule-card">
//           <header class="harvest-schedule-card__header">
//             <div>
//               <p class="harvest-eyebrow">Delivery</p>
//               <h3>${escapeHtml(formatDate(date))}</h3>
//               ${status ? `<span class="harvest-badge harvest-badge--queued">${escapeHtml(status)}</span>` : ''}
//             </div>
//             ${
//               canManage
//                 ? `<div class="harvest-schedule-card__actions">
//                     <button class="harvest-text-action" type="button" data-action="open-skip-delivery" data-contract-id="${escapeAttr(
//                       contract.id
//                     )}" data-delivery-date="${escapeAttr(date)}">Skip This Delivery</button>
//                     <button class="harvest-text-action" type="button" data-action="open-reschedule" data-contract-id="${escapeAttr(
//                       contract.id
//                     )}" data-delivery-date="${escapeAttr(date)}">Reschedule</button>
//                     <button class="harvest-text-action" type="button" data-action="open-order-note" data-contract-id="${escapeAttr(
//                       contract.id
//                     )}" data-delivery-date="${escapeAttr(date)}" data-note="${escapeAttr(
//                     item.note || ''
//                   )}">Order Note</button>
//                   </div>`
//                 : ''
//             }
//           </header>
//           <div class="harvest-schedule-card__products">
//             ${products
//               .map((product) =>
//                 this.renderProductCard(product, contract, {
//                   editable: false,
//                   isOneTime: isOneTimeProduct(product, contract),
//                   context: 'schedule',
//                 })
//               )
//               .join('')}
//           </div>
//         </article>
//       `;
//     }

//     renderHistoryTab(contract) {
//       const id = rawId(contract.id);
//       const key = this.tabKey(contract, 'history');
//       const data = this.state.tabData.history[id];

//       if (this.state.tabErrors[key]) {
//         return this.renderTabState('History', this.state.tabErrors[key], {
//           error: true,
//           retry: 'history',
//         });
//       }

//       if (!data) {
//         this.ensureTabData(contract, 'history');
//         return this.renderTabState('Loading history', 'Checking completed orders.', {
//           loading: true,
//         });
//       }

//       if (!data.items.length) {
//         return this.renderTabState(
//           'No order history',
//           'No completed orders or cancelled attempts were returned for this harvest.'
//         );
//       }

//       const page = this.state.historyPages[id] || 1;
//       const pageCount = Math.max(1, Math.ceil(data.items.length / HISTORY_PAGE_SIZE));
//       const safePage = Math.min(page, pageCount);
//       const start = (safePage - 1) * HISTORY_PAGE_SIZE;
//       const visibleItems = data.items.slice(start, start + HISTORY_PAGE_SIZE);

//       return `
//         <section class="harvest-history-list" aria-label="Order history">
//           ${visibleItems.map((item) => this.renderHistoryOrder(item, contract)).join('')}
//           ${this.renderHistoryPagination(contract, safePage, pageCount)}
//         </section>
//       `;
//     }

//     renderHistoryOrder(item, contract) {
//       const products = item.products?.length ? item.products : [];
//       const showBillingAttempt = item.status && !item.status.toLowerCase().includes('cancel');

//       return `
//         <article class="harvest-history-card">
//           <header class="harvest-history-card__header">
//             <div>
//               ${
//                 item.orderNumber
//                   ? `<p class="harvest-eyebrow d-none">Order #${escapeHtml(item.orderNumber)}</p>`
//                   : '<p class="harvest-eyebrow d-none">Order</p>'
//               }
//               <h3 style="margin: 0; font-size: 1.15rem; font-weight: 500;">Order Date: ${escapeHtml(formatDate(item.date))}</h3>
//               ${
//                 showBillingAttempt
//                   ? `<p class="harvest-history-card__billing-attempt d-none" style="font-size: 0.9rem; color: #4b5563; margin-top: 4px; margin-bottom: 0;">Billing Attempt: ${escapeHtml(formatDate(item.billingDate || item.date))}</p>`
//                   : ''
//               }
//             </div>
//             <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
//               ${
//                 item.status
//                   ? `<span class="harvest-badge ${
//                       item.status.toLowerCase().includes('cancel')
//                         ? ''
//                         : 'harvest-badge--queued'
//                     }" style="${
//                       item.status.toLowerCase().includes('cancel')
//                         ? 'background-color: #fef08a; color: #854d0e; border: 1px solid #fde047; font-weight: 500; padding: 4px 10px; border-radius: 9999px; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.05em;'
//                         : ''
//                     }">${escapeHtml(item.status)}</span>`
//                   : ''
//               }
//               ${
//                 item.orderUrl
//                   ? `<a class="harvest-button harvest-button--secondary" href="${escapeAttr(
//                       item.orderUrl
//                     )}">View Order Details</a>`
//                   : ''
//               }
//             </div>
//           </header>
//           ${
//             products.length
//               ? `<div class="harvest-history-card__products">
//                   ${products
//                     .map((product) =>
//                       this.renderProductCard(product, contract, {
//                         editable: false,
//                         isOneTime: isOneTimeProduct(product, contract),
//                         context: 'history',
//                       })
//                     )
//                     .join('')}
//                 </div>`
//               : ''
//           }
//           <footer class="harvest-history-card__footer">
//             <strong>Order Total:</strong>
//             <span>${escapeHtml(formatMoney(item.total, getCurrency(contract)))}</span>
//           </footer>
//         </article>
//       `;
//     }

//     renderHistoryPagination(contract, page, pageCount) {
//       if (pageCount <= 1) return '';

//       return `
//         <nav class="harvest-pagination" aria-label="History pages">
//           <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
//             contract.id
//           )}" data-page="1" ${page === 1 ? 'disabled' : ''} aria-label="First page">&laquo;</button>
//           <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
//             contract.id
//           )}" data-page="${page - 1}" ${page === 1 ? 'disabled' : ''} aria-label="Previous page">&lsaquo;</button>
//           <span>${page}</span>
//           <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
//             contract.id
//           )}" data-page="${page + 1}" ${page === pageCount ? 'disabled' : ''} aria-label="Next page">&rsaquo;</button>
//           <button type="button" data-action="history-page" data-contract-id="${escapeAttr(
//             contract.id
//           )}" data-page="${pageCount}" ${page === pageCount ? 'disabled' : ''} aria-label="Last page">&raquo;</button>
//         </nav>
//       `;
//     }

//     renderBuildABoxView() {
//       const contract = this.getSelectedContract();
//       if (!contract) {
//         return `
//           <section class="harvest-state harvest-state--error">
//             <h2>Subscription not found</h2>
//             <button class="harvest-button harvest-button--primary" type="button" data-action="back-list">
//               Back to all harvests
//             </button>
//           </section>
//         `;
//       }

//       const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
//       const totals = calculateContractTotals(contract, oneTimeProducts);
//       const status = normalizeStatus(contract.status);
//       const editable = status === 'ACTIVE' || status === 'PAUSED';
//       const availableItems = this.getOneTimeCandidates(contract);

//       // Filter availableItems based on search query
//       let filteredAvailable = availableItems;
//       if (this.state.productSearchQuery) {
//         const query = this.state.productSearchQuery.toLowerCase().trim();
//         filteredAvailable = availableItems.filter(p =>
//           getProductTitle(p).toLowerCase().includes(query) ||
//           (p.sku && p.sku.toLowerCase().includes(query))
//         );
//       }

//       return `
//         <section class="harvest-build-box-view">
//           <div class="harvest-build-box-header">
//             <button class="harvest-back-button" type="button" data-action="view-detail" data-contract-id="${escapeAttr(contract.id)}">
//               &lsaquo; Back to Details
//             </button>
//             <div class="harvest-build-box-title">
//               <h2>Edit Products & Catalog</h2>
//               <p class="harvest-eyebrow">Subscription #${escapeHtml(rawId(contract.id))}</p>
//             </div>
//             <p class="harvest-build-box-desc">
//               Search the full catalog and add items to your subscription as a recurring product or as a one-time purchase.
//             </p>
//           </div>

//           <div class="harvest-build-box-layout">
//             <div class="harvest-build-box-main">
              
//               <!-- Left Section: Current Items in Coming Harvest -->
//               <div class="harvest-build-box-section">
//                 <h3 class="harvest-section-title">In Your Coming Harvest</h3>
//                 <p class="harvest-section-subtitle">These items are currently scheduled to deliver next. Adjust quantities as needed.</p>
                
//                 <div class="harvest-detail-products">
//                   ${recurringProducts
//                     .map((product) =>
//                       this.renderProductCard(product, contract, {
//                         editable: true,
//                         isOneTime: false,
//                         context: 'build-a-box',
//                       })
//                     )
//                     .join('')}
//                   ${oneTimeProducts
//                     .map((product) =>
//                       this.renderProductCard(product, contract, {
//                         editable: true,
//                         isOneTime: true,
//                         context: 'build-a-box',
//                       })
//                     )
//                     .join('')}
//                   ${recurringProducts.length === 0 && oneTimeProducts.length === 0 ? `
//                     <div class="harvest-empty-box-state">
//                       <p>Your box is empty! Add sweet harvests from the catalog below.</p>
//                     </div>
//                   ` : ''}
//                 </div>
//               </div>

//               <!-- Product Catalog / Browse Section -->
//               <div class="harvest-build-box-section harvest-build-box-section--browse">
                
//                 <!-- Catalog Actions, Search, and Switches Bar -->
//                 <div class="harvest-catalog-controls-container">
//                   <div class="harvest-catalog-search-wrapper">
//                     <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
//                            placeholder="Search product catalog..." value="${escapeAttr(this.state.productSearchQuery)}">
//                     ${this.state.productSearchQuery ? `
//                       <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search">&times;</button>
//                     ` : ''}
//                   </div>

//                   <div class="harvest-catalog-toggle-container">
//                     <label class="harvest-catalog-toggle-label">Clicking "Add" inserts product as:</label>
//                     <div class="harvest-segmented-control">
//                       <button class="harvest-segment-btn ${this.state.productCatalogMode === 'recurring' ? 'is-active' : ''}" 
//                               type="button" data-action="change-catalog-mode" data-mode="recurring">
//                         Subscription Product (Recurring)
//                       </button>
//                       <button class="harvest-segment-btn ${this.state.productCatalogMode === 'one_time' ? 'is-active' : ''}" 
//                               type="button" data-action="change-catalog-mode" data-mode="one_time">
//                         One-Time Delivery (Next Order)
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <h3 class="harvest-section-title" style="margin-top: 16px;">Browse Product Catalog</h3>
//                 <p class="harvest-section-subtitle">Click "+ Add" to include the selected type of product in your next shipment.</p>
                
//                 <div class="harvest-detail-products">
//                   ${filteredAvailable.length === 0 ? `
//                     <div class="harvest-catalog-empty-filtered" style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
//                       <p style="color: var(--harvest-text-muted); font-size: 1.1rem;">No results in catalog match your search.</p>
//                       <button type="button" class="harvest-button harvest-button--secondary" data-action="clear-catalog-search" style="margin-top: 12px;">
//                         Reset filter
//                       </button>
//                     </div>
//                   ` : filteredAvailable
//                     .map((product) => {
//                       const variantId = getAddableVariantId(product);
//                       const inBoxOfRecurring = recurringProducts.some(
//                         (p) => rawId(getVariantId(p)) === rawId(variantId)
//                       );
//                       const inBoxOfOneTime = oneTimeProducts.some(
//                         (p) => rawId(getVariantId(p)) === rawId(variantId)
//                       );
//                       const inBox = inBoxOfRecurring || inBoxOfOneTime;
                      
//                       const badgeLabel = inBoxOfRecurring 
//                         ? 'Added (Recurring)' 
//                         : (inBoxOfOneTime ? 'Added (One-Time)' : '');

//                       const actionLabel = this.state.productCatalogMode === 'recurring' 
//                         ? '+ Add Subscription' 
//                         : '+ Add One-Time';
                      
//                       return `
//                         <article class="harvest-product-card harvest-product-card--available">
//                           <div class="harvest-product-card__media">
//                             <img
//                               src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
//                               alt="${escapeAttr(getProductTitle(product))}"
//                               loading="lazy"
//                             >
//                             ${badgeLabel ? `
//                               <div class="harvest-badge-overlay">
//                                 <span class="harvest-badge ${inBoxOfRecurring ? 'harvest-badge--in-box' : 'harvest-badge--one-time'}">${escapeHtml(badgeLabel)}</span>
//                               </div>
//                             ` : ''}
//                           </div>
//                           <div class="harvest-product-card__body">
//                             <div class="harvest-product-card__copy">
//                               <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
//                               <p class="harvest-product-card__price">
//                                 ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
//                               </p>
//                             </div>
//                             <button
//                               class="harvest-button ${inBox ? 'harvest-button--secondary' : 'harvest-button--primary'} harvest-add-box-btn"
//                               type="button"
//                               data-action="build-a-box-add-item"
//                               data-contract-id="${escapeAttr(contract.id)}"
//                               data-variant-id="${escapeAttr(variantId)}"
//                               data-price="${getProductPrice(product)}"
//                             >
//                               ${actionLabel}
//                             </button>
//                           </div>
//                         </article>
//                       `;
//                     })
//                     .join('')}
//                 </div>
//               </div>
//             </div>

//             <!-- Sidebar Column: Totals Summary -->
//             <aside class="harvest-build-box-sidebar">
//               <div class="harvest-sidebar-card harvest-settings-card">
//                 <header class="harvest-sidebar-card__heading">
//                   <h3>Order Summary</h3>
//                   <span>Box total</span>
//                 </header>
                
//                 <div class="harvest-box-summary-stats">
//                   <div class="harvest-summary-qty-row">
//                     <span>Recurring items:</span>
//                     <strong>${recurringProducts.length}</strong>
//                   </div>
//                   <div class="harvest-summary-qty-row">
//                     <span>One-time items:</span>
//                     <strong>${oneTimeProducts.length}</strong>
//                   </div>
//                 </div>

//                 <div class="harvest-sidebar-totals-block">
//                   ${this.renderTotals(totals, contract)}
//                 </div>

//                 <div class="harvest-sidebar-actions">
//                   <button
//                     class="harvest-button harvest-button--primary w-full"
//                     type="button"
//                     data-action="view-detail"
//                     data-contract-id="${escapeAttr(contract.id)}"
//                   >
//                     View Updated Order &rsaquo;
//                   </button>
//                 </div>
//               </div>
//             </aside>
//           </div>
//         </section>
//       `;
//     }

//     renderUpcomingTab(contract) {
//       const { recurringProducts, oneTimeProducts } = getSplitProducts(contract);
//       const totals = calculateContractTotals(contract, oneTimeProducts);
//       const status = normalizeStatus(contract.status);
//       const editable = status === 'ACTIVE' || status === 'PAUSED';
//       const futureDeliveries = this.getFutureDeliveries(contract);

//       return `
//         <div class="harvest-upcoming-layout">
//           <section class="harvest-upcoming-panel">
//             <header class="harvest-panel-heading">
//               <div>
//                 <p class="harvest-eyebrow">Your Upcoming Harvest</p>
//                 <h3>${escapeHtml(formatDate(getNextDeliveryDate(contract) || getNextPaymentDate(contract)))}</h3>
//               </div>
//               ${
//                 editable
//                   ? `<div class="harvest-panel-actions">
//                       <button class="harvest-button harvest-button--primary" type="button" data-action="open-build-a-box" data-contract-id="${escapeAttr(contract.id)}">Edit Order</button>
//                       <button class="harvest-button harvest-button--secondary" type="button" data-action="open-skip-delivery" data-contract-id="${escapeAttr(
//                         contract.id
//                       )}" data-delivery-date="${escapeAttr(
//                       getNextDeliveryDate(contract) || getNextPaymentDate(contract)
//                     )}">Skip This Delivery</button>
//                       <button class="harvest-button harvest-button--secondary" type="button" data-action="open-add-one-time" data-contract-id="${escapeAttr(
//                         contract.id
//                       )}">Add One-Time Items</button>
//                     </div>`
//                   : '<span class="harvest-badge harvest-badge--box">Build a box</span>'
//               }
//             </header>

//             <div class="harvest-detail-products">
//               ${recurringProducts
//                 .map((product) =>
//                   this.renderProductCard(product, contract, {
//                     editable,
//                     isOneTime: false,
//                     context: 'detail',
//                   })
//                 )
//                 .join('')}
//               ${oneTimeProducts
//                 .map((product) =>
//                   this.renderProductCard(product, contract, {
//                     editable,
//                     isOneTime: true,
//                     context: 'detail',
//                   })
//                 )
//                 .join('')}
//             </div>

//             <div class="harvest-upcoming-panel__totals">
//               ${this.renderTotals(totals, contract)}
//             </div>

//             ${
//               futureDeliveries.length
//                 ? `<section class="harvest-future-deliveries d-none">
//                     <header class="harvest-future-deliveries__heading">
//                       <p class="harvest-eyebrow">Upcoming Deliveries</p>
//                       <h3>Future Shipment Timeline</h3>
//                     </header>
                    
//                     <div class="harvest-timeline-container">
//                       <div class="harvest-timeline-line"></div>
//                       <div class="harvest-timeline-list">
//                         ${futureDeliveries
//                           .map(
//                             (delivery, index) => {
//                               const deliveryDateStr = delivery.date;
//                               return `
//                                 <div class="harvest-timeline-node">
//                                   <div class="harvest-timeline-marker-wrapper">
//                                     <div class="harvest-timeline-marker ${index === 0 ? 'is-next' : ''}"></div>
//                                   </div>
//                                   <div class="harvest-timeline-content">
//                                     <div class="harvest-timeline-header-row">
//                                       <span class="harvest-timeline-date">${escapeHtml(formatDate(deliveryDateStr))}</span>
//                                       ${index === 0 ? `<span class="harvest-badge-timeline-upcoming">Next Shipment</span>` : ''}
//                                     </div>
//                                     <div class="harvest-timeline-details-row">
//                                       <span class="harvest-timeline-products-count">${delivery.productCount} product${delivery.productCount !== 1 ? 's' : ''} scheduled</span>
//                                       ${editable ? `
//                                         <div class="harvest-timeline-action-buttons">
//                                           <button class="harvest-timeline-link-btn" type="button" 
//                                                   data-action="open-skip-delivery" data-contract-id="${escapeAttr(contract.id)}" 
//                                                   data-delivery-date="${escapeAttr(deliveryDateStr)}">
//                                             Skip
//                                           </button>
//                                           <span class="harvest-timeline-sep">|</span>
//                                           <button class="harvest-timeline-link-btn" type="button" 
//                                                   data-action="open-reschedule-delivery" data-contract-id="${escapeAttr(contract.id)}" 
//                                                   data-delivery-date="${escapeAttr(deliveryDateStr)}">
//                                             Reschedule
//                                           </button>
//                                         </div>
//                                       ` : ''}
//                                     </div>
//                                   </div>
//                                 </div>
//                               `;
//                             }
//                           )
//                           .join('')}
//                       </div>
//                     </div>

//                     <footer class="harvest-future-deliveries__footer">
//                       <button class="harvest-button harvest-button--secondary" type="button" data-action="view-past-orders" data-contract-id="${escapeAttr(
//                         contract.id
//                       )}">View Order History</button>
//                     </footer>
//                   </section>`
//                 : ''
//             }
//           </section>

//           <aside class="harvest-detail-sidebar">
//             ${this.renderUpcomingSidebar(contract, totals)}
//           </aside>
//         </div>
//       `;
//     }

//     getFutureDeliveries(contract) {
//       const id = rawId(contract.id);
//       const data = this.state.tabData.schedules[id];
//       if (data && data.items && data.items.length) {
//         const items = data.available ? data.items : buildProjectedSchedules(contract);
//         return items.slice(0, 4).map((item) => ({
//           date: item.date || getNextPaymentDate(contract),
//           productCount: (item.products || scheduleProductsForContract(contract, 0)).length,
//         }));
//       }
//       if (normalizeStatus(contract.status) === 'CANCELLED') return [];
//       const projected = buildProjectedSchedules(contract);
//       return projected.slice(0, 4).map((item) => ({
//         date: item.date,
//         productCount: item.products.length,
//       }));
//     }

//     renderProductCard(product, contract, options = {}) {
//       const quantity = getQuantity(product);
//       const lineId = getLineId(product);
//       const variantId = getVariantId(product);
//       const lineKey = pendingLineKey(contract.id, lineId);
//       const isPending = this.state.pendingLines.has(lineKey);
//       const editable = Boolean(options.editable && lineId);
//       const canChangeQuantity = editable;
//       const canSwap = canChangeQuantity;
//       const canRemove = editable;
      
//       let isOneTime = Boolean(options.isOneTime);
//       if (!isOneTime && contract && contract.oneTimeProducts) {
//         const vId = rawId(getVariantId(product));
//         if (vId) {
//           isOneTime = contract.oneTimeProducts.some(otp => rawId(getVariantId(otp)) === vId);
//         }
//       }
//       if (!isOneTime) {
//         isOneTime = isOneTimeProduct(product, contract);
//       }
//       const classes = [
//         'harvest-product-card',
//         `harvest-product-card--${options.context || 'detail'}`,
//         isPending ? 'is-pending' : '',
//         editable ? 'is-editable' : '',
//       ]
//         .filter(Boolean)
//         .join(' ');

//       return `
//         <article class="${classes}" data-action="${canSwap ? 'open-swap' : ''}" data-contract-id="${escapeAttr(contract.id)}" data-line-id="${escapeAttr(lineId)}" data-variant-id="${escapeAttr(variantId)}" data-one-time="${isOneTime ? 'true' : 'false'}">
//           <div class="harvest-product-card__media">
//             <img
//               src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
//               alt="${escapeAttr(getProductTitle(product))}"
//               loading="lazy"
//             >
//             ${
//               isOneTime
//                 ? `<span class="harvest-product-card__one-time-tag">One-Time</span>`
//                 : ''
//             }
            
//             <!-- Top Action Icons Overlay: Swap and Remove -->
//             ${
//               canSwap || canRemove
//                 ? `<div class="harvest-image-action-overlay">
//                     ${
//                       canSwap
//                         ? `<button
//                             class="harvest-image-action-btn harvest-image-swap-btn d-none"
//                             type="button"
//                             data-action="open-swap"
//                             data-contract-id="${escapeAttr(contract.id)}"
//                             data-line-id="${escapeAttr(lineId)}"
//                             data-variant-id="${escapeAttr(variantId)}"
//                             data-one-time="${isOneTime ? 'true' : 'false'}"
//                             title="Swap product"
//                             aria-label="Swap ${escapeAttr(getProductTitle(product))}"
//                           >
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
//                               <path d="M21 2v6h-6"/>
//                               <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
//                               <path d="M3 22v-6h6"/>
//                               <path d="M21 12a9 9 0 0 1-15 6.7L3 16"/>
//                             </svg>
//                           </button>`
//                         : ''
//                     }
//                     ${
//                       canRemove
//                         ? `<button
//                             class="harvest-image-action-btn harvest-image-remove-btn"
//                             type="button"
//                             data-action="open-remove-product"
//                             data-contract-id="${escapeAttr(contract.id)}"
//                             data-line-id="${escapeAttr(lineId)}"
//                             data-one-time="${isOneTime ? 'true' : 'false'}"
//                             title="Remove item"
//                             aria-label="Remove ${escapeAttr(getProductTitle(product))}"
//                           >
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//                               <path d="M3 6h18"/>
//                               <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
//                               <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
//                             </svg>
//                           </button>`
//                         : ''
//                     }
//                   </div>`
//                 : ''
//             }

//             <!-- Bottom Floating Quantity Counter Overlay -->
//             ${
//               canChangeQuantity
//                 ? `
//                   <div class="harvest-image-quantity-overlay" data-action="none">
//                     <button
//                       type="button"
//                       data-action="change-quantity"
//                       data-change="-1"
//                       data-contract-id="${escapeAttr(contract.id)}"
//                       data-line-id="${escapeAttr(lineId)}"
//                       data-variant-id="${escapeAttr(variantId)}"
//                       data-one-time="${isOneTime ? 'true' : 'false'}"
//                       ${quantity <= 1 || isPending ? 'disabled' : ''}
//                       aria-label="Decrease quantity"
//                     >&minus;</button>
//                     <output class="harvest-image-qty-value">${quantity}</output>
//                     <button
//                       type="button"
//                       data-action="change-quantity"
//                       data-change="1"
//                       data-contract-id="${escapeAttr(contract.id)}"
//                       data-line-id="${escapeAttr(lineId)}"
//                       data-variant-id="${escapeAttr(variantId)}"
//                       data-one-time="${isOneTime ? 'true' : 'false'}"
//                       ${isPending ? 'disabled' : ''}
//                       aria-label="Increase quantity"
//                     >+</button>
//                   </div>
//                 `
//                 : ''
//             }

//             <div class="harvest-product-card__badges">
//               ${
//                 isOneTime
//                   ? '<span class="d-none harvest-badge harvest-badge--one-time">One-Time</span>'
//                   : ''
//               }
//               ${
//                 isProductOutOfStock(product)
//                   ? '<span class="harvest-badge harvest-badge--stock">Out of stock</span>'
//                   : ''
//               }
//             </div>
//           </div>
//           <div class="harvest-product-card__body">
//             <div class="harvest-product-card__copy">
//               <h4>${escapeHtml(getProductTitle(product))}</h4>
//               <p class="harvest-product-card__price">${quantity > 1 ? `${quantity} x ` : ''}${escapeHtml(
//                 formatMoney(getLineTotal(product), getCurrency(contract, product))
//               )}</p>
//             </div>
//             ${
//               !canChangeQuantity
//                 ? `<span class="harvest-quantity-label">Quantity: ${quantity}</span>`
//                 : ''
//             }
//           </div>
//         </article>
//       `;
//     }

//     renderUpcomingSidebar(contract, totals) {
//       const nextDelivery = getNextDeliveryDate(contract);
//       const status = normalizeStatus(contract.status);
//       const delivery = totals.delivery;
//       const currency = getCurrency(contract);
//       const paymentDetails = getPaymentDetails(contract);
//       const deliveryText = getHumanizedDeliveryText(contract);

//       return `
//         <section class="harvest-sidebar-card harvest-settings-card">
//           <header class="harvest-sidebar-card__heading">
//             <h3>Subscription Settings</h3>
//             ${nextDelivery ? `<span>${escapeHtml(formatDate(nextDelivery))}</span>` : ''}
//           </header>

//           <div class="harvest-setting-row harvest-setting-row--stacked d-none">
//             <span>Delivering / Shipping Window</span>
//             <p>${deliveryText}</p>
//           </div>

//           <div class="harvest-setting-row">
//             <span>Frequency settings</span>
//             <strong>${escapeHtml(formatFrequency(contract))}</strong>
//           </div>

//           <div class="harvest-setting-row harvest-setting-row--stacked">
//             <span>Payment method</span>
//             <p>${escapeHtml(paymentDetails)}</p>
//             <p class="harvest-sidebar-card__muted d-none">Delivery fee: ${escapeHtml(
//               formatMoney(delivery, currency)
//             )}</p>
//           </div>

//           <div class="harvest-sidebar-actions d-none">
//             ${this.renderContractActions(contract)}
//           </div>
//           ${
//             status === 'CANCELLED'
//               ? '<p class="harvest-sidebar-card__muted">This subscription is closed and can only be viewed.</p>'
//               : ''
//           }
//         </section>
//       `;
//     }

//     getSortedContracts() {
//       return [...this.contracts].sort((a, b) => {
//         const direction = this.state.sortDirection === 'asc' ? 1 : -1;
//         let result = 0;

//         if (this.state.sortKey === 'status') {
//           result = normalizeStatus(a.status).localeCompare(normalizeStatus(b.status));
//         } else if (this.state.sortKey === 'id') {
//           result = rawId(a.id).localeCompare(rawId(b.id), undefined, { numeric: true });
//         } else if (this.state.sortKey === 'created-at') {
//           const dateA = a.createdAt || a.createdDate;
//           const dateB = b.createdAt || b.createdDate;
//           result = dateValue(dateA) - dateValue(dateB);
//         } else if (this.state.sortKey === 'next-payment') {
//           result = dateValue(getNextPaymentDate(a)) - dateValue(getNextPaymentDate(b));
//         } else {
//           // 'default' - ACTIVE (0) first, then PAUSED (1), then CLOSED/CANCELLED (2), then next order date
//           const rankA = statusRank(a.status);
//           const rankB = statusRank(b.status);
//           if (rankA !== rankB) {
//             return rankA - rankB;
//           }
//           result = dateValue(getNextPaymentDate(a)) - dateValue(getNextPaymentDate(b));
//         }

//         return result * direction;
//       });
//     }

//     findContract(id) {
//       return this.contracts.find(
//         (contract) => String(contract.id) === String(id) || rawId(contract.id) === rawId(id)
//       );
//     }

//     getSelectedContract() {
//       return this.findContract(this.state.selectedContractId);
//     }

//     findLine(contract, lineId) {
//       const recurring = getContractLines(contract).find(
//         (line) => String(getLineId(line)) === String(lineId) || rawId(getLineId(line)) === rawId(lineId)
//       );
//       if (recurring) return recurring;
//       return (contract.oneTimeProducts || []).find(
//         (line) => String(getLineId(line)) === String(lineId) || rawId(getLineId(line)) === rawId(lineId)
//       );
//     }

//     findProduct(contract, lineId, isOneTime = false) {
//       const primaryProducts = isOneTime ? contract?.oneTimeProducts || [] : getContractLines(contract);
//       const found = primaryProducts.find(
//         (product) => String(getLineId(product)) === String(lineId) || rawId(getLineId(product)) === rawId(lineId)
//       );
//       if (found) return found;

//       const secondaryProducts = isOneTime ? getContractLines(contract) : contract?.oneTimeProducts || [];
//       return secondaryProducts.find(
//         (product) => String(getLineId(product)) === String(lineId) || rawId(getLineId(product)) === rawId(lineId)
//       );
//     }

//     isOneTimeApiProduct(contract, product) {
//       if (!contract || !product) return false;
//       const lineId = getLineId(product);
//       const variantId = getVariantId(product);
//       return (contract.oneTimeProducts || []).some((item) => {
//         const itemLineId = getLineId(item);
//         if (lineId && itemLineId) {
//           return String(itemLineId) === String(lineId) || rawId(itemLineId) === rawId(lineId);
//         }
//         return variantId && rawId(getVariantId(item)) === rawId(variantId);
//       });
//     }

//     getSwapCandidates(currentProduct) {
//       const currentVariant = rawId(getVariantId(currentProduct));
//       const sourceProducts = [
//         ...SYSTEM_PRODUCTS,
//         ...this.contracts.flatMap((contract) => [
//           ...getContractLines(contract),
//           ...(contract.oneTimeProducts || []),
//         ])
//       ];
//       return uniqueProductsByVariant(sourceProducts).filter(
//         (product) =>
//           rawId(getAddableVariantId(product)) &&
//           rawId(getAddableVariantId(product)) !== currentVariant &&
//           !isProductOutOfStock(product)
//       );
//     }

//     getOneTimeCandidates(contract) {
//       const sourceProducts = [
//         ...SYSTEM_PRODUCTS,
//         ...getContractLines(contract),
//         ...(contract?.oneTimeProducts || []),
//         ...this.contracts.flatMap((item) => [
//           ...getContractLines(item),
//           ...(item?.oneTimeProducts || []),
//         ]),
//       ];

//       return uniqueProductsByVariant(sourceProducts).filter(
//         (product) => rawId(getAddableVariantId(product)) && !isProductOutOfStock(product)
//       );
//     }

//     async reloadActiveTab(tab) {
//       const contract = this.getSelectedContract();
//       if (!contract || !['schedules', 'history'].includes(tab)) return;
//       delete this.state.tabData[tab][rawId(contract.id)];
//       await this.loadTabData(contract.id, tab);
//     }

//     changeHistoryPage(contractId, page) {
//       const contract = this.findContract(contractId);
//       if (!contract) return;
//       this.state.historyPages[rawId(contract.id)] = Math.max(1, Number(page) || 1);
//       this.render();
//     }

//     async handleClick(event) {
//       const actionElement = event.target.closest('[data-action]');
//       if (!actionElement || !this.root.contains(actionElement)) return;

//       const action = actionElement.dataset.action;
//       const contractId = actionElement.dataset.contractId;

//       try {
//         switch (action) {
//           case 'retry':
//             await this.loadPortalData({ showLoading: true });
//             break;
//           case 'open-build-a-box':
//             this.openBuildABoxModal(contractId);
//             break;
//           case 'build-a-box-add-item': {
//             let variantId = actionElement.dataset.variantId;
//             const contract = this.getSelectedContract();
//             if (!contract) break;
            
//             const isModal = this.state.isBuildABoxModalOpen;
//             if (isModal) {
//               this.setModalBusy(true);
//               actionElement.textContent = 'Adding...';
//             } else {
//               this.state.loading = true;
//               this.render();
//             }

//             try {
//               const product = findCatalogOrContractProduct(variantId);
//               const addableVariantId = product ? (getAddableVariantId(product) || variantId) : variantId;
//               variantId = await this.resolveVariantId(addableVariantId);
//               if (product && isProductIdValue(product, variantId)) {
//                 throw new Error(`Variant ID not found for ${getProductTitle(product)}.`);
//               }
//               if (this.state.productCatalogMode === 'recurring') {
//                 // Add as subscription product (recurring)
//                 await this.api.addRecurringProduct(contract.id, variantId, 1);
//                 this.setNotice('Successfully added subscription product to your box!', 'success');
//               } else {
//                 // Add as one-off delivery product (one-time)
//                 const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
//                 await this.api.addOneTimeProduct(contract.id, variantId, 1, deliveryDate);
//                 this.setNotice('Successfully added one-time product to your box!', 'success');
//               }
//               await this.loadPortalData({ showLoading: false });
//               if (isModal) {
//                 this.updateBuildABoxModalContent();
//               }
//             } catch (error) {
//               this.setNotice(userFacingError(error, 'Could not add item to box.'), 'error');
//             } finally {
//               if (isModal) {
//                 this.setModalBusy(false);
//               } else {
//                 this.state.loading = false;
//                 this.render();
//               }
//             }
//             break;
//           }
//           case 'change-catalog-mode': {
//             this.state.productCatalogMode = actionElement.dataset.mode;
//             if (this.state.isBuildABoxModalOpen) {
//               this.updateBuildABoxModalContent();
//             } else {
//               this.render();
//             }
//             break;
//           }
//           case 'clear-catalog-search': {
//             this.state.productSearchQuery = '';
//             if (this.state.isBuildABoxModalOpen) {
//               this.updateBuildABoxModalContent();
//             } else {
//               this.render();
//             }
//             break;
//           }
//           case 'filter-list': {
//             this.state.listFilter = actionElement.dataset.filter;
//             this.render();
//             break;
//           }
//           case 'reactivate-contract': {
//             this.state.loading = true;
//             this.render();
//             try {
//               await this.api.updateContractStatus(contractId || this.state.selectedContractId, 'ACTIVE');
//               this.setNotice('Subscription resumed successfully!', 'success');
//               await this.loadPortalData({ showLoading: false });
//             } catch (error) {
//               this.setNotice(userFacingError(error, 'Could not resume subscription.'), 'error');
//             } finally {
//               this.state.loading = false;
//               this.render();
//             }
//             break;
//           }
//           case 'dismiss-notice':
//             this.clearNotice();
//             break;
//           case 'toggle-sort-direction':
//             this.state.sortDirection =
//               this.state.sortDirection === 'asc' ? 'desc' : 'asc';
//             this.render();
//             break;
//           case 'view-detail':
//             this.navigateToDetail(contractId);
//             break;
//           case 'back-list':
//             this.navigateToList();
//             break;
//           case 'select-tab':
//             this.navigateToDetail(contractId, actionElement.dataset.tab);
//             break;
//           case 'reload-tab':
//             await this.reloadActiveTab(actionElement.dataset.tab);
//             break;
//           case 'history-page':
//             this.changeHistoryPage(contractId, actionElement.dataset.page);
//             break;
//           case 'pause-subscription':
//             this.openPauseRetentionModal(contractId);
//             break;
//           case 'resume-subscription':
//             this.openResumeModal(contractId);
//             break;
//           case 'cancel-subscription':
//             this.openCancelModal(contractId);
//             break;
//           case 'change-quantity':
//             await this.changeQuantity(actionElement);
//             break;
//           case 'open-swap':
//             this.openSwapModal(actionElement);
//             break;
//           case 'open-remove-product':
//             this.openRemoveProductModal(actionElement);
//             break;
//           case 'open-skip-delivery':
//             this.openSkipDeliveryModal(actionElement);
//             break;
//           case 'open-reschedule':
//           case 'open-reschedule-delivery':
//             this.openRescheduleModal(actionElement);
//             break;
//           case 'open-order-note':
//             this.openOrderNoteModal(actionElement);
//             break;
//           case 'open-add-one-time':
//             this.openAddOneTimeModal(contractId);
//             break;
//           case 'view-past-orders':
//             this.navigateToDetail(contractId, 'history');
//             break;
//           default:
//             break;
//         }
//       } catch (error) {
//         console.error('Harvest portal action error:', error);
//         this.setNotice(userFacingError(error, 'That action could not be completed.'), 'error');
//       }
//     }

//     handleChange(event) {
//       const action = event.target.dataset.action;
//       if (action === 'change-sort') {
//         this.state.sortKey = event.target.value;
//         this.render();
//       }
//     }

//     async handleModalClick(event) {
//       if (
//         event.target.matches('[data-modal-close]') ||
//         event.target.matches('.harvest-modal__backdrop') ||
//         event.target === this.modalRoot
//       ) {
//         this.closeModal();
//         return;
//       }

//       const actionElement = event.target.closest('[data-action], [data-modal-action]');
//       if (!actionElement) return;

//       const action = actionElement.dataset.action || actionElement.dataset.modalAction;
//       const contractId = actionElement.dataset.contractId;

//       try {
//         if (action === 'modal-qty-change') {
//           const variantId = actionElement.dataset.variantId;
//           const change = Number(actionElement.dataset.change) || 0;
//           const input = document.getElementById(`modal-qty-${variantId}`);
//           if (input) {
//             let currentVal = Number(input.value) || 0;
//             let nextVal = currentVal + change;
//             if (nextVal < 0) nextVal = 0;
//             input.value = nextVal;
//             this.state.modalQuantities[variantId] = nextVal;
//             this.updateEditProductsButtonState();
//           }
//           return;
//         } else if (action === 'toggle-purchase-type') {
//           this.state.productCatalogMode = this.state.productCatalogMode === 'recurring' ? 'one_time' : 'recurring';
//           this.updateBuildABoxModalContent();
//           this.updateEditProductsButtonState();
//           return;
//         } else if (action === 'toggle-catalog-filter') {
//           this.state.isFilterExpanded = !this.state.isFilterExpanded;
//           if (this.state.isBuildABoxModalOpen) {
//             this.updateBuildABoxModalContent();
//             this.updateEditProductsButtonState();
//           } else if (this.state.isSwapModalOpen) {
//             this.updateSwapModalContent();
//           }
//           return;
//         } else if (action === 'confirm-add-multiple') {
//           await this.executeAddMultipleProducts(contractId, actionElement);
//           return;
//         } else if (action === 'clear-catalog-search') {
//           this.state.productSearchQuery = '';
//           if (this.state.isBuildABoxModalOpen) {
//             this.updateBuildABoxModalContent();
//             this.updateEditProductsButtonState();
//           } else if (this.state.isSwapModalOpen) {
//             this.updateSwapModalContent();
//           }
//           return;
//         } else if (action === 'confirm-card-swap') {
//           const lineId = actionElement.dataset.lineId;
//           const oldVariantId = actionElement.dataset.oldVariantId;
//           const quantity = Number(actionElement.dataset.quantity) || 1;
//           const newVariantId = actionElement.dataset.newVariantId;
//           const isOneTime = actionElement.dataset.oneTime === 'true';
//           this.openSwapConfirmationModal(contractId, lineId, oldVariantId, quantity, newVariantId, isOneTime);
//           return;
//         } else if (action === 'go-back-to-swap-list') {
//           const mockElement = {
//             dataset: {
//               contractId: actionElement.dataset.contractId,
//               lineId: actionElement.dataset.lineId,
//               variantId: actionElement.dataset.variantId,
//               oneTime: actionElement.dataset.oneTime
//             }
//           };
//           this.openSwapModal(mockElement);
//           return;
//         } else if (action === 'execute-actual-swap') {
//           const lineId = actionElement.dataset.lineId;
//           const oldVariantId = actionElement.dataset.oldVariantId;
//           const quantity = Number(actionElement.dataset.quantity) || 1;
//           const unresolvedVariantId = actionElement.dataset.newVariantId;
//           const isOneTime = actionElement.dataset.oneTime === 'true';
          
//           this.setModalBusy(true);
//           actionElement.textContent = 'Swapping...';
          
//           const contract = this.findContract(contractId);
//           if (!contract) throw new Error('Contract not found.');

//           const selectedProduct = findCatalogOrContractProduct(unresolvedVariantId);
//           const addableVariantId = selectedProduct ? (getAddableVariantId(selectedProduct) || unresolvedVariantId) : unresolvedVariantId;
//           const newVariantId = await this.resolveVariantId(addableVariantId);
//           if (selectedProduct && isProductIdValue(selectedProduct, newVariantId)) {
//             throw new Error(`Variant ID not found for ${getProductTitle(selectedProduct)}.`);
//           }

//           if (isOneTime) {
//             const oldProduct = this.findProduct(contract, lineId, true);
//             if (oldProduct) {
//               const removeAsOneTime = this.isOneTimeApiProduct(contract, oldProduct);
//               await this.api.removeLineItem(contract.id, oldProduct, removeAsOneTime);
//             }
//             const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
//             await this.api.addOneTimeProduct(contract.id, newVariantId, quantity, deliveryDate);
//           } else {
//             const shopDomain = getShopDomain();
//             const oldLineIdGid = lineId && !lineId.startsWith('gid://') ? `gid://shopify/SubscriptionContractLine/${lineId}` : lineId;

//             const standardPayload = {
//               shop: shopDomain,
//               contractId: rawId(contractId),
//               oldVariants: [Number(rawId(oldVariantId))],
//               newVariants: {
//                 [rawId(newVariantId)]: quantity,
//               },
//               oldLineId: oldLineIdGid,
//             };

//             let newProductObj = null;
//             try {
//               const portal = window.harvestPortal || window.portal || this;
//               const sourceProducts = [
//                 ...SYSTEM_PRODUCTS,
//                 ...(portal.contracts || []).flatMap((c) => [
//                   ...getContractLines(c),
//                   ...(c.oneTimeProducts || []),
//                 ])
//               ];
//               newProductObj = sourceProducts.find(p => rawId(getAddableVariantId(p) || getVariantId(p)) === rawId(newVariantId));
//             } catch (err) {
//               console.warn('Error fetching sourceProducts for swap details:', err);
//             }

//             const pTitle = newProductObj ? getProductTitle(newProductObj) : 'Product';
//             const pImage = newProductObj ? getProductImage(newProductObj) : PLACEHOLDER_IMAGE;
//             const pId = newProductObj ? rawId(newProductObj?.productId || newProductObj?.product?.id || '') : '';
//             const vTitle = newProductObj ? (newProductObj?.variant?.title || newProductObj?.variantTitle || '') : '';

//             const groupSwapPayload = {
//               variantQuantityList: [
//                 {
//                   variantId: Number(rawId(newVariantId)) || newVariantId,
//                   quantity: quantity,
//                   title: vTitle || pTitle,
//                   image: pImage,
//                   productTitle: pTitle,
//                   productId: Number(pId) || pId || undefined,
//                   variantTitle: vTitle || pTitle,
//                   swapId: isNaN(Number(rawId(oldVariantId))) ? oldVariantId : (Number(rawId(oldVariantId)) || oldVariantId)
//                 }
//               ]
//             };

//             await this.api.replaceVariants(contractId, standardPayload, groupSwapPayload);
//           }

//           await this.loadPortalData({ showLoading: false });
//           this.state.isSwapModalOpen = false;
//           this.closeModal();
//           this.setNotice('Product swapped successfully.', 'success');
//           return;
//         } else if (action === 'show-pause-reason') {
//           this.openPauseReasonModal(contractId);
//         } else if (action === 'confirm-pause') {
//           const select = this.modalRoot.querySelector('[name="pause-reason"]');
//           if (!select?.value) {
//             this.setModalMessage('Please select a pause reason.', 'error');
//             return;
//           }
//           await this.executeStatusChange(contractId, 'PAUSED', 'Subscription paused.');
//         } else if (action === 'confirm-resume') {
//           await this.executeStatusChange(contractId, 'ACTIVE', 'Subscription resumed.');
//         } else if (action === 'confirm-cancel') {
//           await this.executeStatusChange(contractId, 'CANCELLED', 'Subscription cancelled.');
//         } else if (action === 'confirm-swap') {
//           await this.executeSwap(actionElement);
//         } else if (action === 'confirm-remove-product') {
//           await this.executeRemoveProduct(actionElement);
//         } else if (action === 'confirm-skip-delivery') {
//           await this.executeSkipDelivery(actionElement);
//         } else if (action === 'confirm-reschedule') {
//           await this.executeReschedule(actionElement);
//         } else if (action === 'confirm-order-note') {
//           await this.executeOrderNote(actionElement);
//         } else if (action === 'confirm-add-one-time') {
//           await this.executeAddOneTime(actionElement);
//         }
//       } catch (error) {
//         console.error('Harvest portal modal action error:', error);
//         this.setModalBusy(false);
//         this.setModalMessage(
//           userFacingError(error, 'That action could not be completed.'),
//           'error'
//         );
//       }
//     }

//     openPauseRetentionModal(contractId) {
//       this.openModal({
//         title: 'Pause Subscription',
//         body: `
//           <p>Need a break? You can continue to pause this subscription. Skipping individual orders will be available in a future portal update.</p>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>
//             Keep Subscription Active
//           </button>
//           <button class="harvest-button harvest-button--primary" type="button" data-modal-action="show-pause-reason" data-contract-id="${escapeAttr(
//             contractId
//           )}">
//             Continue to Pause
//           </button>
//         `,
//       });
//     }

//     openPauseReasonModal(contractId) {
//       this.openModal({
//         title: 'Pause Subscription',
//         body: `
//           <label class="harvest-field harvest-field--stacked">
//             <span>Why are you pausing?</span>
//             <select name="pause-reason">
//               <option value="">Select Pause Reason</option>
//               <option value="budget">I have more than I need right now</option>
//               <option value="away">I will be out of town or unavailable</option>
//               <option value="break">Just taking a short break</option>
//               <option value="other">Other</option>
//             </select>
//           </label>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Go Back</button>
//           <button class="harvest-button harvest-button--primary" type="button" data-modal-action="confirm-pause" data-contract-id="${escapeAttr(
//             contractId
//           )}">Pause Subscription</button>
//         `,
//       });
//     }

//     openResumeModal(contractId) {
//       this.openModal({
//         title: 'Resume Subscription',
//         body: '<p>Your subscription will become active again and continue on its existing schedule.</p>',
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Not Now</button>
//           <button class="harvest-button harvest-button--primary" type="button" data-modal-action="confirm-resume" data-contract-id="${escapeAttr(
//             contractId
//           )}">Resume Subscription</button>
//         `,
//       });
//     }

//     openCancelModal(contractId) {
//       this.openModal({
//         title: 'Cancel Subscription',
//         body: '<p>Are you sure you want to cancel this subscription? This action may not be reversible from the portal.</p>',
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Subscription</button>
//           <button class="harvest-button harvest-button--danger" type="button" data-modal-action="confirm-cancel" data-contract-id="${escapeAttr(
//             contractId
//           )}">Cancel Subscription</button>
//         `,
//       });
//     }

//     openRemoveProductModal(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const isOneTime = actionElement.dataset.oneTime === 'true';
//       const product = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);

//       if (!contract || !product) {
//         this.setNotice('That harvest item was not found.', 'error');
//         return;
//       }

//       this.openModal({
//         title: 'Remove Item',
//         body: `
//           <p>Remove <strong>${escapeHtml(getProductTitle(product))}</strong> from this harvest?</p>
//           <p class="harvest-modal-note">This updates the upcoming delivery after Appstle confirms the change.</p>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Item</button>
//           <button
//             class="harvest-button harvest-button--danger"
//             type="button"
//             data-modal-action="confirm-remove-product"
//             data-contract-id="${escapeAttr(contract.id)}"
//             data-line-id="${escapeAttr(getLineId(product))}"
//             data-one-time="${isOneTime ? 'true' : 'false'}"
//           >Remove Item</button>
//         `,
//       });
//     }

//     openSkipDeliveryModal(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
//       if (!contract || !deliveryDate) {
//         this.setNotice('No delivery date was found to skip.', 'error');
//         return;
//       }

//       this.openModal({
//         title: 'Skip This Delivery',
//         body: `
//           <p>Skip the delivery scheduled for <strong>${escapeHtml(
//             formatDate(deliveryDate)
//           )}</strong>?</p>
//           <p class="harvest-modal-note">Your following deliveries stay on their current frequency.</p>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Keep Delivery</button>
//           <button
//             class="harvest-button harvest-button--primary"
//             type="button"
//             data-modal-action="confirm-skip-delivery"
//             data-contract-id="${escapeAttr(contract.id)}"
//             data-delivery-date="${escapeAttr(deliveryDate)}"
//           >Skip This Delivery</button>
//         `,
//       });
//     }

//     openRescheduleModal(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
//       if (!contract || !deliveryDate) {
//         this.setNotice('No delivery date was found to reschedule.', 'error');
//         return;
//       }

//       const expectedWeekday = getWeekdayName(deliveryDate);

//       this.openModal({
//         title: 'Reschedule Delivery',
//         body: `
//           <p>Choose a new date for <strong>${escapeHtml(formatDate(deliveryDate))}</strong>.</p>
//           ${expectedWeekday ? `
//             <div style="margin-bottom: 12px; font-size: 13px; padding: 10px; border-radius: 6px; background-color: #f0f7ff; color: #004085; border: 1px solid #b8daff; line-height: 1.4;">
//               <strong>Note:</strong> Your subscription is configured for <strong>${expectedWeekday}</strong> deliveries. Please select a <strong>${expectedWeekday}</strong> to avoid Appstle rescheduling restrictions.
//             </div>
//           ` : ''}
//           <label class="harvest-field harvest-field--stacked">
//             <span>New delivery date</span>
//             <input type="date" name="reschedule-date" min="${escapeAttr(
//               toDateInputValue(new Date())
//             )}" value="${escapeAttr(toDateInputValue(deliveryDate))}">
//           </label>
//           <div class="reschedule-warning" style="margin-top: 8px;"></div>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Cancel</button>
//           <button
//             class="harvest-button harvest-button--primary"
//             type="button"
//             data-modal-action="confirm-reschedule"
//             data-contract-id="${escapeAttr(contract.id)}"
//             data-delivery-date="${escapeAttr(deliveryDate)}"
//           >Reschedule</button>
//         `,
//       });

//       const dateInput = this.modalRoot.querySelector('[name="reschedule-date"]');
//       if (dateInput && expectedWeekday) {
//         const warningDiv = this.modalRoot.querySelector('.reschedule-warning');
//         dateInput.addEventListener('change', () => {
//           const selectedDate = dateInput.value;
//           const selectedWeekday = getWeekdayName(selectedDate);
//           if (selectedWeekday && selectedWeekday !== expectedWeekday) {
//             warningDiv.innerHTML = `
//               <div style="font-size: 13px; padding: 10px; border-radius: 6px; background-color: #fff3cd; color: #856404; border: 1px solid #ffeeba; line-height: 1.4;">
//                 <strong>Warning:</strong> You selected a <strong>${selectedWeekday}</strong>, but your subscription's allowed delivery day is <strong>${expectedWeekday}</strong>. Appstle may reject this date.
//               </div>
//             `;
//           } else {
//             warningDiv.innerHTML = '';
//           }
//         });
//       }
//     }

//     openOrderNoteModal(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const deliveryDate = actionElement.dataset.deliveryDate || getNextDeliveryDate(contract);
//       if (!contract || !deliveryDate) {
//         this.setNotice('No delivery date was found for this note.', 'error');
//         return;
//       }

//       this.openModal({
//         title: 'Order Note',
//         body: `
//           <p>Add a note for <strong>${escapeHtml(formatDate(deliveryDate))}</strong>.</p>
//           <label class="harvest-field harvest-field--stacked">
//             <span>Note</span>
//             <textarea name="order-note" rows="4">${escapeHtml(
//               actionElement.dataset.note || ''
//             )}</textarea>
//           </label>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close>Cancel</button>
//           <button
//             class="harvest-button harvest-button--primary"
//             type="button"
//             data-modal-action="confirm-order-note"
//             data-contract-id="${escapeAttr(contract.id)}"
//             data-delivery-date="${escapeAttr(deliveryDate)}"
//           >Save Note</button>
//         `,
//       });
//     }

//     openAddOneTimeModal(contractId) {
//       this.openBuildABoxModal(contractId, 'one_time');
//     }

//     async executeStatusChange(contractId, status, successMessage) {
//       this.setModalBusy(true);
//       await this.api.updateContractStatus(contractId, status);
//       await this.loadPortalData({ showLoading: false });
//       this.closeModal();
//       this.setNotice(successMessage, 'success');
//     }

//     async executeRemoveProduct(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const isOneTime = actionElement.dataset.oneTime === 'true';
//       const product = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);
//       if (!contract || !product) throw new Error('Harvest item was not found.');

//       this.setModalBusy(true);
//       try {
//         const removeAsOneTime = isOneTime && this.isOneTimeApiProduct(contract, product);
//         await this.api.removeLineItem(contract.id, product, removeAsOneTime);
//         await this.loadPortalData({ showLoading: false });
//         this.closeModal();
//         this.setNotice('Item removed from your upcoming harvest.', 'success');
//       } catch (err) {
//         this.setNotice(userFacingError(err, 'Could not remove item.'), 'error');
//       }
//     }

//     async executeSkipDelivery(actionElement) {
//       const contractId = actionElement.dataset.contractId;
//       const contract = this.findContract(contractId);
//       const deliveryDate = actionElement.dataset.deliveryDate || (contract ? getNextDeliveryDate(contract) : '');
      
//       this.setModalBusy(true);
//       try {
//         await this.api.skipDelivery(contractId, deliveryDate);
//       } catch (err) {
//         console.warn('[Harvest Portal] skipDelivery failed. Attempting reschedule-based skip fallback...', err);
//         if (contract && deliveryDate) {
//           const nextDateIso = addScheduleInterval(deliveryDate, contract, 1);
//           if (nextDateIso) {
//             console.log(`[Harvest Portal] Fallback: Rescheduling delivery from ${deliveryDate} to ${nextDateIso}`);
//             await this.api.rescheduleDelivery(contractId, deliveryDate, nextDateIso);
//           } else {
//             throw err;
//           }
//         } else {
//           throw err;
//         }
//       }
//       this.invalidateTabData(contractId, 'schedules');
//       await this.loadPortalData({ showLoading: false });
//       this.closeModal();
//       this.setNotice('Delivery skipped.', 'success');
//     }

//     async executeReschedule(actionElement) {
//       const newDate = this.modalRoot.querySelector('[name="reschedule-date"]')?.value;
//       if (!newDate) {
//         this.setModalMessage('Please choose a delivery date.', 'error');
//         return;
//       }

//       this.setModalBusy(true);
//       await this.api.rescheduleDelivery(
//         actionElement.dataset.contractId,
//         actionElement.dataset.deliveryDate,
//         newDate
//       );
//       this.invalidateTabData(actionElement.dataset.contractId, 'schedules');
//       await this.loadPortalData({ showLoading: false });
//       this.closeModal();
//       this.setNotice('Delivery rescheduled.', 'success');
//     }

//     async executeOrderNote(actionElement) {
//       const note = this.modalRoot.querySelector('[name="order-note"]')?.value || '';
//       this.setModalBusy(true);
//       try {
//         await this.api.updateOrderNote(
//           actionElement.dataset.contractId,
//           actionElement.dataset.deliveryDate,
//           note
//         );
//         this.invalidateTabData(actionElement.dataset.contractId, 'schedules');
//         await this.loadPortalData({ showLoading: false });
//         this.closeModal();
//         this.setNotice('Order note saved.', 'success');
//       } catch (error) {
//         console.error('Error saving order note:', error);
//         this.setModalBusy(false);
//         this.setModalMessage(error.message || 'Failed to save order note.', 'error');
//       }
//     }


//     async executeAddOneTime(actionElement) {
//       const variantId = this.modalRoot.querySelector('[name="one-time-variant"]')?.value;
//       const quantity = Number(this.modalRoot.querySelector('[name="one-time-quantity"]')?.value || 1);
//       if (!variantId || quantity < 1) {
//         this.setModalMessage('Please choose an item and quantity.', 'error');
//         return;
//       }

//       this.setModalBusy(true);
//       try {
//         await this.api.addOneTimeProduct(
//           actionElement.dataset.contractId,
//           variantId,
//           quantity,
//           actionElement.dataset.deliveryDate
//         );
//         await this.loadPortalData({ showLoading: false });
//         this.closeModal();
//         this.setNotice('One-time item added to your upcoming harvest.', 'success');
//       } catch (error) {
//         this.setNotice(userFacingError(error, 'Could not add item to box.'), 'error');
//       }
//     }

//     invalidateTabData(contractId, tab) {
//       const id = rawId(contractId);
//       if (this.state.tabData[tab]) delete this.state.tabData[tab][id];
//     }

//     async changeQuantity(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const isOneTime = actionElement.dataset.oneTime === 'true';
//       const line = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime);
//       if (!contract || !line) throw new Error('Harvest item was not found.');

//       const lineId = String(actionElement.dataset.lineId);
//       const lineKey = pendingLineKey(contract.id, lineId);
//       if (this.state.pendingLines.has(lineKey)) return;

//       const oldQuantity = getQuantity(line);
//       const nextQuantity = oldQuantity + Number(actionElement.dataset.change || 0);
//       if (nextQuantity < 1) return;

//       this.state.pendingLines.add(lineKey);
//       line.quantity = nextQuantity;
//       this.render();

//       try {
//         if (isOneTime) {
//           const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
//           const variantId = getVariantId(line);
//           await this.api.addOneTimeProduct(
//             contract.id,
//             variantId,
//             nextQuantity,
//             deliveryDate
//           );
//         } else {
//           await this.api.updateLineItemQuantity(
//             contract.id,
//             actionElement.dataset.lineId,
//             actionElement.dataset.variantId,
//             nextQuantity
//           );
//         }
//         this.setNotice('Product quantity updated.', 'success');
//       } catch (error) {
//         line.quantity = oldQuantity;
//         throw error;
//       } finally {
//         this.state.pendingLines.delete(lineKey);
//         this.render();
//       }
//     }

//     openSwapModal(actionElement) {
//       const contract = this.findContract(actionElement.dataset.contractId);
//       const isOneTime = actionElement.dataset.oneTime === 'true' || (typeof actionElement.closest === 'function' && actionElement.closest('.harvest-product-card')?.dataset.oneTime === 'true') || false;
//       const line = contract && this.findProduct(contract, actionElement.dataset.lineId, isOneTime, actionElement.dataset.variantId);
//       if (!contract || !line) {
//         this.setNotice('Harvest item was not found.', 'error');
//         return;
//       }

//       this.state.selectedContractId = contract.id;
//       this.state.swappingLineId = actionElement.dataset.lineId || getLineId(line);
//       this.state.swappingOldVariantId = actionElement.dataset.variantId || getVariantId(line);
//       this.state.swappingQuantity = getQuantity(line);
//       this.state.swappingIsOneTime = isOneTime;
//       this.state.isSwapModalOpen = true;
//       this.state.selectedCategory = '';
//       this.state.isFilterExpanded = false;

//       const candidates = this.getSwapCandidates(line);
//       if (!candidates.length) {
//         this.openModal({
//           title: 'Swap Item',
//           body: '<p>No eligible swap items were returned from your current harvests.</p>',
//           actions:
//             '<button class="harvest-button harvest-button--primary" type="button" data-modal-close>Close</button>',
//         });
//         return;
//       }

//       this.openModal({
//         title: 'Select Product',
//         dialogClass: 'harvest-modal__dialog--large',
//         body: this.renderSwapModalBody(contract, line),
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-modal-close style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
//             Cancel
//           </button>
//         `
//       });
//     }

//     updateSwapModalContent() {
//       const contract = this.getSelectedContract();
//       const line = contract && this.findLine(contract, this.state.swappingLineId);
//       if (!contract || !line) return;
      
//       const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
//       if (bodyContainer) {
//         bodyContainer.innerHTML = `
//           <div class="harvest-modal__message" hidden></div>
//           ${this.renderSwapModalBody(contract, line)}
//         `;
//       }

//       // Keep search input focused
//       const input = this.modalRoot.querySelector('#catalog-search');
//       if (input) {
//         input.focus();
//         const val = input.value;
//         input.value = '';
//         input.value = val;
//       }
//     }

//     renderSwapModalBody(contract, line) {
//       const candidates = this.getSwapCandidates(line);

//       // Collect all unique tags for the filter
//       const uniqueTags = new Set();
//       candidates.forEach(p => {
//         if (p.tags && Array.isArray(p.tags)) {
//           p.tags.forEach(t => {
//             if (t && t.length > 1) {
//               uniqueTags.add(t.charAt(0).toUpperCase() + t.slice(1));
//             }
//           });
//         }
//         if (p.productType) {
//           uniqueTags.add(p.productType.charAt(0).toUpperCase() + p.productType.slice(1));
//         }
//       });
//       const tagList = Array.from(uniqueTags).sort();

//       // Filter swap candidates by search query
//       let filteredCandidates = candidates;
//       if (this.state.productSearchQuery) {
//         const query = this.state.productSearchQuery.toLowerCase().trim();
//         filteredCandidates = candidates.filter(p =>
//           getProductTitle(p).toLowerCase().includes(query) ||
//           (p.sku && p.sku.toLowerCase().includes(query))
//         );
//       }

//       // Filter by selected tag category
//       if (this.state.selectedCategory) {
//         const cat = this.state.selectedCategory.toLowerCase();
//         filteredCandidates = filteredCandidates.filter(p =>
//           (p.productType && p.productType.toLowerCase() === cat) ||
//           (p.tags && p.tags.some(t => t.toLowerCase() === cat))
//         );
//       }

//       return `
//         <!-- Search bar inside swap modal -->
//         <div class="harvest-catalog-controls-container" style="margin-bottom: 12px; padding: 0; background: transparent; border: none;">
//           <div class="harvest-catalog-search-row" style="display: flex; align-items: center; gap: 8px; width: 100%;">
//             <div class="harvest-catalog-search-wrapper" style="position: relative; flex: 1; max-width: 100%;">
//               <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
//                      placeholder="Search a product to swap..." value="${escapeAttr(this.state.productSearchQuery || '')}"
//                      style="padding-left: 36px; height: 42px; box-sizing: border-box;">
//               <!-- Magnifying Glass Icon -->
//               <svg class="harvest-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--harvest-text-muted);">
//                 <circle cx="11" cy="11" r="8"></circle>
//                 <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//               </svg>
//               ${this.state.productSearchQuery ? `
//                 <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search" style="right: 10px;">&times;</button>
//               ` : ''}
//             </div>
//             <button class="harvest-catalog-filter-btn one-time" type="button" data-action="toggle-catalog-filter" style="display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; background: var(--harvest-surface); cursor: pointer; color: var(--harvest-text);">
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//                 <line x1="4" y1="21" x2="4" y2="14"></line>
//                 <line x1="4" y1="10" x2="4" y2="3"></line>
//                 <line x1="12" y1="21" x2="12" y2="12"></line>
//                 <line x1="12" y1="8" x2="12" y2="3"></line>
//                 <line x1="20" y1="21" x2="20" y2="16"></line>
//                 <line x1="20" y1="12" x2="20" y2="3"></line>
//                 <line x1="1" y1="14" x2="7" y2="14"></line>
//                 <line x1="9" y1="8" x2="15" y2="8"></line>
//                 <line x1="17" y1="16" x2="23" y2="16"></line>
//               </svg>
//             </button>
//           </div>
          
//           <div class="harvest-catalog-filter-container" style="margin-top: 12px; display: ${this.state.isFilterExpanded ? 'block' : 'none'};">
//             <label style="display: block; font-size: 13px; font-weight: 600; color: var(--harvest-text-muted); margin-bottom: 4px;">Tags</label>
//             <select id="catalog-tag-select" class="harvest-select" style="width: 100%; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; padding: 0 12px; background: #fff;">
//               <option value="">Select...</option>
//               ${tagList.map(tag => `<option value="${escapeAttr(tag)}" ${this.state.selectedCategory === tag ? 'selected' : ''}>${escapeHtml(tag)}</option>`).join('')}
//             </select>
//           </div>
//         </div>

//         <p class="harvest-section-subtitle" style="margin-top: 12px; margin-bottom: 12px;">
//           Select a product below to confirm the swap:
//         </p>

//         <div class="harvest-detail-products harvest-catalog-modal-grid">
//           ${filteredCandidates.length === 0 ? `
//             <div style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
//               <p style="color: var(--harvest-text-muted);">No products match your search.</p>
//             </div>
//           ` : filteredCandidates
//             .map((product) => {
//               const variantId = getAddableVariantId(product);
//               return `
//                 <article class="harvest-product-card harvest-product-card--available">
//                   <div class="harvest-product-card__media">
//                     <img
//                       src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
//                       alt="${escapeAttr(getProductTitle(product))}"
//                       loading="lazy"
//                     >
//                   </div>
//                   <div class="harvest-product-card__body">
//                     <div class="harvest-product-card__copy">
//                       <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
//                       <p class="harvest-product-card__price">
//                         ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
//                       </p>
//                     </div>
//                     <button
//                       class="harvest-button harvest-button--primary"
//                       type="button"
//                       data-action="confirm-card-swap"
//                       data-contract-id="${escapeAttr(contract.id)}"
//                       data-line-id="${escapeAttr(this.state.swappingLineId)}"
//                       data-old-variant-id="${escapeAttr(this.state.swappingOldVariantId)}"
//                       data-new-variant-id="${escapeAttr(variantId)}"
//                       data-quantity="${this.state.swappingQuantity}"
//                       data-one-time="${this.state.swappingIsOneTime ? 'true' : 'false'}"
//                       style="width: 100%; margin-top: 12px; background: #000000 !important; border-color: #000000 !important; color: #ffffff !important;"
//                     >
//                       Confirm Swap
//                     </button>
//                   </div>
//                 </article>
//               `;
//             })
//             .join('')}
//         </div>
//       `;
//     }

//     openSwapConfirmationModal(contractId, lineId, oldVariantId, quantity, newVariantId, isOneTime = false) {
//       this.state.swappingNewVariantId = newVariantId;
      
//       const contract = this.findContract(contractId);
//       const line = contract && this.findProduct(contract, lineId, isOneTime, oldVariantId);
      
//       const oldProduct = line;
//       const newProduct = findCatalogOrContractProduct(newVariantId);
      
//       const oldTitle = oldProduct ? getProductTitle(oldProduct) : 'Current Item';
//       const oldImage = oldProduct ? getProductImage(oldProduct) : PLACEHOLDER_IMAGE;
//       const oldPrice = oldProduct ? getProductPrice(oldProduct) : 0;
      
//       const newTitle = newProduct ? getProductTitle(newProduct) : 'New Item';
//       const newImage = newProduct ? getProductImage(newProduct) : PLACEHOLDER_IMAGE;
//       const newPrice = newProduct ? getProductPrice(newProduct) : 0;
//       const currency = getCurrency(contract, newProduct);

//       this.openModal({
//         title: 'Swap Product',
//         dialogClass: 'harvest-modal__dialog--medium',
//         body: `
//           <div class="harvest-swap-confirm-container" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; padding: 12px 0;">
//             <!-- Current Product -->
//             <div class="harvest-swap-confirm-box" style="border: 1px solid var(--harvest-border); border-radius: 8px; padding: 12px; background: var(--harvest-surface-muted);">
//               <span class="harvest-eyebrow" style="display: block; font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--harvest-text-muted); margin-bottom: 8px;">Current Product</span>
//               <div style="display: flex; gap: 12px; align-items: start;">
//                 <img src="${escapeAttr(safeImageUrl(oldImage))}" alt="${escapeAttr(oldTitle)}" style="width: 56px; height: 56px; object-fit: cover; border-radius: 4px;">
//                 <div>
//                   <h4 style="margin: 0; font-size: 13.6px; font-weight: 600; line-height: 1.3;">${escapeHtml(oldTitle)}</h4>
//                   <div style="font-size: 13px; color: var(--harvest-text-muted); margin-top: 4px;">Qty: ${quantity}</div>
//                   <div style="font-size: 13.6px; font-weight: 600; margin-top: 4px;">${escapeHtml(formatMoney(oldPrice, currency))}</div>
//                 </div>
//               </div>
//             </div>

//             <!-- Swapping To -->
//             <div class="harvest-swap-confirm-box" style="border: 1px solid var(--harvest-border); border-radius: 8px; padding: 12px; background: var(--harvest-surface-muted);">
//               <span class="harvest-eyebrow" style="display: block; font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--harvest-text-muted); margin-bottom: 8px;">Swapping To</span>
//               <div style="display: flex; gap: 12px; align-items: start;">
//                 <img src="${escapeAttr(safeImageUrl(newImage))}" alt="${escapeAttr(newTitle)}" style="width: 56px; height: 56px; object-fit: cover; border-radius: 4px;">
//                 <div>
//                   <h4 style="margin: 0; font-size: 13.6px; font-weight: 600; line-height: 1.3;">${escapeHtml(newTitle)}</h4>
//                   <div style="font-size: 13px; color: var(--harvest-text-muted); margin-top: 4px;">Qty: ${quantity}</div>
//                   <div style="font-size: 13.6px; font-weight: 600; margin-top: 4px;">${escapeHtml(formatMoney(newPrice, currency))}</div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         `,
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-action="go-back-to-swap-list" 
//                   data-contract-id="${escapeAttr(contractId)}" data-line-id="${escapeAttr(lineId)}" 
//                   data-variant-id="${escapeAttr(oldVariantId)}" data-one-time="${isOneTime ? 'true' : 'false'}"
//                   style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
//             Choose different product
//           </button>
//           <button class="harvest-button harvest-button--primary" type="button" data-action="execute-actual-swap" 
//                   data-contract-id="${escapeAttr(contractId)}" data-line-id="${escapeAttr(lineId)}" 
//                   data-old-variant-id="${escapeAttr(oldVariantId)}" data-new-variant-id="${escapeAttr(newVariantId)}" 
//                   data-quantity="${quantity}" data-one-time="${isOneTime ? 'true' : 'false'}"
//                   style="background: #000000 !important; border-color: #000000 !important; color: #ffffff !important;">
//             Confirm Swap
//           </button>
//         `
//       });
//     }

//     renderModalAddingProgress() {
//       return `
//         <div class="harvest-adding-progress-container" style="display: flex; flex-direction: column; gap: 16px; padding: 20px;">
//           ${(this.state.addingItems || []).map(item => {
//             const product = findCatalogOrContractProduct(item.variantId);
//             const title = product ? getProductTitle(product) : 'Product';
//             const image = product ? getProductImage(product) : PLACEHOLDER_IMAGE;
//             const isDone = item.status === 'success';
//             return `
//               <div class="harvest-adding-progress-row" style="display: flex; align-items: center; justify-content: space-between; padding: 12px; border: 1px solid var(--harvest-border); border-radius: 8px; background: var(--harvest-surface);">
//                 <div style="display: flex; align-items: center; gap: 12px;">
//                   <img src="${escapeAttr(safeImageUrl(image))}" alt="${escapeAttr(title)}" style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px;">
//                   <strong style="font-size: 14px;">${escapeHtml(title)}</strong>
//                 </div>
//                 <div style="font-size: 13px; font-weight: 600; color: ${isDone ? 'var(--harvest-active, #2e7d32)' : 'var(--harvest-text-muted)'}; display: flex; align-items: center; gap: 6px;">
//                   ${isDone ? `
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="color: #2e7d32;">
//                       <polyline points="20 6 9 17 4 12"></polyline>
//                     </svg>
//                     Added
//                   ` : `
//                     <div class="harvest-inline-spinner" style="width: 14px; height: 14px; border: 2px solid rgba(0,0,0,0.1); border-top-color: #000; border-radius: 50%; animation: harvest-spin 0.6s linear infinite; box-sizing: border-box;"></div>
//                     Adding
//                   `}
//                 </div>
//               </div>
//             `;
//           }).join('')}
//         </div>
//       `;
//     }

//     async executeAddMultipleProducts(contractId, actionElement) {
//       const contract = this.findContract(contractId);
//       if (!contract) return;
      
//       const toAdd = [];
//       Object.entries(this.state.modalQuantities).forEach(([variantId, qty]) => {
//         if (qty > 0) {
//           toAdd.push({ variantId, quantity: qty });
//         }
//       });
      
//       if (toAdd.length === 0) {
//         this.setModalMessage('Please select a quantity > 0 for at least one item.', 'error');
//         return;
//       }
      
//       this.state.addingItems = toAdd.map(item => ({ ...item, status: 'pending' }));
      
//       // Update modal body to display adding progress checklist
//       const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
//       if (bodyContainer) {
//         bodyContainer.innerHTML = this.renderModalAddingProgress();
//       }
      
//       // Disable modal action footer buttons
//       this.setModalBusy(true);
      
//       try {
//         const deliveryDate = getNextDeliveryDate(contract) || getNextPaymentDate(contract);
        
//         for (const item of this.state.addingItems) {
//           const product = findCatalogOrContractProduct(item.variantId);
//           const addableVariantId = product ? (getAddableVariantId(product) || item.variantId) : item.variantId;
//           const resolvedVariantId = await this.resolveVariantId(addableVariantId);
//           if (product && isProductIdValue(product, resolvedVariantId)) {
//             throw new Error(`Variant ID not found for ${getProductTitle(product)}.`);
//           }
//           if (this.state.productCatalogMode === 'recurring') {
//             await this.api.addRecurringProduct(contract.id, resolvedVariantId, item.quantity);
//           } else {
//             await this.api.addOneTimeProduct(contract.id, resolvedVariantId, item.quantity, deliveryDate);
//           }
//           item.status = 'success';
          
//           // Re-render checklist with green checkmark for the added item
//           if (bodyContainer) {
//             bodyContainer.innerHTML = this.renderModalAddingProgress();
//           }
//         }
        
//         await this.loadPortalData({ showLoading: false });
//         this.state.isBuildABoxModalOpen = false;
//         this.state.addingItems = null;
//         this.closeModal();
//         this.setNotice('Successfully updated products in your box!', 'success');
//       } catch (error) {
//         console.error('Error adding multiple products:', error);
//         this.setModalMessage(userFacingError(error, 'Could not add items to box.'), 'error');
//         this.setModalBusy(false);
//       }
//     }

//     async executeSwap(actionElement) {
//       const selectedRadio = this.modalRoot.querySelector('[name="swap-variant"]:checked');
//       const unresolvedVariantId = selectedRadio ? selectedRadio.value : '';
//       if (!unresolvedVariantId) {
//         this.setModalMessage('Please choose a replacement item.', 'error');
//         return;
//       }

//       this.setModalBusy(true);

//       const contractId = rawId(actionElement.dataset.contractId);
//       const oldVariantId = rawId(actionElement.dataset.variantId);
//       const oldLineId = actionElement.dataset.lineId;
//       const quantity = Number(actionElement.dataset.quantity) || 1;

//       // Look up newProductObj using unresolvedVariantId
//       let newProductObj = null;
//       try {
//         const portal = window.harvestPortal || window.portal || this;
//         const sourceProducts = [
//           ...SYSTEM_PRODUCTS,
//           ...(portal.contracts || []).flatMap((c) => [
//             ...getContractLines(c),
//             ...(c.oneTimeProducts || []),
//           ])
//         ];
//         newProductObj = sourceProducts.find(p => rawId(getVariantId(p)) === rawId(unresolvedVariantId));
//       } catch (err) {
//         console.warn('Error fetching sourceProducts for swap details:', err);
//       }

//       // Resolve the variant ID
//       const selectedProduct = findCatalogOrContractProduct(unresolvedVariantId);
//       const addableVariantId = selectedProduct ? (getAddableVariantId(selectedProduct) || unresolvedVariantId) : unresolvedVariantId;
//       const newVariantId = await this.resolveVariantId(addableVariantId);
//       if (selectedProduct && isProductIdValue(selectedProduct, newVariantId)) {
//         throw new Error(`Variant ID not found for ${getProductTitle(selectedProduct)}.`);
//       }

//       const shopDomain = getShopDomain();

//       const oldLineIdGid = oldLineId && !oldLineId.startsWith('gid://') ? `gid://shopify/SubscriptionContractLine/${oldLineId}` : oldLineId;

//       const standardPayload = {
//         shop: shopDomain,
//         contractId: contractId,
//         oldVariants: [Number(oldVariantId)],
//         newVariants: {
//           [rawId(newVariantId)]: quantity,
//         },
//         oldLineId: oldLineIdGid,
//       };

//       const pTitle = newProductObj ? getProductTitle(newProductObj) : 'Product';
//       const pImage = newProductObj ? getProductImage(newProductObj) : PLACEHOLDER_IMAGE;
//       const pId = newProductObj ? rawId(newProductObj?.productId || newProductObj?.product?.id || '') : '';
//       const vTitle = newProductObj ? (newProductObj?.variant?.title || newProductObj?.variantTitle || '') : '';

//       const groupSwapPayload = {
//         variantQuantityList: [
//           {
//             variantId: Number(rawId(newVariantId)) || newVariantId,
//             quantity: quantity,
//             title: vTitle || pTitle,
//             image: pImage,
//             productTitle: pTitle,
//             productId: Number(pId) || pId || undefined,
//             variantTitle: vTitle || pTitle,
//             swapId: isNaN(Number(rawId(oldVariantId))) ? oldVariantId : (Number(rawId(oldVariantId)) || oldVariantId)
//           }
//         ]
//       };

//       try {
//         await this.api.replaceVariants(contractId, standardPayload, groupSwapPayload);
//         await this.loadPortalData({ showLoading: false });
//         this.closeModal();
//         this.setNotice('Product swapped successfully.', 'success');
//       } catch (error) {
//         console.error('Swap execution failed:', error);
//         this.setModalMessage(userFacingError(error, 'Could not swap product.'), 'error');
//         this.setModalBusy(false);
//       }
//     }

//     // Compatibility aliases for integrations that previously called portal methods directly.
//     loadEditView(contractId) {
//       this.navigateToDetail(contractId);
//     }

//     pauseSub(contractId) {
//       this.openPauseRetentionModal(contractId);
//     }

//     resumeSub(contractId) {
//       this.openResumeModal(contractId);
//     }

//     cancelSub(contractId) {
//       this.openCancelModal(contractId);
//     }    updateEditProductsButtonState() {
//       const editBtn = this.modalRoot.querySelector('[data-action="confirm-add-multiple"]');
//       if (editBtn) {
//         const hasQty = Object.values(this.state.modalQuantities || {}).some(qty => qty > 0);
//         if (hasQty) {
//           editBtn.disabled = false;
//           editBtn.style.setProperty('background-color', '#000000', 'important');
//           editBtn.style.setProperty('border-color', '#000000', 'important');
//           editBtn.style.setProperty('color', '#ffffff', 'important');
//           editBtn.style.opacity = '1';
//           editBtn.style.cursor = 'pointer';
//         } else {
//           editBtn.disabled = true;
//           editBtn.style.setProperty('background-color', '#9ca3af', 'important');
//           editBtn.style.setProperty('border-color', '#9ca3af', 'important');
//           editBtn.style.setProperty('color', '#ffffff', 'important');
//           editBtn.style.opacity = '0.6';
//           editBtn.style.cursor = 'not-allowed';
//         }
//       }
//     }

//     openBuildABoxModal(contractId, defaultMode = 'recurring') {
//       this.state.selectedContractId = contractId;
//       this.state.isBuildABoxModalOpen = true;
//       this.state.modalQuantities = {};
//       this.state.selectedCategory = '';
//       this.state.isFilterExpanded = false;
//       this.state.productCatalogMode = defaultMode;

//       const contract = this.getSelectedContract();
//       if (!contract) return;

//       this.openModal({
//         title: defaultMode === 'one_time' ? 'Add One-Time Items' : 'Select Product',
//         dialogClass: 'harvest-modal__dialog--large',
//         body: this.renderBuildABoxModalBody(contract),
//         actions: `
//           <button class="harvest-button harvest-button--secondary" type="button" data-action="toggle-purchase-type" style="background: #ffffff !important; border: 1px solid #dfe2e5 !important; color: #000000 !important;">
//             Change purchase type
//           </button>
//           <button class="harvest-button harvest-button--primary" type="button" data-action="confirm-add-multiple" data-contract-id="${escapeAttr(contract.id)}">
//             Edit Products
//           </button>
//         `
//       });

//       this.updateEditProductsButtonState();
//     }

//     updateBuildABoxModalContent() {
//       const contract = this.getSelectedContract();
//       if (!contract) return;
      
//       const titleElement = this.modalRoot.querySelector('#harvest-modal-title');
//       if (titleElement) {
//         titleElement.textContent = this.state.productCatalogMode === 'one_time' ? 'Add One-Time Items' : 'Select Product';
//       }

//       const bodyContainer = this.modalRoot.querySelector('.harvest-modal__body');
//       if (bodyContainer) {
//         bodyContainer.innerHTML = `
//           <div class="harvest-modal__message" hidden></div>
//           ${this.renderBuildABoxModalBody(contract)}
//         `;
//       }
      
//       // Keep search input focused and cursor at the end
//       const input = this.modalRoot.querySelector('#catalog-search');
//       if (input) {
//         input.focus();
//         const val = input.value;
//         input.value = '';
//         input.value = val;
//       }
//     }

//     renderBuildABoxModalBody(contract) {
//       const availableItems = this.getOneTimeCandidates(contract);
//       const recurringProducts = getContractLines(contract);
//       const oneTimeProducts = contract.oneTimeProducts || [];

//       // Collect all unique tags for the filter
//       const uniqueTags = new Set();
//       availableItems.forEach(p => {
//         if (p.tags && Array.isArray(p.tags)) {
//           p.tags.forEach(t => {
//             if (t && t.length > 1) {
//               uniqueTags.add(t.charAt(0).toUpperCase() + t.slice(1));
//             }
//           });
//         }
//         if (p.productType) {
//           uniqueTags.add(p.productType.charAt(0).toUpperCase() + p.productType.slice(1));
//         }
//       });
//       const tagList = Array.from(uniqueTags).sort();

//       // Filter availableItems based on search query
//       let filteredAvailable = availableItems;
//       if (this.state.productSearchQuery) {
//         const query = this.state.productSearchQuery.toLowerCase().trim();
//         filteredAvailable = availableItems.filter(p =>
//           getProductTitle(p).toLowerCase().includes(query) ||
//           (p.sku && p.sku.toLowerCase().includes(query))
//         );
//       }

//       // Filter by selected tag category
//       if (this.state.selectedCategory) {
//         const cat = this.state.selectedCategory.toLowerCase();
//         filteredAvailable = filteredAvailable.filter(p =>
//           (p.productType && p.productType.toLowerCase() === cat) ||
//           (p.tags && p.tags.some(t => t.toLowerCase() === cat))
//         );
//       }

//       return `
//         <!-- Catalog Actions, Search, and Switches Bar -->
//         <div class="harvest-catalog-controls-container" style="margin-bottom: 12px; padding: 0; background: transparent; border: none;">
//           <div class="harvest-catalog-search-row" style="display: flex; align-items: center; gap: 8px; width: 100%;">
//             <div class="harvest-catalog-search-wrapper" style="position: relative; flex: 1; max-width: 100%;">
//               <input type="text" id="catalog-search" class="harvest-catalog-search-input" 
//                      placeholder="Search a product to add..." value="${escapeAttr(this.state.productSearchQuery || '')}"
//                      style="padding-left: 36px; height: 42px; box-sizing: border-box;">
//               <!-- Magnifying Glass Icon -->
//               <svg class="harvest-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--harvest-text-muted);">
//                 <circle cx="11" cy="11" r="8"></circle>
//                 <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//               </svg>
//               ${this.state.productSearchQuery ? `
//                 <button class="harvest-catalog-clear-search" type="button" data-action="clear-catalog-search" style="right: 10px;">&times;</button>
//               ` : ''}
//             </div>
//             <button class="harvest-catalog-filter-btn ${this.state.productCatalogMode === 'recurring' ? '' : 'd-none'}" type="button" data-action="toggle-catalog-filter" style="display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; background: var(--harvest-surface); cursor: pointer; color: var(--harvest-text);">
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//                 <line x1="4" y1="21" x2="4" y2="14"></line>
//                 <line x1="4" y1="10" x2="4" y2="3"></line>
//                 <line x1="12" y1="21" x2="12" y2="12"></line>
//                 <line x1="12" y1="8" x2="12" y2="3"></line>
//                 <line x1="20" y1="21" x2="20" y2="16"></line>
//                 <line x1="20" y1="12" x2="20" y2="3"></line>
//                 <line x1="1" y1="14" x2="7" y2="14"></line>
//                 <line x1="9" y1="8" x2="15" y2="8"></line>
//                 <line x1="17" y1="16" x2="23" y2="16"></line>
//               </svg>
//             </button>
//           </div>
          
//           <div class="harvest-catalog-filter-container ${this.state.productCatalogMode === 'recurring' ? '' : 'd-none'}" style="margin-top: 12px; display: ${this.state.isFilterExpanded ? 'block' : 'none'};">
//             <label style="display: block; font-size: 13px; font-weight: 600; color: var(--harvest-text-muted); margin-bottom: 4px;">Tags</label>
//             <select id="catalog-tag-select" class="harvest-select" style="width: 100%; height: 42px; border: 1px solid var(--harvest-border); border-radius: 6px; padding: 0 12px; background: #fff;">
//               <option value="">Select...</option>
//               ${tagList.map(tag => `<option value="${escapeAttr(tag)}" ${this.state.selectedCategory === tag ? 'selected' : ''}>${escapeHtml(tag)}</option>`).join('')}
//             </select>
//           </div>
//         </div>

//         <div style="margin-bottom: 16px; font-size: 14px; display: flex; align-items: center; justify-content: space-between; border: 1px solid var(--harvest-border); padding: 12px; border-radius: 8px; background: var(--harvest-surface-muted);">
//           <span>Adding items as: <strong style="color: var(--harvest-primary, #22c55e);">${this.state.productCatalogMode === 'recurring' ? 'Subscription (Recurring)' : 'One-Time Delivery'}</strong></span>
//         </div>
        
//         <div class="harvest-detail-products harvest-catalog-modal-grid">
//           ${filteredAvailable.length === 0 ? `
//             <div class="harvest-catalog-empty-filtered" style="grid-column: 1 / -1; text-align: center; padding: 48px; border: 1px dashed var(--harvest-border); border-radius: 8px;">
//               <p style="color: var(--harvest-text-muted); font-size: 1.1rem;">No results in catalog match your search.</p>
//               <button type="button" class="harvest-button harvest-button--secondary" data-action="clear-catalog-search" style="margin-top: 12px;">
//                 Reset filter
//               </button>
//             </div>
//           ` : filteredAvailable
//             .map((product) => {
//               const variantId = getAddableVariantId(product);
//               const alreadyInBox = checkIfProductInContract(product, recurringProducts, oneTimeProducts);
              
//               return `
//                 <article class="harvest-product-card harvest-product-card--available">
//                   <div class="harvest-product-card__media">
//                     ${alreadyInBox ? '<span class="harvest-product-card__badge">Already in Box</span>' : ''}
//                     <img
//                       src="${escapeAttr(safeImageUrl(getProductImage(product)))}"
//                       alt="${escapeAttr(getProductTitle(product))}"
//                       loading="lazy"
//                     >
//                   </div>
//                   <div class="harvest-product-card__body">
//                     <div class="harvest-product-card__copy">
//                       <h4 class="harvest-product-card-catalog-title">${escapeHtml(getProductTitle(product))}</h4>
//                       <p class="harvest-product-card__price">
//                         ${escapeHtml(formatMoney(getProductPrice(product), getCurrency(contract, product)))}
//                       </p>
//                     </div>
//                     <div class="harvest-quantity-control">
//                       <button class="harvest-qty-btn" type="button" data-action="modal-qty-change" data-variant-id="${escapeAttr(variantId)}" data-change="-1">&minus;</button>
//                       <input class="harvest-qty-input" type="number" id="modal-qty-${escapeAttr(variantId)}" min="0" value="${this.state.modalQuantities[variantId] || 0}" readonly>
//                       <button class="harvest-qty-btn" type="button" data-action="modal-qty-change" data-variant-id="${escapeAttr(variantId)}" data-change="1">+</button>
//                     </div>
//                   </div>
//                 </article>
//               `;
//             })
//             .join('')}
//         </div>
//       `;
//     }

//     closeModal() {
//       this.modalRoot.hidden = true;
//       this.modalRoot.innerHTML = '';
//       document.body.classList.remove('harvest-modal-open');
//       this.lastFocusedElement?.focus?.();
//       this.lastFocusedElement = null;
//     }

//     createModalRoot() {
//       this.modalRoot = document.createElement('div');
//       this.modalRoot.className = 'harvest-modal';
//       this.modalRoot.hidden = true;
//       document.body.appendChild(this.modalRoot);
//     }

//     openModal(options) {
//       this.lastFocusedElement = document.activeElement;
//       const dClass = options.dialogClass ? ` ${options.dialogClass}` : '';
//       this.modalRoot.innerHTML = `
//         <div class="harvest-modal__backdrop" data-modal-close></div>
//         <section class="harvest-modal__dialog${dClass}" role="dialog" aria-modal="true" aria-labelledby="harvest-modal-title">
//           <header class="harvest-modal__header">
//             <h2 id="harvest-modal-title">${escapeHtml(options.title)}</h2>
//             <button class="harvest-modal__close" type="button" data-modal-close aria-label="Close modal">&times;</button>
//           </header>
//           <div class="harvest-modal__body">
//             <div class="harvest-modal__message" hidden></div>
//             ${options.body}
//           </div>
//           <footer class="harvest-modal__actions">${options.actions}</footer>
//         </section>
//       `;
//       this.modalRoot.hidden = false;
//       document.body.classList.add('harvest-modal-open');
//       const focusTarget = this.modalRoot.querySelector('select, input, button');
//       focusTarget?.focus();
//     }

//     setModalBusy(isBusy) {
//       this.modalRoot
//         .querySelectorAll('button, input, select, textarea')
//         .forEach((element) => (element.disabled = isBusy));
//       const dialog = this.modalRoot.querySelector('.harvest-modal__dialog');
//       if (dialog) dialog.setAttribute('aria-busy', String(isBusy));
//     }

//     setModalMessage(message, type) {
//       const messageElement = this.modalRoot.querySelector('.harvest-modal__message');
//       if (!messageElement) return;
//       messageElement.hidden = false;
//       messageElement.className = `harvest-modal__message harvest-modal__message--${type}`;
//       messageElement.textContent = message;
//     }

//     setNotice(message, type = 'success') {
//       window.clearTimeout(this.noticeTimer);
//       this.state.notice = { message, type };
//       this.render();
//       this.noticeTimer = window.setTimeout(() => this.clearNotice(), 6000);
//     }

//     clearNotice() {
//       window.clearTimeout(this.noticeTimer);
//       this.state.notice = null;
//       this.render();
//     }

//     hideLegacyModal() {
//       const legacyModal = document.getElementById('swap-modal-overlay');
//       if (legacyModal) {
//         legacyModal.hidden = true;
//         legacyModal.setAttribute('aria-hidden', 'true');
//         legacyModal.querySelectorAll('[onclick]').forEach((element) => {
//           element.removeAttribute('onclick');
//         });
//       }
//     }
//   }

//   function isContract(obj) {
//     if (!obj || typeof obj !== 'object') return false;
//     return Boolean(
//       obj.id ||
//       obj.contractId ||
//       obj.status ||
//       obj.lines ||
//       obj.nextBillingDate ||
//       obj.shopifyContractId ||
//       obj.subscriptionContractId
//     );
//   }

//   function extractContractFromObject(obj) {
//     if (!obj || typeof obj !== 'object') return null;
//     if (isContract(obj)) return obj;
//     if (obj.subscriptionContract && isContract(obj.subscriptionContract)) return obj.subscriptionContract;
//     if (obj.contract && isContract(obj.contract)) return obj.contract;
//     if (obj.node && isContract(obj.node)) return obj.node;
//     return null;
//   }

//   function extractCustomer(payload) {
//     if (!payload) return null;

//     // Recursive helper to look for subscriptionContracts or a contracts array inside nested structures
//     function findCustomerOrContracts(obj) {
//       if (!obj || typeof obj !== 'object') return null;

//       // Case 1: The object directly matches the target structure
//       if (obj.subscriptionContracts) {
//         return obj;
//       }

//       // Case 2: Array structures
//       if (Array.isArray(obj)) {
//         // Try to map objects in the array that look like contracts
//         const extractedContracts = obj
//           .map(extractContractFromObject)
//           .filter(Boolean);

//         if (extractedContracts.length > 0) {
//           return { subscriptionContracts: extractedContracts };
//         }

//         // Check if elements are lists of contract objects
//         if (obj[0] && (obj[0].id || obj[0].status || obj[0].lines || obj[0].nextBillingDate)) {
//           return { subscriptionContracts: obj };
//         }

//         // Recursively check elements of the array
//         for (const item of obj) {
//           const found = findCustomerOrContracts(item);
//           if (found) return found;
//         }
//       } else {
//         // Case 3: Standard object - recursively check all nested keys
//         for (const key of Object.keys(obj)) {
//           // Skip known non-object / basic values
//           if (key === '__typename' || key === 'id' || key === 'status') continue;
          
//           const val = obj[key];
//           if (val && typeof val === 'object') {
//             const found = findCustomerOrContracts(val);
//             if (found) return found;
//           }
//         }
//       }
//       return null;
//     }

//     const found = findCustomerOrContracts(payload);
//     if (found) return found;

//     // Fallback: Try manual paths
//     const contractPaths = [
//       payload.data?.subscriptionCustomers,
//       payload.data?.subscriptionCustomer,
//       payload.data?.subscriptionContracts,
//       payload.subscriptionCustomers,
//       payload.subscriptionCustomer,
//       payload.data?.customers,
//       payload.customers,
//       payload.data,
//     ];

//     for (const candidate of contractPaths) {
//       if (!candidate) continue;
//       // If candidate has contracts directly
//       const contracts = getConnectionItems(
//         candidate.subscriptionContracts || candidate
//       );
//       if (contracts.length) {
//         return { subscriptionContracts: contracts };
//       }
//       // If candidate is an array, try each item
//       const arr = Array.isArray(candidate) ? candidate : [candidate];
//       for (const item of arr) {
//         const itemContracts = getConnectionItems(
//           item?.subscriptionContracts || item
//         );
//         if (itemContracts.length) {
//           return { subscriptionContracts: itemContracts };
//         }
//       }
//     }

//     return null;
//   }

//   function extractOneTimeProducts(payload) {
//     if (!payload) return [];
    
//     function collectOneOffs(obj, results = []) {
//       if (!obj || typeof obj !== 'object') return results;
      
//       if (Array.isArray(obj)) {
//         for (const item of obj) {
//           collectOneOffs(item, results);
//         }
//         return results;
//       }
      
//       const varId = obj.variantId || 
//                     obj.variant_id || 
//                     obj.productVariantId || 
//                     obj.product_variant_id || 
//                     obj.variant?.id || 
//                     obj.variant?.variantId || 
//                     obj.productVariant?.id || 
//                     obj.productVariant?.variantId || 
//                     (obj.id && !String(obj.id).includes('SubscriptionContract') && !String(obj.id).includes('SubscriptionLine') ? obj.id : null);

//       if (varId && (obj.title || obj.quantity !== undefined || obj.price !== undefined || obj.lineId || obj.variantTitle || obj.variant?.title)) {
//         const exists = results.some(p => rawId(getVariantId(p)) === rawId(varId) && (p.lineId || p.id) === (obj.lineId || obj.id));
//         if (!exists) {
//           results.push(obj);
//         }
//         return results;
//       }
      
//       for (const key of Object.keys(obj)) {
//         if (key === '__typename' || key === 'status') continue;
//         const val = obj[key];
//         if (val && typeof val === 'object') {
//           collectOneOffs(val, results);
//         }
//       }
//       return results;
//     }
    
//     const items = collectOneOffs(payload);
//     return items.map((product) =>
//       Object.assign({ _harvestOneTime: true }, product)
//     );
//   }

//   function extractScheduleItems(payload) {
//     if (!payload) return [];
//     const candidates = [
//       payload?.data?.schedules,
//       payload?.data?.schedule,
//       payload?.data?.upcomingOrders,
//       payload?.data?.upcomingSubscriptions,
//       payload?.data?.orders,
//       payload?.schedules,
//       payload?.schedule,
//       payload?.upcomingOrders,
//       payload?.upcomingSubscriptions,
//       payload?.orders,
//       payload,
//     ];

//     return firstCollection(candidates);
//   }

//   function extractHistoryItems(payload) {
//     if (!payload) return [];

//     const historyKeys = [
//       'history',
//       'orders',
//       'billingAttempts',
//       'subscriptionBillingAttempts',
//       'orderHistory',
//       'billingHistory',
//       'invoiceHistory',
//       'subscriptionContractsOrderHistory',
//       'subscriptionContractsOrders',
//       'billing_attempts',
//       'order_history',
//     ];

//     function findHistoryCollection(obj) {
//       if (!obj || typeof obj !== 'object') return null;

//       // If it's an array, check elements
//       if (Array.isArray(obj)) {
//         for (const item of obj) {
//           const found = findHistoryCollection(item);
//           if (found && found.length) return found;
//         }
//         return null;
//       }

//       // Check direct keys first
//       for (const key of historyKeys) {
//         if (Object.prototype.hasOwnProperty.call(obj, key)) {
//           const items = getConnectionItems(obj[key]);
//           if (items && items.length > 0) {
//             return items;
//           }
//         }
//       }

//       // If not found, recursively search nested keys
//       for (const key of Object.keys(obj)) {
//         if (key === '__typename' || key === 'id' || key === 'status') continue;
        
//         const val = obj[key];
//         if (val && typeof val === 'object') {
//           const found = findHistoryCollection(val);
//           if (found && found.length) return found;
//         }
//       }

//       return null;
//     }

//     const recursiveItems = findHistoryCollection(payload);
//     if (recursiveItems && recursiveItems.length > 0) {
//       return recursiveItems;
//     }

//     const candidates = [
//       payload?.data?.history,
//       payload?.data?.orders,
//       payload?.data?.billingAttempts,
//       payload?.data?.subscriptionBillingAttempts,
//       payload?.history,
//       payload?.orders,
//       payload?.billingAttempts,
//       payload?.subscriptionBillingAttempts,
//       payload,
//     ];

//     return firstCollection(candidates);
//   }

//   function firstCollection(candidates) {
//     for (const candidate of candidates) {
//       const items = getConnectionItems(candidate);
//       if (items.length) return items;
//       if (candidate && typeof candidate === 'object' && !Array.isArray(candidate)) {
//         const values = Object.values(candidate);
//         for (const value of values) {
//           const nestedItems = getConnectionItems(value);
//           if (nestedItems.length) return nestedItems;
//         }
//       }
//     }
//     return [];
//   }

//   function normalizeScheduleItem(item, contract, index) {
//     const date =
//       firstValue(item, [
//         'deliveryDate',
//         'scheduledDate',
//         'billingDate',
//         'nextBillingDate',
//         'orderDate',
//         'date',
//       ]) || addScheduleInterval(getNextDeliveryDate(contract), contract, index);
//     const products = extractProductsFromRecord(item);

//     return {
//       date,
//       status: firstValue(item, ['status', 'orderStatus', 'billingStatus']) || 'Queued',
//       note: firstValue(item, ['note', 'orderNote', 'customerNote']) || '',
//       products: products.length ? products : scheduleProductsForContract(contract, index),
//     };
//   }

//   function normalizeHistoryItem(item, contract) {
//     const date =
//       firstValue(item, [
//         'processedAt',
//         'orderDate',
//         'billingDate',
//         'createdAt',
//         'createdDate',
//         'date',
//       ]) || getNextDeliveryDate(contract);

//     const billingDate = firstValue(item, [
//       'billingDate',
//       'processedAt',
//       'createdAt',
//       'date'
//     ]);

//     const extractedProducts = extractProductsFromRecord(item);

//     return {
//       date,
//       billingDate: billingDate || date,
//       orderNumber:
//         firstValue(item, ['orderNumber', 'name', 'orderName', 'orderId', 'id']) || '',
//       status: normalizeScheduleStatus(
//         firstValue(item, ['status', 'orderStatus', 'financialStatus']) || 'Completed'
//       ),
//       orderUrl: firstValue(item, ['orderStatusUrl', 'statusUrl', 'orderUrl', 'url']) || '',
//       total:
//         firstMoney(item, ['totalPrice', 'total', 'totalAmount', 'amount']) ??
//         firstMoney(contract, ['totalPrice', 'total', 'nextBillingAmount']) ??
//         0,
//       products: extractedProducts.length ? extractedProducts : getContractLines(contract),
//     };
//   }

//   function extractProductsFromRecord(record) {
//     if (!record) return [];
//     const candidates = [
//       record.lineItems,
//       record.lines,
//       record.items,
//       record.products,
//       record.variants,
//       record.order?.lineItems,
//       record.node?.lineItems,
//       record.node?.order?.lineItems,
//       record.node?.products,
//       record.node?.variants,
//       record.node?.lines,
//       record.subscriptionContractProductHistory,
//       record.node?.subscriptionContractProductHistory,
//       record.order,
//       record.node?.order,
//       record.node,
//     ];
//     for (const candidate of candidates) {
//       if (candidate) {
//         const items = getConnectionItems(candidate);
//         if (items && items.length > 0) {
//           return items;
//         }
//       }
//     }
//     return findLineItemsRecursively(record);
//   }

//   function buildProjectedSchedules(contract) {
//     const firstDate = getNextDeliveryDate(contract);
//     if (!firstDate) return [];

//     return Array.from({ length: SCHEDULE_DELIVERY_COUNT }, (_, index) => ({
//       date: addScheduleInterval(firstDate, contract, index),
//       status: 'Queued',
//       note: '',
//       projected: true,
//       products: scheduleProductsForContract(contract, index),
//     }));
//   }

//   function scheduleProductsForContract(contract, index) {
//     return [
//       ...getContractLines(contract),
//       ...(index === 0
//         ? (contract.oneTimeProducts || []).map((product) =>
//             Object.assign({ _harvestOneTime: true }, product)
//           )
//         : []),
//     ];
//   }

//   function addScheduleInterval(value, contract, index) {
//     const date = new Date(value);
//     if (Number.isNaN(date.getTime())) return value || '';
//     if (!index) return date.toISOString();

//     const policy = contract?.deliveryPolicy || contract?.billingPolicy || {};
//     const count = Number(policy.intervalCount || policy.frequency || 1) || 1;
//     const interval = String(policy.interval || policy.intervalType || 'MONTH').toLowerCase();

//     if (interval.startsWith('day')) date.setDate(date.getDate() + count * index);
//     else if (interval.startsWith('week')) date.setDate(date.getDate() + count * 7 * index);
//     else if (interval.startsWith('year')) date.setFullYear(date.getFullYear() + count * index);
//     else date.setMonth(date.getMonth() + count * index);

//     return date.toISOString();
//   }

//   function normalizeScheduleStatus(status) {
//     const value = String(status || '').replace(/_/g, ' ').trim();
//     if (!value) return 'Queued';
//     return value
//       .toLowerCase()
//       .split(/\s+/)
//       .map(capitalize)
//       .join(' ');
//   }

//   function findVariantIdInObject(obj) {
//     if (!obj || typeof obj !== 'object') return null;
    
//     // 1. Direct standard fields
//     const directFields = [
//       'variantId', 'variant_id', 'productVariantId', 'product_variant_id',
//       'shopifyVariantId', 'shopify_variant_id', 'variant_database_id',
//       'variantDatabaseId', 'variant_gid', 'variantGid', 'shopifyVariant', 'shopify_variant'
//     ];
//     for (const f of directFields) {
//       if (obj[f]) {
//         if (typeof obj[f] === 'object' && obj[f].id) return String(obj[f].id);
//         if (typeof obj[f] === 'string' || typeof obj[f] === 'number') return String(obj[f]);
//       }
//     }
    
//     // 2. Nested objects
//     if (obj.variant && (obj.variant.id || obj.variant.variantId || obj.variant.variant_id)) {
//       return String(obj.variant.id || obj.variant.variantId || obj.variant.variant_id);
//     }
//     if (obj.productVariant && (obj.productVariant.id || obj.productVariant.variantId || obj.productVariant.variant_id)) {
//       return String(obj.productVariant.id || obj.productVariant.variantId || obj.productVariant.variant_id);
//     }
//     if (obj.shopify_variant && (obj.shopify_variant.id || obj.shopify_variant.variant_id)) {
//       return String(obj.shopify_variant.id || obj.shopify_variant.variant_id);
//     }
    
//     // 3. Scan all keys for containing 'variant' (excluding 'variants', 'product_variants')
//     for (const key of Object.keys(obj)) {
//       const lowerKey = key.toLowerCase();
//       if (lowerKey.includes('variant') && !lowerKey.includes('variants') && lowerKey !== 'productvariant' && lowerKey !== 'shopifyvariant') {
//         const val = obj[key];
//         if (val && (typeof val === 'string' || typeof val === 'number')) {
//           // Make sure it doesn't look like a GID for product itself
//           if (!String(val).includes('Product/')) {
//             return String(val);
//           }
//         }
//       }
//     }
//     return null;
//   }

//   function getCatalogProductId(product) {
//     if (!product) return '';
//     const productId =
//       product.productId ||
//       product.product_id ||
//       product.shopifyProductId ||
//       product.shopify_product_id ||
//       product.product?.id ||
//       product.product?.productId ||
//       product.product?.product_id;
//     if (productId) return String(productId);

//     if (product.id && String(product.id).includes('Product/')) {
//       return String(product.id);
//     }
//     return '';
//   }

//   function normalizeVariantCollection(rawVariants) {
//     if (!rawVariants) return [];
//     if (Array.isArray(rawVariants)) {
//       return rawVariants.map((item) => item?.node || item).filter(Boolean);
//     }
//     if (typeof rawVariants !== 'object') return [];
//     if (Array.isArray(rawVariants.edges)) {
//       return rawVariants.edges.map((edge) => edge?.node || edge).filter(Boolean);
//     }
//     if (Array.isArray(rawVariants.nodes)) {
//       return rawVariants.nodes.filter(Boolean);
//     }
//     return Object.values(rawVariants)
//       .flatMap((value) => normalizeVariantCollection(value))
//       .filter(Boolean);
//   }

//   function getVariantIdFromCollection(product) {
//     if (!product || typeof product !== 'object') return '';
//     const productId = rawId(getCatalogProductId(product));
//     const variantCollections = [
//       product.variants,
//       product.productVariants,
//       product.product_variants,
//       product.variantList,
//       product.variant_list,
//       product.variantsList,
//       product.productVariantList,
//       product.shopifyVariants,
//       product.product?.variants,
//       product.product?.productVariants,
//       product.product?.product_variants
//     ];

//     for (const collection of variantCollections) {
//       for (const variant of normalizeVariantCollection(collection)) {
//         if (!variant || typeof variant !== 'object') continue;
//         const variantId = findVariantIdInObject(variant) ||
//           variant.id ||
//           variant.admin_graphql_api_id ||
//           variant.legacyResourceId;
//         if (!variantId) continue;
//         if (String(variantId).includes('Product/')) continue;
//         if (productId && rawId(variantId) === productId) continue;
//         return String(variantId);
//       }
//     }
//     return '';
//   }

//   function isProductIdValue(product, value) {
//     const productId = rawId(getCatalogProductId(product));
//     return Boolean(productId && value && rawId(value) === productId);
//   }

//   function getAddableVariantId(product) {
//     if (!product) return '';

//     const collectionVariantId = getVariantIdFromCollection(product);
//     if (collectionVariantId) return collectionVariantId;

//     const directVariantId = findVariantIdInObject(product);
//     if (directVariantId) {
//       return directVariantId;
//     }

//     return getVariantId(product);
//   }

//   function isOneTimeProduct(product, contract) {
//     if (!product) return false;
    
//     let isOneTime = false;
//     let reason = '';

//     // 1. Robust fuzzy helpers
//     const isOneTimeKey = (key) => {
//       if (!key) return false;
//       const normalized = String(key).toLowerCase().replace(/[-_ ]/g, '');
//       return (
//         normalized.includes('onetime') ||
//         normalized.includes('oneoff') ||
//         normalized.includes('harvestonetime') ||
//         normalized.includes('is_one_time')
//       );
//     };

//     const checkValue = (val) => {
//       if (val === true || val === 1) return true;
//       if (typeof val === 'string') {
//         const normalized = val.toLowerCase().trim().replace(/[-_ ]/g, '');
//         return (
//           normalized === 'true' ||
//           normalized === 'yes' ||
//           normalized === '1' ||
//           normalized === 'onetime' ||
//           normalized === 'oneoff'
//         );
//       }
//       return false;
//     };

//     // 2. Explicit direct and nested flags
//     const targets = [
//       product,
//       product.variant,
//       product.product,
//       product.productVariant,
//       product.shopify_variant,
//       product.shopifyVariant
//     ].filter(Boolean);

//     // Direct keys check (all keys case-insensitive matching)
//     for (const target of targets) {
//       for (const key of Object.keys(target)) {
//         const val = target[key];
//         if (isOneTimeKey(key) && checkValue(val)) {
//           isOneTime = true;
//           reason = `Direct target property match: key=${key}, val=${val}`;
//           break;
//         }
//       }
//       if (isOneTime) break;
//     }

//     // 3. Fallback: Check tags
//     if (!isOneTime) {
//       for (const target of targets) {
//         const tags = target.tags;
//         if (Array.isArray(tags)) {
//           const hasTag = tags.some(t => {
//             const norm = String(t).toLowerCase().replace(/[-_ ]/g, '');
//             return norm === 'onetime' || norm === 'oneoff';
//           });
//           if (hasTag) {
//             isOneTime = true;
//             reason = 'Matched in product/variant tags array';
//             break;
//           }
//         } else if (typeof tags === 'string') {
//           const norm = tags.toLowerCase().replace(/[-_ ]/g, '');
//           if (norm.includes('onetime') || norm.includes('oneoff')) {
//             isOneTime = true;
//             reason = 'Matched in product/variant tags string';
//             break;
//           }
//         }
//       }
//     }

//     // 4. Custom attributes / properties check (supporting array and object formats)
//     if (!isOneTime) {
//       for (const target of targets) {
//         const customAttrs = target.customAttributes || target.custom_attributes || target.properties || target.line_item_properties || target.attributes;
//         if (Array.isArray(customAttrs)) {
//           const hasOneTimeAttr = customAttrs.some(attr => {
//             const key = String(attr?.key || attr?.name || '');
//             const val = attr?.value;
//             return isOneTimeKey(key) && checkValue(val);
//           });
//           if (hasOneTimeAttr) {
//             isOneTime = true;
//             reason = 'custom attribute array match';
//             break;
//           }
//         } else if (customAttrs && typeof customAttrs === 'object') {
//           for (const key of Object.keys(customAttrs)) {
//             const val = customAttrs[key];
//             if (isOneTimeKey(key) && checkValue(val)) {
//               isOneTime = true;
//               reason = `custom attribute object match: key=${key}`;
//               break;
//             }
//           }
//         }
//         if (isOneTime) break;
//       }
//     }

//     // 5. Check if variant exists in contract's oneTimeProducts
//     if (!isOneTime && contract && contract.oneTimeProducts) {
//       const vId = rawId(getVariantId(product));
//       if (vId) {
//         const foundInOneTime = contract.oneTimeProducts.some(otp => {
//           const otvId = rawId(getVariantId(otp));
//           return otvId === vId;
//         });
//         if (foundInOneTime) {
//           isOneTime = true;
//           reason = 'found in contract.oneTimeProducts';
//         }
//       }
//     }

//     if (isOneTime) {
//       console.log(`[isOneTimeProduct] Product "${product.title || getProductTitle(product)}" is determined to be a ONE-TIME product. Reason: ${reason}`);
//     }

//     return isOneTime;
//   }

//   function getSplitProducts(contract) {
//     if (!contract) return { recurringProducts: [], oneTimeProducts: [] };
//     const rawLines = getContractLines(contract);
//     const oneTimeRaw = contract.oneTimeProducts || [];
    
//     const recurringProducts = [];
//     const oneTimeProducts = [...oneTimeRaw];
    
//     rawLines.forEach(p => {
//       if (isOneTimeProduct(p, contract)) {
//         const vId = rawId(getVariantId(p));
//         const exists = oneTimeProducts.some(otp => rawId(getVariantId(otp)) === vId);
//         if (!exists) {
//           oneTimeProducts.push(p);
//         }
//       } else {
//         recurringProducts.push(p);
//       }
//     });

//     console.log('[Harvest Portal Box Inspection] Products currently in subscription box:', {
//       contractId: contract.id,
//       recurringLines: rawLines.map(p => ({
//         id: p.id,
//         variantId: getVariantId(p),
//         title: p.title || p.productTitle || p.product?.title,
//         isOneTime: isOneTimeProduct(p, contract)
//       })),
//       oneTimeProducts: oneTimeRaw.map(p => ({
//         id: p.id,
//         variantId: getVariantId(p),
//         title: p.title || p.productTitle || p.product?.title,
//         isOneTime: isOneTimeProduct(p, contract)
//       }))
//     });
    
//     return { recurringProducts, oneTimeProducts };
//   }

//   function checkIfProductInContract(product, recurringLines, oneTimeLines) {
//     const variantId = rawId(getAddableVariantId(product));
//     if (!variantId) return false;

//     const matchInRecurring = recurringLines.some(
//       (p) => rawId(getVariantId(p)) === variantId
//     );
//     const matchInOneTime = oneTimeLines.some(
//       (p) => rawId(getVariantId(p)) === variantId
//     );
//     if (matchInRecurring || matchInOneTime) return true;

//     const catalogProductId = rawId(getCatalogProductId(product));
//     if (catalogProductId) {
//       const matchProductInRecurring = recurringLines.some(
//         (p) => rawId(getCatalogProductId(p)) === catalogProductId
//       );
//       const matchProductInOneTime = oneTimeLines.some(
//         (p) => rawId(getCatalogProductId(p)) === catalogProductId
//       );
//       return matchProductInRecurring || matchProductInOneTime;
//     }

//     return false;
//   }

//   function parseTagsString(tags) {
//     if (typeof tags !== 'string' || !tags) return [];
//     const trimmed = tags.trim();
//     if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
//       try {
//         const parsed = JSON.parse(trimmed);
//         if (Array.isArray(parsed)) return parsed.map(t => String(t).trim()).filter(Boolean);
//       } catch (e) {}
//     }
//     return trimmed.split(',').map(t => t.trim().replace(/^\[|]$|^"|"$/g, '')).filter(Boolean);
//   }

//   function extractProductsList(payload) {
//     if (!payload) return [];
    
//     // Support Shopify Predictive Search suggestion payload structure directly
//     if (payload && payload.resources && payload.resources.results && payload.resources.results.products) {
//       payload = payload.resources.results.products;
//     }

//     // Support single product object pattern (e.g. from /products/handle.json)
//     if (payload && payload.product && typeof payload.product === 'object' && !Array.isArray(payload.product)) {
//       payload = [payload.product];
//     }
    
//     const items = [];
    
//     // Helper to extract variants from a single product item
//     const processSingleRawProduct = (prod) => {
//       if (!prod || typeof prod !== 'object') return;
      
//       const productId = prod.id || prod.productId || prod.product_id;
//       const productTitle = prod.title || prod.productTitle || prod.product_title || '';
//       const productHandle = prod.handle || prod.productHandle || '';
      
//       // If there are explicit variants under this product
//       const rawVariants =
//         prod.variants ||
//         prod.productVariants ||
//         prod.product_variants ||
//         prod.variantList ||
//         prod.variant_list ||
//         prod.variantsList ||
//         prod.productVariantList ||
//         prod.shopifyVariants ||
//         [];
//       const variantsArr = normalizeVariantCollection(rawVariants);
      
//       if (variantsArr.length > 0) {
//         variantsArr.forEach(v => {
//           if (!v || typeof v !== 'object') return;
//           const varId = findVariantIdInObject(v) || v.id || v.variantId || v.variant_id;
//           if (!varId) return;
          
//           const variantTitle = v.title || v.variantTitle || '';
//           let combinedTitle = productTitle;
//           if (variantTitle && variantTitle !== 'Default' && variantTitle !== 'Default Title' && variantTitle !== productTitle) {
//             combinedTitle = `${productTitle} - ${variantTitle}`;
//           }
          
//           const vImg = getUsableProductImage(v);
//           const pImg = getUsableProductImage(prod);

//           items.push({
//             id: varId,
//             variantId: varId,
//             variant_id: varId,
//             productId: productId,
//             product_id: productId,
//             title: combinedTitle || productTitle || variantTitle || '',
//             productTitle: productTitle,
//             variantTitle: variantTitle,
//             handle: productHandle || v.handle || '',
//             price: v.price || v.variantPrice || v.variant_price || prod.price || 0,
//             image: vImg || pImg || null,
//             available: v.available !== undefined ? v.available : (prod.available !== undefined ? prod.available : true),
//             inventoryQuantity: v.inventory_quantity !== undefined ? v.inventory_quantity : (v.inventoryQuantity !== undefined ? v.inventoryQuantity : (prod.inventory_quantity !== undefined ? prod.inventory_quantity : null)),
//             tags: Array.isArray(prod.tags) ? prod.tags : parseTagsString(prod.tags),
//             productType: prod.product_type || prod.productType || '',
//           });
//         });
//       } else {
//         // If it's a flat product/variant representation itself
//         const varId = findVariantIdInObject(prod) || prod.variantId || prod.variant_id || prod.id;
//         if (varId) {
//           const variantTitle = prod.variantTitle || prod.title || '';
//           let combinedTitle = productTitle || prod.title || '';
//           if (variantTitle && variantTitle !== 'Default' && variantTitle !== 'Default Title' && variantTitle !== combinedTitle) {
//             combinedTitle = `${combinedTitle} - ${variantTitle}`;
//           }
          
//           const pImg = getUsableProductImage(prod);
          
//           items.push({
//             id: varId,
//             variantId: varId,
//             variant_id: varId,
//             productId: productId,
//             product_id: productId,
//             title: combinedTitle || productTitle || variantTitle || '',
//             productTitle: productTitle || prod.title || '',
//             variantTitle: variantTitle,
//             handle: productHandle,
//             price: prod.price || prod.variantPrice || 0,
//             image: pImg || null,
//             available: prod.available !== undefined ? prod.available : true,
//             inventoryQuantity: prod.inventory_quantity !== undefined ? prod.inventory_quantity : (prod.inventoryQuantity !== undefined ? prod.inventoryQuantity : null),
//             tags: Array.isArray(prod.tags) ? prod.tags : parseTagsString(prod.tags),
//             productType: prod.product_type || prod.productType || '',
//           });
//         }
//       }
//     };

//     // If payload is an array directly
//     if (Array.isArray(payload)) {
//       payload.forEach(processSingleRawProduct);
//     } else if (payload && typeof payload === 'object') {
//       // Check popular object property patterns
//       const possibleArrays = [
//         payload.products,
//         payload.data,
//         payload.subscriptionProducts,
//         payload.subscription_products,
//         payload.items,
//         payload.results,
//         payload.nodes
//       ];
      
//       let foundArray = false;
//       for (const arr of possibleArrays) {
//         if (Array.isArray(arr)) {
//           arr.forEach(processSingleRawProduct);
//           foundArray = true;
//           break;
//         }
//       }
      
//       // Fallback: search all object keys for any arrays
//       if (!foundArray) {
//         for (const key of Object.keys(payload)) {
//           const val = payload[key];
//           if (Array.isArray(val) && val.length > 0) {
//             val.forEach(processSingleRawProduct);
//             foundArray = true;
//             break;
//           }
//         }
//       }
      
//       // One more fallback: if payload itself is a single flat product object
//       if (!foundArray) {
//         processSingleRawProduct(payload);
//       }
//     }
    
//     return items;
//   }

//   function uniqueProductsByVariant(products) {
//     const seen = new Set();
//     return products.filter((product) => {
//       const variantId = rawId(getAddableVariantId(product) || getVariantId(product));
//       if (!variantId || seen.has(variantId)) return false;
//       seen.add(variantId);
//       return true;
//     });
//   }

//   function mergeProductImages(products, imageSourceProducts) {
//     const imagesByVariant = new Map();

//     imageSourceProducts.forEach((product) => {
//       const variantId = rawId(getVariantId(product));
//       const image = getUsableProductImage(product);
//       if (variantId && image) imagesByVariant.set(variantId, image);
//     });

//     return products.map((product) => {
//       if (getUsableProductImage(product)) return product;

//       const image = imagesByVariant.get(rawId(getVariantId(product)));
//       return image ? Object.assign({}, product, { image }) : product;
//     });
//   }

//   function getConnectionItems(connection) {
//     if (!connection) return [];
//     if (Array.isArray(connection)) return connection;
//     if (Array.isArray(connection.nodes)) return connection.nodes;
//     if (Array.isArray(connection.edges)) {
//       return connection.edges.map((edge) => edge?.node || edge).filter(Boolean);
//     }
//     return [];
//   }

//   function findLineItemsRecursively(obj) {
//     if (!obj || typeof obj !== 'object') return [];
    
//     if (Array.isArray(obj)) {
//       const looksLikeLines = obj.every(item => item && typeof item === 'object' && (item.variantId || item.variant_id || item.productId || item.title));
//       if (looksLikeLines && obj.length > 0) {
//         return obj;
//       }
//       let found = [];
//       for (const item of obj) {
//         const res = findLineItemsRecursively(item);
//         if (res.length > 0) {
//           found = found.concat(res);
//         }
//       }
//       return found;
//     }

//     if (obj.nodes && Array.isArray(obj.nodes)) {
//       return findLineItemsRecursively(obj.nodes);
//     }
//     if (obj.edges && Array.isArray(obj.edges)) {
//       return findLineItemsRecursively(obj.edges.map(e => e?.node || e).filter(Boolean));
//     }

//     const lineKeys = ['lines', 'lineItems', 'subscriptionContractLineItems', 'subscriptionLines', 'line_items'];
//     for (const key of lineKeys) {
//       if (obj[key]) {
//         const res = findLineItemsRecursively(obj[key]);
//         if (res.length > 0) return res;
//       }
//     }

//     for (const key of Object.keys(obj)) {
//       if (key === '__typename' || key === 'id' || key === 'status') continue;
//       const val = obj[key];
//       if (val && typeof val === 'object') {
//         const res = findLineItemsRecursively(val);
//         if (res.length > 0) return res;
//       }
//     }
//     return [];
//   }

//   function getContractLines(contract) {
//     if (!contract) return [];
//     return extractProductsFromRecord(contract);
//   }

//   function calculateContractTotals(contract, oneTimeProducts) {
//     const splits = getSplitProducts(contract);
//     const products = [...splits.recurringProducts, ...splits.oneTimeProducts];
//     const calculatedSubtotal = products.reduce(
//       (sum, product) => sum + getLineTotal(product),
//       0
//     );
//     const subtotal =
//       firstMoney(contract, [
//         'subtotalPrice',
//         'subtotal',
//         'lineItemsSubtotalPrice',
//         'discountedSubtotal',
//       ]) ?? calculatedSubtotal;
//     const delivery =
//       firstMoney(contract, ['deliveryPrice', 'shippingPrice', 'deliveryAmount']) ?? 0;
//     const explicitTotal = firstMoney(contract, [
//       'totalPrice',
//       'total',
//       'totalAmount',
//       'nextBillingAmount',
//     ]);
//     let discount =
//       firstMoney(contract, ['discountAmount', 'totalDiscounts', 'totalDiscountAmount']) ??
//       calculateDiscounts(contract, subtotal, delivery);

//     if (!discount && explicitTotal !== null) {
//       discount = Math.max(0, subtotal + delivery - explicitTotal);
//     }

//     const total =
//       explicitTotal !== null ? explicitTotal : Math.max(0, subtotal + delivery - discount);

//     return {
//       subtotal: roundMoney(subtotal),
//       delivery: roundMoney(delivery),
//       discount: roundMoney(discount),
//       total: roundMoney(total),
//     };
//   }

//   function calculateDiscounts(contract, subtotal, delivery) {
//     return getConnectionItems(contract?.discounts).reduce((sum, discount) => {
//       const fixed = firstMoney(discount, [
//         'amount',
//         'discountAmount',
//         'value.amount',
//         'value.fixedAmount',
//       ]);
//       if (fixed !== null) return sum + fixed;

//       const percentage =
//         numberValue(deepGet(discount, 'value.percentage')) ??
//         numberValue(discount.percentage);
//       if (percentage === null) return sum;

//       const target = String(
//         discount.targetType || discount.type || discount.title || ''
//       ).toUpperCase();
//       const base = /DELIVERY|SHIPPING/.test(target) ? delivery : subtotal;
//       return sum + base * (percentage / 100);
//     }, 0);
//   }

//   function getLineTotal(product) {
//     const discounted = firstMoney(product, [
//       'lineDiscountedPrice',
//       'discountedPrice',
//       'linePrice',
//       'totalPrice',
//       'totalAmount',
//       'discountedPrice.amount',
//       'lineDiscountedPrice.amount',
//     ]);
//     if (discounted !== null && discounted !== 0) return discounted;

//     const unit = firstMoney(product, [
//       'price',
//       'currentPrice',
//       'variantPrice',
//       'unitPrice',
//       'variant.price',
//       'variant.currentPrice',
//       'variant.variantPrice',
//       'variant.unitPrice',
//       'variantPrice.amount',
//       'unitPrice.amount',
//       'price.amount',
//       'currentPrice.amount',
//       'product.price'
//     ]);
//     return unit !== null ? unit * getQuantity(product) : 0;
//   }

//   function getLineId(product) {
//     return product?.id || product?.lineId || product?.line_item_id || '';
//   }

//   function getVariantId(product) {
//     if (!product) return '';
//     const vId = product?.variantId || 
//                 product?.variant_id || 
//                 product?.variant?.id || 
//                 product?.variant?.variantId || 
//                 product?.productVariantId || 
//                 product?.product_variant_id || 
//                 product?.product_variant?.id;
//     if (vId) return vId;
    
//     // Only fallback to product.id if it's not a SubscriptionLine GID
//     if (product?.id && !String(product.id).includes('SubscriptionLine') && !String(product.id).includes('SubscriptionContractLine')) {
//       return product.id;
//     }
//     return '';
//   }

//   function firstValue(object, paths) {
//     if (!object) return null;
//     for (const path of paths) {
//       const value = deepGet(object, path);
//       if (value !== undefined && value !== null && value !== '') return value;
//     }
//     return null;
//   }

//   function getQuantity(product) {
//     const quantity = Number(product?.quantity || product?.qty || 1);
//     return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
//   }

//   function getProductTitle(product) {
//     if (!product) return 'Product';
//     let title = product?.title ||
//       product?.productTitle ||
//       product?.variantTitle ||
//       product?.variant?.title ||
//       product?.product?.title;
      
//     if (!title || title === 'Product' || title === 'Added Product') {
//       const resolved = findCatalogOrContractProduct(getVariantId(product));
//       if (resolved) {
//         title = resolved.title || resolved.productTitle || resolved.variantTitle || resolved.product?.title;
//       }
//     }
//     return title || 'Product';
//   }

//   function isPlaceholderImageSource(url) {
//     return url === PLACEHOLDER_IMAGE ||
//       /(?:placeholder[-_]?image|image[-_]?placeholder|no[-_]?image)/i.test(url);
//   }

//   function imageUrlFromValue(value, seen = new Set(), depth = 0, skipPlaceholders = false) {
//     if (!value || depth > 5) return null;
//     if (typeof value === 'string') {
//       const url = value.trim();
//       return url && (!skipPlaceholders || !isPlaceholderImageSource(url)) ? url : null;
//     }
//     if (typeof value !== 'object' || seen.has(value)) return null;
//     seen.add(value);

//     const values = Array.isArray(value) ? value : [value];
//     for (const item of values) {
//       if (!item) continue;
//       if (typeof item === 'string') {
//         const url = item.trim();
//         if (url && (!skipPlaceholders || !isPlaceholderImageSource(url))) return url;
//         continue;
//       }
//       if (typeof item !== 'object') continue;

//       // Appstle and Shopify use different naming conventions for the same media URL.
//       for (const key of [
//         'url', 'src', 'originalSrc', 'original_src', 'originalUrl', 'original_url',
//         'transformedSrc', 'transformed_src', 'imageUrl', 'imageURL', 'image_url',
//         'imageSrc', 'image_src', 'secureUrl', 'secure_url'
//       ]) {
//         if (typeof item[key] === 'string' && item[key].trim()) {
//           const url = item[key].trim();
//           if (!skipPlaceholders || !isPlaceholderImageSource(url)) return url;
//         }
//       }

//       for (const key of [
//         'image', 'featuredImage', 'featured_image', 'variantImage', 'variant_image',
//         'productImage', 'product_image', 'previewImage', 'preview_image', 'preview',
//         'media', 'images', 'nodes', 'edges', 'node'
//       ]) {
//         const nested = imageUrlFromValue(item[key], seen, depth + 1, skipPlaceholders);
//         if (nested) return nested;
//       }
//     }
//     return null;
//   }

//   function isPlaceholderImageUrl(value) {
//     const url = imageUrlFromValue(value);
//     return !url || isPlaceholderImageSource(url);
//   }

//   function getUsableProductImage(product) {
//     if (!product) return null;

//     const imageSources = [
//       product.variantImage,
//       product.variant_image,
//       product.variantImageUrl,
//       product.variant_image_url,
//       product.image,
//       product.imageUrl,
//       product.imageURL,
//       product.image_url,
//       product.imageSrc,
//       product.image_src,
//       product.featuredImage,
//       product.featured_image,
//       product.featuredImageUrl,
//       product.featured_image_url,
//       product.productImage,
//       product.product_image,
//       product.productImageUrl,
//       product.product_image_url,
//       product.featuredMedia,
//       product.featured_media,
//       product.media,
//       product.images,
//       product.variant?.image,
//       product.variant?.imageUrl,
//       product.variant?.imageURL,
//       product.variant?.image_url,
//       product.variant?.variantImageUrl,
//       product.variant?.variant_image_url,
//       product.variant?.featuredImage,
//       product.variant?.featured_image,
//       product.variant?.featuredImageUrl,
//       product.variant?.featured_image_url,
//       product.variant?.featuredMedia,
//       product.variant?.featured_media,
//       product.variant?.media,
//       product.variant?.images,
//       product.product?.image,
//       product.product?.imageUrl,
//       product.product?.imageURL,
//       product.product?.image_url,
//       product.product?.featuredImage,
//       product.product?.featured_image,
//       product.product?.featuredImageUrl,
//       product.product?.featured_image_url,
//       product.product?.featuredMedia,
//       product.product?.featured_media,
//       product.product?.media,
//       product.product?.images,
//     ];

//     for (const source of imageSources) {
//       const image = imageUrlFromValue(source, new Set(), 0, true);
//       if (image) return image;
//     }
//     return null;
//   }

//   function getProductImage(product) {
//     if (!product) return PLACEHOLDER_IMAGE;

//     let image = getUsableProductImage(product);
//     if (!image) {
//       const resolved = findCatalogOrContractProduct(getVariantId(product));
//       if (resolved && resolved !== product) image = getUsableProductImage(resolved);
//     }
//     return image || PLACEHOLDER_IMAGE;
//   }

//   function getNextPaymentDate(contract) {
//     return (
//       contract?.nextBillingDate ||
//       contract?.nextBillingDateTime ||
//       contract?.nextPaymentDate ||
//       contract?.nextOrderDate ||
//       contract?.billingPolicy?.nextBillingDate ||
//       ''
//     );
//   }

//   function getNextDeliveryDate(contract) {
//     return (
//       contract?.nextDeliveryDate ||
//       contract?.deliveryDate ||
//       contract?.nextBillingDate ||
//       contract?.nextPaymentDate ||
//       contract?.nextOrderDate ||
//       ''
//     );
//   }

//   function getHumanizedDeliveryText(contract) {
//     const details = getDeliveryDetails(contract);
//     let windowStr = String(details.window || 'Thursday Morning Delivery').toLowerCase();
    
//     // Clean up window string such as "Thursday Morning Delivery" -> "Thursday morning"
//     if (windowStr.includes('delivery')) {
//       windowStr = windowStr.replace('delivery', '').trim();
//     }
    
//     let suffix = 's';
//     if (!windowStr.endsWith('s')) {
//       suffix = 's';
//     } else {
//       suffix = '';
//     }
    
//     return `Delivering to <strong class="harvest-humanized-address">${escapeHtml(details.address)}</strong> on ${escapeHtml(windowStr)}${suffix}`;
//   }

//   function getContractShippingAddress(contract) {
//     if (!contract) return {};
    
//     // Check various common paths where Appstle/Shopify store the address
//     const address = contract.shippingAddress || 
//                     contract.deliveryAddress || 
//                     contract.deliveryMethod?.shippingAddress || 
//                     contract.deliveryMethod?.address || 
//                     contract.deliveryMethod || 
//                     {};
    
//     // If the found object has address fields (like address1, city, or zip), return it
//     if (address.address1 || address.city || address.zip) {
//       return address;
//     }
    
//     // Check if there's an address list in the customer object
//     if (contract.customer?.defaultAddress) {
//       return contract.customer.defaultAddress;
//     }
//     if (contract.customer?.addresses?.[0]) {
//       return contract.customer.addresses[0];
//     }
    
//     return {};
//   }

//   function getDeliveryDetails(contract) {
//     const shipping = getContractShippingAddress(contract);
//     const address = [
//       shipping.address1,
//       shipping.address2,
//       shipping.city,
//       shipping.province,
//       shipping.zip,
//       shipping.country
//     ]
//       .filter(Boolean)
//       .join(', ');

//     let windowVal = contract?.deliveryWindow;
//     if (!windowVal) {
//       const attrs = getConnectionItems(contract?.attributes) || getConnectionItems(contract?.customAttributes) || [];
//       const winAttr = attrs.find(a => a.key?.toLowerCase() === 'delivery_window' || a.key?.toLowerCase() === 'delivery window');
//       if (winAttr) {
//         windowVal = winAttr.value;
//       }
//     }
//     if (!windowVal) {
//       windowVal = contract?.deliveryInstructions || 'Thursday Morning Delivery';
//     }

//     return {
//       address: address || contract?.address || 'Default shipping address',
//       window: windowVal,
//     };
//   }

//   function getPaymentDetails(contract) {
//     const payment = contract?.paymentMethod || {};
//     const masked = payment?.maskedNumber || payment?.card?.last4 || payment?.lastDigits || '';
//     if (masked) return `Ending in ${masked}`;
//     if (payment?.type) return `${payment.type} ${masked}`.trim();
//     return 'Default payment method';
//   }

//   function formatMultiline(value) {
//     if (!value) return '';
//     return String(value).replace(/\n/g, '<br>');
//   }

//   function getUpdateDeadlineDate(contract) {
//     const nextDelivery = getNextDeliveryDate(contract);
//     if (!nextDelivery) return '';
//     const date = new Date(nextDelivery);
//     if (Number.isNaN(date.getTime())) return '';
//     date.setDate(date.getDate() - 1);
//     date.setHours(23, 59, 0, 0);
//     return date.toISOString();
//   }

//   function pendingLineKey(contractId, lineId) {
//     return `${rawId(contractId)}:${rawId(lineId)}`;
//   }

//   function toDateInputValue(value) {
//     const date = new Date(value);
//     if (Number.isNaN(date.getTime())) return '';
//     return date.toISOString().split('T')[0];
//   }

//   function getWeekdayName(dateStr) {
//     if (!dateStr) return '';
//     let dateObj;
//     if (String(dateStr).includes('T')) {
//       dateObj = new Date(dateStr);
//     } else {
//       const parts = String(dateStr).split('-');
//       if (parts.length === 3) {
//         dateObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
//       } else {
//         dateObj = new Date(dateStr);
//       }
//     }
//     if (Number.isNaN(dateObj.getTime())) return '';
//     return dateObj.toLocaleDateString('en-US', { weekday: 'long' });
//   }

//   function isProductOutOfStock(product) {
//     const inventory =
//       product?.inventoryQuantity ??
//       product?.availableQuantity ??
//       product?.inventory ??
//       product?.available;
//     if (inventory === undefined || inventory === null) return false;
//     return Number(inventory) <= 0;
//   }

//   function formatFrequency(contract) {
//     const policy = contract?.billingPolicy || contract?.deliveryPolicy || {};
//     const count = Number(policy.intervalCount || policy.frequency || 1);
//     const interval = String(policy.interval || policy.intervalType || 'MONTH').toLowerCase();
//     const normalized = interval.endsWith('s') ? interval.slice(0, -1) : interval;
//     const label = count === 1 ? normalized : `${normalized}s`;
//     return `Every ${count} ${capitalize(label)}`;
//   }

//   function getCurrency(contract, product) {
//     return (
//       product?.lineDiscountedPrice?.currencyCode ||
//       product?.currentPrice?.currencyCode ||
//       contract?.currencyCode ||
//       contract?.deliveryPrice?.currencyCode ||
//       'USD'
//     );
//   }

//   function customerDisplayName(customer) {
//     const rootEl = document.getElementById('harvest-portal-root');
//     const liquidName = rootEl?.dataset?.customerName;
//     if (liquidName && liquidName.trim() !== '') {
//       return liquidName;
//     }
//     const liquidFirstName = rootEl?.dataset?.customerFirstName;
//     const liquidLastName = rootEl?.dataset?.customerLastName;
//     if (liquidFirstName || liquidLastName) {
//       return [liquidFirstName, liquidLastName].filter(Boolean).join(' ');
//     }
//     const liquidEmail = rootEl?.dataset?.customerEmail;
//     if (liquidEmail && liquidEmail.trim() !== '') {
//       return liquidEmail;
//     }

//     const composed = [customer?.firstName, customer?.lastName].filter(Boolean).join(' ');
//     return (
//       customer?.displayName ||
//       customer?.name ||
//       composed ||
//       customer?.email ||
//       'Customer Account'
//     );
//   }

//   function renderStatusBadge(status) {
//     const label = status === 'CANCELLED' ? 'Closed' : capitalize(status.toLowerCase());
//     return `<span class="harvest-badge harvest-badge--${status.toLowerCase()}">${escapeHtml(
//       label
//     )}</span>`;
//   }

//   function normalizeStatus(status) {
//     const normalized = String(status || 'UNKNOWN').toUpperCase();
//     if (['CANCELLED', 'CANCELED', 'CLOSED', 'EXPIRED'].includes(normalized)) {
//       return 'CANCELLED';
//     }
//     return normalized;
//   }

//   function statusRank(status) {
//     const normalized = normalizeStatus(status);
//     if (normalized === 'ACTIVE') return 0;
//     if (normalized === 'PAUSED') return 1;
//     if (normalized === 'CANCELLED') return 2;
//     return 3;
//   }

//   function actionButton(action, label, contractId, variant = 'secondary') {
//     return `
//       <button
//         class="harvest-button harvest-button--${variant}"
//         type="button"
//         data-action="${escapeAttr(action)}"
//         data-contract-id="${escapeAttr(contractId)}"
//       >${escapeHtml(label)}</button>
//     `;
//   }

//   function selectOption(value, label, selectedValue) {
//     return `<option value="${escapeAttr(value)}" ${
//       value === selectedValue ? 'selected' : ''
//     }>${escapeHtml(label)}</option>`;
//   }

//   function firstMoney(object, paths) {
//     for (const path of paths) {
//       const value = moneyValue(deepGet(object, path));
//       if (value !== null) return value;
//     }
//     return null;
//   }

//   function moneyValue(value) {
//     if (value === undefined || value === null || value === '') return null;
//     if (typeof value === 'object') {
//       return moneyValue(value.amount ?? value.value ?? value.price);
//     }
//     return numberValue(value);
//   }

//   function numberValue(value) {
//     if (value === undefined || value === null || value === '') return null;
//     const number = Number(value);
//     return Number.isFinite(number) ? number : null;
//   }

//   function deepGet(object, path) {
//     return String(path)
//       .split('.')
//       .reduce((value, key) => (value == null ? undefined : value[key]), object);
//   }

//   function formatMoney(amount, currency) {
//     try {
//       return new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: currency || 'USD',
//         minimumFractionDigits: 2,
//       }).format(Number(amount) || 0);
//     } catch (error) {
//       return `$${(Number(amount) || 0).toFixed(2)}`;
//     }
//   }

//   function formatDate(value) {
//     const date = new Date(value);
//     if (Number.isNaN(date.getTime())) return 'Date TBD';
//     return date.toLocaleDateString('en-US', {
//       weekday: 'short',
//       month: 'long',
//       day: 'numeric',
//       year: 'numeric',
//     });
//   }

//   function dateValue(value) {
//     const timestamp = new Date(value || 0).getTime();
//     return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
//   }

//   function rawId(id) {
//     return String(id || '').split('/').pop();
//   }

//   function roundMoney(value) {
//     return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
//   }

//   function capitalize(value) {
//     return String(value || '').charAt(0).toUpperCase() + String(value || '').slice(1);
//   }

//   function getInitials(value) {
//     const initials = String(value || '')
//       .split(/\s+/)
//       .filter(Boolean)
//       .slice(0, 2)
//       .map((part) => part.charAt(0).toUpperCase())
//       .join('');
//     return initials || 'CA';
//   }

//   function safeImageUrl(value) {
//     const url = imageUrlFromValue(value);
//     if (!url || isPlaceholderImageUrl(url)) return PLACEHOLDER_IMAGE;
//     if (/^\/\//.test(url)) return `https:${url}`;
//     if (/^(https?:\/\/|\/|data:image\/)/i.test(url)) return url;
//     return PLACEHOLDER_IMAGE;
//   }

//   function escapeHtml(value) {
//     return String(value ?? '')
//       .replace(/&/g, '&')
//       .replace(/</g, '<')
//       .replace(/>/g, '>')
//       .replace(/"/g, '"')
//       .replace(/'/g, '&#039;');
//   }

//   function escapeAttr(value) {
//     return escapeHtml(value);
//   }

//   function userFacingError(error, fallback) {
//     if (error instanceof PortalRequestError && error.status === 401) {
//       return 'Your session has expired. Please log in again.';
//     }
//     return error?.message || fallback;
//   }

//   const root = document.getElementById('harvest-portal-root');
//   if (root) {
//     const portal = new HarvestPortal(root);
//     window.harvestPortal = portal;
//     window.portal = portal;
//   }
// })();
